(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4b9f"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4b9f"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("bUBkB", function(module, exports) {

var $alyXF = parcelRequire("alyXF");
/*!
 * jQuery JavaScript Library v3.2.1
 * https://jquery.com/
 *
 * Includes Sizzle.js
 * https://sizzlejs.com/
 *
 * Copyright JS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2017-03-20T18:59Z
 */ (function(global, factory) {
    "use strict";
    if (typeof module.exports === "object") // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket #14549 for more info.
    module.exports = global.document ? factory(global, true) : function(w) {
        if (!w.document) throw new Error("jQuery requires a window with a document");
        return factory(w);
    };
    else factory(global);
// Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : undefined, function(window1, noGlobal) {
    // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
    // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
    // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
    // enough that all such attempts are guarded in a try block.
    "use strict";
    var arr = [];
    var document = window1.document;
    var getProto = Object.getPrototypeOf;
    var slice = arr.slice;
    var concat = arr.concat;
    var push = arr.push;
    var indexOf = arr.indexOf;
    var class2type = {};
    var toString = class2type.toString;
    var hasOwn = class2type.hasOwnProperty;
    var fnToString = hasOwn.toString;
    var ObjectFunctionString = fnToString.call(Object);
    var support = {};
    function DOMEval(code, doc) {
        doc = doc || document;
        var script = doc.createElement("script");
        script.text = code;
        doc.head.appendChild(script).parentNode.removeChild(script);
    }
    /* global Symbol */ // Defining this global in .eslintrc.json would create a danger of using the global
    // unguarded in another place, it seems safer to define global only for this module
    var version = "3.2.1", // Define a local copy of jQuery
    jQuery = function jQuery1(selector, context) {
        // The jQuery object is actually just the init constructor 'enhanced'
        // Need init if jQuery is called (just allow error to be thrown if not included)
        return new jQuery.fn.init(selector, context);
    }, // Support: Android <=4.0 only
    // Make sure we trim BOM and NBSP
    rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, // Matches dashed string for camelizing
    rmsPrefix = /^-ms-/, rdashAlpha = /-([a-z])/g, // Used by jQuery.camelCase as callback to replace()
    fcamelCase = function fcamelCase(all, letter) {
        return letter.toUpperCase();
    };
    jQuery.fn = jQuery.prototype = {
        // The current version of jQuery being used
        jquery: version,
        constructor: jQuery,
        // The default length of a jQuery object is 0
        length: 0,
        toArray: function toArray() {
            return slice.call(this);
        },
        // Get the Nth element in the matched element set OR
        // Get the whole matched element set as a clean array
        get: function get(num) {
            // Return all the elements in a clean array
            if (num == null) return slice.call(this);
            // Return just the one element from the set
            return num < 0 ? this[num + this.length] : this[num];
        },
        // Take an array of elements and push it onto the stack
        // (returning the new matched element set)
        pushStack: function pushStack(elems) {
            // Build a new jQuery matched element set
            var ret = jQuery.merge(this.constructor(), elems);
            // Add the old object onto the stack (as a reference)
            ret.prevObject = this;
            // Return the newly-formed element set
            return ret;
        },
        // Execute a callback for every element in the matched set.
        each: function each(callback) {
            return jQuery.each(this, callback);
        },
        map: function map(callback) {
            return this.pushStack(jQuery.map(this, function(elem, i) {
                return callback.call(elem, i, elem);
            }));
        },
        slice: function slice1() {
            return this.pushStack(slice.apply(this, arguments));
        },
        first: function first() {
            return this.eq(0);
        },
        last: function last() {
            return this.eq(-1);
        },
        eq: function eq(i) {
            var len = this.length, j = +i + (i < 0 ? len : 0);
            return this.pushStack(j >= 0 && j < len ? [
                this[j]
            ] : []);
        },
        end: function end() {
            return this.prevObject || this.constructor();
        },
        // For internal use only.
        // Behaves like an Array's method, not like a jQuery method.
        push: push,
        sort: arr.sort,
        splice: arr.splice
    };
    jQuery.extend = jQuery.fn.extend = function() {
        var options, name, src, copy, copyIsArray, clone, target = arguments[0] || {}, i = 1, length = arguments.length, deep = false;
        // Handle a deep copy situation
        if (typeof target === "boolean") {
            deep = target;
            // Skip the boolean and the target
            target = arguments[i] || {};
            i++;
        }
        // Handle case when target is a string or something (possible in deep copy)
        if (typeof target !== "object" && !jQuery.isFunction(target)) target = {};
        // Extend jQuery itself if only one argument is passed
        if (i === length) {
            target = this;
            i--;
        }
        for(; i < length; i++){
            // Only deal with non-null/undefined values
            if ((options = arguments[i]) != null) // Extend the base object
            for(name in options){
                src = target[name];
                copy = options[name];
                // Prevent never-ending loop
                if (target === copy) continue;
                // Recurse if we're merging plain objects or arrays
                if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
                    if (copyIsArray) {
                        copyIsArray = false;
                        clone = src && Array.isArray(src) ? src : [];
                    } else clone = src && jQuery.isPlainObject(src) ? src : {};
                    // Never move original objects, clone them
                    target[name] = jQuery.extend(deep, clone, copy);
                // Don't bring in undefined values
                } else if (copy !== undefined) target[name] = copy;
            }
        }
        // Return the modified object
        return target;
    };
    jQuery.extend({
        // Unique for each copy of jQuery on the page
        expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
        // Assume jQuery is ready without the ready module
        isReady: true,
        error: function error(msg) {
            throw new Error(msg);
        },
        noop: function noop() {},
        isFunction: function isFunction(obj) {
            return jQuery.type(obj) === "function";
        },
        isWindow: function isWindow(obj) {
            return obj != null && obj === obj.window;
        },
        isNumeric: function isNumeric(obj) {
            // As of jQuery 3.0, isNumeric is limited to
            // strings and numbers (primitives or objects)
            // that can be coerced to finite numbers (gh-2662)
            var type = jQuery.type(obj);
            return (type === "number" || type === "string") && // parseFloat NaNs numeric-cast false positives ("")
            // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
            // subtraction forces infinities to NaN
            !isNaN(obj - parseFloat(obj));
        },
        isPlainObject: function isPlainObject(obj) {
            var proto, Ctor;
            // Detect obvious negatives
            // Use toString instead of jQuery.type to catch host objects
            if (!obj || toString.call(obj) !== "[object Object]") return false;
            proto = getProto(obj);
            // Objects with no prototype (e.g., `Object.create( null )`) are plain
            if (!proto) return true;
            // Objects with prototype are plain iff they were constructed by a global Object function
            Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
            return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
        },
        isEmptyObject: function isEmptyObject(obj) {
            /* eslint-disable no-unused-vars */ // See https://github.com/eslint/eslint/issues/6125
            var name;
            for(name in obj)return false;
            return true;
        },
        type: function type(obj) {
            if (obj == null) return obj + "";
            // Support: Android <=2.3 only (functionish RegExp)
            return typeof obj === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : typeof obj === "undefined" ? "undefined" : (0, $alyXF._)(obj);
        },
        // Evaluates a script in a global context
        globalEval: function globalEval(code) {
            DOMEval(code);
        },
        // Convert dashed to camelCase; used by the css and data modules
        // Support: IE <=9 - 11, Edge 12 - 13
        // Microsoft forgot to hump their vendor prefix (#9572)
        camelCase: function camelCase(string) {
            return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
        },
        each: function each(obj, callback) {
            var length, i = 0;
            if (isArrayLike(obj)) {
                length = obj.length;
                for(; i < length; i++){
                    if (callback.call(obj[i], i, obj[i]) === false) break;
                }
            } else for(i in obj){
                if (callback.call(obj[i], i, obj[i]) === false) break;
            }
            return obj;
        },
        // Support: Android <=4.0 only
        trim: function trim(text) {
            return text == null ? "" : (text + "").replace(rtrim, "");
        },
        // results is for internal usage only
        makeArray: function makeArray(arr, results) {
            var ret = results || [];
            if (arr != null) {
                if (isArrayLike(Object(arr))) jQuery.merge(ret, typeof arr === "string" ? [
                    arr
                ] : arr);
                else push.call(ret, arr);
            }
            return ret;
        },
        inArray: function inArray(elem, arr, i) {
            return arr == null ? -1 : indexOf.call(arr, elem, i);
        },
        // Support: Android <=4.0 only, PhantomJS 1 only
        // push.apply(_, arraylike) throws on ancient WebKit
        merge: function merge(first, second) {
            var len = +second.length, j = 0, i = first.length;
            for(; j < len; j++)first[i++] = second[j];
            first.length = i;
            return first;
        },
        grep: function grep(elems, callback, invert) {
            var callbackInverse, matches = [], i = 0, length = elems.length, callbackExpect = !invert;
            // Go through the array, only saving the items
            // that pass the validator function
            for(; i < length; i++){
                callbackInverse = !callback(elems[i], i);
                if (callbackInverse !== callbackExpect) matches.push(elems[i]);
            }
            return matches;
        },
        // arg is for internal usage only
        map: function map(elems, callback, arg) {
            var length, value, i = 0, ret = [];
            // Go through the array, translating each of the items to their new values
            if (isArrayLike(elems)) {
                length = elems.length;
                for(; i < length; i++){
                    value = callback(elems[i], i, arg);
                    if (value != null) ret.push(value);
                }
            // Go through every key on the object,
            } else for(i in elems){
                value = callback(elems[i], i, arg);
                if (value != null) ret.push(value);
            }
            // Flatten any nested arrays
            return concat.apply([], ret);
        },
        // A global GUID counter for objects
        guid: 1,
        // Bind a function to a context, optionally partially applying any
        // arguments.
        proxy: function proxy(fn, context) {
            var tmp, args, proxy;
            if (typeof context === "string") {
                tmp = fn[context];
                context = fn;
                fn = tmp;
            }
            // Quick check to determine if target is callable, in the spec
            // this throws a TypeError, but we will just return undefined.
            if (!jQuery.isFunction(fn)) return undefined;
            // Simulated bind
            args = slice.call(arguments, 2);
            proxy = function proxy() {
                return fn.apply(context || this, args.concat(slice.call(arguments)));
            };
            // Set the guid of unique handler to the same of original handler, so it can be removed
            proxy.guid = fn.guid = fn.guid || jQuery.guid++;
            return proxy;
        },
        now: Date.now,
        // jQuery.support is not used in Core but other projects attach their
        // properties to it so it needs to exist.
        support: support
    });
    if (typeof Symbol === "function") jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
    // Populate the class2type map
    jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function(i, name) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    function isArrayLike(obj) {
        // Support: real iOS 8.2 only (not reproducible in simulator)
        // `in` check used to prevent JIT error (gh-2145)
        // hasOwn isn't used here due to false negatives
        // regarding Nodelist length in IE
        var length = !!obj && "length" in obj && obj.length, type = jQuery.type(obj);
        if (type === "function" || jQuery.isWindow(obj)) return false;
        return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
    }
    var Sizzle = /*!
 * Sizzle CSS Selector Engine v2.3.3
 * https://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-08-08
 */ function(window1) {
        var i, support, Expr, getText, isXML, tokenize, compile, select, outermostContext, sortInput, hasDuplicate, // Local document vars
        setDocument, document, docElem, documentIsHTML, rbuggyQSA, rbuggyMatches, matches, contains, // Instance-specific data
        expando = "sizzle" + 1 * new Date(), preferredDoc = window1.document, dirruns = 0, done = 0, classCache = createCache(), tokenCache = createCache(), compilerCache = createCache(), sortOrder = function sortOrder(a, b) {
            if (a === b) hasDuplicate = true;
            return 0;
        }, // Instance methods
        hasOwn = {}.hasOwnProperty, arr = [], pop = arr.pop, push_native = arr.push, push = arr.push, slice = arr.slice, // Use a stripped-down indexOf as it's faster than native
        // https://jsperf.com/thor-indexof-vs-for/5
        indexOf = function indexOf(list, elem) {
            var i = 0, len = list.length;
            for(; i < len; i++){
                if (list[i] === elem) return i;
            }
            return -1;
        }, booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped", // Regular expressions
        // http://www.w3.org/TR/css3-selectors/#whitespace
        whitespace = "[\\x20\\t\\r\\n\\f]", // http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
        identifier = "(?:\\\\.|[\\w-]|[^\0-\\xa0])+", // Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
        attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace + // Operator (capture 2)
        "*([*^$|!~]?=)" + whitespace + // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]", pseudos = ":(" + identifier + ")(?:\\((" + // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
        // 1. quoted (capture 3; capture 4 or capture 5)
        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" + // 2. simple (capture 6)
        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" + // 3. anything else (capture 2)
        ".*" + ")\\)|)", // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
        rwhitespace = new RegExp(whitespace + "+", "g"), rtrim = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g"), rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"), rcombinators = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"), rattributeQuotes = new RegExp("=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g"), rpseudo = new RegExp(pseudos), ridentifier = new RegExp("^" + identifier + "$"), matchExpr = {
            "ID": new RegExp("^#(" + identifier + ")"),
            "CLASS": new RegExp("^\\.(" + identifier + ")"),
            "TAG": new RegExp("^(" + identifier + "|[*])"),
            "ATTR": new RegExp("^" + attributes),
            "PSEUDO": new RegExp("^" + pseudos),
            "CHILD": new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
            "bool": new RegExp("^(?:" + booleans + ")$", "i"),
            // For use in libraries implementing .is()
            // We use this for POS matching in `select`
            "needsContext": new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
        }, rinputs = /^(?:input|select|textarea|button)$/i, rheader = /^h\d$/i, rnative = /^[^{]+\{\s*\[native \w/, // Easily-parseable/retrievable ID or TAG or CLASS selectors
        rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/, rsibling = /[+~]/, // CSS escapes
        // http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
        runescape = new RegExp("\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig"), funescape = function funescape(_, escaped, escapedWhitespace) {
            var high = "0x" + escaped - 0x10000;
            // NaN means non-codepoint
            // Support: Firefox<24
            // Workaround erroneous numeric interpretation of +"0x"
            return high !== high || escapedWhitespace ? escaped : high < 0 ? // BMP codepoint
            String.fromCharCode(high + 0x10000) : // Supplemental Plane codepoint (surrogate pair)
            String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
        }, // CSS string/identifier serialization
        // https://drafts.csswg.org/cssom/#common-serializing-idioms
        rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g, fcssescape = function fcssescape(ch, asCodePoint) {
            if (asCodePoint) {
                // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
                if (ch === "\0") return "\uFFFD";
                // Control characters and (dependent upon position) numbers get escaped as code points
                return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
            }
            // Other potentially-special ASCII characters get backslash-escaped
            return "\\" + ch;
        }, // Used for iframes
        // See setDocument()
        // Removing the function wrapper causes a "Permission Denied"
        // error in IE
        unloadHandler = function unloadHandler() {
            setDocument();
        }, disabledAncestor = addCombinator(function(elem) {
            return elem.disabled === true && ("form" in elem || "label" in elem);
        }, {
            dir: "parentNode",
            next: "legend"
        });
        // Optimize for push.apply( _, NodeList )
        try {
            push.apply(arr = slice.call(preferredDoc.childNodes), preferredDoc.childNodes);
            // Support: Android<4.0
            // Detect silently failing push.apply
            arr[preferredDoc.childNodes.length].nodeType;
        } catch (e) {
            push = {
                apply: arr.length ? // Leverage slice if possible
                function(target, els) {
                    push_native.apply(target, slice.call(els));
                } : // Support: IE<9
                // Otherwise append directly
                function(target, els) {
                    var j = target.length, i = 0;
                    // Can't trust NodeList.length
                    while(target[j++] = els[i++]);
                    target.length = j - 1;
                }
            };
        }
        function Sizzle(selector, context, results, seed) {
            var m, i, elem, nid, match, groups, newSelector, newContext = context && context.ownerDocument, // nodeType defaults to 9, since context defaults to document
            nodeType = context ? context.nodeType : 9;
            results = results || [];
            // Return early from calls with invalid selector or context
            if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) return results;
            // Try to shortcut find operations (as opposed to filters) in HTML documents
            if (!seed) {
                if ((context ? context.ownerDocument || context : preferredDoc) !== document) setDocument(context);
                context = context || document;
                if (documentIsHTML) {
                    // If the selector is sufficiently simple, try using a "get*By*" DOM method
                    // (excepting DocumentFragment context, where the methods don't exist)
                    if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
                        // ID selector
                        if (m = match[1]) {
                            // Document context
                            if (nodeType === 9) {
                                if (elem = context.getElementById(m)) // Support: IE, Opera, Webkit
                                // TODO: identify versions
                                // getElementById can match elements by name instead of ID
                                {
                                    if (elem.id === m) {
                                        results.push(elem);
                                        return results;
                                    }
                                } else return results;
                            // Element context
                            } else // Support: IE, Opera, Webkit
                            // TODO: identify versions
                            // getElementById can match elements by name instead of ID
                            if (newContext && (elem = newContext.getElementById(m)) && contains(context, elem) && elem.id === m) {
                                results.push(elem);
                                return results;
                            }
                        // Type selector
                        } else if (match[2]) {
                            push.apply(results, context.getElementsByTagName(selector));
                            return results;
                        // Class selector
                        } else if ((m = match[3]) && support.getElementsByClassName && context.getElementsByClassName) {
                            push.apply(results, context.getElementsByClassName(m));
                            return results;
                        }
                    }
                    // Take advantage of querySelectorAll
                    if (support.qsa && !compilerCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
                        if (nodeType !== 1) {
                            newContext = context;
                            newSelector = selector;
                        // qSA looks outside Element context, which is not what we want
                        // Thanks to Andrew Dupont for this workaround technique
                        // Support: IE <=8
                        // Exclude object elements
                        } else if (context.nodeName.toLowerCase() !== "object") {
                            // Capture the context ID, setting it first if necessary
                            if (nid = context.getAttribute("id")) nid = nid.replace(rcssescape, fcssescape);
                            else context.setAttribute("id", nid = expando);
                            // Prefix every selector in the list
                            groups = tokenize(selector);
                            i = groups.length;
                            while(i--)groups[i] = "#" + nid + " " + toSelector(groups[i]);
                            newSelector = groups.join(",");
                            // Expand context for sibling selectors
                            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
                        }
                        if (newSelector) try {
                            push.apply(results, newContext.querySelectorAll(newSelector));
                            return results;
                        } catch (qsaError) {} finally{
                            if (nid === expando) context.removeAttribute("id");
                        }
                    }
                }
            }
            // All others
            return select(selector.replace(rtrim, "$1"), context, results, seed);
        }
        /**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */ function createCache() {
            var keys = [];
            function cache(key, value) {
                // Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
                if (keys.push(key + " ") > Expr.cacheLength) // Only keep the most recent entries
                delete cache[keys.shift()];
                return cache[key + " "] = value;
            }
            return cache;
        }
        /**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */ function markFunction(fn) {
            fn[expando] = true;
            return fn;
        }
        /**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */ function assert(fn) {
            var el = document.createElement("fieldset");
            try {
                return !!fn(el);
            } catch (e) {
                return false;
            } finally{
                // Remove from its parent by default
                if (el.parentNode) el.parentNode.removeChild(el);
                // release memory in IE
                el = null;
            }
        }
        /**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */ function addHandle(attrs, handler) {
            var arr = attrs.split("|"), i = arr.length;
            while(i--)Expr.attrHandle[arr[i]] = handler;
        }
        /**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */ function siblingCheck(a, b) {
            var cur = b && a, diff = cur && a.nodeType === 1 && b.nodeType === 1 && a.sourceIndex - b.sourceIndex;
            // Use IE sourceIndex if available on both nodes
            if (diff) return diff;
            // Check if b follows a
            if (cur) while(cur = cur.nextSibling){
                if (cur === b) return -1;
            }
            return a ? 1 : -1;
        }
        /**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */ function createInputPseudo(type) {
            return function(elem) {
                var name = elem.nodeName.toLowerCase();
                return name === "input" && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */ function createButtonPseudo(type) {
            return function(elem) {
                var name = elem.nodeName.toLowerCase();
                return (name === "input" || name === "button") && elem.type === type;
            };
        }
        /**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */ function createDisabledPseudo(disabled) {
            // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
            return function(elem) {
                // Only certain elements can match :enabled or :disabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
                // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
                if ("form" in elem) {
                    // Check for inherited disabledness on relevant non-disabled elements:
                    // * listed form-associated elements in a disabled fieldset
                    //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
                    // * option elements in a disabled optgroup
                    //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
                    // All such elements have a "form" property.
                    if (elem.parentNode && elem.disabled === false) {
                        // Option elements defer to a parent optgroup if present
                        if ("label" in elem) {
                            if ("label" in elem.parentNode) return elem.parentNode.disabled === disabled;
                            else return elem.disabled === disabled;
                        }
                        // Support: IE 6 - 11
                        // Use the isDisabled shortcut property to check for disabled fieldset ancestors
                        return elem.isDisabled === disabled || // Where there is no isDisabled, check manually
                        /* jshint -W018 */ elem.isDisabled !== !disabled && disabledAncestor(elem) === disabled;
                    }
                    return elem.disabled === disabled;
                // Try to winnow out elements that can't be disabled before trusting the disabled property.
                // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
                // even exist on them, let alone have a boolean value.
                } else if ("label" in elem) return elem.disabled === disabled;
                // Remaining elements are neither :enabled nor :disabled
                return false;
            };
        }
        /**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */ function createPositionalPseudo(fn) {
            return markFunction(function(argument) {
                argument = +argument;
                return markFunction(function(seed, matches) {
                    var j, matchIndexes = fn([], seed.length, argument), i = matchIndexes.length;
                    // Match elements found at the specified indexes
                    while(i--)if (seed[j = matchIndexes[i]]) seed[j] = !(matches[j] = seed[j]);
                });
            });
        }
        /**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */ function testContext(context) {
            return context && typeof context.getElementsByTagName !== "undefined" && context;
        }
        // Expose support vars for convenience
        support = Sizzle.support = {};
        /**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */ isXML = Sizzle.isXML = function isXML(elem) {
            // documentElement is verified for cases where it doesn't yet exist
            // (such as loading iframes in IE - #4833)
            var documentElement = elem && (elem.ownerDocument || elem).documentElement;
            return documentElement ? documentElement.nodeName !== "HTML" : false;
        };
        /**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */ setDocument = Sizzle.setDocument = function setDocument(node) {
            var hasCompare, subWindow, doc = node ? node.ownerDocument || node : preferredDoc;
            // Return early if doc is invalid or already selected
            if (doc === document || doc.nodeType !== 9 || !doc.documentElement) return document;
            // Update global variables
            document = doc;
            docElem = document.documentElement;
            documentIsHTML = !isXML(document);
            // Support: IE 9-11, Edge
            // Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
            if (preferredDoc !== document && (subWindow = document.defaultView) && subWindow.top !== subWindow) {
                // Support: IE 11, Edge
                if (subWindow.addEventListener) subWindow.addEventListener("unload", unloadHandler, false);
                else if (subWindow.attachEvent) subWindow.attachEvent("onunload", unloadHandler);
            }
            /* Attributes
	---------------------------------------------------------------------- */ // Support: IE<8
            // Verify that getAttribute really returns attributes and not properties
            // (excepting IE8 booleans)
            support.attributes = assert(function(el) {
                el.className = "i";
                return !el.getAttribute("className");
            });
            /* getElement(s)By*
	---------------------------------------------------------------------- */ // Check if getElementsByTagName("*") returns only elements
            support.getElementsByTagName = assert(function(el) {
                el.appendChild(document.createComment(""));
                return !el.getElementsByTagName("*").length;
            });
            // Support: IE<9
            support.getElementsByClassName = rnative.test(document.getElementsByClassName);
            // Support: IE<10
            // Check if getElementById returns elements by name
            // The broken getElementById methods don't pick up programmatically-set names,
            // so use a roundabout getElementsByName test
            support.getById = assert(function(el) {
                docElem.appendChild(el).id = expando;
                return !document.getElementsByName || !document.getElementsByName(expando).length;
            });
            // ID filter and find
            if (support.getById) {
                Expr.filter["ID"] = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        return elem.getAttribute("id") === attrId;
                    };
                };
                Expr.find["ID"] = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var elem = context.getElementById(id);
                        return elem ? [
                            elem
                        ] : [];
                    }
                };
            } else {
                Expr.filter["ID"] = function(id) {
                    var attrId = id.replace(runescape, funescape);
                    return function(elem) {
                        var _$node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
                        return _$node && _$node.value === attrId;
                    };
                };
                // Support: IE 6 - 7 only
                // getElementById is not reliable as a find shortcut
                Expr.find["ID"] = function(id, context) {
                    if (typeof context.getElementById !== "undefined" && documentIsHTML) {
                        var _$node, i, elems, elem = context.getElementById(id);
                        if (elem) {
                            // Verify the id attribute
                            _$node = elem.getAttributeNode("id");
                            if (_$node && _$node.value === id) return [
                                elem
                            ];
                            // Fall back on getElementsByName
                            elems = context.getElementsByName(id);
                            i = 0;
                            while(elem = elems[i++]){
                                _$node = elem.getAttributeNode("id");
                                if (_$node && _$node.value === id) return [
                                    elem
                                ];
                            }
                        }
                        return [];
                    }
                };
            }
            // Tag
            Expr.find["TAG"] = support.getElementsByTagName ? function(tag, context) {
                if (typeof context.getElementsByTagName !== "undefined") return context.getElementsByTagName(tag);
                else if (support.qsa) return context.querySelectorAll(tag);
            } : function(tag, context) {
                var elem, tmp = [], i = 0, // By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
                results = context.getElementsByTagName(tag);
                // Filter out possible comments
                if (tag === "*") {
                    while(elem = results[i++])if (elem.nodeType === 1) tmp.push(elem);
                    return tmp;
                }
                return results;
            };
            // Class
            Expr.find["CLASS"] = support.getElementsByClassName && function(className, context) {
                if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) return context.getElementsByClassName(className);
            };
            /* QSA/matchesSelector
	---------------------------------------------------------------------- */ // QSA and matchesSelector support
            // matchesSelector(:active) reports false when true (IE9/Opera 11.5)
            rbuggyMatches = [];
            // qSa(:focus) reports false when true (Chrome 21)
            // We allow this because of a bug in IE8/9 that throws an error
            // whenever `document.activeElement` is accessed on an iframe
            // So, we allow :focus to pass through QSA all the time to avoid the IE error
            // See https://bugs.jquery.com/ticket/13378
            rbuggyQSA = [];
            if (support.qsa = rnative.test(document.querySelectorAll)) {
                // Build QSA regex
                // Regex strategy adopted from Diego Perini
                assert(function(el) {
                    // Select is set to empty string on purpose
                    // This is to test IE's treatment of not explicitly
                    // setting a boolean content attribute,
                    // since its presence should be enough
                    // https://bugs.jquery.com/ticket/12359
                    docElem.appendChild(el).innerHTML = "<a id='" + expando + "'></a>" + "<select id='" + expando + "-\r\\' msallowcapture=''>" + "<option selected=''></option></select>";
                    // Support: IE8, Opera 11-12.16
                    // Nothing should be selected when empty strings follow ^= or $= or *=
                    // The test attribute must be unknown in Opera but "safe" for WinRT
                    // https://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
                    if (el.querySelectorAll("[msallowcapture^='']").length) rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")");
                    // Support: IE8
                    // Boolean attributes and "value" are not treated correctly
                    if (!el.querySelectorAll("[selected]").length) rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
                    // Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
                    if (!el.querySelectorAll("[id~=" + expando + "-]").length) rbuggyQSA.push("~=");
                    // Webkit/Opera - :checked should return selected option elements
                    // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    // IE8 throws error here and will not see later tests
                    if (!el.querySelectorAll(":checked").length) rbuggyQSA.push(":checked");
                    // Support: Safari 8+, iOS 8+
                    // https://bugs.webkit.org/show_bug.cgi?id=136851
                    // In-page `selector#id sibling-combinator selector` fails
                    if (!el.querySelectorAll("a#" + expando + "+*").length) rbuggyQSA.push(".#.+[+~]");
                });
                assert(function(el) {
                    el.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                    // Support: Windows 8 Native Apps
                    // The type and name attributes are restricted during .innerHTML assignment
                    var input = document.createElement("input");
                    input.setAttribute("type", "hidden");
                    el.appendChild(input).setAttribute("name", "D");
                    // Support: IE8
                    // Enforce case-sensitivity of name attribute
                    if (el.querySelectorAll("[name=d]").length) rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?=");
                    // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
                    // IE8 throws error here and will not see later tests
                    if (el.querySelectorAll(":enabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                    // Support: IE9-11+
                    // IE's :disabled selector does not pick up the children of disabled fieldsets
                    docElem.appendChild(el).disabled = true;
                    if (el.querySelectorAll(":disabled").length !== 2) rbuggyQSA.push(":enabled", ":disabled");
                    // Opera 10-11 does not throw on post-comma invalid pseudos
                    el.querySelectorAll("*,:x");
                    rbuggyQSA.push(",.*:");
                });
            }
            if (support.matchesSelector = rnative.test(matches = docElem.matches || docElem.webkitMatchesSelector || docElem.mozMatchesSelector || docElem.oMatchesSelector || docElem.msMatchesSelector)) assert(function(el) {
                // Check to see if it's possible to do matchesSelector
                // on a disconnected node (IE 9)
                support.disconnectedMatch = matches.call(el, "*");
                // This should fail with an exception
                // Gecko does not error, returns false instead
                matches.call(el, "[s!='']:x");
                rbuggyMatches.push("!=", pseudos);
            });
            rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
            rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"));
            /* Contains
	---------------------------------------------------------------------- */ hasCompare = rnative.test(docElem.compareDocumentPosition);
            // Element contains another
            // Purposefully self-exclusive
            // As in, an element does not contain itself
            contains = hasCompare || rnative.test(docElem.contains) ? function contains(a, b) {
                var adown = a.nodeType === 9 ? a.documentElement : a, bup = b && b.parentNode;
                return a === bup || !!(bup && bup.nodeType === 1 && (adown.contains ? adown.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
            } : function(a, b) {
                if (b) while(b = b.parentNode){
                    if (b === a) return true;
                }
                return false;
            };
            /* Sorting
	---------------------------------------------------------------------- */ // Document order sorting
            sortOrder = hasCompare ? function sortOrder(a, b) {
                // Flag for duplicate removal
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                // Sort on method existence if only one input has compareDocumentPosition
                var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
                if (compare) return compare;
                // Calculate position if both inputs belong to the same document
                compare = (a.ownerDocument || a) === (b.ownerDocument || b) ? a.compareDocumentPosition(b) : // Otherwise we know they are disconnected
                1;
                // Disconnected nodes
                if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
                    // Choose the first element that is related to our preferred document
                    if (a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a)) return -1;
                    if (b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b)) return 1;
                    // Maintain original order
                    return sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
                }
                return compare & 4 ? -1 : 1;
            } : function(a, b) {
                // Exit early if the nodes are identical
                if (a === b) {
                    hasDuplicate = true;
                    return 0;
                }
                var cur, i = 0, aup = a.parentNode, bup = b.parentNode, ap = [
                    a
                ], bp = [
                    b
                ];
                // Parentless nodes are either documents or disconnected
                if (!aup || !bup) return a === document ? -1 : b === document ? 1 : aup ? -1 : bup ? 1 : sortInput ? indexOf(sortInput, a) - indexOf(sortInput, b) : 0;
                else if (aup === bup) return siblingCheck(a, b);
                // Otherwise we need full lists of their ancestors for comparison
                cur = a;
                while(cur = cur.parentNode)ap.unshift(cur);
                cur = b;
                while(cur = cur.parentNode)bp.unshift(cur);
                // Walk down the tree looking for a discrepancy
                while(ap[i] === bp[i])i++;
                return i ? // Do a sibling check if the nodes have a common ancestor
                siblingCheck(ap[i], bp[i]) : // Otherwise nodes in our document sort first
                ap[i] === preferredDoc ? -1 : bp[i] === preferredDoc ? 1 : 0;
            };
            return document;
        };
        Sizzle.matches = function(expr, elements) {
            return Sizzle(expr, null, null, elements);
        };
        Sizzle.matchesSelector = function(elem, expr) {
            // Set document vars if needed
            if ((elem.ownerDocument || elem) !== document) setDocument(elem);
            // Make sure that attribute selectors are quoted
            expr = expr.replace(rattributeQuotes, "='$1']");
            if (support.matchesSelector && documentIsHTML && !compilerCache[expr + " "] && (!rbuggyMatches || !rbuggyMatches.test(expr)) && (!rbuggyQSA || !rbuggyQSA.test(expr))) try {
                var ret = matches.call(elem, expr);
                // IE 9's matchesSelector returns false on disconnected nodes
                if (ret || support.disconnectedMatch || // As well, disconnected nodes are said to be in a document
                // fragment in IE 9
                elem.document && elem.document.nodeType !== 11) return ret;
            } catch (e) {}
            return Sizzle(expr, document, null, [
                elem
            ]).length > 0;
        };
        Sizzle.contains = function(context, elem) {
            // Set document vars if needed
            if ((context.ownerDocument || context) !== document) setDocument(context);
            return contains(context, elem);
        };
        Sizzle.attr = function(elem, name) {
            // Set document vars if needed
            if ((elem.ownerDocument || elem) !== document) setDocument(elem);
            var fn = Expr.attrHandle[name.toLowerCase()], // Don't get fooled by Object.prototype properties (jQuery #13807)
            val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
            return val !== undefined ? val : support.attributes || !documentIsHTML ? elem.getAttribute(name) : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
        };
        Sizzle.escape = function(sel) {
            return (sel + "").replace(rcssescape, fcssescape);
        };
        Sizzle.error = function(msg) {
            throw new Error("Syntax error, unrecognized expression: " + msg);
        };
        /**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */ Sizzle.uniqueSort = function(results) {
            var elem, duplicates = [], j = 0, i = 0;
            // Unless we *know* we can detect duplicates, assume their presence
            hasDuplicate = !support.detectDuplicates;
            sortInput = !support.sortStable && results.slice(0);
            results.sort(sortOrder);
            if (hasDuplicate) {
                while(elem = results[i++])if (elem === results[i]) j = duplicates.push(i);
                while(j--)results.splice(duplicates[j], 1);
            }
            // Clear input after sorting to release objects
            // See https://github.com/jquery/sizzle/pull/225
            sortInput = null;
            return results;
        };
        /**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */ getText = Sizzle.getText = function(elem) {
            var node, ret = "", i = 0, nodeType = elem.nodeType;
            if (!nodeType) // If no nodeType, this is expected to be an array
            while(node = elem[i++])// Do not traverse comment nodes
            ret += getText(node);
            else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
                // Use textContent for elements
                // innerText usage removed for consistency of new lines (jQuery #11153)
                if (typeof elem.textContent === "string") return elem.textContent;
                else // Traverse its children
                for(elem = elem.firstChild; elem; elem = elem.nextSibling)ret += getText(elem);
            } else if (nodeType === 3 || nodeType === 4) return elem.nodeValue;
            // Do not include comment or processing instruction nodes
            return ret;
        };
        Expr = Sizzle.selectors = {
            // Can be adjusted by the user
            cacheLength: 50,
            createPseudo: markFunction,
            match: matchExpr,
            attrHandle: {},
            find: {},
            relative: {
                ">": {
                    dir: "parentNode",
                    first: true
                },
                " ": {
                    dir: "parentNode"
                },
                "+": {
                    dir: "previousSibling",
                    first: true
                },
                "~": {
                    dir: "previousSibling"
                }
            },
            preFilter: {
                "ATTR": function(match) {
                    match[1] = match[1].replace(runescape, funescape);
                    // Move the given value to match[3] whether quoted or unquoted
                    match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
                    if (match[2] === "~=") match[3] = " " + match[3] + " ";
                    return match.slice(0, 4);
                },
                "CHILD": function(match) {
                    /* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/ match[1] = match[1].toLowerCase();
                    if (match[1].slice(0, 3) === "nth") {
                        // nth-* requires argument
                        if (!match[3]) Sizzle.error(match[0]);
                        // numeric x and y parameters for Expr.filter.CHILD
                        // remember that false/true cast respectively to 0/1
                        match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
                        match[5] = +(match[7] + match[8] || match[3] === "odd");
                    // other types prohibit arguments
                    } else if (match[3]) Sizzle.error(match[0]);
                    return match;
                },
                "PSEUDO": function(match) {
                    var excess, unquoted = !match[6] && match[2];
                    if (matchExpr["CHILD"].test(match[0])) return null;
                    // Accept quoted arguments as-is
                    if (match[3]) match[2] = match[4] || match[5] || "";
                    else if (unquoted && rpseudo.test(unquoted) && // Get excess from tokenize (recursively)
                    (excess = tokenize(unquoted, true)) && // advance to the next closing parenthesis
                    (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
                        // excess is a negative index
                        match[0] = match[0].slice(0, excess);
                        match[2] = unquoted.slice(0, excess);
                    }
                    // Return only captures needed by the pseudo filter method (type and argument)
                    return match.slice(0, 3);
                }
            },
            filter: {
                "TAG": function(nodeNameSelector) {
                    var _$nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
                    return nodeNameSelector === "*" ? function() {
                        return true;
                    } : function(elem) {
                        return elem.nodeName && elem.nodeName.toLowerCase() === _$nodeName;
                    };
                },
                "CLASS": function(className) {
                    var pattern = classCache[className + " "];
                    return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)"), classCache(className, function(elem) {
                        return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
                    }));
                },
                "ATTR": function(name, operator, check) {
                    return function(elem) {
                        var result = Sizzle.attr(elem, name);
                        if (result == null) return operator === "!=";
                        if (!operator) return true;
                        result += "";
                        return operator === "=" ? result === check : operator === "!=" ? result !== check : operator === "^=" ? check && result.indexOf(check) === 0 : operator === "*=" ? check && result.indexOf(check) > -1 : operator === "$=" ? check && result.slice(-check.length) === check : operator === "~=" ? (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1 : operator === "|=" ? result === check || result.slice(0, check.length + 1) === check + "-" : false;
                    };
                },
                "CHILD": function(type, what, argument, first, last) {
                    var simple = type.slice(0, 3) !== "nth", forward = type.slice(-4) !== "last", ofType = what === "of-type";
                    return first === 1 && last === 0 ? // Shortcut for :nth-*(n)
                    function(elem) {
                        return !!elem.parentNode;
                    } : function(elem, context, xml) {
                        var cache, uniqueCache, outerCache, node, nodeIndex, start, dir = simple !== forward ? "nextSibling" : "previousSibling", parent = elem.parentNode, name = ofType && elem.nodeName.toLowerCase(), useCache = !xml && !ofType, diff = false;
                        if (parent) {
                            // :(first|last|only)-(child|of-type)
                            if (simple) {
                                while(dir){
                                    node = elem;
                                    while(node = node[dir]){
                                        if (ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) return false;
                                    }
                                    // Reverse direction for :only-* (if we haven't yet done so)
                                    start = dir = type === "only" && !start && "nextSibling";
                                }
                                return true;
                            }
                            start = [
                                forward ? parent.firstChild : parent.lastChild
                            ];
                            // non-xml :nth-child(...) stores cache data on `parent`
                            if (forward && useCache) {
                                // Seek `elem` from a previously-cached index
                                // ...in a gzip-friendly way
                                node = parent;
                                outerCache = node[expando] || (node[expando] = {});
                                // Support: IE <9 only
                                // Defend against cloned attroperties (jQuery gh-1709)
                                uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                cache = uniqueCache[type] || [];
                                nodeIndex = cache[0] === dirruns && cache[1];
                                diff = nodeIndex && cache[2];
                                node = nodeIndex && parent.childNodes[nodeIndex];
                                while(node = ++nodeIndex && node && node[dir] || // Fallback to seeking `elem` from the start
                                (diff = nodeIndex = 0) || start.pop())// When found, cache indexes on `parent` and break
                                if (node.nodeType === 1 && ++diff && node === elem) {
                                    uniqueCache[type] = [
                                        dirruns,
                                        nodeIndex,
                                        diff
                                    ];
                                    break;
                                }
                            } else {
                                // Use previously-cached element index if available
                                if (useCache) {
                                    // ...in a gzip-friendly way
                                    node = elem;
                                    outerCache = node[expando] || (node[expando] = {});
                                    // Support: IE <9 only
                                    // Defend against cloned attroperties (jQuery gh-1709)
                                    uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                    cache = uniqueCache[type] || [];
                                    nodeIndex = cache[0] === dirruns && cache[1];
                                    diff = nodeIndex;
                                }
                                // xml :nth-child(...)
                                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                                if (diff === false) {
                                    // Use the same loop as above to seek `elem` from the start
                                    while(node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop())if ((ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) && ++diff) {
                                        // Cache the index of each encountered element
                                        if (useCache) {
                                            outerCache = node[expando] || (node[expando] = {});
                                            // Support: IE <9 only
                                            // Defend against cloned attroperties (jQuery gh-1709)
                                            uniqueCache = outerCache[node.uniqueID] || (outerCache[node.uniqueID] = {});
                                            uniqueCache[type] = [
                                                dirruns,
                                                diff
                                            ];
                                        }
                                        if (node === elem) break;
                                    }
                                }
                            }
                            // Incorporate the offset, then check against cycle size
                            diff -= last;
                            return diff === first || diff % first === 0 && diff / first >= 0;
                        }
                    };
                },
                "PSEUDO": function(pseudo, argument) {
                    // pseudo-class names are case-insensitive
                    // http://www.w3.org/TR/selectors/#pseudo-classes
                    // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
                    // Remember that setFilters inherits from pseudos
                    var args, fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || Sizzle.error("unsupported pseudo: " + pseudo);
                    // The user may use createPseudo to indicate that
                    // arguments are needed to create the filter function
                    // just as Sizzle does
                    if (fn[expando]) return fn(argument);
                    // But maintain support for old signatures
                    if (fn.length > 1) {
                        args = [
                            pseudo,
                            pseudo,
                            "",
                            argument
                        ];
                        return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function(seed, matches) {
                            var idx, matched = fn(seed, argument), i = matched.length;
                            while(i--){
                                idx = indexOf(seed, matched[i]);
                                seed[idx] = !(matches[idx] = matched[i]);
                            }
                        }) : function(elem) {
                            return fn(elem, 0, args);
                        };
                    }
                    return fn;
                }
            },
            pseudos: {
                // Potentially complex pseudos
                "not": markFunction(function(selector) {
                    // Trim the selector passed to compile
                    // to avoid treating leading and trailing
                    // spaces as combinators
                    var input = [], results = [], matcher = compile(selector.replace(rtrim, "$1"));
                    return matcher[expando] ? markFunction(function(seed, matches, context, xml) {
                        var elem, unmatched = matcher(seed, null, xml, []), i = seed.length;
                        // Match elements unmatched by `matcher`
                        while(i--)if (elem = unmatched[i]) seed[i] = !(matches[i] = elem);
                    }) : function(elem, context, xml) {
                        input[0] = elem;
                        matcher(input, null, xml, results);
                        // Don't keep the element (issue #299)
                        input[0] = null;
                        return !results.pop();
                    };
                }),
                "has": markFunction(function(selector) {
                    return function(elem) {
                        return Sizzle(selector, elem).length > 0;
                    };
                }),
                "contains": markFunction(function(text) {
                    text = text.replace(runescape, funescape);
                    return function(elem) {
                        return (elem.textContent || elem.innerText || getText(elem)).indexOf(text) > -1;
                    };
                }),
                // "Whether an element is represented by a :lang() selector
                // is based solely on the element's language value
                // being equal to the identifier C,
                // or beginning with the identifier C immediately followed by "-".
                // The matching of C against the element's language value is performed case-insensitively.
                // The identifier C does not have to be a valid language name."
                // http://www.w3.org/TR/selectors/#lang-pseudo
                "lang": markFunction(function(lang) {
                    // lang value must be a valid identifier
                    if (!ridentifier.test(lang || "")) Sizzle.error("unsupported lang: " + lang);
                    lang = lang.replace(runescape, funescape).toLowerCase();
                    return function(elem) {
                        var elemLang;
                        do if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                            elemLang = elemLang.toLowerCase();
                            return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
                        }
                        while ((elem = elem.parentNode) && elem.nodeType === 1);
                        return false;
                    };
                }),
                // Miscellaneous
                "target": function(elem) {
                    var hash = window1.location && window1.location.hash;
                    return hash && hash.slice(1) === elem.id;
                },
                "root": function(elem) {
                    return elem === docElem;
                },
                "focus": function(elem) {
                    return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
                },
                // Boolean properties
                "enabled": createDisabledPseudo(false),
                "disabled": createDisabledPseudo(true),
                "checked": function(elem) {
                    // In CSS3, :checked should return both checked and selected elements
                    // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
                    var _$nodeName = elem.nodeName.toLowerCase();
                    return _$nodeName === "input" && !!elem.checked || _$nodeName === "option" && !!elem.selected;
                },
                "selected": function(elem) {
                    // Accessing this property makes selected-by-default
                    // options in Safari work properly
                    if (elem.parentNode) elem.parentNode.selectedIndex;
                    return elem.selected === true;
                },
                // Contents
                "empty": function(elem) {
                    // http://www.w3.org/TR/selectors/#empty-pseudo
                    // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
                    //   but not by others (comment: 8; processing instruction: 7; etc.)
                    // nodeType < 6 works because attributes (2) do not appear as children
                    for(elem = elem.firstChild; elem; elem = elem.nextSibling){
                        if (elem.nodeType < 6) return false;
                    }
                    return true;
                },
                "parent": function(elem) {
                    return !Expr.pseudos["empty"](elem);
                },
                // Element/input types
                "header": function(elem) {
                    return rheader.test(elem.nodeName);
                },
                "input": function(elem) {
                    return rinputs.test(elem.nodeName);
                },
                "button": function(elem) {
                    var name = elem.nodeName.toLowerCase();
                    return name === "input" && elem.type === "button" || name === "button";
                },
                "text": function(elem) {
                    var attr;
                    return elem.nodeName.toLowerCase() === "input" && elem.type === "text" && // Support: IE<8
                    // New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
                    ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
                },
                // Position-in-collection
                "first": createPositionalPseudo(function() {
                    return [
                        0
                    ];
                }),
                "last": createPositionalPseudo(function(matchIndexes, length) {
                    return [
                        length - 1
                    ];
                }),
                "eq": createPositionalPseudo(function(matchIndexes, length, argument) {
                    return [
                        argument < 0 ? argument + length : argument
                    ];
                }),
                "even": createPositionalPseudo(function(matchIndexes, length) {
                    var i = 0;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                "odd": createPositionalPseudo(function(matchIndexes, length) {
                    var i = 1;
                    for(; i < length; i += 2)matchIndexes.push(i);
                    return matchIndexes;
                }),
                "lt": createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; --i >= 0;)matchIndexes.push(i);
                    return matchIndexes;
                }),
                "gt": createPositionalPseudo(function(matchIndexes, length, argument) {
                    var i = argument < 0 ? argument + length : argument;
                    for(; ++i < length;)matchIndexes.push(i);
                    return matchIndexes;
                })
            }
        };
        Expr.pseudos["nth"] = Expr.pseudos["eq"];
        // Add button/input type pseudos
        for(i in {
            radio: true,
            checkbox: true,
            file: true,
            password: true,
            image: true
        })Expr.pseudos[i] = createInputPseudo(i);
        for(i in {
            submit: true,
            reset: true
        })Expr.pseudos[i] = createButtonPseudo(i);
        // Easy API for creating new setFilters
        function setFilters() {}
        setFilters.prototype = Expr.filters = Expr.pseudos;
        Expr.setFilters = new setFilters();
        tokenize = Sizzle.tokenize = function tokenize(selector, parseOnly) {
            var matched, match, tokens, type, soFar, groups, preFilters, cached = tokenCache[selector + " "];
            if (cached) return parseOnly ? 0 : cached.slice(0);
            soFar = selector;
            groups = [];
            preFilters = Expr.preFilter;
            while(soFar){
                // Comma and first run
                if (!matched || (match = rcomma.exec(soFar))) {
                    if (match) // Don't consume trailing commas as valid
                    soFar = soFar.slice(match[0].length) || soFar;
                    groups.push(tokens = []);
                }
                matched = false;
                // Combinators
                if (match = rcombinators.exec(soFar)) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        // Cast descendant combinators to space
                        type: match[0].replace(rtrim, " ")
                    });
                    soFar = soFar.slice(matched.length);
                }
                // Filters
                for(type in Expr.filter)if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
                    matched = match.shift();
                    tokens.push({
                        value: matched,
                        type: type,
                        matches: match
                    });
                    soFar = soFar.slice(matched.length);
                }
                if (!matched) break;
            }
            // Return the length of the invalid excess
            // if we're just parsing
            // Otherwise, throw an error or return tokens
            return parseOnly ? soFar.length : soFar ? Sizzle.error(selector) : // Cache the tokens
            tokenCache(selector, groups).slice(0);
        };
        function toSelector(tokens) {
            var i = 0, len = tokens.length, selector = "";
            for(; i < len; i++)selector += tokens[i].value;
            return selector;
        }
        function addCombinator(matcher, combinator, base) {
            var dir = combinator.dir, skip = combinator.next, key = skip || dir, checkNonElements = base && key === "parentNode", doneName = done++;
            return combinator.first ? // Check against closest ancestor/preceding element
            function(elem, context, xml) {
                while(elem = elem[dir]){
                    if (elem.nodeType === 1 || checkNonElements) return matcher(elem, context, xml);
                }
                return false;
            } : // Check against all ancestor/preceding elements
            function(elem, context, xml) {
                var oldCache, uniqueCache, outerCache, newCache = [
                    dirruns,
                    doneName
                ];
                // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
                if (xml) {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        if (matcher(elem, context, xml)) return true;
                    }
                } else {
                    while(elem = elem[dir])if (elem.nodeType === 1 || checkNonElements) {
                        outerCache = elem[expando] || (elem[expando] = {});
                        // Support: IE <9 only
                        // Defend against cloned attroperties (jQuery gh-1709)
                        uniqueCache = outerCache[elem.uniqueID] || (outerCache[elem.uniqueID] = {});
                        if (skip && skip === elem.nodeName.toLowerCase()) elem = elem[dir] || elem;
                        else if ((oldCache = uniqueCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) // Assign to newCache so results back-propagate to previous elements
                        return newCache[2] = oldCache[2];
                        else {
                            // Reuse newcache so results back-propagate to previous elements
                            uniqueCache[key] = newCache;
                            // A match means we're done; a fail means we have to keep checking
                            if (newCache[2] = matcher(elem, context, xml)) return true;
                        }
                    }
                }
                return false;
            };
        }
        function elementMatcher(matchers) {
            return matchers.length > 1 ? function(elem, context, xml) {
                var i = matchers.length;
                while(i--){
                    if (!matchers[i](elem, context, xml)) return false;
                }
                return true;
            } : matchers[0];
        }
        function multipleContexts(selector, contexts, results) {
            var i = 0, len = contexts.length;
            for(; i < len; i++)Sizzle(selector, contexts[i], results);
            return results;
        }
        function condense(unmatched, map, filter, context, xml) {
            var elem, newUnmatched = [], i = 0, len = unmatched.length, mapped = map != null;
            for(; i < len; i++){
                if (elem = unmatched[i]) {
                    if (!filter || filter(elem, context, xml)) {
                        newUnmatched.push(elem);
                        if (mapped) map.push(i);
                    }
                }
            }
            return newUnmatched;
        }
        function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
            if (postFilter && !postFilter[expando]) postFilter = setMatcher(postFilter);
            if (postFinder && !postFinder[expando]) postFinder = setMatcher(postFinder, postSelector);
            return markFunction(function(seed, results, context, xml) {
                var temp, i, elem, preMap = [], postMap = [], preexisting = results.length, // Get initial elements from seed or context
                elems = seed || multipleContexts(selector || "*", context.nodeType ? [
                    context
                ] : context, []), // Prefilter to get matcher input, preserving a map for seed-results synchronization
                matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems, matcherOut = matcher ? // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
                postFinder || (seed ? preFilter : preexisting || postFilter) ? // ...intermediate processing is necessary
                [] : // ...otherwise use results directly
                results : matcherIn;
                // Find primary matches
                if (matcher) matcher(matcherIn, matcherOut, context, xml);
                // Apply postFilter
                if (postFilter) {
                    temp = condense(matcherOut, postMap);
                    postFilter(temp, [], context, xml);
                    // Un-match failing elements by moving them back to matcherIn
                    i = temp.length;
                    while(i--)if (elem = temp[i]) matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
                }
                if (seed) {
                    if (postFinder || preFilter) {
                        if (postFinder) {
                            // Get the final matcherOut by condensing this intermediate into postFinder contexts
                            temp = [];
                            i = matcherOut.length;
                            while(i--)if (elem = matcherOut[i]) // Restore matcherIn since elem is not yet a final match
                            temp.push(matcherIn[i] = elem);
                            postFinder(null, matcherOut = [], temp, xml);
                        }
                        // Move matched elements from seed to results to keep them synchronized
                        i = matcherOut.length;
                        while(i--)if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf(seed, elem) : preMap[i]) > -1) seed[temp] = !(results[temp] = elem);
                    }
                } else {
                    matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
                    if (postFinder) postFinder(null, results, matcherOut, xml);
                    else push.apply(results, matcherOut);
                }
            });
        }
        function matcherFromTokens(tokens) {
            var checkContext, matcher, j, len = tokens.length, leadingRelative = Expr.relative[tokens[0].type], implicitRelative = leadingRelative || Expr.relative[" "], i = leadingRelative ? 1 : 0, // The foundational matcher ensures that elements are reachable from top-level context(s)
            matchContext = addCombinator(function(elem) {
                return elem === checkContext;
            }, implicitRelative, true), matchAnyContext = addCombinator(function(elem) {
                return indexOf(checkContext, elem) > -1;
            }, implicitRelative, true), matchers = [
                function(elem, context, xml) {
                    var ret = !leadingRelative && (xml || context !== outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));
                    // Avoid hanging onto element (issue #299)
                    checkContext = null;
                    return ret;
                }
            ];
            for(; i < len; i++)if (matcher = Expr.relative[tokens[i].type]) matchers = [
                addCombinator(elementMatcher(matchers), matcher)
            ];
            else {
                matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
                // Return special upon seeing a positional matcher
                if (matcher[expando]) {
                    // Find the next relative operator (if any) for proper handling
                    j = ++i;
                    for(; j < len; j++){
                        if (Expr.relative[tokens[j].type]) break;
                    }
                    return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(// If the preceding token was a descendant combinator, insert an implicit any-element `*`
                    tokens.slice(0, i - 1).concat({
                        value: tokens[i - 2].type === " " ? "*" : ""
                    })).replace(rtrim, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
                }
                matchers.push(matcher);
            }
            return elementMatcher(matchers);
        }
        function matcherFromGroupMatchers(elementMatchers, setMatchers) {
            var bySet = setMatchers.length > 0, byElement = elementMatchers.length > 0, superMatcher = function superMatcher(seed, context, xml, results, outermost) {
                var elem, j, matcher, matchedCount = 0, i = "0", unmatched = seed && [], setMatched = [], contextBackup = outermostContext, // We must always have either seed elements or outermost context
                elems = seed || byElement && Expr.find["TAG"]("*", outermost), // Use integer dirruns iff this is the outermost matcher
                dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1, len = elems.length;
                if (outermost) outermostContext = context === document || context || outermost;
                // Add elements passing elementMatchers directly to results
                // Support: IE<9, Safari
                // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
                for(; i !== len && (elem = elems[i]) != null; i++){
                    if (byElement && elem) {
                        j = 0;
                        if (!context && elem.ownerDocument !== document) {
                            setDocument(elem);
                            xml = !documentIsHTML;
                        }
                        while(matcher = elementMatchers[j++])if (matcher(elem, context || document, xml)) {
                            results.push(elem);
                            break;
                        }
                        if (outermost) dirruns = dirrunsUnique;
                    }
                    // Track unmatched elements for set filters
                    if (bySet) {
                        // They will have gone through all possible matchers
                        if (elem = !matcher && elem) matchedCount--;
                        // Lengthen the array for every element, matched or not
                        if (seed) unmatched.push(elem);
                    }
                }
                // `i` is now the count of elements visited above, and adding it to `matchedCount`
                // makes the latter nonnegative.
                matchedCount += i;
                // Apply set filters to unmatched elements
                // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
                // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
                // no element matchers and no seed.
                // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
                // case, which will result in a "00" `matchedCount` that differs from `i` but is also
                // numerically zero.
                if (bySet && i !== matchedCount) {
                    j = 0;
                    while(matcher = setMatchers[j++])matcher(unmatched, setMatched, context, xml);
                    if (seed) {
                        // Reintegrate element matches to eliminate the need for sorting
                        if (matchedCount > 0) {
                            while(i--)if (!(unmatched[i] || setMatched[i])) setMatched[i] = pop.call(results);
                        }
                        // Discard index placeholder values to get only actual matches
                        setMatched = condense(setMatched);
                    }
                    // Add matches to results
                    push.apply(results, setMatched);
                    // Seedless set matches succeeding multiple successful matchers stipulate sorting
                    if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) Sizzle.uniqueSort(results);
                }
                // Override manipulation of globals by nested matchers
                if (outermost) {
                    dirruns = dirrunsUnique;
                    outermostContext = contextBackup;
                }
                return unmatched;
            };
            return bySet ? markFunction(superMatcher) : superMatcher;
        }
        compile = Sizzle.compile = function compile(selector, match /* Internal Use Only */ ) {
            var i, setMatchers = [], elementMatchers = [], cached = compilerCache[selector + " "];
            if (!cached) {
                // Generate a function of recursive functions that can be used to check each element
                if (!match) match = tokenize(selector);
                i = match.length;
                while(i--){
                    cached = matcherFromTokens(match[i]);
                    if (cached[expando]) setMatchers.push(cached);
                    else elementMatchers.push(cached);
                }
                // Cache the compiled function
                cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
                // Save selector and tokenization
                cached.selector = selector;
            }
            return cached;
        };
        /**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */ select = Sizzle.select = function select(selector, context, results, seed) {
            var i, tokens, token, type, find, compiled = typeof selector === "function" && selector, match = !seed && tokenize(selector = compiled.selector || selector);
            results = results || [];
            // Try to minimize operations if there is only one selector in the list and no seed
            // (the latter of which guarantees us context)
            if (match.length === 1) {
                // Reduce context if the leading compound selector is an ID
                tokens = match[0] = match[0].slice(0);
                if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
                    context = (Expr.find["ID"](token.matches[0].replace(runescape, funescape), context) || [])[0];
                    if (!context) return results;
                    else if (compiled) context = context.parentNode;
                    selector = selector.slice(tokens.shift().value.length);
                }
                // Fetch a seed set for right-to-left matching
                i = matchExpr["needsContext"].test(selector) ? 0 : tokens.length;
                while(i--){
                    token = tokens[i];
                    // Abort if we hit a combinator
                    if (Expr.relative[type = token.type]) break;
                    if (find = Expr.find[type]) // Search, expanding context for leading sibling combinators
                    {
                        if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
                            // If seed is empty or no tokens remain, we can return early
                            tokens.splice(i, 1);
                            selector = seed.length && toSelector(tokens);
                            if (!selector) {
                                push.apply(results, seed);
                                return results;
                            }
                            break;
                        }
                    }
                }
            }
            // Compile and execute a filtering function if one is not provided
            // Provide `match` to avoid retokenization if we modified the selector above
            (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
            return results;
        };
        // One-time assignments
        // Sort stability
        support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
        // Support: Chrome 14-35+
        // Always assume duplicates if they aren't passed to the comparison function
        support.detectDuplicates = !!hasDuplicate;
        // Initialize against the default document
        setDocument();
        // Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
        // Detached nodes confoundingly follow *each other*
        support.sortDetached = assert(function(el) {
            // Should return 1, but returns 4 (following)
            return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
        });
        // Support: IE<8
        // Prevent attribute/property "interpolation"
        // https://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
        if (!assert(function(el) {
            el.innerHTML = "<a href='#'></a>";
            return el.firstChild.getAttribute("href") === "#";
        })) addHandle("type|href|height|width", function(elem, name, isXML) {
            if (!isXML) return elem.getAttribute(name, name.toLowerCase() === "type" ? 1 : 2);
        });
        // Support: IE<9
        // Use defaultValue in place of getAttribute("value")
        if (!support.attributes || !assert(function(el) {
            el.innerHTML = "<input/>";
            el.firstChild.setAttribute("value", "");
            return el.firstChild.getAttribute("value") === "";
        })) addHandle("value", function(elem, name, isXML) {
            if (!isXML && elem.nodeName.toLowerCase() === "input") return elem.defaultValue;
        });
        // Support: IE<9
        // Use getAttributeNode to fetch booleans when getAttribute lies
        if (!assert(function(el) {
            return el.getAttribute("disabled") == null;
        })) addHandle(booleans, function(elem, name, isXML) {
            var val;
            if (!isXML) return elem[name] === true ? name.toLowerCase() : (val = elem.getAttributeNode(name)) && val.specified ? val.value : null;
        });
        return Sizzle;
    }(window1);
    jQuery.find = Sizzle;
    jQuery.expr = Sizzle.selectors;
    // Deprecated
    jQuery.expr[":"] = jQuery.expr.pseudos;
    jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
    jQuery.text = Sizzle.getText;
    jQuery.isXMLDoc = Sizzle.isXML;
    jQuery.contains = Sizzle.contains;
    jQuery.escapeSelector = Sizzle.escape;
    var dir = function dir(elem, dir, until) {
        var matched = [], truncate = until !== undefined;
        while((elem = elem[dir]) && elem.nodeType !== 9)if (elem.nodeType === 1) {
            if (truncate && jQuery(elem).is(until)) break;
            matched.push(elem);
        }
        return matched;
    };
    var siblings = function siblings(n, elem) {
        var matched = [];
        for(; n; n = n.nextSibling)if (n.nodeType === 1 && n !== elem) matched.push(n);
        return matched;
    };
    var rneedsContext = jQuery.expr.match.needsContext;
    function nodeName(elem, name) {
        return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
    }
    var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
    var risSimple = /^.[^:#\[\.,]*$/;
    // Implement the identical functionality for filter and not
    function winnow(elements, qualifier, not) {
        if (jQuery.isFunction(qualifier)) return jQuery.grep(elements, function(elem, i) {
            return !!qualifier.call(elem, i, elem) !== not;
        });
        // Single element
        if (qualifier.nodeType) return jQuery.grep(elements, function(elem) {
            return elem === qualifier !== not;
        });
        // Arraylike of elements (jQuery, arguments, Array)
        if (typeof qualifier !== "string") return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not;
        });
        // Simple selector that can be filtered directly, removing non-Elements
        if (risSimple.test(qualifier)) return jQuery.filter(qualifier, elements, not);
        // Complex selector, compare the two sets, removing non-Elements
        qualifier = jQuery.filter(qualifier, elements);
        return jQuery.grep(elements, function(elem) {
            return indexOf.call(qualifier, elem) > -1 !== not && elem.nodeType === 1;
        });
    }
    jQuery.filter = function(expr, elems, not) {
        var elem = elems[0];
        if (not) expr = ":not(" + expr + ")";
        if (elems.length === 1 && elem.nodeType === 1) return jQuery.find.matchesSelector(elem, expr) ? [
            elem
        ] : [];
        return jQuery.find.matches(expr, jQuery.grep(elems, function(elem) {
            return elem.nodeType === 1;
        }));
    };
    jQuery.fn.extend({
        find: function find(selector) {
            var i, ret, len = this.length, self = this;
            if (typeof selector !== "string") return this.pushStack(jQuery(selector).filter(function() {
                for(i = 0; i < len; i++){
                    if (jQuery.contains(self[i], this)) return true;
                }
            }));
            ret = this.pushStack([]);
            for(i = 0; i < len; i++)jQuery.find(selector, self[i], ret);
            return len > 1 ? jQuery.uniqueSort(ret) : ret;
        },
        filter: function filter(selector) {
            return this.pushStack(winnow(this, selector || [], false));
        },
        not: function not(selector) {
            return this.pushStack(winnow(this, selector || [], true));
        },
        is: function is(selector) {
            return !!winnow(this, // If this is a positional/relative selector, check membership in the returned set
            // so $("p:first").is("p:last") won't return true for a doc with two "p".
            typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
        }
    });
    // Initialize a jQuery object
    // A central reference to the root jQuery(document)
    var rootjQuery, // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
    // Strict HTML recognition (#11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/, init = jQuery.fn.init = function init(selector, context, root) {
        var match, elem;
        // HANDLE: $(""), $(null), $(undefined), $(false)
        if (!selector) return this;
        // Method init() accepts an alternate rootjQuery
        // so migrate can support jQuery.sub (gh-2101)
        root = root || rootjQuery;
        // Handle HTML strings
        if (typeof selector === "string") {
            if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) // Assume that strings that start and end with <> are HTML and skip the regex check
            match = [
                null,
                selector,
                null
            ];
            else match = rquickExpr.exec(selector);
            // Match html or make sure no context is specified for #id
            if (match && (match[1] || !context)) {
                // HANDLE: $(html) -> $(array)
                if (match[1]) {
                    context = context instanceof jQuery ? context[0] : context;
                    // Option to run scripts is true for back-compat
                    // Intentionally let the error be thrown if parseHTML is not present
                    jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));
                    // HANDLE: $(html, props)
                    if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
                        for(match in context)// Properties of context are called as methods if possible
                        if (jQuery.isFunction(this[match])) this[match](context[match]);
                        else this.attr(match, context[match]);
                    }
                    return this;
                // HANDLE: $(#id)
                } else {
                    elem = document.getElementById(match[2]);
                    if (elem) {
                        // Inject the element directly into the jQuery object
                        this[0] = elem;
                        this.length = 1;
                    }
                    return this;
                }
            } else if (!context || context.jquery) return (context || root).find(selector);
            else return this.constructor(context).find(selector);
        // HANDLE: $(DOMElement)
        } else if (selector.nodeType) {
            this[0] = selector;
            this.length = 1;
            return this;
        // HANDLE: $(function)
        // Shortcut for document ready
        } else if (jQuery.isFunction(selector)) return root.ready !== undefined ? root.ready(selector) : // Execute immediately if ready is not present
        selector(jQuery);
        return jQuery.makeArray(selector, this);
    };
    // Give the init function the jQuery prototype for later instantiation
    init.prototype = jQuery.fn;
    // Initialize central reference
    rootjQuery = jQuery(document);
    var rparentsprev = /^(?:parents|prev(?:Until|All))/, // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
        children: true,
        contents: true,
        next: true,
        prev: true
    };
    jQuery.fn.extend({
        has: function has(target) {
            var targets = jQuery(target, this), l = targets.length;
            return this.filter(function() {
                var i = 0;
                for(; i < l; i++){
                    if (jQuery.contains(this, targets[i])) return true;
                }
            });
        },
        closest: function closest(selectors, context) {
            var cur, i = 0, l = this.length, matched = [], targets = typeof selectors !== "string" && jQuery(selectors);
            // Positional selectors never match, since there's no _selection_ context
            if (!rneedsContext.test(selectors)) for(; i < l; i++){
                for(cur = this[i]; cur && cur !== context; cur = cur.parentNode)// Always skip document fragments
                if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 : // Don't pass non-elements to Sizzle
                cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
                    matched.push(cur);
                    break;
                }
            }
            return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
        },
        // Determine the position of an element within the set
        index: function index(elem) {
            // No argument, return index in parent
            if (!elem) return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            // Index in selector
            if (typeof elem === "string") return indexOf.call(jQuery(elem), this[0]);
            // Locate the position of the desired element
            return indexOf.call(this, // If it receives a jQuery object, the first element is used
            elem.jquery ? elem[0] : elem);
        },
        add: function add(selector, context) {
            return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
        },
        addBack: function addBack(selector) {
            return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
        }
    });
    function sibling(cur, dir) {
        while((cur = cur[dir]) && cur.nodeType !== 1);
        return cur;
    }
    jQuery.each({
        parent: function parent(elem) {
            var parent = elem.parentNode;
            return parent && parent.nodeType !== 11 ? parent : null;
        },
        parents: function parents(elem) {
            return dir(elem, "parentNode");
        },
        parentsUntil: function parentsUntil(elem, i, until) {
            return dir(elem, "parentNode", until);
        },
        next: function next(elem) {
            return sibling(elem, "nextSibling");
        },
        prev: function prev(elem) {
            return sibling(elem, "previousSibling");
        },
        nextAll: function nextAll(elem) {
            return dir(elem, "nextSibling");
        },
        prevAll: function prevAll(elem) {
            return dir(elem, "previousSibling");
        },
        nextUntil: function nextUntil(elem, i, until) {
            return dir(elem, "nextSibling", until);
        },
        prevUntil: function prevUntil(elem, i, until) {
            return dir(elem, "previousSibling", until);
        },
        siblings: function siblings1(elem) {
            return siblings((elem.parentNode || {}).firstChild, elem);
        },
        children: function children(elem) {
            return siblings(elem.firstChild);
        },
        contents: function contents(elem) {
            if (nodeName(elem, "iframe")) return elem.contentDocument;
            // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
            // Treat the template element as a regular one in browsers that
            // don't support it.
            if (nodeName(elem, "template")) elem = elem.content || elem;
            return jQuery.merge([], elem.childNodes);
        }
    }, function(name, fn) {
        jQuery.fn[name] = function(until, selector) {
            var matched = jQuery.map(this, fn, until);
            if (name.slice(-5) !== "Until") selector = until;
            if (selector && typeof selector === "string") matched = jQuery.filter(selector, matched);
            if (this.length > 1) {
                // Remove duplicates
                if (!guaranteedUnique[name]) jQuery.uniqueSort(matched);
                // Reverse order for parents* and prev-derivatives
                if (rparentsprev.test(name)) matched.reverse();
            }
            return this.pushStack(matched);
        };
    });
    var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;
    // Convert String-formatted options into Object-formatted ones
    function createOptions(options) {
        var object = {};
        jQuery.each(options.match(rnothtmlwhite) || [], function(_, flag) {
            object[flag] = true;
        });
        return object;
    }
    /*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */ jQuery.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
        var firing, // Last fire value for non-forgettable lists
        memory, // Flag to know if list was already fired
        fired, // Flag to prevent firing
        locked, // Actual callback list
        list = [], // Queue of execution data for repeatable lists
        queue = [], // Index of currently firing callback (modified by add/remove as needed)
        firingIndex = -1, // Fire callbacks
        fire = function fire() {
            // Enforce single-firing
            locked = locked || options.once;
            // Execute callbacks for all pending executions,
            // respecting firingIndex overrides and runtime changes
            fired = firing = true;
            for(; queue.length; firingIndex = -1){
                memory = queue.shift();
                while(++firingIndex < list.length)// Run callback and check for early termination
                if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
                    // Jump to end and forget the data so .add doesn't re-fire
                    firingIndex = list.length;
                    memory = false;
                }
            }
            // Forget the data if we're done with it
            if (!options.memory) memory = false;
            firing = false;
            // Clean up if we're done firing for good
            if (locked) {
                // Keep an empty list if we have data for future add calls
                if (memory) list = [];
                else list = "";
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function add() {
                if (list) {
                    // If we have memory from a past run, we should fire after adding
                    if (memory && !firing) {
                        firingIndex = list.length - 1;
                        queue.push(memory);
                    }
                    (function add(args) {
                        jQuery.each(args, function(_, arg) {
                            if (jQuery.isFunction(arg)) {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && jQuery.type(arg) !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    if (memory && !firing) fire();
                }
                return this;
            },
            // Remove a callback from the list
            remove: function remove() {
                jQuery.each(arguments, function(_, arg) {
                    var index;
                    while((index = jQuery.inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (index <= firingIndex) firingIndex--;
                    }
                });
                return this;
            },
            // Check if a given callback is in the list.
            // If no argument is given, return whether or not list has callbacks attached.
            has: function has(fn) {
                return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
            },
            // Remove all callbacks from the list
            empty: function empty() {
                if (list) list = [];
                return this;
            },
            // Disable .fire and .add
            // Abort any current/pending executions
            // Clear all callbacks and values
            disable: function disable() {
                locked = queue = [];
                list = memory = "";
                return this;
            },
            disabled: function disabled() {
                return !list;
            },
            // Disable .fire
            // Also disable .add unless we have memory (since it would have no effect)
            // Abort any pending executions
            lock: function lock() {
                locked = queue = [];
                if (!memory && !firing) list = memory = "";
                return this;
            },
            locked: function locked1() {
                return !!locked;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function fireWith(context, args) {
                if (!locked) {
                    args = args || [];
                    args = [
                        context,
                        args.slice ? args.slice() : args
                    ];
                    queue.push(args);
                    if (!firing) fire();
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function fire() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function fired1() {
                return !!fired;
            }
        };
        return self;
    };
    function Identity(v) {
        return v;
    }
    function Thrower(ex) {
        throw ex;
    }
    function adoptValue(value, resolve, reject, noValue) {
        var method;
        try {
            // Check for promise aspect first to privilege synchronous behavior
            if (value && jQuery.isFunction(method = value.promise)) method.call(value).done(resolve).fail(reject);
            else if (value && jQuery.isFunction(method = value.then)) method.call(value, resolve, reject);
            else // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
            // * false: [ value ].slice( 0 ) => resolve( value )
            // * true: [ value ].slice( 1 ) => resolve()
            resolve.apply(undefined, [
                value
            ].slice(noValue));
        // For Promises/A+, convert exceptions into rejections
        // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
        // Deferred#then to conditionally suppress rejection.
        } catch (value) {
            // Support: Android 4.0 only
            // Strict mode functions invoked without .call/.apply get global-object context
            reject.apply(undefined, [
                value
            ]);
        }
    }
    jQuery.extend({
        Deferred: function Deferred(func) {
            var tuples = [
                // action, add listener, callbacks,
                // ... .then handlers, argument index, [final state]
                [
                    "notify",
                    "progress",
                    jQuery.Callbacks("memory"),
                    jQuery.Callbacks("memory"),
                    2
                ],
                [
                    "resolve",
                    "done",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    0,
                    "resolved"
                ],
                [
                    "reject",
                    "fail",
                    jQuery.Callbacks("once memory"),
                    jQuery.Callbacks("once memory"),
                    1,
                    "rejected"
                ]
            ], state = "pending", promise = {
                state: function state1() {
                    return state;
                },
                always: function always() {
                    deferred.done(arguments).fail(arguments);
                    return this;
                },
                "catch": function(fn) {
                    return promise.then(null, fn);
                },
                // Keep pipe for back-compat
                pipe: function pipe() {
                    var fns = arguments;
                    return jQuery.Deferred(function(newDefer) {
                        jQuery.each(tuples, function(i, tuple) {
                            // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                            var fn = jQuery.isFunction(fns[tuple[4]]) && fns[tuple[4]];
                            // deferred.progress(function() { bind to newDefer or newDefer.notify })
                            // deferred.done(function() { bind to newDefer or newDefer.resolve })
                            // deferred.fail(function() { bind to newDefer or newDefer.reject })
                            deferred[tuple[1]](function() {
                                var returned = fn && fn.apply(this, arguments);
                                if (returned && jQuery.isFunction(returned.promise)) returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                                else newDefer[tuple[0] + "With"](this, fn ? [
                                    returned
                                ] : arguments);
                            });
                        });
                        fns = null;
                    }).promise();
                },
                then: function then(onFulfilled, onRejected, onProgress) {
                    var maxDepth = 0;
                    function resolve(depth, deferred, handler, special) {
                        return function() {
                            var that = this, args = arguments, mightThrow = function mightThrow() {
                                var returned, then;
                                // Support: Promises/A+ section 2.3.3.3.3
                                // https://promisesaplus.com/#point-59
                                // Ignore double-resolution attempts
                                if (depth < maxDepth) return;
                                returned = handler.apply(that, args);
                                // Support: Promises/A+ section 2.3.1
                                // https://promisesaplus.com/#point-48
                                if (returned === deferred.promise()) throw new TypeError("Thenable self-resolution");
                                // Support: Promises/A+ sections 2.3.3.1, 3.5
                                // https://promisesaplus.com/#point-54
                                // https://promisesaplus.com/#point-75
                                // Retrieve `then` only once
                                then = returned && // Support: Promises/A+ section 2.3.4
                                // https://promisesaplus.com/#point-64
                                // Only check objects and functions for thenability
                                (typeof returned === "object" || typeof returned === "function") && returned.then;
                                // Handle a returned thenable
                                if (jQuery.isFunction(then)) {
                                    // Special processors (notify) just wait for resolution
                                    if (special) then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));
                                    else {
                                        // ...and disregard older resolution values
                                        maxDepth++;
                                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                                    }
                                } else {
                                    // Only substitute handlers pass on context
                                    // and multiple values (non-spec behavior)
                                    if (handler !== Identity) {
                                        that = undefined;
                                        args = [
                                            returned
                                        ];
                                    }
                                    // Process the value(s)
                                    // Default process is resolve
                                    (special || deferred.resolveWith)(that, args);
                                }
                            }, // Only normal processors (resolve) catch and reject exceptions
                            process = special ? mightThrow : function process1() {
                                try {
                                    mightThrow();
                                } catch (e) {
                                    if (jQuery.Deferred.exceptionHook) jQuery.Deferred.exceptionHook(e, process.stackTrace);
                                    // Support: Promises/A+ section 2.3.3.3.4.1
                                    // https://promisesaplus.com/#point-61
                                    // Ignore post-resolution exceptions
                                    if (depth + 1 >= maxDepth) {
                                        // Only substitute handlers pass on context
                                        // and multiple values (non-spec behavior)
                                        if (handler !== Thrower) {
                                            that = undefined;
                                            args = [
                                                e
                                            ];
                                        }
                                        deferred.rejectWith(that, args);
                                    }
                                }
                            };
                            // Support: Promises/A+ section 2.3.3.3.1
                            // https://promisesaplus.com/#point-57
                            // Re-resolve promises immediately to dodge false rejection from
                            // subsequent errors
                            if (depth) process();
                            else {
                                // Call an optional hook to record the stack, in case of exception
                                // since it's otherwise lost when execution goes async
                                if (jQuery.Deferred.getStackHook) process.stackTrace = jQuery.Deferred.getStackHook();
                                window1.setTimeout(process);
                            }
                        };
                    }
                    return jQuery.Deferred(function(newDefer) {
                        // progress_handlers.add( ... )
                        tuples[0][3].add(resolve(0, newDefer, jQuery.isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));
                        // fulfilled_handlers.add( ... )
                        tuples[1][3].add(resolve(0, newDefer, jQuery.isFunction(onFulfilled) ? onFulfilled : Identity));
                        // rejected_handlers.add( ... )
                        tuples[2][3].add(resolve(0, newDefer, jQuery.isFunction(onRejected) ? onRejected : Thrower));
                    }).promise();
                },
                // Get a promise for this deferred
                // If obj is provided, the promise aspect is added to the object
                promise: function promise1(obj) {
                    return obj != null ? jQuery.extend(obj, promise) : promise;
                }
            }, deferred = {};
            // Add list-specific methods
            jQuery.each(tuples, function(i, tuple) {
                var list = tuple[2], stateString = tuple[5];
                // promise.progress = list.add
                // promise.done = list.add
                // promise.fail = list.add
                promise[tuple[1]] = list.add;
                // Handle state
                if (stateString) list.add(function() {
                    // state = "resolved" (i.e., fulfilled)
                    // state = "rejected"
                    state = stateString;
                }, // rejected_callbacks.disable
                // fulfilled_callbacks.disable
                tuples[3 - i][2].disable, // progress_callbacks.lock
                tuples[0][2].lock);
                // progress_handlers.fire
                // fulfilled_handlers.fire
                // rejected_handlers.fire
                list.add(tuple[3].fire);
                // deferred.notify = function() { deferred.notifyWith(...) }
                // deferred.resolve = function() { deferred.resolveWith(...) }
                // deferred.reject = function() { deferred.rejectWith(...) }
                deferred[tuple[0]] = function() {
                    deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
                    return this;
                };
                // deferred.notifyWith = list.fireWith
                // deferred.resolveWith = list.fireWith
                // deferred.rejectWith = list.fireWith
                deferred[tuple[0] + "With"] = list.fireWith;
            });
            // Make the deferred a promise
            promise.promise(deferred);
            // Call given func if any
            if (func) func.call(deferred, deferred);
            // All done!
            return deferred;
        },
        // Deferred helper
        when: function when(singleValue) {
            var // count of uncompleted subordinates
            remaining = arguments.length, // count of unprocessed arguments
            i = remaining, // subordinate fulfillment data
            resolveContexts = Array(i), resolveValues = slice.call(arguments), // the master Deferred
            master = jQuery.Deferred(), // subordinate callback factory
            updateFunc = function updateFunc(i) {
                return function(value) {
                    resolveContexts[i] = this;
                    resolveValues[i] = arguments.length > 1 ? slice.call(arguments) : value;
                    if (!--remaining) master.resolveWith(resolveContexts, resolveValues);
                };
            };
            // Single- and empty arguments are adopted like Promise.resolve
            if (remaining <= 1) {
                adoptValue(singleValue, master.done(updateFunc(i)).resolve, master.reject, !remaining);
                // Use .then() to unwrap secondary thenables (cf. gh-3000)
                if (master.state() === "pending" || jQuery.isFunction(resolveValues[i] && resolveValues[i].then)) return master.then();
            }
            // Multiple arguments are aggregated like Promise.all array elements
            while(i--)adoptValue(resolveValues[i], updateFunc(i), master.reject);
            return master.promise();
        }
    });
    // These usually indicate a programmer mistake during development,
    // warn about them ASAP rather than swallowing them by default.
    var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
    jQuery.Deferred.exceptionHook = function(error, stack) {
        // Support: IE 8 - 9 only
        // Console exists when dev tools are open, which can happen at any time
        if (window1.console && window1.console.warn && error && rerrorNames.test(error.name)) window1.console.warn("jQuery.Deferred exception: " + error.message, error.stack, stack);
    };
    jQuery.readyException = function(error) {
        window1.setTimeout(function() {
            throw error;
        });
    };
    // The deferred used on DOM ready
    var readyList = jQuery.Deferred();
    jQuery.fn.ready = function(fn) {
        readyList.then(fn)// Wrap jQuery.readyException in a function so that the lookup
        // happens at the time of error handling instead of callback
        // registration.
        .catch(function(error) {
            jQuery.readyException(error);
        });
        return this;
    };
    jQuery.extend({
        // Is the DOM ready to be used? Set to true once it occurs.
        isReady: false,
        // A counter to track how many items to wait for before
        // the ready event fires. See #6781
        readyWait: 1,
        // Handle when the DOM is ready
        ready: function ready(wait) {
            // Abort if there are pending holds or we're already ready
            if (wait === true ? --jQuery.readyWait : jQuery.isReady) return;
            // Remember that the DOM is ready
            jQuery.isReady = true;
            // If a normal DOM Ready event fired, decrement, and wait if need be
            if (wait !== true && --jQuery.readyWait > 0) return;
            // If there are functions bound, to execute
            readyList.resolveWith(document, [
                jQuery
            ]);
        }
    });
    jQuery.ready.then = readyList.then;
    // The ready event handler and self cleanup method
    function completed() {
        document.removeEventListener("DOMContentLoaded", completed);
        window1.removeEventListener("load", completed);
        jQuery.ready();
    }
    // Catch cases where $(document).ready() is called
    // after the browser event has already occurred.
    // Support: IE <=9 - 10 only
    // Older IE sometimes signals "interactive" too soon
    if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay ready
    window1.setTimeout(jQuery.ready);
    else {
        // Use the handy event callback
        document.addEventListener("DOMContentLoaded", completed);
        // A fallback to window.onload, that will always work
        window1.addEventListener("load", completed);
    }
    // Multifunctional method to get and set values of a collection
    // The value/s can optionally be executed if it's a function
    var access = function access1(elems, fn, key, value, chainable, emptyGet, raw) {
        var i = 0, len = elems.length, bulk = key == null;
        // Sets many values
        if (jQuery.type(key) === "object") {
            chainable = true;
            for(i in key)access(elems, fn, i, key[i], true, emptyGet, raw);
        // Sets one value
        } else if (value !== undefined) {
            chainable = true;
            if (!jQuery.isFunction(value)) raw = true;
            if (bulk) {
                // Bulk operations run against the entire set
                if (raw) {
                    fn.call(elems, value);
                    fn = null;
                // ...except when executing function values
                } else {
                    bulk = fn;
                    fn = function fn(elem, key, value) {
                        return bulk.call(jQuery(elem), value);
                    };
                }
            }
            if (fn) for(; i < len; i++)fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
        if (chainable) return elems;
        // Gets
        if (bulk) return fn.call(elems);
        return len ? fn(elems[0], key) : emptyGet;
    };
    var acceptData = function acceptData(owner) {
        // Accepts only:
        //  - Node
        //    - Node.ELEMENT_NODE
        //    - Node.DOCUMENT_NODE
        //  - Object
        //    - Any
        return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
    };
    function Data() {
        this.expando = jQuery.expando + Data.uid++;
    }
    Data.uid = 1;
    Data.prototype = {
        cache: function cache(owner) {
            // Check if the owner object already has a cache
            var value = owner[this.expando];
            // If not, create one
            if (!value) {
                value = {};
                // We can accept data for non-element nodes in modern browsers,
                // but we should not, see #8335.
                // Always return an empty object.
                if (acceptData(owner)) {
                    // If it is a node unlikely to be stringify-ed or looped over
                    // use plain assignment
                    if (owner.nodeType) owner[this.expando] = value;
                    else Object.defineProperty(owner, this.expando, {
                        value: value,
                        configurable: true
                    });
                }
            }
            return value;
        },
        set: function set(owner, data, value) {
            var prop, cache = this.cache(owner);
            // Handle: [ owner, key, value ] args
            // Always use camelCase key (gh-2257)
            if (typeof data === "string") cache[jQuery.camelCase(data)] = value;
            else // Copy the properties one-by-one to the cache object
            for(prop in data)cache[jQuery.camelCase(prop)] = data[prop];
            return cache;
        },
        get: function get(owner, key) {
            return key === undefined ? this.cache(owner) : // Always use camelCase key (gh-2257)
            owner[this.expando] && owner[this.expando][jQuery.camelCase(key)];
        },
        access: function access(owner, key, value) {
            // In cases where either:
            //
            //   1. No key was specified
            //   2. A string key was specified, but no value provided
            //
            // Take the "read" path and allow the get method to determine
            // which value to return, respectively either:
            //
            //   1. The entire cache object
            //   2. The data stored at the key
            //
            if (key === undefined || key && typeof key === "string" && value === undefined) return this.get(owner, key);
            // When the key is not a string, or both a key and value
            // are specified, set or extend (existing objects) with either:
            //
            //   1. An object of properties
            //   2. A key and value
            //
            this.set(owner, key, value);
            // Since the "set" path can have two possible entry points
            // return the expected data based on which path was taken[*]
            return value !== undefined ? value : key;
        },
        remove: function remove(owner, key) {
            var i, cache = owner[this.expando];
            if (cache === undefined) return;
            if (key !== undefined) {
                // Support array or space separated string of keys
                if (Array.isArray(key)) // If key is an array of keys...
                // We always set camelCase keys, so remove that.
                key = key.map(jQuery.camelCase);
                else {
                    key = jQuery.camelCase(key);
                    // If a key with the spaces exists, use it.
                    // Otherwise, create an array by matching non-whitespace
                    key = key in cache ? [
                        key
                    ] : key.match(rnothtmlwhite) || [];
                }
                i = key.length;
                while(i--)delete cache[key[i]];
            }
            // Remove the expando if there's no more data
            if (key === undefined || jQuery.isEmptyObject(cache)) {
                // Support: Chrome <=35 - 45
                // Webkit & Blink performance suffers when deleting properties
                // from DOM nodes, so set to undefined instead
                // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
                if (owner.nodeType) owner[this.expando] = undefined;
                else delete owner[this.expando];
            }
        },
        hasData: function hasData(owner) {
            var cache = owner[this.expando];
            return cache !== undefined && !jQuery.isEmptyObject(cache);
        }
    };
    var dataPriv = new Data();
    var dataUser = new Data();
    //	Implementation Summary
    //
    //	1. Enforce API surface and semantic compatibility with 1.9.x branch
    //	2. Improve the module's maintainability by reducing the storage
    //		paths to a single mechanism.
    //	3. Use the same single mechanism to support "private" and "user" data.
    //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
    //	5. Avoid exposing implementation details on user objects (eg. expando properties)
    //	6. Provide a clear path for implementation upgrade to WeakMap in 2014
    var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/, rmultiDash = /[A-Z]/g;
    function getData(data) {
        if (data === "true") return true;
        if (data === "false") return false;
        if (data === "null") return null;
        // Only convert to a number if it doesn't change the string
        if (data === +data + "") return +data;
        if (rbrace.test(data)) return JSON.parse(data);
        return data;
    }
    function dataAttr(elem, key, data) {
        var name;
        // If nothing was found internally, try to fetch any
        // data from the HTML5 data-* attribute
        if (data === undefined && elem.nodeType === 1) {
            name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
            data = elem.getAttribute(name);
            if (typeof data === "string") {
                try {
                    data = getData(data);
                } catch (e) {}
                // Make sure we set the data so it isn't changed later
                dataUser.set(elem, key, data);
            } else data = undefined;
        }
        return data;
    }
    jQuery.extend({
        hasData: function hasData(elem) {
            return dataUser.hasData(elem) || dataPriv.hasData(elem);
        },
        data: function data(elem, name, data) {
            return dataUser.access(elem, name, data);
        },
        removeData: function removeData(elem, name) {
            dataUser.remove(elem, name);
        },
        // TODO: Now that all calls to _data and _removeData have been replaced
        // with direct calls to dataPriv methods, these can be deprecated.
        _data: function _data(elem, name, data) {
            return dataPriv.access(elem, name, data);
        },
        _removeData: function _removeData(elem, name) {
            dataPriv.remove(elem, name);
        }
    });
    jQuery.fn.extend({
        data: function data(key, value) {
            var i, name, data, elem = this[0], attrs = elem && elem.attributes;
            // Gets all values
            if (key === undefined) {
                if (this.length) {
                    data = dataUser.get(elem);
                    if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
                        i = attrs.length;
                        while(i--)// Support: IE 11 only
                        // The attrs elements can be null (#14894)
                        if (attrs[i]) {
                            name = attrs[i].name;
                            if (name.indexOf("data-") === 0) {
                                name = jQuery.camelCase(name.slice(5));
                                dataAttr(elem, name, data[name]);
                            }
                        }
                        dataPriv.set(elem, "hasDataAttrs", true);
                    }
                }
                return data;
            }
            // Sets multiple values
            if (typeof key === "object") return this.each(function() {
                dataUser.set(this, key);
            });
            return access(this, function(value) {
                var data;
                // The calling jQuery object (element matches) is not empty
                // (and therefore has an element appears at this[ 0 ]) and the
                // `value` parameter was not undefined. An empty jQuery object
                // will result in `undefined` for elem = this[ 0 ] which will
                // throw an exception if an attempt to read a data cache is made.
                if (elem && value === undefined) {
                    // Attempt to get data from the cache
                    // The key will always be camelCased in Data
                    data = dataUser.get(elem, key);
                    if (data !== undefined) return data;
                    // Attempt to "discover" the data in
                    // HTML5 custom data-* attrs
                    data = dataAttr(elem, key);
                    if (data !== undefined) return data;
                    // We tried really hard, but the data doesn't exist.
                    return;
                }
                // Set the data...
                this.each(function() {
                    // We always store the camelCased key
                    dataUser.set(this, key, value);
                });
            }, null, value, arguments.length > 1, null, true);
        },
        removeData: function removeData(key) {
            return this.each(function() {
                dataUser.remove(this, key);
            });
        }
    });
    jQuery.extend({
        queue: function queue(elem, type, data) {
            var queue;
            if (elem) {
                type = (type || "fx") + "queue";
                queue = dataPriv.get(elem, type);
                // Speed up dequeue by getting out quickly if this is just a lookup
                if (data) {
                    if (!queue || Array.isArray(data)) queue = dataPriv.access(elem, type, jQuery.makeArray(data));
                    else queue.push(data);
                }
                return queue || [];
            }
        },
        dequeue: function dequeue(elem, type) {
            type = type || "fx";
            var queue = jQuery.queue(elem, type), startLength = queue.length, fn = queue.shift(), hooks = jQuery._queueHooks(elem, type), next = function next() {
                jQuery.dequeue(elem, type);
            };
            // If the fx queue is dequeued, always remove the progress sentinel
            if (fn === "inprogress") {
                fn = queue.shift();
                startLength--;
            }
            if (fn) {
                // Add a progress sentinel to prevent the fx queue from being
                // automatically dequeued
                if (type === "fx") queue.unshift("inprogress");
                // Clear up the last queue stop function
                delete hooks.stop;
                fn.call(elem, next, hooks);
            }
            if (!startLength && hooks) hooks.empty.fire();
        },
        // Not public - generate a queueHooks object, or return the current one
        _queueHooks: function _queueHooks(elem, type) {
            var key = type + "queueHooks";
            return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
                empty: jQuery.Callbacks("once memory").add(function() {
                    dataPriv.remove(elem, [
                        type + "queue",
                        key
                    ]);
                })
            });
        }
    });
    jQuery.fn.extend({
        queue: function queue(type, data) {
            var setter = 2;
            if (typeof type !== "string") {
                data = type;
                type = "fx";
                setter--;
            }
            if (arguments.length < setter) return jQuery.queue(this[0], type);
            return data === undefined ? this : this.each(function() {
                var queue = jQuery.queue(this, type, data);
                // Ensure a hooks for this queue
                jQuery._queueHooks(this, type);
                if (type === "fx" && queue[0] !== "inprogress") jQuery.dequeue(this, type);
            });
        },
        dequeue: function dequeue(type) {
            return this.each(function() {
                jQuery.dequeue(this, type);
            });
        },
        clearQueue: function clearQueue(type) {
            return this.queue(type || "fx", []);
        },
        // Get a promise resolved when queues of a certain type
        // are emptied (fx is the type by default)
        promise: function promise(type, obj) {
            var tmp, count = 1, defer = jQuery.Deferred(), elements = this, i = this.length, resolve = function resolve() {
                if (!--count) defer.resolveWith(elements, [
                    elements
                ]);
            };
            if (typeof type !== "string") {
                obj = type;
                type = undefined;
            }
            type = type || "fx";
            while(i--){
                tmp = dataPriv.get(elements[i], type + "queueHooks");
                if (tmp && tmp.empty) {
                    count++;
                    tmp.empty.add(resolve);
                }
            }
            resolve();
            return defer.promise(obj);
        }
    });
    var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
    var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
    var cssExpand = [
        "Top",
        "Right",
        "Bottom",
        "Left"
    ];
    var isHiddenWithinTree = function isHiddenWithinTree(elem, el) {
        // isHiddenWithinTree might be called from jQuery#filter function;
        // in that case, element will be second argument
        elem = el || elem;
        // Inline style trumps all
        return elem.style.display === "none" || elem.style.display === "" && // Otherwise, check computed style
        // Support: Firefox <=43 - 45
        // Disconnected elements can have computed display: none, so first confirm that elem is
        // in the document.
        jQuery.contains(elem.ownerDocument, elem) && jQuery.css(elem, "display") === "none";
    };
    var swap = function swap(elem, options, callback, args) {
        var ret, name, old = {};
        // Remember the old values, and insert the new ones
        for(name in options){
            old[name] = elem.style[name];
            elem.style[name] = options[name];
        }
        ret = callback.apply(elem, args || []);
        // Revert the old values
        for(name in options)elem.style[name] = old[name];
        return ret;
    };
    function adjustCSS(elem, prop, valueParts, tween) {
        var adjusted, scale = 1, maxIterations = 20, currentValue = tween ? function currentValue() {
            return tween.cur();
        } : function() {
            return jQuery.css(elem, prop, "");
        }, initial = currentValue(), unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"), // Starting value computation is required for potential unit mismatches
        initialInUnit = (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
        if (initialInUnit && initialInUnit[3] !== unit) {
            // Trust units reported by jQuery.css
            unit = unit || initialInUnit[3];
            // Make sure we update the tween properties later on
            valueParts = valueParts || [];
            // Iteratively approximate from a nonzero starting point
            initialInUnit = +initial || 1;
            do {
                // If previous iteration zeroed out, double until we get *something*.
                // Use string for doubling so we don't accidentally see scale as unchanged below
                scale = scale || ".5";
                // Adjust and apply
                initialInUnit = initialInUnit / scale;
                jQuery.style(elem, prop, initialInUnit + unit);
            // Update scale, tolerating zero or NaN from tween.cur()
            // Break the loop if scale is unchanged or perfect, or if we've just had enough.
            }while (scale !== (scale = currentValue() / initial) && scale !== 1 && --maxIterations);
        }
        if (valueParts) {
            initialInUnit = +initialInUnit || +initial || 0;
            // Apply relative offset (+=/-=) if specified
            adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
            if (tween) {
                tween.unit = unit;
                tween.start = initialInUnit;
                tween.end = adjusted;
            }
        }
        return adjusted;
    }
    var defaultDisplayMap = {};
    function getDefaultDisplay(elem) {
        var temp, doc = elem.ownerDocument, _$nodeName = elem.nodeName, display = defaultDisplayMap[_$nodeName];
        if (display) return display;
        temp = doc.body.appendChild(doc.createElement(_$nodeName));
        display = jQuery.css(temp, "display");
        temp.parentNode.removeChild(temp);
        if (display === "none") display = "block";
        defaultDisplayMap[_$nodeName] = display;
        return display;
    }
    function showHide(elements, show) {
        var display, elem, values = [], index = 0, length = elements.length;
        // Determine new display value for elements that need to change
        for(; index < length; index++){
            elem = elements[index];
            if (!elem.style) continue;
            display = elem.style.display;
            if (show) {
                // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
                // check is required in this first loop unless we have a nonempty display value (either
                // inline or about-to-be-restored)
                if (display === "none") {
                    values[index] = dataPriv.get(elem, "display") || null;
                    if (!values[index]) elem.style.display = "";
                }
                if (elem.style.display === "" && isHiddenWithinTree(elem)) values[index] = getDefaultDisplay(elem);
            } else if (display !== "none") {
                values[index] = "none";
                // Remember what we're overwriting
                dataPriv.set(elem, "display", display);
            }
        }
        // Set the display of the elements in a second loop to avoid constant reflow
        for(index = 0; index < length; index++)if (values[index] != null) elements[index].style.display = values[index];
        return elements;
    }
    jQuery.fn.extend({
        show: function show() {
            return showHide(this, true);
        },
        hide: function hide() {
            return showHide(this);
        },
        toggle: function toggle(state) {
            if (typeof state === "boolean") return state ? this.show() : this.hide();
            return this.each(function() {
                if (isHiddenWithinTree(this)) jQuery(this).show();
                else jQuery(this).hide();
            });
        }
    });
    var rcheckableType = /^(?:checkbox|radio)$/i;
    var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]+)/i;
    var rscriptType = /^$|\/(?:java|ecma)script/i;
    // We have to close these tags to support XHTML (#13200)
    var wrapMap = {
        // Support: IE <=9 only
        option: [
            1,
            "<select multiple='multiple'>",
            "</select>"
        ],
        // XHTML parsers do not magically insert elements in the
        // same way that tag soup parsers do. So we cannot shorten
        // this by omitting <tbody> or other required elements.
        thead: [
            1,
            "<table>",
            "</table>"
        ],
        col: [
            2,
            "<table><colgroup>",
            "</colgroup></table>"
        ],
        tr: [
            2,
            "<table><tbody>",
            "</tbody></table>"
        ],
        td: [
            3,
            "<table><tbody><tr>",
            "</tr></tbody></table>"
        ],
        _default: [
            0,
            "",
            ""
        ]
    };
    // Support: IE <=9 only
    wrapMap.optgroup = wrapMap.option;
    wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
    wrapMap.th = wrapMap.td;
    function getAll(context, tag) {
        // Support: IE <=9 - 11 only
        // Use typeof to avoid zero-argument method invocation on host objects (#15151)
        var ret;
        if (typeof context.getElementsByTagName !== "undefined") ret = context.getElementsByTagName(tag || "*");
        else if (typeof context.querySelectorAll !== "undefined") ret = context.querySelectorAll(tag || "*");
        else ret = [];
        if (tag === undefined || tag && nodeName(context, tag)) return jQuery.merge([
            context
        ], ret);
        return ret;
    }
    // Mark scripts as having already been evaluated
    function setGlobalEval(elems, refElements) {
        var i = 0, l = elems.length;
        for(; i < l; i++)dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
    var rhtml = /<|&#?\w+;/;
    function buildFragment(elems, context, scripts, selection, ignored) {
        var elem, tmp, tag, wrap, contains, j, fragment = context.createDocumentFragment(), nodes = [], i = 0, l = elems.length;
        for(; i < l; i++){
            elem = elems[i];
            if (elem || elem === 0) {
                // Add nodes directly
                if (jQuery.type(elem) === "object") // Support: Android <=4.0 only, PhantomJS 1 only
                // push.apply(_, arraylike) throws on ancient WebKit
                jQuery.merge(nodes, elem.nodeType ? [
                    elem
                ] : elem);
                else if (!rhtml.test(elem)) nodes.push(context.createTextNode(elem));
                else {
                    tmp = tmp || fragment.appendChild(context.createElement("div"));
                    // Deserialize a standard representation
                    tag = (rtagName.exec(elem) || [
                        "",
                        ""
                    ])[1].toLowerCase();
                    wrap = wrapMap[tag] || wrapMap._default;
                    tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];
                    // Descend through wrappers to the right content
                    j = wrap[0];
                    while(j--)tmp = tmp.lastChild;
                    // Support: Android <=4.0 only, PhantomJS 1 only
                    // push.apply(_, arraylike) throws on ancient WebKit
                    jQuery.merge(nodes, tmp.childNodes);
                    // Remember the top-level container
                    tmp = fragment.firstChild;
                    // Ensure the created nodes are orphaned (#12392)
                    tmp.textContent = "";
                }
            }
        }
        // Remove wrapper from fragment
        fragment.textContent = "";
        i = 0;
        while(elem = nodes[i++]){
            // Skip elements already in the context collection (trac-4087)
            if (selection && jQuery.inArray(elem, selection) > -1) {
                if (ignored) ignored.push(elem);
                continue;
            }
            contains = jQuery.contains(elem.ownerDocument, elem);
            // Append to fragment
            tmp = getAll(fragment.appendChild(elem), "script");
            // Preserve script evaluation history
            if (contains) setGlobalEval(tmp);
            // Capture executables
            if (scripts) {
                j = 0;
                while(elem = tmp[j++])if (rscriptType.test(elem.type || "")) scripts.push(elem);
            }
        }
        return fragment;
    }
    (function() {
        var fragment = document.createDocumentFragment(), div = fragment.appendChild(document.createElement("div")), input = document.createElement("input");
        // Support: Android 4.0 - 4.3 only
        // Check state lost if the name is set (#11217)
        // Support: Windows Web Apps (WWA)
        // `name` and `type` must use .setAttribute for WWA (#14901)
        input.setAttribute("type", "radio");
        input.setAttribute("checked", "checked");
        input.setAttribute("name", "t");
        div.appendChild(input);
        // Support: Android <=4.1 only
        // Older WebKit doesn't clone checked state correctly in fragments
        support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;
        // Support: IE <=11 only
        // Make sure textarea (and checkbox) defaultValue is properly cloned
        div.innerHTML = "<textarea>x</textarea>";
        support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;
    })();
    var documentElement = document.documentElement;
    var rkeyEvent = /^key/, rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/, rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
    function returnTrue() {
        return true;
    }
    function returnFalse() {
        return false;
    }
    // Support: IE <=9 only
    // See #13393 for more info
    function safeActiveElement() {
        try {
            return document.activeElement;
        } catch (err) {}
    }
    function on(elem, types, selector, data, fn, one) {
        var origFn, type;
        // Types can be a map of types/handlers
        if (typeof types === "object") {
            // ( types-Object, selector, data )
            if (typeof selector !== "string") {
                // ( types-Object, data )
                data = data || selector;
                selector = undefined;
            }
            for(type in types)on(elem, type, selector, data, types[type], one);
            return elem;
        }
        if (data == null && fn == null) {
            // ( types, fn )
            fn = selector;
            data = selector = undefined;
        } else if (fn == null) {
            if (typeof selector === "string") {
                // ( types, selector, fn )
                fn = data;
                data = undefined;
            } else {
                // ( types, data, fn )
                fn = data;
                data = selector;
                selector = undefined;
            }
        }
        if (fn === false) fn = returnFalse;
        else if (!fn) return elem;
        if (one === 1) {
            origFn = fn;
            fn = function fn(event) {
                // Can use an empty set, since event contains the info
                jQuery().off(event);
                return origFn.apply(this, arguments);
            };
            // Use same guid so caller can remove using origFn
            fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
        }
        return elem.each(function() {
            jQuery.event.add(this, types, fn, data, selector);
        });
    }
    /*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */ jQuery.event = {
        global: {},
        add: function add(elem, types, handler, data, selector) {
            var handleObjIn, eventHandle, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.get(elem);
            // Don't attach events to noData or text/comment nodes (but allow plain objects)
            if (!elemData) return;
            // Caller can pass in an object of custom data in lieu of the handler
            if (handler.handler) {
                handleObjIn = handler;
                handler = handleObjIn.handler;
                selector = handleObjIn.selector;
            }
            // Ensure that invalid selectors throw exceptions at attach time
            // Evaluate against documentElement in case elem is a non-element node (e.g., document)
            if (selector) jQuery.find.matchesSelector(documentElement, selector);
            // Make sure that the handler has a unique ID, used to find/remove it later
            if (!handler.guid) handler.guid = jQuery.guid++;
            // Init the element's event structure and main handler, if this is the first
            if (!(events = elemData.events)) events = elemData.events = {};
            if (!(eventHandle = elemData.handle)) eventHandle = elemData.handle = function eventHandle(e) {
                // Discard the second event of a jQuery.event.trigger() and
                // when an event is called after a page has unloaded
                return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
            };
            // Handle multiple events separated by a space
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // There *must* be a type, no attaching namespace-only handlers
                if (!type) continue;
                // If event changes its type, use the special event handlers for the changed type
                special = jQuery.event.special[type] || {};
                // If selector defined, determine special event api type, otherwise given type
                type = (selector ? special.delegateType : special.bindType) || type;
                // Update special based on newly reset type
                special = jQuery.event.special[type] || {};
                // handleObj is passed to all event handlers
                handleObj = jQuery.extend({
                    type: type,
                    origType: origType,
                    data: data,
                    handler: handler,
                    guid: handler.guid,
                    selector: selector,
                    needsContext: selector && jQuery.expr.match.needsContext.test(selector),
                    namespace: namespaces.join(".")
                }, handleObjIn);
                // Init the event handler queue if we're the first
                if (!(handlers = events[type])) {
                    handlers = events[type] = [];
                    handlers.delegateCount = 0;
                    // Only use addEventListener if the special events handler returns false
                    if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
                        if (elem.addEventListener) elem.addEventListener(type, eventHandle);
                    }
                }
                if (special.add) {
                    special.add.call(elem, handleObj);
                    if (!handleObj.handler.guid) handleObj.handler.guid = handler.guid;
                }
                // Add to the element's handler list, delegates in front
                if (selector) handlers.splice(handlers.delegateCount++, 0, handleObj);
                else handlers.push(handleObj);
                // Keep track of which events have ever been used, for event optimization
                jQuery.event.global[type] = true;
            }
        },
        // Detach an event or set of events from an element
        remove: function remove(elem, types, handler, selector, mappedTypes) {
            var j, origCount, tmp, events, t, handleObj, special, handlers, type, namespaces, origType, elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
            if (!elemData || !(events = elemData.events)) return;
            // Once for each type.namespace in types; type may be omitted
            types = (types || "").match(rnothtmlwhite) || [
                ""
            ];
            t = types.length;
            while(t--){
                tmp = rtypenamespace.exec(types[t]) || [];
                type = origType = tmp[1];
                namespaces = (tmp[2] || "").split(".").sort();
                // Unbind all events (on this namespace, if provided) for the element
                if (!type) {
                    for(type in events)jQuery.event.remove(elem, type + types[t], handler, selector, true);
                    continue;
                }
                special = jQuery.event.special[type] || {};
                type = (selector ? special.delegateType : special.bindType) || type;
                handlers = events[type] || [];
                tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");
                // Remove matching events
                origCount = j = handlers.length;
                while(j--){
                    handleObj = handlers[j];
                    if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
                        handlers.splice(j, 1);
                        if (handleObj.selector) handlers.delegateCount--;
                        if (special.remove) special.remove.call(elem, handleObj);
                    }
                }
                // Remove generic event handler if we removed something and no more handlers exist
                // (avoids potential for endless recursion during removal of special event handlers)
                if (origCount && !handlers.length) {
                    if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) jQuery.removeEvent(elem, type, elemData.handle);
                    delete events[type];
                }
            }
            // Remove data and the expando if it's no longer used
            if (jQuery.isEmptyObject(events)) dataPriv.remove(elem, "handle events");
        },
        dispatch: function dispatch(nativeEvent) {
            // Make a writable jQuery.Event from the native event object
            var event = jQuery.event.fix(nativeEvent);
            var i, j, ret, matched, handleObj, handlerQueue, args = new Array(arguments.length), handlers = (dataPriv.get(this, "events") || {})[event.type] || [], special = jQuery.event.special[event.type] || {};
            // Use the fix-ed jQuery.Event rather than the (read-only) native event
            args[0] = event;
            for(i = 1; i < arguments.length; i++)args[i] = arguments[i];
            event.delegateTarget = this;
            // Call the preDispatch hook for the mapped type, and let it bail if desired
            if (special.preDispatch && special.preDispatch.call(this, event) === false) return;
            // Determine handlers
            handlerQueue = jQuery.event.handlers.call(this, event, handlers);
            // Run delegates first; they may want to stop propagation beneath us
            i = 0;
            while((matched = handlerQueue[i++]) && !event.isPropagationStopped()){
                event.currentTarget = matched.elem;
                j = 0;
                while((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped())// Triggered event must either 1) have no namespace, or 2) have namespace(s)
                // a subset or equal to those in the bound event (both can have no namespace).
                if (!event.rnamespace || event.rnamespace.test(handleObj.namespace)) {
                    event.handleObj = handleObj;
                    event.data = handleObj.data;
                    ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
                    if (ret !== undefined) {
                        if ((event.result = ret) === false) {
                            event.preventDefault();
                            event.stopPropagation();
                        }
                    }
                }
            }
            // Call the postDispatch hook for the mapped type
            if (special.postDispatch) special.postDispatch.call(this, event);
            return event.result;
        },
        handlers: function handlers(event, handlers) {
            var i, handleObj, sel, matchedHandlers, matchedSelectors, handlerQueue = [], delegateCount = handlers.delegateCount, cur = event.target;
            // Find delegate handlers
            if (delegateCount && // Support: IE <=9
            // Black-hole SVG <use> instance trees (trac-13180)
            cur.nodeType && // Support: Firefox <=42
            // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
            // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
            // Support: IE 11 only
            // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
            !(event.type === "click" && event.button >= 1)) {
                for(; cur !== this; cur = cur.parentNode || this)// Don't check non-elements (#13208)
                // Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
                if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
                    matchedHandlers = [];
                    matchedSelectors = {};
                    for(i = 0; i < delegateCount; i++){
                        handleObj = handlers[i];
                        // Don't conflict with Object.prototype properties (#13203)
                        sel = handleObj.selector + " ";
                        if (matchedSelectors[sel] === undefined) matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [
                            cur
                        ]).length;
                        if (matchedSelectors[sel]) matchedHandlers.push(handleObj);
                    }
                    if (matchedHandlers.length) handlerQueue.push({
                        elem: cur,
                        handlers: matchedHandlers
                    });
                }
            }
            // Add the remaining (directly-bound) handlers
            cur = this;
            if (delegateCount < handlers.length) handlerQueue.push({
                elem: cur,
                handlers: handlers.slice(delegateCount)
            });
            return handlerQueue;
        },
        addProp: function addProp(name, hook) {
            Object.defineProperty(jQuery.Event.prototype, name, {
                enumerable: true,
                configurable: true,
                get: jQuery.isFunction(hook) ? function() {
                    if (this.originalEvent) return hook(this.originalEvent);
                } : function() {
                    if (this.originalEvent) return this.originalEvent[name];
                },
                set: function set(value) {
                    Object.defineProperty(this, name, {
                        enumerable: true,
                        configurable: true,
                        writable: true,
                        value: value
                    });
                }
            });
        },
        fix: function fix(originalEvent) {
            return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
        },
        special: {
            load: {
                // Prevent triggered image.load events from bubbling to window.load
                noBubble: true
            },
            focus: {
                // Fire native event if possible so blur/focus sequence is correct
                trigger: function trigger() {
                    if (this !== safeActiveElement() && this.focus) {
                        this.focus();
                        return false;
                    }
                },
                delegateType: "focusin"
            },
            blur: {
                trigger: function trigger() {
                    if (this === safeActiveElement() && this.blur) {
                        this.blur();
                        return false;
                    }
                },
                delegateType: "focusout"
            },
            click: {
                // For checkbox, fire native event so checked state will be right
                trigger: function trigger() {
                    if (this.type === "checkbox" && this.click && nodeName(this, "input")) {
                        this.click();
                        return false;
                    }
                },
                // For cross-browser consistency, don't fire native .click() on links
                _default: function _default(event) {
                    return nodeName(event.target, "a");
                }
            },
            beforeunload: {
                postDispatch: function postDispatch(event) {
                    // Support: Firefox 20+
                    // Firefox doesn't alert if the returnValue field is not set.
                    if (event.result !== undefined && event.originalEvent) event.originalEvent.returnValue = event.result;
                }
            }
        }
    };
    jQuery.removeEvent = function(elem, type, handle) {
        // This "if" is needed for plain objects
        if (elem.removeEventListener) elem.removeEventListener(type, handle);
    };
    jQuery.Event = function(src, props) {
        // Allow instantiation without the 'new' keyword
        if (!(this instanceof jQuery.Event)) return new jQuery.Event(src, props);
        // Event object
        if (src && src.type) {
            this.originalEvent = src;
            this.type = src.type;
            // Events bubbling up the document may have been marked as prevented
            // by a handler lower down the tree; reflect the correct value.
            this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined && // Support: Android <=2.3 only
            src.returnValue === false ? returnTrue : returnFalse;
            // Create target properties
            // Support: Safari <=6 - 7 only
            // Target should not be a text node (#504, #13143)
            this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
            this.currentTarget = src.currentTarget;
            this.relatedTarget = src.relatedTarget;
        // Event type
        } else this.type = src;
        // Put explicitly provided properties onto the event object
        if (props) jQuery.extend(this, props);
        // Create a timestamp if incoming event doesn't have one
        this.timeStamp = src && src.timeStamp || jQuery.now();
        // Mark it as fixed
        this[jQuery.expando] = true;
    };
    // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
    // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
    jQuery.Event.prototype = {
        constructor: jQuery.Event,
        isDefaultPrevented: returnFalse,
        isPropagationStopped: returnFalse,
        isImmediatePropagationStopped: returnFalse,
        isSimulated: false,
        preventDefault: function preventDefault() {
            var e = this.originalEvent;
            this.isDefaultPrevented = returnTrue;
            if (e && !this.isSimulated) e.preventDefault();
        },
        stopPropagation: function stopPropagation() {
            var e = this.originalEvent;
            this.isPropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopPropagation();
        },
        stopImmediatePropagation: function stopImmediatePropagation() {
            var e = this.originalEvent;
            this.isImmediatePropagationStopped = returnTrue;
            if (e && !this.isSimulated) e.stopImmediatePropagation();
            this.stopPropagation();
        }
    };
    // Includes all common event props including KeyEvent and MouseEvent specific props
    jQuery.each({
        altKey: true,
        bubbles: true,
        cancelable: true,
        changedTouches: true,
        ctrlKey: true,
        detail: true,
        eventPhase: true,
        metaKey: true,
        pageX: true,
        pageY: true,
        shiftKey: true,
        view: true,
        "char": true,
        charCode: true,
        key: true,
        keyCode: true,
        button: true,
        buttons: true,
        clientX: true,
        clientY: true,
        offsetX: true,
        offsetY: true,
        pointerId: true,
        pointerType: true,
        screenX: true,
        screenY: true,
        targetTouches: true,
        toElement: true,
        touches: true,
        which: function which(event) {
            var button = event.button;
            // Add which for key events
            if (event.which == null && rkeyEvent.test(event.type)) return event.charCode != null ? event.charCode : event.keyCode;
            // Add which for click: 1 === left; 2 === middle; 3 === right
            if (!event.which && button !== undefined && rmouseEvent.test(event.type)) {
                if (button & 1) return 1;
                if (button & 2) return 3;
                if (button & 4) return 2;
                return 0;
            }
            return event.which;
        }
    }, jQuery.event.addProp);
    // Create mouseenter/leave events using mouseover/out and event-time checks
    // so that event delegation works in jQuery.
    // Do the same for pointerenter/pointerleave and pointerover/pointerout
    //
    // Support: Safari 7 only
    // Safari sends mouseenter too often; see:
    // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
    // for the description of the bug (it existed in older Chrome versions as well).
    jQuery.each({
        mouseenter: "mouseover",
        mouseleave: "mouseout",
        pointerenter: "pointerover",
        pointerleave: "pointerout"
    }, function(orig, fix) {
        jQuery.event.special[orig] = {
            delegateType: fix,
            bindType: fix,
            handle: function handle(event) {
                var ret, target = this, related = event.relatedTarget, handleObj = event.handleObj;
                // For mouseenter/leave call the handler if related is outside the target.
                // NB: No relatedTarget if the mouse left/entered the browser window
                if (!related || related !== target && !jQuery.contains(target, related)) {
                    event.type = handleObj.origType;
                    ret = handleObj.handler.apply(this, arguments);
                    event.type = fix;
                }
                return ret;
            }
        };
    });
    jQuery.fn.extend({
        on: function on1(types, selector, data, fn) {
            return on(this, types, selector, data, fn);
        },
        one: function one(types, selector, data, fn) {
            return on(this, types, selector, data, fn, 1);
        },
        off: function off(types, selector, fn) {
            var handleObj, type;
            if (types && types.preventDefault && types.handleObj) {
                // ( event )  dispatched jQuery.Event
                handleObj = types.handleObj;
                jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
                return this;
            }
            if (typeof types === "object") {
                // ( types-object [, selector] )
                for(type in types)this.off(type, selector, types[type]);
                return this;
            }
            if (selector === false || typeof selector === "function") {
                // ( types [, fn] )
                fn = selector;
                selector = undefined;
            }
            if (fn === false) fn = returnFalse;
            return this.each(function() {
                jQuery.event.remove(this, types, fn, selector);
            });
        }
    });
    var /* eslint-disable max-len */ // See https://github.com/eslint/eslint/issues/3229
    rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([a-z][^\/\0>\x20\t\r\n\f]*)[^>]*)\/>/gi, /* eslint-enable */ // Support: IE <=10 - 11, Edge 12 - 13
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i, // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i, rscriptTypeMasked = /^true\/(.*)/, rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
    // Prefer a tbody over its parent table for containing new rows
    function manipulationTarget(elem, content) {
        if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) return jQuery(">tbody", elem)[0] || elem;
        return elem;
    }
    // Replace/restore the type attribute of script elements for safe DOM manipulation
    function disableScript(elem) {
        elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
        return elem;
    }
    function restoreScript(elem) {
        var match = rscriptTypeMasked.exec(elem.type);
        if (match) elem.type = match[1];
        else elem.removeAttribute("type");
        return elem;
    }
    function cloneCopyEvent(src, dest) {
        var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;
        if (dest.nodeType !== 1) return;
        // 1. Copy private data: events, handlers, etc.
        if (dataPriv.hasData(src)) {
            pdataOld = dataPriv.access(src);
            pdataCur = dataPriv.set(dest, pdataOld);
            events = pdataOld.events;
            if (events) {
                delete pdataCur.handle;
                pdataCur.events = {};
                for(type in events)for(i = 0, l = events[type].length; i < l; i++)jQuery.event.add(dest, type, events[type][i]);
            }
        }
        // 2. Copy user data
        if (dataUser.hasData(src)) {
            udataOld = dataUser.access(src);
            udataCur = jQuery.extend({}, udataOld);
            dataUser.set(dest, udataCur);
        }
    }
    // Fix IE bugs, see support tests
    function fixInput(src, dest) {
        var _$nodeName = dest.nodeName.toLowerCase();
        // Fails to persist the checked state of a cloned checkbox or radio button.
        if (_$nodeName === "input" && rcheckableType.test(src.type)) dest.checked = src.checked;
        else if (_$nodeName === "input" || _$nodeName === "textarea") dest.defaultValue = src.defaultValue;
    }
    function domManip(collection, args, callback, ignored) {
        // Flatten any nested arrays
        args = concat.apply([], args);
        var fragment, first, scripts, hasScripts, node, doc, i = 0, l = collection.length, iNoClone = l - 1, value = args[0], isFunction = jQuery.isFunction(value);
        // We can't cloneNode fragments that contain checked, in WebKit
        if (isFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) return collection.each(function(index) {
            var self = collection.eq(index);
            if (isFunction) args[0] = value.call(this, index, self.html());
            domManip(self, args, callback, ignored);
        });
        if (l) {
            fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
            first = fragment.firstChild;
            if (fragment.childNodes.length === 1) fragment = first;
            // Require either new content or an interest in ignored elements to invoke the callback
            if (first || ignored) {
                scripts = jQuery.map(getAll(fragment, "script"), disableScript);
                hasScripts = scripts.length;
                // Use the original fragment for the last item
                // instead of the first because it can end up
                // being emptied incorrectly in certain situations (#8070).
                for(; i < l; i++){
                    node = fragment;
                    if (i !== iNoClone) {
                        node = jQuery.clone(node, true, true);
                        // Keep references to cloned scripts for later restoration
                        if (hasScripts) // Support: Android <=4.0 only, PhantomJS 1 only
                        // push.apply(_, arraylike) throws on ancient WebKit
                        jQuery.merge(scripts, getAll(node, "script"));
                    }
                    callback.call(collection[i], node, i);
                }
                if (hasScripts) {
                    doc = scripts[scripts.length - 1].ownerDocument;
                    // Reenable scripts
                    jQuery.map(scripts, restoreScript);
                    // Evaluate executable scripts on first document insertion
                    for(i = 0; i < hasScripts; i++){
                        node = scripts[i];
                        if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
                            if (node.src) // Optional AJAX dependency, but won't run scripts if not present
                            {
                                if (jQuery._evalUrl) jQuery._evalUrl(node.src);
                            } else DOMEval(node.textContent.replace(rcleanScript, ""), doc);
                        }
                    }
                }
            }
        }
        return collection;
    }
    function remove(elem, selector, keepData) {
        var node, nodes = selector ? jQuery.filter(selector, elem) : elem, i = 0;
        for(; (node = nodes[i]) != null; i++){
            if (!keepData && node.nodeType === 1) jQuery.cleanData(getAll(node));
            if (node.parentNode) {
                if (keepData && jQuery.contains(node.ownerDocument, node)) setGlobalEval(getAll(node, "script"));
                node.parentNode.removeChild(node);
            }
        }
        return elem;
    }
    jQuery.extend({
        htmlPrefilter: function htmlPrefilter(html) {
            return html.replace(rxhtmlTag, "<$1></$2>");
        },
        clone: function clone(elem, dataAndEvents, deepDataAndEvents) {
            var i, l, srcElements, destElements, clone = elem.cloneNode(true), inPage = jQuery.contains(elem.ownerDocument, elem);
            // Fix IE cloning issues
            if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
                // We eschew Sizzle here for performance reasons: https://jsperf.com/getall-vs-sizzle/2
                destElements = getAll(clone);
                srcElements = getAll(elem);
                for(i = 0, l = srcElements.length; i < l; i++)fixInput(srcElements[i], destElements[i]);
            }
            // Copy the events from the original to the clone
            if (dataAndEvents) {
                if (deepDataAndEvents) {
                    srcElements = srcElements || getAll(elem);
                    destElements = destElements || getAll(clone);
                    for(i = 0, l = srcElements.length; i < l; i++)cloneCopyEvent(srcElements[i], destElements[i]);
                } else cloneCopyEvent(elem, clone);
            }
            // Preserve script evaluation history
            destElements = getAll(clone, "script");
            if (destElements.length > 0) setGlobalEval(destElements, !inPage && getAll(elem, "script"));
            // Return the cloned set
            return clone;
        },
        cleanData: function cleanData(elems) {
            var data, elem, type, special = jQuery.event.special, i = 0;
            for(; (elem = elems[i]) !== undefined; i++)if (acceptData(elem)) {
                if (data = elem[dataPriv.expando]) {
                    if (data.events) {
                        for(type in data.events)if (special[type]) jQuery.event.remove(elem, type);
                        else jQuery.removeEvent(elem, type, data.handle);
                    }
                    // Support: Chrome <=35 - 45+
                    // Assign undefined instead of using delete, see Data#remove
                    elem[dataPriv.expando] = undefined;
                }
                if (elem[dataUser.expando]) // Support: Chrome <=35 - 45+
                // Assign undefined instead of using delete, see Data#remove
                elem[dataUser.expando] = undefined;
            }
        }
    });
    jQuery.fn.extend({
        detach: function detach(selector) {
            return remove(this, selector, true);
        },
        remove: function remove1(selector) {
            return remove(this, selector);
        },
        text: function text(value) {
            return access(this, function(value) {
                return value === undefined ? jQuery.text(this) : this.empty().each(function() {
                    if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) this.textContent = value;
                });
            }, null, value, arguments.length);
        },
        append: function append() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.appendChild(elem);
                }
            });
        },
        prepend: function prepend() {
            return domManip(this, arguments, function(elem) {
                if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
                    var target = manipulationTarget(this, elem);
                    target.insertBefore(elem, target.firstChild);
                }
            });
        },
        before: function before() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this);
            });
        },
        after: function after() {
            return domManip(this, arguments, function(elem) {
                if (this.parentNode) this.parentNode.insertBefore(elem, this.nextSibling);
            });
        },
        empty: function empty() {
            var elem, i = 0;
            for(; (elem = this[i]) != null; i++)if (elem.nodeType === 1) {
                // Prevent memory leaks
                jQuery.cleanData(getAll(elem, false));
                // Remove any remaining nodes
                elem.textContent = "";
            }
            return this;
        },
        clone: function clone(dataAndEvents, deepDataAndEvents) {
            dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
            deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
            return this.map(function() {
                return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
            });
        },
        html: function html(value) {
            return access(this, function(value) {
                var elem = this[0] || {}, i = 0, l = this.length;
                if (value === undefined && elem.nodeType === 1) return elem.innerHTML;
                // See if we can take a shortcut and just use innerHTML
                if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || [
                    "",
                    ""
                ])[1].toLowerCase()]) {
                    value = jQuery.htmlPrefilter(value);
                    try {
                        for(; i < l; i++){
                            elem = this[i] || {};
                            // Remove element nodes and prevent memory leaks
                            if (elem.nodeType === 1) {
                                jQuery.cleanData(getAll(elem, false));
                                elem.innerHTML = value;
                            }
                        }
                        elem = 0;
                    // If using innerHTML throws an exception, use the fallback method
                    } catch (e) {}
                }
                if (elem) this.empty().append(value);
            }, null, value, arguments.length);
        },
        replaceWith: function replaceWith() {
            var ignored = [];
            // Make the changes, replacing each non-ignored context element with the new content
            return domManip(this, arguments, function(elem) {
                var parent = this.parentNode;
                if (jQuery.inArray(this, ignored) < 0) {
                    jQuery.cleanData(getAll(this));
                    if (parent) parent.replaceChild(elem, this);
                }
            // Force callback invocation
            }, ignored);
        }
    });
    jQuery.each({
        appendTo: "append",
        prependTo: "prepend",
        insertBefore: "before",
        insertAfter: "after",
        replaceAll: "replaceWith"
    }, function(name, original) {
        jQuery.fn[name] = function(selector) {
            var elems, ret = [], insert = jQuery(selector), last = insert.length - 1, i = 0;
            for(; i <= last; i++){
                elems = i === last ? this : this.clone(true);
                jQuery(insert[i])[original](elems);
                // Support: Android <=4.0 only, PhantomJS 1 only
                // .get() because push.apply(_, arraylike) throws on ancient WebKit
                push.apply(ret, elems.get());
            }
            return this.pushStack(ret);
        };
    });
    var rmargin = /^margin/;
    var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
    var getStyles = function getStyles(elem) {
        // Support: IE <=11 only, Firefox <=30 (#15098, #14150)
        // IE throws on elements created in popups
        // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
        var view = elem.ownerDocument.defaultView;
        if (!view || !view.opener) view = window1;
        return view.getComputedStyle(elem);
    };
    (function() {
        // Executing both pixelPosition & boxSizingReliable tests require only one layout
        // so they're executed at the same time to save the second computation.
        function computeStyleTests() {
            // This is a singleton, we need to execute it only once
            if (!div) return;
            div.style.cssText = "box-sizing:border-box;position:relative;display:block;margin:auto;border:1px;padding:1px;top:1%;width:50%";
            div.innerHTML = "";
            documentElement.appendChild(container);
            var divStyle = window1.getComputedStyle(div);
            pixelPositionVal = divStyle.top !== "1%";
            // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
            reliableMarginLeftVal = divStyle.marginLeft === "2px";
            boxSizingReliableVal = divStyle.width === "4px";
            // Support: Android 4.0 - 4.3 only
            // Some styles come back with percentage values, even though they shouldn't
            div.style.marginRight = "50%";
            pixelMarginRightVal = divStyle.marginRight === "4px";
            documentElement.removeChild(container);
            // Nullify the div so it wouldn't be stored in the memory and
            // it will also be a sign that checks already performed
            div = null;
        }
        var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal, container = document.createElement("div"), div = document.createElement("div");
        // Finish early in limited (non-browser) environments
        if (!div.style) return;
        // Support: IE <=9 - 11 only
        // Style of cloned element affects source element cloned (#8908)
        div.style.backgroundClip = "content-box";
        div.cloneNode(true).style.backgroundClip = "";
        support.clearCloneStyle = div.style.backgroundClip === "content-box";
        container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;padding:0;margin-top:1px;position:absolute";
        container.appendChild(div);
        jQuery.extend(support, {
            pixelPosition: function pixelPosition() {
                computeStyleTests();
                return pixelPositionVal;
            },
            boxSizingReliable: function boxSizingReliable() {
                computeStyleTests();
                return boxSizingReliableVal;
            },
            pixelMarginRight: function pixelMarginRight() {
                computeStyleTests();
                return pixelMarginRightVal;
            },
            reliableMarginLeft: function reliableMarginLeft() {
                computeStyleTests();
                return reliableMarginLeftVal;
            }
        });
    })();
    function curCSS(elem, name, computed) {
        var width, minWidth, maxWidth, ret, // Support: Firefox 51+
        // Retrieving style before computed somehow
        // fixes an issue with getting wrong values
        // on detached elements
        style = elem.style;
        computed = computed || getStyles(elem);
        // getPropertyValue is needed for:
        //   .css('filter') (IE 9 only, #12537)
        //   .css('--customProperty) (#3144)
        if (computed) {
            ret = computed.getPropertyValue(name) || computed[name];
            if (ret === "" && !jQuery.contains(elem.ownerDocument, elem)) ret = jQuery.style(elem, name);
            // A tribute to the "awesome hack by Dean Edwards"
            // Android Browser returns percentage for some values,
            // but width seems to be reliably pixels.
            // This is against the CSSOM draft spec:
            // https://drafts.csswg.org/cssom/#resolved-values
            if (!support.pixelMarginRight() && rnumnonpx.test(ret) && rmargin.test(name)) {
                // Remember the original values
                width = style.width;
                minWidth = style.minWidth;
                maxWidth = style.maxWidth;
                // Put in the new values to get a computed value out
                style.minWidth = style.maxWidth = style.width = ret;
                ret = computed.width;
                // Revert the changed values
                style.width = width;
                style.minWidth = minWidth;
                style.maxWidth = maxWidth;
            }
        }
        return ret !== undefined ? // Support: IE <=9 - 11 only
        // IE returns zIndex value as an integer.
        ret + "" : ret;
    }
    function addGetHookIf(conditionFn, hookFn) {
        // Define the hook, we'll check on the first run if it's really needed.
        return {
            get: function get() {
                if (conditionFn()) {
                    // Hook not needed (or it's not possible to use it due
                    // to missing dependency), remove it.
                    delete this.get;
                    return;
                }
                // Hook needed; redefine it so that the support test is not executed again.
                return (this.get = hookFn).apply(this, arguments);
            }
        };
    }
    var // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/, rcustomProp = /^--/, cssShow = {
        position: "absolute",
        visibility: "hidden",
        display: "block"
    }, cssNormalTransform = {
        letterSpacing: "0",
        fontWeight: "400"
    }, cssPrefixes = [
        "Webkit",
        "Moz",
        "ms"
    ], emptyStyle = document.createElement("div").style;
    // Return a css property mapped to a potentially vendor prefixed property
    function vendorPropName(name) {
        // Shortcut for names that are not vendor prefixed
        if (name in emptyStyle) return name;
        // Check for vendor prefixed names
        var capName = name[0].toUpperCase() + name.slice(1), i = cssPrefixes.length;
        while(i--){
            name = cssPrefixes[i] + capName;
            if (name in emptyStyle) return name;
        }
    }
    // Return a property mapped along what jQuery.cssProps suggests or to
    // a vendor prefixed property.
    function finalPropName(name) {
        var ret = jQuery.cssProps[name];
        if (!ret) ret = jQuery.cssProps[name] = vendorPropName(name) || name;
        return ret;
    }
    function setPositiveNumber(elem, value, subtract) {
        // Any relative (+/-) values have already been
        // normalized at this point
        var matches = rcssNum.exec(value);
        return matches ? // Guard against undefined "subtract", e.g., when used as in cssHooks
        Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
    }
    function augmentWidthOrHeight(elem, name, extra, isBorderBox, styles) {
        var i, val = 0;
        // If we already have the right measurement, avoid augmentation
        if (extra === (isBorderBox ? "border" : "content")) i = 4;
        else i = name === "width" ? 1 : 0;
        for(; i < 4; i += 2){
            // Both box models exclude margin, so add it if we want it
            if (extra === "margin") val += jQuery.css(elem, extra + cssExpand[i], true, styles);
            if (isBorderBox) {
                // border-box includes padding, so remove it if we want content
                if (extra === "content") val -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // At this point, extra isn't border nor margin, so remove border
                if (extra !== "margin") val -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            } else {
                // At this point, extra isn't content, so add padding
                val += jQuery.css(elem, "padding" + cssExpand[i], true, styles);
                // At this point, extra isn't content nor padding, so add border
                if (extra !== "padding") val += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
            }
        }
        return val;
    }
    function getWidthOrHeight(elem, name, extra) {
        // Start with computed style
        var valueIsBorderBox, styles = getStyles(elem), val = curCSS(elem, name, styles), isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";
        // Computed unit is not pixels. Stop here and return.
        if (rnumnonpx.test(val)) return val;
        // Check for style in case a browser which returns unreliable values
        // for getComputedStyle silently falls back to the reliable elem.style
        valueIsBorderBox = isBorderBox && (support.boxSizingReliable() || val === elem.style[name]);
        // Fall back to offsetWidth/Height when value is "auto"
        // This happens for inline elements with no explicit setting (gh-3571)
        if (val === "auto") val = elem["offset" + name[0].toUpperCase() + name.slice(1)];
        // Normalize "", auto, and prepare for extra
        val = parseFloat(val) || 0;
        // Use the active box-sizing model to add/subtract irrelevant styles
        return val + augmentWidthOrHeight(elem, name, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles) + "px";
    }
    jQuery.extend({
        // Add in style property hooks for overriding the default
        // behavior of getting and setting a style property
        cssHooks: {
            opacity: {
                get: function get(elem, computed) {
                    if (computed) {
                        // We should always get a number back from opacity
                        var ret = curCSS(elem, "opacity");
                        return ret === "" ? "1" : ret;
                    }
                }
            }
        },
        // Don't automatically add "px" to these possibly-unitless properties
        cssNumber: {
            "animationIterationCount": true,
            "columnCount": true,
            "fillOpacity": true,
            "flexGrow": true,
            "flexShrink": true,
            "fontWeight": true,
            "lineHeight": true,
            "opacity": true,
            "order": true,
            "orphans": true,
            "widows": true,
            "zIndex": true,
            "zoom": true
        },
        // Add in properties whose names you wish to fix before
        // setting or getting the value
        cssProps: {
            "float": "cssFloat"
        },
        // Get and set the style property on a DOM Node
        style: function style(elem, name, value, extra) {
            // Don't set styles on text and comment nodes
            if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) return;
            // Make sure that we're working with the right name
            var ret, type, hooks, origName = jQuery.camelCase(name), isCustomProp = rcustomProp.test(name), style = elem.style;
            // Make sure that we're working with the right name. We don't
            // want to query the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Gets hook for the prefixed version, then unprefixed version
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // Check if we're setting a value
            if (value !== undefined) {
                type = typeof value === "undefined" ? "undefined" : (0, $alyXF._)(value);
                // Convert "+=" or "-=" to relative numbers (#7345)
                if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
                    value = adjustCSS(elem, name, ret);
                    // Fixes bug #9237
                    type = "number";
                }
                // Make sure that null and NaN values aren't set (#7116)
                if (value == null || value !== value) return;
                // If a number was passed in, add the unit (except for certain CSS properties)
                if (type === "number") value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
                // background-* props affect original clone's values
                if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) style[name] = "inherit";
                // If a hook was provided, use that value, otherwise just set the specified value
                if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
                    if (isCustomProp) style.setProperty(name, value);
                    else style[name] = value;
                }
            } else {
                // If a hook was provided get the non-computed value from there
                if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) return ret;
                // Otherwise just get the value from the style object
                return style[name];
            }
        },
        css: function css(elem, name, extra, styles) {
            var val, num, hooks, origName = jQuery.camelCase(name), isCustomProp = rcustomProp.test(name);
            // Make sure that we're working with the right name. We don't
            // want to modify the value if it is a CSS custom property
            // since they are user-defined.
            if (!isCustomProp) name = finalPropName(origName);
            // Try prefixed name followed by the unprefixed name
            hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];
            // If a hook was provided get the computed value from there
            if (hooks && "get" in hooks) val = hooks.get(elem, true, extra);
            // Otherwise, if a way to get the computed value exists, use that
            if (val === undefined) val = curCSS(elem, name, styles);
            // Convert "normal" to computed value
            if (val === "normal" && name in cssNormalTransform) val = cssNormalTransform[name];
            // Make numeric if forced or a qualifier was provided and val looks numeric
            if (extra === "" || extra) {
                num = parseFloat(val);
                return extra === true || isFinite(num) ? num || 0 : val;
            }
            return val;
        }
    });
    jQuery.each([
        "height",
        "width"
    ], function(i, name) {
        jQuery.cssHooks[name] = {
            get: function get(elem, computed, extra) {
                if (computed) // Certain elements can have dimension info if we invisibly show them
                // but it must have a current display style that would benefit
                return rdisplayswap.test(jQuery.css(elem, "display")) && // Support: Safari 8+
                // Table columns in Safari have non-zero offsetWidth & zero
                // getBoundingClientRect().width unless display is changed.
                // Support: IE <=11 only
                // Running getBoundingClientRect on a disconnected node
                // in IE throws an error.
                (!elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function() {
                    return getWidthOrHeight(elem, name, extra);
                }) : getWidthOrHeight(elem, name, extra);
            },
            set: function set(elem, value, extra) {
                var matches, styles = extra && getStyles(elem), subtract = extra && augmentWidthOrHeight(elem, name, extra, jQuery.css(elem, "boxSizing", false, styles) === "border-box", styles);
                // Convert to pixels if value adjustment is needed
                if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
                    elem.style[name] = value;
                    value = jQuery.css(elem, name);
                }
                return setPositiveNumber(elem, value, subtract);
            }
        };
    });
    jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function(elem, computed) {
        if (computed) return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
            marginLeft: 0
        }, function() {
            return elem.getBoundingClientRect().left;
        })) + "px";
    });
    // These hooks are used by animate to expand properties
    jQuery.each({
        margin: "",
        padding: "",
        border: "Width"
    }, function(prefix, suffix) {
        jQuery.cssHooks[prefix + suffix] = {
            expand: function expand(value) {
                var i = 0, expanded = {}, // Assumes a single number if not a string
                parts = typeof value === "string" ? value.split(" ") : [
                    value
                ];
                for(; i < 4; i++)expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
                return expanded;
            }
        };
        if (!rmargin.test(prefix)) jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    });
    jQuery.fn.extend({
        css: function css(name, value) {
            return access(this, function(elem, name, value) {
                var styles, len, map = {}, i = 0;
                if (Array.isArray(name)) {
                    styles = getStyles(elem);
                    len = name.length;
                    for(; i < len; i++)map[name[i]] = jQuery.css(elem, name[i], false, styles);
                    return map;
                }
                return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
            }, name, value, arguments.length > 1);
        }
    });
    function Tween(elem, options, prop, end, easing) {
        return new Tween.prototype.init(elem, options, prop, end, easing);
    }
    jQuery.Tween = Tween;
    Tween.prototype = {
        constructor: Tween,
        init: function init(elem, options, prop, end, easing, unit) {
            this.elem = elem;
            this.prop = prop;
            this.easing = easing || jQuery.easing._default;
            this.options = options;
            this.start = this.now = this.cur();
            this.end = end;
            this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
        },
        cur: function cur() {
            var hooks = Tween.propHooks[this.prop];
            return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
        },
        run: function run(percent) {
            var eased, hooks = Tween.propHooks[this.prop];
            if (this.options.duration) this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
            else this.pos = eased = percent;
            this.now = (this.end - this.start) * eased + this.start;
            if (this.options.step) this.options.step.call(this.elem, this.now, this);
            if (hooks && hooks.set) hooks.set(this);
            else Tween.propHooks._default.set(this);
            return this;
        }
    };
    Tween.prototype.init.prototype = Tween.prototype;
    Tween.propHooks = {
        _default: {
            get: function get(tween) {
                var result;
                // Use a property on the element directly when it is not a DOM element,
                // or when there is no matching style property that exists.
                if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) return tween.elem[tween.prop];
                // Passing an empty string as a 3rd parameter to .css will automatically
                // attempt a parseFloat and fallback to a string if the parse fails.
                // Simple values such as "10px" are parsed to Float;
                // complex values such as "rotate(1rad)" are returned as-is.
                result = jQuery.css(tween.elem, tween.prop, "");
                // Empty strings, null, undefined and "auto" are converted to 0.
                return !result || result === "auto" ? 0 : result;
            },
            set: function set(tween) {
                // Use step hook for back compat.
                // Use cssHook if its there.
                // Use .style if available and use plain properties where available.
                if (jQuery.fx.step[tween.prop]) jQuery.fx.step[tween.prop](tween);
                else if (tween.elem.nodeType === 1 && (tween.elem.style[jQuery.cssProps[tween.prop]] != null || jQuery.cssHooks[tween.prop])) jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
                else tween.elem[tween.prop] = tween.now;
            }
        }
    };
    // Support: IE <=9 only
    // Panic based approach to setting things on disconnected nodes
    Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
        set: function set(tween) {
            if (tween.elem.nodeType && tween.elem.parentNode) tween.elem[tween.prop] = tween.now;
        }
    };
    jQuery.easing = {
        linear: function linear(p) {
            return p;
        },
        swing: function swing(p) {
            return 0.5 - Math.cos(p * Math.PI) / 2;
        },
        _default: "swing"
    };
    jQuery.fx = Tween.prototype.init;
    // Back compat <1.8 extension point
    jQuery.fx.step = {};
    var fxNow, inProgress, rfxtypes = /^(?:toggle|show|hide)$/, rrun = /queueHooks$/;
    function schedule() {
        if (inProgress) {
            if (document.hidden === false && window1.requestAnimationFrame) window1.requestAnimationFrame(schedule);
            else window1.setTimeout(schedule, jQuery.fx.interval);
            jQuery.fx.tick();
        }
    }
    // Animations created synchronously will run synchronously
    function createFxNow() {
        window1.setTimeout(function() {
            fxNow = undefined;
        });
        return fxNow = jQuery.now();
    }
    // Generate parameters to create a standard animation
    function genFx(type, includeWidth) {
        var which, i = 0, attrs = {
            height: type
        };
        // If we include width, step value is 1 to do all cssExpand values,
        // otherwise step value is 2 to skip over Left and Right
        includeWidth = includeWidth ? 1 : 0;
        for(; i < 4; i += 2 - includeWidth){
            which = cssExpand[i];
            attrs["margin" + which] = attrs["padding" + which] = type;
        }
        if (includeWidth) attrs.opacity = attrs.width = type;
        return attrs;
    }
    function createTween(value, prop, animation) {
        var tween, collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]), index = 0, length = collection.length;
        for(; index < length; index++){
            if (tween = collection[index].call(animation, prop, value)) // We're done with this property
            return tween;
        }
    }
    function defaultPrefilter(elem, props, opts) {
        var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display, isBox = "width" in props || "height" in props, anim = this, orig = {}, style = elem.style, hidden = elem.nodeType && isHiddenWithinTree(elem), dataShow = dataPriv.get(elem, "fxshow");
        // Queue-skipping animations hijack the fx hooks
        if (!opts.queue) {
            hooks = jQuery._queueHooks(elem, "fx");
            if (hooks.unqueued == null) {
                hooks.unqueued = 0;
                oldfire = hooks.empty.fire;
                hooks.empty.fire = function() {
                    if (!hooks.unqueued) oldfire();
                };
            }
            hooks.unqueued++;
            anim.always(function() {
                // Ensure the complete handler is called before this completes
                anim.always(function() {
                    hooks.unqueued--;
                    if (!jQuery.queue(elem, "fx").length) hooks.empty.fire();
                });
            });
        }
        // Detect show/hide animations
        for(prop in props){
            value = props[prop];
            if (rfxtypes.test(value)) {
                delete props[prop];
                toggle = toggle || value === "toggle";
                if (value === (hidden ? "hide" : "show")) {
                    // Pretend to be hidden if this is a "show" and
                    // there is still data from a stopped show/hide
                    if (value === "show" && dataShow && dataShow[prop] !== undefined) hidden = true;
                    else continue;
                }
                orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
            }
        }
        // Bail out if this is a no-op like .hide().hide()
        propTween = !jQuery.isEmptyObject(props);
        if (!propTween && jQuery.isEmptyObject(orig)) return;
        // Restrict "overflow" and "display" styles during box animations
        if (isBox && elem.nodeType === 1) {
            // Support: IE <=9 - 11, Edge 12 - 13
            // Record all 3 overflow attributes because IE does not infer the shorthand
            // from identically-valued overflowX and overflowY
            opts.overflow = [
                style.overflow,
                style.overflowX,
                style.overflowY
            ];
            // Identify a display type, preferring old show/hide data over the CSS cascade
            restoreDisplay = dataShow && dataShow.display;
            if (restoreDisplay == null) restoreDisplay = dataPriv.get(elem, "display");
            display = jQuery.css(elem, "display");
            if (display === "none") {
                if (restoreDisplay) display = restoreDisplay;
                else {
                    // Get nonempty value(s) by temporarily forcing visibility
                    showHide([
                        elem
                    ], true);
                    restoreDisplay = elem.style.display || restoreDisplay;
                    display = jQuery.css(elem, "display");
                    showHide([
                        elem
                    ]);
                }
            }
            // Animate inline elements as inline-block
            if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
                if (jQuery.css(elem, "float") === "none") {
                    // Restore the original display value at the end of pure show/hide animations
                    if (!propTween) {
                        anim.done(function() {
                            style.display = restoreDisplay;
                        });
                        if (restoreDisplay == null) {
                            display = style.display;
                            restoreDisplay = display === "none" ? "" : display;
                        }
                    }
                    style.display = "inline-block";
                }
            }
        }
        if (opts.overflow) {
            style.overflow = "hidden";
            anim.always(function() {
                style.overflow = opts.overflow[0];
                style.overflowX = opts.overflow[1];
                style.overflowY = opts.overflow[2];
            });
        }
        // Implement show/hide animations
        propTween = false;
        for(prop in orig){
            // General show/hide setup for this element animation
            if (!propTween) {
                if (dataShow) {
                    if ("hidden" in dataShow) hidden = dataShow.hidden;
                } else dataShow = dataPriv.access(elem, "fxshow", {
                    display: restoreDisplay
                });
                // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
                if (toggle) dataShow.hidden = !hidden;
                // Show elements before animating them
                if (hidden) showHide([
                    elem
                ], true);
                /* eslint-disable no-loop-func */ anim.done(function() {
                    /* eslint-enable no-loop-func */ // The final step of a "hide" animation is actually hiding the element
                    if (!hidden) showHide([
                        elem
                    ]);
                    dataPriv.remove(elem, "fxshow");
                    for(prop in orig)jQuery.style(elem, prop, orig[prop]);
                });
            }
            // Per-property setup
            propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
            if (!(prop in dataShow)) {
                dataShow[prop] = propTween.start;
                if (hidden) {
                    propTween.end = propTween.start;
                    propTween.start = 0;
                }
            }
        }
    }
    function propFilter(props, specialEasing) {
        var index, name, easing, value, hooks;
        // camelCase, specialEasing and expand cssHook pass
        for(index in props){
            name = jQuery.camelCase(index);
            easing = specialEasing[name];
            value = props[index];
            if (Array.isArray(value)) {
                easing = value[1];
                value = props[index] = value[0];
            }
            if (index !== name) {
                props[name] = value;
                delete props[index];
            }
            hooks = jQuery.cssHooks[name];
            if (hooks && "expand" in hooks) {
                value = hooks.expand(value);
                delete props[name];
                // Not quite $.extend, this won't overwrite existing keys.
                // Reusing 'index' because we have the correct "name"
                for(index in value)if (!(index in props)) {
                    props[index] = value[index];
                    specialEasing[index] = easing;
                }
            } else specialEasing[name] = easing;
        }
    }
    function Animation(elem, properties, options) {
        var result, stopped, index = 0, length = Animation.prefilters.length, deferred = jQuery.Deferred().always(function() {
            // Don't match elem in the :animated selector
            delete tick.elem;
        }), tick = function tick() {
            if (stopped) return false;
            var currentTime = fxNow || createFxNow(), remaining = Math.max(0, animation.startTime + animation.duration - currentTime), // Support: Android 2.3 only
            // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
            temp = remaining / animation.duration || 0, percent = 1 - temp, index = 0, length = animation.tweens.length;
            for(; index < length; index++)animation.tweens[index].run(percent);
            deferred.notifyWith(elem, [
                animation,
                percent,
                remaining
            ]);
            // If there's more to do, yield
            if (percent < 1 && length) return remaining;
            // If this was an empty animation, synthesize a final progress notification
            if (!length) deferred.notifyWith(elem, [
                animation,
                1,
                0
            ]);
            // Resolve the animation and report its conclusion
            deferred.resolveWith(elem, [
                animation
            ]);
            return false;
        }, animation = deferred.promise({
            elem: elem,
            props: jQuery.extend({}, properties),
            opts: jQuery.extend(true, {
                specialEasing: {},
                easing: jQuery.easing._default
            }, options),
            originalProperties: properties,
            originalOptions: options,
            startTime: fxNow || createFxNow(),
            duration: options.duration,
            tweens: [],
            createTween: function createTween(prop, end) {
                var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
                animation.tweens.push(tween);
                return tween;
            },
            stop: function stop(gotoEnd) {
                var index = 0, // If we are going to the end, we want to run all the tweens
                // otherwise we skip this part
                length = gotoEnd ? animation.tweens.length : 0;
                if (stopped) return this;
                stopped = true;
                for(; index < length; index++)animation.tweens[index].run(1);
                // Resolve when we played the last frame; otherwise, reject
                if (gotoEnd) {
                    deferred.notifyWith(elem, [
                        animation,
                        1,
                        0
                    ]);
                    deferred.resolveWith(elem, [
                        animation,
                        gotoEnd
                    ]);
                } else deferred.rejectWith(elem, [
                    animation,
                    gotoEnd
                ]);
                return this;
            }
        }), props = animation.props;
        propFilter(props, animation.opts.specialEasing);
        for(; index < length; index++){
            result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
            if (result) {
                if (jQuery.isFunction(result.stop)) jQuery._queueHooks(animation.elem, animation.opts.queue).stop = jQuery.proxy(result.stop, result);
                return result;
            }
        }
        jQuery.map(props, createTween, animation);
        if (jQuery.isFunction(animation.opts.start)) animation.opts.start.call(elem, animation);
        // Attach callbacks from options
        animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
        jQuery.fx.timer(jQuery.extend(tick, {
            elem: elem,
            anim: animation,
            queue: animation.opts.queue
        }));
        return animation;
    }
    jQuery.Animation = jQuery.extend(Animation, {
        tweeners: {
            "*": [
                function(prop, value) {
                    var tween = this.createTween(prop, value);
                    adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
                    return tween;
                }
            ]
        },
        tweener: function tweener(props, callback) {
            if (jQuery.isFunction(props)) {
                callback = props;
                props = [
                    "*"
                ];
            } else props = props.match(rnothtmlwhite);
            var prop, index = 0, length = props.length;
            for(; index < length; index++){
                prop = props[index];
                Animation.tweeners[prop] = Animation.tweeners[prop] || [];
                Animation.tweeners[prop].unshift(callback);
            }
        },
        prefilters: [
            defaultPrefilter
        ],
        prefilter: function prefilter(callback, prepend) {
            if (prepend) Animation.prefilters.unshift(callback);
            else Animation.prefilters.push(callback);
        }
    });
    jQuery.speed = function(speed, easing, fn) {
        var opt = speed && typeof speed === "object" ? jQuery.extend({}, speed) : {
            complete: fn || !fn && easing || jQuery.isFunction(speed) && speed,
            duration: speed,
            easing: fn && easing || easing && !jQuery.isFunction(easing) && easing
        };
        // Go to the end state if fx are off
        if (jQuery.fx.off) opt.duration = 0;
        else if (typeof opt.duration !== "number") {
            if (opt.duration in jQuery.fx.speeds) opt.duration = jQuery.fx.speeds[opt.duration];
            else opt.duration = jQuery.fx.speeds._default;
        }
        // Normalize opt.queue - true/undefined/null -> "fx"
        if (opt.queue == null || opt.queue === true) opt.queue = "fx";
        // Queueing
        opt.old = opt.complete;
        opt.complete = function() {
            if (jQuery.isFunction(opt.old)) opt.old.call(this);
            if (opt.queue) jQuery.dequeue(this, opt.queue);
        };
        return opt;
    };
    jQuery.fn.extend({
        fadeTo: function fadeTo(speed, to, easing, callback) {
            // Show any hidden elements after setting opacity to 0
            return this.filter(isHiddenWithinTree).css("opacity", 0).show()// Animate to the value specified
            .end().animate({
                opacity: to
            }, speed, easing, callback);
        },
        animate: function animate(prop, speed, easing, callback) {
            var empty = jQuery.isEmptyObject(prop), optall = jQuery.speed(speed, easing, callback), doAnimation = function doAnimation() {
                // Operate on a copy of prop so per-property easing won't be lost
                var anim = Animation(this, jQuery.extend({}, prop), optall);
                // Empty animations, or finishing resolves immediately
                if (empty || dataPriv.get(this, "finish")) anim.stop(true);
            };
            doAnimation.finish = doAnimation;
            return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
        },
        stop: function stop(type, clearQueue, gotoEnd) {
            var stopQueue = function stopQueue(hooks) {
                var stop = hooks.stop;
                delete hooks.stop;
                stop(gotoEnd);
            };
            if (typeof type !== "string") {
                gotoEnd = clearQueue;
                clearQueue = type;
                type = undefined;
            }
            if (clearQueue && type !== false) this.queue(type || "fx", []);
            return this.each(function() {
                var dequeue = true, index = type != null && type + "queueHooks", timers = jQuery.timers, data = dataPriv.get(this);
                if (index) {
                    if (data[index] && data[index].stop) stopQueue(data[index]);
                } else {
                    for(index in data)if (data[index] && data[index].stop && rrun.test(index)) stopQueue(data[index]);
                }
                for(index = timers.length; index--;)if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
                    timers[index].anim.stop(gotoEnd);
                    dequeue = false;
                    timers.splice(index, 1);
                }
                // Start the next in the queue if the last step wasn't forced.
                // Timers currently will call their complete callbacks, which
                // will dequeue but only if they were gotoEnd.
                if (dequeue || !gotoEnd) jQuery.dequeue(this, type);
            });
        },
        finish: function finish(type) {
            if (type !== false) type = type || "fx";
            return this.each(function() {
                var index, data = dataPriv.get(this), queue = data[type + "queue"], hooks = data[type + "queueHooks"], timers = jQuery.timers, length = queue ? queue.length : 0;
                // Enable finishing flag on private data
                data.finish = true;
                // Empty the queue first
                jQuery.queue(this, type, []);
                if (hooks && hooks.stop) hooks.stop.call(this, true);
                // Look for any active animations, and finish them
                for(index = timers.length; index--;)if (timers[index].elem === this && timers[index].queue === type) {
                    timers[index].anim.stop(true);
                    timers.splice(index, 1);
                }
                // Look for any animations in the old queue and finish them
                for(index = 0; index < length; index++)if (queue[index] && queue[index].finish) queue[index].finish.call(this);
                // Turn off finishing flag
                delete data.finish;
            });
        }
    });
    jQuery.each([
        "toggle",
        "show",
        "hide"
    ], function(i, name) {
        var cssFn = jQuery.fn[name];
        jQuery.fn[name] = function(speed, easing, callback) {
            return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
        };
    });
    // Generate shortcuts for custom animations
    jQuery.each({
        slideDown: genFx("show"),
        slideUp: genFx("hide"),
        slideToggle: genFx("toggle"),
        fadeIn: {
            opacity: "show"
        },
        fadeOut: {
            opacity: "hide"
        },
        fadeToggle: {
            opacity: "toggle"
        }
    }, function(name, props) {
        jQuery.fn[name] = function(speed, easing, callback) {
            return this.animate(props, speed, easing, callback);
        };
    });
    jQuery.timers = [];
    jQuery.fx.tick = function() {
        var timer, i = 0, timers = jQuery.timers;
        fxNow = jQuery.now();
        for(; i < timers.length; i++){
            timer = timers[i];
            // Run the timer and safely remove it when done (allowing for external removal)
            if (!timer() && timers[i] === timer) timers.splice(i--, 1);
        }
        if (!timers.length) jQuery.fx.stop();
        fxNow = undefined;
    };
    jQuery.fx.timer = function(timer) {
        jQuery.timers.push(timer);
        jQuery.fx.start();
    };
    jQuery.fx.interval = 13;
    jQuery.fx.start = function() {
        if (inProgress) return;
        inProgress = true;
        schedule();
    };
    jQuery.fx.stop = function() {
        inProgress = null;
    };
    jQuery.fx.speeds = {
        slow: 600,
        fast: 200,
        // Default speed
        _default: 400
    };
    // Based off of the plugin by Clint Helfers, with permission.
    // https://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
    jQuery.fn.delay = function(time, type) {
        time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
        type = type || "fx";
        return this.queue(type, function(next, hooks) {
            var timeout = window1.setTimeout(next, time);
            hooks.stop = function() {
                window1.clearTimeout(timeout);
            };
        });
    };
    (function() {
        var input = document.createElement("input"), select = document.createElement("select"), opt = select.appendChild(document.createElement("option"));
        input.type = "checkbox";
        // Support: Android <=4.3 only
        // Default value for a checkbox should be "on"
        support.checkOn = input.value !== "";
        // Support: IE <=11 only
        // Must access selectedIndex to make default options select
        support.optSelected = opt.selected;
        // Support: IE <=11 only
        // An input loses its value after becoming a radio
        input = document.createElement("input");
        input.value = "t";
        input.type = "radio";
        support.radioValue = input.value === "t";
    })();
    var boolHook, attrHandle = jQuery.expr.attrHandle;
    jQuery.fn.extend({
        attr: function attr(name, value) {
            return access(this, jQuery.attr, name, value, arguments.length > 1);
        },
        removeAttr: function removeAttr(name) {
            return this.each(function() {
                jQuery.removeAttr(this, name);
            });
        }
    });
    jQuery.extend({
        attr: function attr(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set attributes on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            // Fallback to prop when attributes are not supported
            if (typeof elem.getAttribute === "undefined") return jQuery.prop(elem, name, value);
            // Attribute hooks are determined by the lowercase version
            // Grab necessary hook if one is defined
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
            if (value !== undefined) {
                if (value === null) {
                    jQuery.removeAttr(elem, name);
                    return;
                }
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                elem.setAttribute(name, value + "");
                return value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            ret = jQuery.find.attr(elem, name);
            // Non-existent attributes return null, we normalize to undefined
            return ret == null ? undefined : ret;
        },
        attrHooks: {
            type: {
                set: function set(elem, value) {
                    if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
                        var val = elem.value;
                        elem.setAttribute("type", value);
                        if (val) elem.value = val;
                        return value;
                    }
                }
            }
        },
        removeAttr: function removeAttr(elem, value) {
            var name, i = 0, // Attribute names can contain non-HTML whitespace characters
            // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
            attrNames = value && value.match(rnothtmlwhite);
            if (attrNames && elem.nodeType === 1) while(name = attrNames[i++])elem.removeAttribute(name);
        }
    });
    // Hooks for boolean attributes
    boolHook = {
        set: function set(elem, value, name) {
            if (value === false) // Remove boolean attributes when set to false
            jQuery.removeAttr(elem, name);
            else elem.setAttribute(name, name);
            return name;
        }
    };
    jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function(i, name) {
        var getter = attrHandle[name] || jQuery.find.attr;
        attrHandle[name] = function(elem, name, isXML) {
            var ret, handle, lowercaseName = name.toLowerCase();
            if (!isXML) {
                // Avoid an infinite loop by temporarily removing this function from the getter
                handle = attrHandle[lowercaseName];
                attrHandle[lowercaseName] = ret;
                ret = getter(elem, name, isXML) != null ? lowercaseName : null;
                attrHandle[lowercaseName] = handle;
            }
            return ret;
        };
    });
    var rfocusable = /^(?:input|select|textarea|button)$/i, rclickable = /^(?:a|area)$/i;
    jQuery.fn.extend({
        prop: function prop(name, value) {
            return access(this, jQuery.prop, name, value, arguments.length > 1);
        },
        removeProp: function removeProp(name) {
            return this.each(function() {
                delete this[jQuery.propFix[name] || name];
            });
        }
    });
    jQuery.extend({
        prop: function prop(elem, name, value) {
            var ret, hooks, nType = elem.nodeType;
            // Don't get/set properties on text, comment and attribute nodes
            if (nType === 3 || nType === 8 || nType === 2) return;
            if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
                // Fix name and attach hooks
                name = jQuery.propFix[name] || name;
                hooks = jQuery.propHooks[name];
            }
            if (value !== undefined) {
                if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) return ret;
                return elem[name] = value;
            }
            if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) return ret;
            return elem[name];
        },
        propHooks: {
            tabIndex: {
                get: function get(elem) {
                    // Support: IE <=9 - 11 only
                    // elem.tabIndex doesn't always return the
                    // correct value when it hasn't been explicitly set
                    // https://web.archive.org/web/20141116233347/http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
                    // Use proper attribute retrieval(#12072)
                    var tabindex = jQuery.find.attr(elem, "tabindex");
                    if (tabindex) return parseInt(tabindex, 10);
                    if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) return 0;
                    return -1;
                }
            }
        },
        propFix: {
            "for": "htmlFor",
            "class": "className"
        }
    });
    // Support: IE <=11 only
    // Accessing the selectedIndex property
    // forces the browser to respect setting selected
    // on the option
    // The getter ensures a default option is selected
    // when in an optgroup
    // eslint rule "no-unused-expressions" is disabled for this code
    // since it considers such accessions noop
    if (!support.optSelected) jQuery.propHooks.selected = {
        get: function get(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent && parent.parentNode) parent.parentNode.selectedIndex;
            return null;
        },
        set: function set(elem) {
            /* eslint no-unused-expressions: "off" */ var parent = elem.parentNode;
            if (parent) {
                parent.selectedIndex;
                if (parent.parentNode) parent.parentNode.selectedIndex;
            }
        }
    };
    jQuery.each([
        "tabIndex",
        "readOnly",
        "maxLength",
        "cellSpacing",
        "cellPadding",
        "rowSpan",
        "colSpan",
        "useMap",
        "frameBorder",
        "contentEditable"
    ], function() {
        jQuery.propFix[this.toLowerCase()] = this;
    });
    // Strip and collapse whitespace according to HTML spec
    // https://html.spec.whatwg.org/multipage/infrastructure.html#strip-and-collapse-whitespace
    function stripAndCollapse(value) {
        var tokens = value.match(rnothtmlwhite) || [];
        return tokens.join(" ");
    }
    function getClass(elem) {
        return elem.getAttribute && elem.getAttribute("class") || "";
    }
    jQuery.fn.extend({
        addClass: function addClass(value) {
            var classes, elem, cur, curValue, clazz, j, finalValue, i = 0;
            if (jQuery.isFunction(value)) return this.each(function(j) {
                jQuery(this).addClass(value.call(this, j, getClass(this)));
            });
            if (typeof value === "string" && value) {
                classes = value.match(rnothtmlwhite) || [];
                while(elem = this[i++]){
                    curValue = getClass(elem);
                    cur = elem.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                    if (cur) {
                        j = 0;
                        while(clazz = classes[j++])if (cur.indexOf(" " + clazz + " ") < 0) cur += clazz + " ";
                        // Only assign if different to avoid unneeded rendering.
                        finalValue = stripAndCollapse(cur);
                        if (curValue !== finalValue) elem.setAttribute("class", finalValue);
                    }
                }
            }
            return this;
        },
        removeClass: function removeClass(value) {
            var classes, elem, cur, curValue, clazz, j, finalValue, i = 0;
            if (jQuery.isFunction(value)) return this.each(function(j) {
                jQuery(this).removeClass(value.call(this, j, getClass(this)));
            });
            if (!arguments.length) return this.attr("class", "");
            if (typeof value === "string" && value) {
                classes = value.match(rnothtmlwhite) || [];
                while(elem = this[i++]){
                    curValue = getClass(elem);
                    // This expression is here for better compressibility (see addClass)
                    cur = elem.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
                    if (cur) {
                        j = 0;
                        while(clazz = classes[j++])// Remove *all* instances
                        while(cur.indexOf(" " + clazz + " ") > -1)cur = cur.replace(" " + clazz + " ", " ");
                        // Only assign if different to avoid unneeded rendering.
                        finalValue = stripAndCollapse(cur);
                        if (curValue !== finalValue) elem.setAttribute("class", finalValue);
                    }
                }
            }
            return this;
        },
        toggleClass: function toggleClass(value, stateVal) {
            var type = typeof value === "undefined" ? "undefined" : (0, $alyXF._)(value);
            if (typeof stateVal === "boolean" && type === "string") return stateVal ? this.addClass(value) : this.removeClass(value);
            if (jQuery.isFunction(value)) return this.each(function(i) {
                jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
            });
            return this.each(function() {
                var className, i, self, classNames;
                if (type === "string") {
                    // Toggle individual class names
                    i = 0;
                    self = jQuery(this);
                    classNames = value.match(rnothtmlwhite) || [];
                    while(className = classNames[i++])// Check each className given, space separated list
                    if (self.hasClass(className)) self.removeClass(className);
                    else self.addClass(className);
                // Toggle whole class name
                } else if (value === undefined || type === "boolean") {
                    className = getClass(this);
                    if (className) // Store className if set
                    dataPriv.set(this, "__className__", className);
                    // If the element has a class name or if we're passed `false`,
                    // then remove the whole classname (if there was one, the above saved it).
                    // Otherwise bring back whatever was previously saved (if anything),
                    // falling back to the empty string if nothing was stored.
                    if (this.setAttribute) this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
                }
            });
        },
        hasClass: function hasClass(selector) {
            var className, elem, i = 0;
            className = " " + selector + " ";
            while(elem = this[i++]){
                if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) return true;
            }
            return false;
        }
    });
    var rreturn = /\r/g;
    jQuery.fn.extend({
        val: function val(value) {
            var hooks, ret, isFunction, elem = this[0];
            if (!arguments.length) {
                if (elem) {
                    hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
                    if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) return ret;
                    ret = elem.value;
                    // Handle most common string cases
                    if (typeof ret === "string") return ret.replace(rreturn, "");
                    // Handle cases where value is null/undef or number
                    return ret == null ? "" : ret;
                }
                return;
            }
            isFunction = jQuery.isFunction(value);
            return this.each(function(i) {
                var val;
                if (this.nodeType !== 1) return;
                if (isFunction) val = value.call(this, i, jQuery(this).val());
                else val = value;
                // Treat null/undefined as ""; convert numbers to string
                if (val == null) val = "";
                else if (typeof val === "number") val += "";
                else if (Array.isArray(val)) val = jQuery.map(val, function(value) {
                    return value == null ? "" : value + "";
                });
                hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];
                // If set returns undefined, fall back to normal setting
                if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) this.value = val;
            });
        }
    });
    jQuery.extend({
        valHooks: {
            option: {
                get: function get(elem) {
                    var val = jQuery.find.attr(elem, "value");
                    return val != null ? val : // Support: IE <=10 - 11 only
                    // option.text throws exceptions (#14686, #14858)
                    // Strip and collapse whitespace
                    // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
                    stripAndCollapse(jQuery.text(elem));
                }
            },
            select: {
                get: function get(elem) {
                    var value, option, i, options = elem.options, index = elem.selectedIndex, one = elem.type === "select-one", values = one ? null : [], max = one ? index + 1 : options.length;
                    if (index < 0) i = max;
                    else i = one ? index : 0;
                    // Loop through all the selected options
                    for(; i < max; i++){
                        option = options[i];
                        // Support: IE <=9 only
                        // IE8-9 doesn't update selected after form reset (#2551)
                        if ((option.selected || i === index) && // Don't return options that are disabled or in a disabled optgroup
                        !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
                            // Get the specific value for the option
                            value = jQuery(option).val();
                            // We don't need an array for one selects
                            if (one) return value;
                            // Multi-Selects return an array
                            values.push(value);
                        }
                    }
                    return values;
                },
                set: function set(elem, value) {
                    var optionSet, option, options = elem.options, values = jQuery.makeArray(value), i = options.length;
                    while(i--){
                        option = options[i];
                        /* eslint-disable no-cond-assign */ if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) optionSet = true;
                    /* eslint-enable no-cond-assign */ }
                    // Force browsers to behave consistently when non-matching value is set
                    if (!optionSet) elem.selectedIndex = -1;
                    return values;
                }
            }
        }
    });
    // Radios and checkboxes getter/setter
    jQuery.each([
        "radio",
        "checkbox"
    ], function() {
        jQuery.valHooks[this] = {
            set: function set(elem, value) {
                if (Array.isArray(value)) return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
            }
        };
        if (!support.checkOn) jQuery.valHooks[this].get = function(elem) {
            return elem.getAttribute("value") === null ? "on" : elem.value;
        };
    });
    // Return jQuery for attributes-only inclusion
    var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;
    jQuery.extend(jQuery.event, {
        trigger: function trigger(event, data, elem, onlyHandlers) {
            var i, cur, tmp, bubbleType, ontype, handle, special, eventPath = [
                elem || document
            ], type = hasOwn.call(event, "type") ? event.type : event, namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
            cur = tmp = elem = elem || document;
            // Don't do events on text and comment nodes
            if (elem.nodeType === 3 || elem.nodeType === 8) return;
            // focus/blur morphs to focusin/out; ensure we're not firing them right now
            if (rfocusMorph.test(type + jQuery.event.triggered)) return;
            if (type.indexOf(".") > -1) {
                // Namespaced trigger; create a regexp to match event type in handle()
                namespaces = type.split(".");
                type = namespaces.shift();
                namespaces.sort();
            }
            ontype = type.indexOf(":") < 0 && "on" + type;
            // Caller can pass in a jQuery.Event object, Object, or just an event type string
            event = event[jQuery.expando] ? event : new jQuery.Event(type, typeof event === "object" && event);
            // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
            event.isTrigger = onlyHandlers ? 2 : 3;
            event.namespace = namespaces.join(".");
            event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;
            // Clean up the event in case it is being reused
            event.result = undefined;
            if (!event.target) event.target = elem;
            // Clone any incoming data and prepend the event, creating the handler arg list
            data = data == null ? [
                event
            ] : jQuery.makeArray(data, [
                event
            ]);
            // Allow special events to draw outside the lines
            special = jQuery.event.special[type] || {};
            if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) return;
            // Determine event propagation path in advance, per W3C events spec (#9951)
            // Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
            if (!onlyHandlers && !special.noBubble && !jQuery.isWindow(elem)) {
                bubbleType = special.delegateType || type;
                if (!rfocusMorph.test(bubbleType + type)) cur = cur.parentNode;
                for(; cur; cur = cur.parentNode){
                    eventPath.push(cur);
                    tmp = cur;
                }
                // Only add window if we got to document (e.g., not plain obj or detached DOM)
                if (tmp === (elem.ownerDocument || document)) eventPath.push(tmp.defaultView || tmp.parentWindow || window1);
            }
            // Fire handlers on the event path
            i = 0;
            while((cur = eventPath[i++]) && !event.isPropagationStopped()){
                event.type = i > 1 ? bubbleType : special.bindType || type;
                // jQuery handler
                handle = (dataPriv.get(cur, "events") || {})[event.type] && dataPriv.get(cur, "handle");
                if (handle) handle.apply(cur, data);
                // Native handler
                handle = ontype && cur[ontype];
                if (handle && handle.apply && acceptData(cur)) {
                    event.result = handle.apply(cur, data);
                    if (event.result === false) event.preventDefault();
                }
            }
            event.type = type;
            // If nobody prevented the default action, do it now
            if (!onlyHandlers && !event.isDefaultPrevented()) {
                if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) // Call a native DOM method on the target with the same name as the event.
                // Don't do default actions on window, that's where global variables be (#6170)
                {
                    if (ontype && jQuery.isFunction(elem[type]) && !jQuery.isWindow(elem)) {
                        // Don't re-trigger an onFOO event when we call its FOO() method
                        tmp = elem[ontype];
                        if (tmp) elem[ontype] = null;
                        // Prevent re-triggering of the same event, since we already bubbled it above
                        jQuery.event.triggered = type;
                        elem[type]();
                        jQuery.event.triggered = undefined;
                        if (tmp) elem[ontype] = tmp;
                    }
                }
            }
            return event.result;
        },
        // Piggyback on a donor event to simulate a different one
        // Used only for `focus(in | out)` events
        simulate: function simulate(type, elem, event) {
            var e = jQuery.extend(new jQuery.Event(), event, {
                type: type,
                isSimulated: true
            });
            jQuery.event.trigger(e, null, elem);
        }
    });
    jQuery.fn.extend({
        trigger: function trigger(type, data) {
            return this.each(function() {
                jQuery.event.trigger(type, data, this);
            });
        },
        triggerHandler: function triggerHandler(type, data) {
            var elem = this[0];
            if (elem) return jQuery.event.trigger(type, data, elem, true);
        }
    });
    jQuery.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function(i, name) {
        // Handle event binding
        jQuery.fn[name] = function(data, fn) {
            return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
        };
    });
    jQuery.fn.extend({
        hover: function hover(fnOver, fnOut) {
            return this.mouseenter(fnOver).mouseleave(fnOut || fnOver);
        }
    });
    support.focusin = "onfocusin" in window1;
    // Support: Firefox <=44
    // Firefox doesn't have focus(in | out) events
    // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
    //
    // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
    // focus(in | out) events fire after focus & blur events,
    // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
    // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
    if (!support.focusin) jQuery.each({
        focus: "focusin",
        blur: "focusout"
    }, function(orig, fix) {
        // Attach a single capturing handler on the document while someone wants focusin/focusout
        var handler = function handler(event) {
            jQuery.event.simulate(fix, event.target, jQuery.event.fix(event));
        };
        jQuery.event.special[fix] = {
            setup: function setup() {
                var doc = this.ownerDocument || this, attaches = dataPriv.access(doc, fix);
                if (!attaches) doc.addEventListener(orig, handler, true);
                dataPriv.access(doc, fix, (attaches || 0) + 1);
            },
            teardown: function teardown() {
                var doc = this.ownerDocument || this, attaches = dataPriv.access(doc, fix) - 1;
                if (!attaches) {
                    doc.removeEventListener(orig, handler, true);
                    dataPriv.remove(doc, fix);
                } else dataPriv.access(doc, fix, attaches);
            }
        };
    });
    var location = window1.location;
    var nonce = jQuery.now();
    var rquery = /\?/;
    // Cross-browser xml parsing
    jQuery.parseXML = function(data) {
        var xml;
        if (!data || typeof data !== "string") return null;
        // Support: IE 9 - 11 only
        // IE throws on parseFromString with invalid input.
        try {
            xml = new window1.DOMParser().parseFromString(data, "text/xml");
        } catch (e) {
            xml = undefined;
        }
        if (!xml || xml.getElementsByTagName("parsererror").length) jQuery.error("Invalid XML: " + data);
        return xml;
    };
    var rbracket = /\[\]$/, rCRLF = /\r?\n/g, rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i, rsubmittable = /^(?:input|select|textarea|keygen)/i;
    function buildParams(prefix, obj, traditional, add) {
        var name;
        if (Array.isArray(obj)) // Serialize array item.
        jQuery.each(obj, function(i, v) {
            if (traditional || rbracket.test(prefix)) // Treat each array item as a scalar.
            add(prefix, v);
            else // Item is non-scalar (array or object), encode its numeric index.
            buildParams(prefix + "[" + (typeof v === "object" && v != null ? i : "") + "]", v, traditional, add);
        });
        else if (!traditional && jQuery.type(obj) === "object") // Serialize object item.
        for(name in obj)buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
        else // Serialize scalar item.
        add(prefix, obj);
    }
    // Serialize an array of form elements or a set of
    // key/values into a query string
    jQuery.param = function(a, traditional) {
        var prefix, s = [], add = function add(key, valueOrFunction) {
            // If value is a function, invoke it and use its return value
            var value = jQuery.isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
            s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
        };
        // If an array was passed in, assume that it is an array of form elements.
        if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) // Serialize the form elements
        jQuery.each(a, function() {
            add(this.name, this.value);
        });
        else // If traditional, encode the "old" way (the way 1.3.2 or older
        // did it), otherwise encode params recursively.
        for(prefix in a)buildParams(prefix, a[prefix], traditional, add);
        // Return the resulting serialization
        return s.join("&");
    };
    jQuery.fn.extend({
        serialize: function serialize() {
            return jQuery.param(this.serializeArray());
        },
        serializeArray: function serializeArray() {
            return this.map(function() {
                // Can add propHook for "elements" to filter or add form elements
                var elements = jQuery.prop(this, "elements");
                return elements ? jQuery.makeArray(elements) : this;
            }).filter(function() {
                var type = this.type;
                // Use .is( ":disabled" ) so that fieldset[disabled] works
                return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
            }).map(function(i, elem) {
                var val = jQuery(this).val();
                if (val == null) return null;
                if (Array.isArray(val)) return jQuery.map(val, function(val) {
                    return {
                        name: elem.name,
                        value: val.replace(rCRLF, "\r\n")
                    };
                });
                return {
                    name: elem.name,
                    value: val.replace(rCRLF, "\r\n")
                };
            }).get();
        }
    });
    var r20 = /%20/g, rhash = /#.*$/, rantiCache = /([?&])_=[^&]*/, rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg, // #7653, #8125, #8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/, rnoContent = /^(?:GET|HEAD)$/, rprotocol = /^\/\//, /* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */ prefilters = {}, /* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */ transports = {}, // Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
    allTypes = "*/".concat("*"), // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
    originAnchor.href = location.href;
    // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
    function addToPrefiltersOrTransports(structure) {
        // dataTypeExpression is optional and defaults to "*"
        return function(dataTypeExpression, func) {
            if (typeof dataTypeExpression !== "string") {
                func = dataTypeExpression;
                dataTypeExpression = "*";
            }
            var dataType, i = 0, dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
            if (jQuery.isFunction(func)) {
                // For each dataType in the dataTypeExpression
                while(dataType = dataTypes[i++])// Prepend if requested
                if (dataType[0] === "+") {
                    dataType = dataType.slice(1) || "*";
                    (structure[dataType] = structure[dataType] || []).unshift(func);
                // Otherwise append
                } else (structure[dataType] = structure[dataType] || []).push(func);
            }
        };
    }
    // Base inspection function for prefilters and transports
    function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
        var inspected = {}, seekingTransport = structure === transports;
        function inspect(dataType) {
            var selected;
            inspected[dataType] = true;
            jQuery.each(structure[dataType] || [], function(_, prefilterOrFactory) {
                var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
                if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
                    options.dataTypes.unshift(dataTypeOrTransport);
                    inspect(dataTypeOrTransport);
                    return false;
                } else if (seekingTransport) return !(selected = dataTypeOrTransport);
            });
            return selected;
        }
        return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
    }
    // A special extend for ajax options
    // that takes "flat" options (not to be deep extended)
    // Fixes #9887
    function ajaxExtend(target, src) {
        var key, deep, flatOptions = jQuery.ajaxSettings.flatOptions || {};
        for(key in src)if (src[key] !== undefined) (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
        if (deep) jQuery.extend(true, target, deep);
        return target;
    }
    /* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */ function ajaxHandleResponses(s, jqXHR, responses) {
        var ct, type, finalDataType, firstDataType, contents = s.contents, dataTypes = s.dataTypes;
        // Remove auto dataType and get content-type in the process
        while(dataTypes[0] === "*"){
            dataTypes.shift();
            if (ct === undefined) ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
        }
        // Check if we're dealing with a known content-type
        if (ct) {
            for(type in contents)if (contents[type] && contents[type].test(ct)) {
                dataTypes.unshift(type);
                break;
            }
        }
        // Check to see if we have a response for the expected dataType
        if (dataTypes[0] in responses) finalDataType = dataTypes[0];
        else {
            // Try convertible dataTypes
            for(type in responses){
                if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
                    finalDataType = type;
                    break;
                }
                if (!firstDataType) firstDataType = type;
            }
            // Or just use first one
            finalDataType = finalDataType || firstDataType;
        }
        // If we found a dataType
        // We add the dataType to the list if needed
        // and return the corresponding response
        if (finalDataType) {
            if (finalDataType !== dataTypes[0]) dataTypes.unshift(finalDataType);
            return responses[finalDataType];
        }
    }
    /* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */ function ajaxConvert(s, response, jqXHR, isSuccess) {
        var conv2, current, conv, tmp, prev, converters = {}, // Work with a copy of dataTypes in case we need to modify it for conversion
        dataTypes = s.dataTypes.slice();
        // Create converters map with lowercased keys
        if (dataTypes[1]) for(conv in s.converters)converters[conv.toLowerCase()] = s.converters[conv];
        current = dataTypes.shift();
        // Convert to each sequential dataType
        while(current){
            if (s.responseFields[current]) jqXHR[s.responseFields[current]] = response;
            // Apply the dataFilter if provided
            if (!prev && isSuccess && s.dataFilter) response = s.dataFilter(response, s.dataType);
            prev = current;
            current = dataTypes.shift();
            if (current) {
                // There's only work to do if current dataType is non-auto
                if (current === "*") current = prev;
                else if (prev !== "*" && prev !== current) {
                    // Seek a direct converter
                    conv = converters[prev + " " + current] || converters["* " + current];
                    // If none found, seek a pair
                    if (!conv) for(conv2 in converters){
                        // If conv2 outputs current
                        tmp = conv2.split(" ");
                        if (tmp[1] === current) {
                            // If prev can be converted to accepted input
                            conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                            if (conv) {
                                // Condense equivalence converters
                                if (conv === true) conv = converters[conv2];
                                else if (converters[conv2] !== true) {
                                    current = tmp[0];
                                    dataTypes.unshift(tmp[1]);
                                }
                                break;
                            }
                        }
                    }
                    // Apply converter (if not an equivalence)
                    if (conv !== true) {
                        // Unless errors are allowed to bubble, catch and return them
                        if (conv && s.throws) response = conv(response);
                        else try {
                            response = conv(response);
                        } catch (e) {
                            return {
                                state: "parsererror",
                                error: conv ? e : "No conversion from " + prev + " to " + current
                            };
                        }
                    }
                }
            }
        }
        return {
            state: "success",
            data: response
        };
    }
    jQuery.extend({
        // Counter for holding the number of active queries
        active: 0,
        // Last-Modified header cache for next request
        lastModified: {},
        etag: {},
        ajaxSettings: {
            url: location.href,
            type: "GET",
            isLocal: rlocalProtocol.test(location.protocol),
            global: true,
            processData: true,
            async: true,
            contentType: "application/x-www-form-urlencoded; charset=UTF-8",
            /*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/ accepts: {
                "*": allTypes,
                text: "text/plain",
                html: "text/html",
                xml: "application/xml, text/xml",
                json: "application/json, text/javascript"
            },
            contents: {
                xml: /\bxml\b/,
                html: /\bhtml/,
                json: /\bjson\b/
            },
            responseFields: {
                xml: "responseXML",
                text: "responseText",
                json: "responseJSON"
            },
            // Data converters
            // Keys separate source (or catchall "*") and destination types with a single space
            converters: {
                // Convert anything to text
                "* text": String,
                // Text to html (true = no transformation)
                "text html": true,
                // Evaluate text as a json expression
                "text json": JSON.parse,
                // Parse text as xml
                "text xml": jQuery.parseXML
            },
            // For options that shouldn't be deep extended:
            // you can add your own custom options here if
            // and when you create one that shouldn't be
            // deep extended (see ajaxExtend)
            flatOptions: {
                url: true,
                context: true
            }
        },
        // Creates a full fledged settings object into target
        // with both ajaxSettings and settings fields.
        // If target is omitted, writes into ajaxSettings.
        ajaxSetup: function ajaxSetup(target, settings) {
            return settings ? // Building a settings object
            ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) : // Extending ajaxSettings
            ajaxExtend(jQuery.ajaxSettings, target);
        },
        ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
        ajaxTransport: addToPrefiltersOrTransports(transports),
        // Main method
        ajax: function ajax(url, options) {
            // If url is an object, simulate pre-1.5 signature
            if (typeof url === "object") {
                options = url;
                url = undefined;
            }
            // Force options to be an object
            options = options || {};
            var transport, // URL without anti-cache param
            cacheURL, // Response headers
            responseHeadersString, responseHeaders, // timeout handle
            timeoutTimer, // Url cleanup var
            urlAnchor, // Request state (becomes false upon send and true upon completion)
            _$completed, // To know if global events are to be dispatched
            fireGlobals, // Loop variable
            i, // uncached part of the url
            uncached, // Create the final options object
            s = jQuery.ajaxSetup({}, options), // Callbacks context
            callbackContext = s.context || s, // Context for global events is callbackContext if it is a DOM node or jQuery collection
            globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event, // Deferreds
            deferred = jQuery.Deferred(), completeDeferred = jQuery.Callbacks("once memory"), // Status-dependent callbacks
            statusCode = s.statusCode || {}, // Headers (they are sent all at once)
            requestHeaders = {}, requestHeadersNames = {}, // Default abort message
            strAbort = "canceled", // Fake xhr
            jqXHR = {
                readyState: 0,
                // Builds headers hashtable if needed
                getResponseHeader: function getResponseHeader(key) {
                    var match;
                    if (_$completed) {
                        if (!responseHeaders) {
                            responseHeaders = {};
                            while(match = rheaders.exec(responseHeadersString))responseHeaders[match[1].toLowerCase()] = match[2];
                        }
                        match = responseHeaders[key.toLowerCase()];
                    }
                    return match == null ? null : match;
                },
                // Raw string
                getAllResponseHeaders: function getAllResponseHeaders() {
                    return _$completed ? responseHeadersString : null;
                },
                // Caches the header
                setRequestHeader: function setRequestHeader(name, value) {
                    if (_$completed == null) {
                        name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
                        requestHeaders[name] = value;
                    }
                    return this;
                },
                // Overrides response content-type header
                overrideMimeType: function overrideMimeType(type) {
                    if (_$completed == null) s.mimeType = type;
                    return this;
                },
                // Status-dependent callbacks
                statusCode: function statusCode1(map) {
                    var code;
                    if (map) {
                        if (_$completed) // Execute the appropriate callbacks
                        jqXHR.always(map[jqXHR.status]);
                        else // Lazy-add the new callbacks in a way that preserves old ones
                        for(code in map)statusCode[code] = [
                            statusCode[code],
                            map[code]
                        ];
                    }
                    return this;
                },
                // Cancel the request
                abort: function abort(statusText) {
                    var finalText = statusText || strAbort;
                    if (transport) transport.abort(finalText);
                    done(0, finalText);
                    return this;
                }
            };
            // Attach deferreds
            deferred.promise(jqXHR);
            // Add protocol if not provided (prefilters might expect it)
            // Handle falsy url in the settings object (#10093: consistency with old signature)
            // We also use the url parameter if available
            s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");
            // Alias method option to type as per ticket #12004
            s.type = options.method || options.type || s.method || s.type;
            // Extract dataTypes list
            s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [
                ""
            ];
            // A cross-domain request is in order when the origin doesn't match the current origin.
            if (s.crossDomain == null) {
                urlAnchor = document.createElement("a");
                // Support: IE <=8 - 11, Edge 12 - 13
                // IE throws exception on accessing the href property if url is malformed,
                // e.g. http://example.com:80x/
                try {
                    urlAnchor.href = s.url;
                    // Support: IE <=8 - 11 only
                    // Anchor's host property isn't correctly set when s.url is relative
                    urlAnchor.href = urlAnchor.href;
                    s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
                } catch (e) {
                    // If there is an error parsing the URL, assume it is crossDomain,
                    // it can be rejected by the transport if it is invalid
                    s.crossDomain = true;
                }
            }
            // Convert data if not already a string
            if (s.data && s.processData && typeof s.data !== "string") s.data = jQuery.param(s.data, s.traditional);
            // Apply prefilters
            inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);
            // If request was aborted inside a prefilter, stop there
            if (_$completed) return jqXHR;
            // We can fire global events as of now if asked to
            // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
            fireGlobals = jQuery.event && s.global;
            // Watch for a new set of requests
            if (fireGlobals && jQuery.active++ === 0) jQuery.event.trigger("ajaxStart");
            // Uppercase the type
            s.type = s.type.toUpperCase();
            // Determine if request has content
            s.hasContent = !rnoContent.test(s.type);
            // Save the URL in case we're toying with the If-Modified-Since
            // and/or If-None-Match header later on
            // Remove hash to simplify url manipulation
            cacheURL = s.url.replace(rhash, "");
            // More options handling for requests with no content
            if (!s.hasContent) {
                // Remember the hash so we can put it back
                uncached = s.url.slice(cacheURL.length);
                // If data is available, append data to url
                if (s.data) {
                    cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;
                    // #9682: remove data so that it's not used in an eventual retry
                    delete s.data;
                }
                // Add or update anti-cache param if needed
                if (s.cache === false) {
                    cacheURL = cacheURL.replace(rantiCache, "$1");
                    uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce++ + uncached;
                }
                // Put hash and anti-cache on the URL that will be requested (gh-1732)
                s.url = cacheURL + uncached;
            // Change '%20' to '+' if this is encoded form body content (gh-2658)
            } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) s.data = s.data.replace(r20, "+");
            // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
            if (s.ifModified) {
                if (jQuery.lastModified[cacheURL]) jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
                if (jQuery.etag[cacheURL]) jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
            }
            // Set the correct header, if data is being sent
            if (s.data && s.hasContent && s.contentType !== false || options.contentType) jqXHR.setRequestHeader("Content-Type", s.contentType);
            // Set the Accepts header for the server, depending on the dataType
            jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);
            // Check for headers option
            for(i in s.headers)jqXHR.setRequestHeader(i, s.headers[i]);
            // Allow custom headers/mimetypes and early abort
            if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || _$completed)) // Abort if not done already and return
            return jqXHR.abort();
            // Aborting is no longer a cancellation
            strAbort = "abort";
            // Install callbacks on deferreds
            completeDeferred.add(s.complete);
            jqXHR.done(s.success);
            jqXHR.fail(s.error);
            // Get transport
            transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);
            // If no transport, we auto-abort
            if (!transport) done(-1, "No Transport");
            else {
                jqXHR.readyState = 1;
                // Send global event
                if (fireGlobals) globalEventContext.trigger("ajaxSend", [
                    jqXHR,
                    s
                ]);
                // If request was aborted inside ajaxSend, stop there
                if (_$completed) return jqXHR;
                // Timeout
                if (s.async && s.timeout > 0) timeoutTimer = window1.setTimeout(function() {
                    jqXHR.abort("timeout");
                }, s.timeout);
                try {
                    _$completed = false;
                    transport.send(requestHeaders, done);
                } catch (e) {
                    // Rethrow post-completion exceptions
                    if (_$completed) throw e;
                    // Propagate others as results
                    done(-1, e);
                }
            }
            // Callback for when everything is done
            function done(status, nativeStatusText, responses, headers) {
                var isSuccess, success, error, response, modified, statusText = nativeStatusText;
                // Ignore repeat invocations
                if (_$completed) return;
                _$completed = true;
                // Clear timeout if it exists
                if (timeoutTimer) window1.clearTimeout(timeoutTimer);
                // Dereference transport for early garbage collection
                // (no matter how long the jqXHR object will be used)
                transport = undefined;
                // Cache response headers
                responseHeadersString = headers || "";
                // Set readyState
                jqXHR.readyState = status > 0 ? 4 : 0;
                // Determine if successful
                isSuccess = status >= 200 && status < 300 || status === 304;
                // Get response data
                if (responses) response = ajaxHandleResponses(s, jqXHR, responses);
                // Convert no matter what (that way responseXXX fields are always set)
                response = ajaxConvert(s, response, jqXHR, isSuccess);
                // If successful, handle type chaining
                if (isSuccess) {
                    // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
                    if (s.ifModified) {
                        modified = jqXHR.getResponseHeader("Last-Modified");
                        if (modified) jQuery.lastModified[cacheURL] = modified;
                        modified = jqXHR.getResponseHeader("etag");
                        if (modified) jQuery.etag[cacheURL] = modified;
                    }
                    // if no content
                    if (status === 204 || s.type === "HEAD") statusText = "nocontent";
                    else if (status === 304) statusText = "notmodified";
                    else {
                        statusText = response.state;
                        success = response.data;
                        error = response.error;
                        isSuccess = !error;
                    }
                } else {
                    // Extract error from statusText and normalize for non-aborts
                    error = statusText;
                    if (status || !statusText) {
                        statusText = "error";
                        if (status < 0) status = 0;
                    }
                }
                // Set data for the fake xhr object
                jqXHR.status = status;
                jqXHR.statusText = (nativeStatusText || statusText) + "";
                // Success/Error
                if (isSuccess) deferred.resolveWith(callbackContext, [
                    success,
                    statusText,
                    jqXHR
                ]);
                else deferred.rejectWith(callbackContext, [
                    jqXHR,
                    statusText,
                    error
                ]);
                // Status-dependent callbacks
                jqXHR.statusCode(statusCode);
                statusCode = undefined;
                if (fireGlobals) globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [
                    jqXHR,
                    s,
                    isSuccess ? success : error
                ]);
                // Complete
                completeDeferred.fireWith(callbackContext, [
                    jqXHR,
                    statusText
                ]);
                if (fireGlobals) {
                    globalEventContext.trigger("ajaxComplete", [
                        jqXHR,
                        s
                    ]);
                    // Handle the global AJAX counter
                    if (!--jQuery.active) jQuery.event.trigger("ajaxStop");
                }
            }
            return jqXHR;
        },
        getJSON: function getJSON(url, data, callback) {
            return jQuery.get(url, data, callback, "json");
        },
        getScript: function getScript(url, callback) {
            return jQuery.get(url, undefined, callback, "script");
        }
    });
    jQuery.each([
        "get",
        "post"
    ], function(i, method) {
        jQuery[method] = function(url, data, callback, type) {
            // Shift arguments if data argument was omitted
            if (jQuery.isFunction(data)) {
                type = type || callback;
                callback = data;
                data = undefined;
            }
            // The url can be an options object (which then must have .url)
            return jQuery.ajax(jQuery.extend({
                url: url,
                type: method,
                dataType: type,
                data: data,
                success: callback
            }, jQuery.isPlainObject(url) && url));
        };
    });
    jQuery._evalUrl = function(url) {
        return jQuery.ajax({
            url: url,
            // Make this explicit, since user can override this through ajaxSetup (#11264)
            type: "GET",
            dataType: "script",
            cache: true,
            async: false,
            global: false,
            "throws": true
        });
    };
    jQuery.fn.extend({
        wrapAll: function wrapAll(html) {
            var wrap;
            if (this[0]) {
                if (jQuery.isFunction(html)) html = html.call(this[0]);
                // The elements to wrap the target around
                wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
                if (this[0].parentNode) wrap.insertBefore(this[0]);
                wrap.map(function() {
                    var elem = this;
                    while(elem.firstElementChild)elem = elem.firstElementChild;
                    return elem;
                }).append(this);
            }
            return this;
        },
        wrapInner: function wrapInner(html) {
            if (jQuery.isFunction(html)) return this.each(function(i) {
                jQuery(this).wrapInner(html.call(this, i));
            });
            return this.each(function() {
                var self = jQuery(this), contents = self.contents();
                if (contents.length) contents.wrapAll(html);
                else self.append(html);
            });
        },
        wrap: function wrap(html) {
            var isFunction = jQuery.isFunction(html);
            return this.each(function(i) {
                jQuery(this).wrapAll(isFunction ? html.call(this, i) : html);
            });
        },
        unwrap: function unwrap(selector) {
            this.parent(selector).not("body").each(function() {
                jQuery(this).replaceWith(this.childNodes);
            });
            return this;
        }
    });
    jQuery.expr.pseudos.hidden = function(elem) {
        return !jQuery.expr.pseudos.visible(elem);
    };
    jQuery.expr.pseudos.visible = function(elem) {
        return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
    };
    jQuery.ajaxSettings.xhr = function() {
        try {
            return new window1.XMLHttpRequest();
        } catch (e) {}
    };
    var xhrSuccessStatus = {
        // File protocol always yields status code 0, assume 200
        0: 200,
        // Support: IE <=9 only
        // #1450: sometimes IE returns 1223 when it should be 204
        1223: 204
    }, xhrSupported = jQuery.ajaxSettings.xhr();
    support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
    support.ajax = xhrSupported = !!xhrSupported;
    jQuery.ajaxTransport(function(options) {
        var callback, errorCallback;
        // Cross domain only allowed if supported through XMLHttpRequest
        if (support.cors || xhrSupported && !options.crossDomain) return {
            send: function send(headers, complete) {
                var i, xhr = options.xhr();
                xhr.open(options.type, options.url, options.async, options.username, options.password);
                // Apply custom fields if provided
                if (options.xhrFields) for(i in options.xhrFields)xhr[i] = options.xhrFields[i];
                // Override mime type if needed
                if (options.mimeType && xhr.overrideMimeType) xhr.overrideMimeType(options.mimeType);
                // X-Requested-With header
                // For cross-domain requests, seeing as conditions for a preflight are
                // akin to a jigsaw puzzle, we simply never set it to be sure.
                // (it can always be set on a per-request basis or even using ajaxSetup)
                // For same-domain requests, won't change header if already provided.
                if (!options.crossDomain && !headers["X-Requested-With"]) headers["X-Requested-With"] = "XMLHttpRequest";
                // Set headers
                for(i in headers)xhr.setRequestHeader(i, headers[i]);
                // Callback
                callback = function(type) {
                    return function() {
                        if (callback) {
                            callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;
                            if (type === "abort") xhr.abort();
                            else if (type === "error") {
                                // Support: IE <=9 only
                                // On a manual native abort, IE9 throws
                                // errors on any property access that is not readyState
                                if (typeof xhr.status !== "number") complete(0, "error");
                                else complete(// File: protocol always yields status 0; see #8605, #14207
                                xhr.status, xhr.statusText);
                            } else complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText, // Support: IE <=9 only
                            // IE9 has no XHR2 but throws on binary (trac-11426)
                            // For XHR2 non-text, let the caller handle it (gh-2498)
                            (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                                binary: xhr.response
                            } : {
                                text: xhr.responseText
                            }, xhr.getAllResponseHeaders());
                        }
                    };
                };
                // Listen to events
                xhr.onload = callback();
                errorCallback = xhr.onerror = callback("error");
                // Support: IE 9 only
                // Use onreadystatechange to replace onabort
                // to handle uncaught aborts
                if (xhr.onabort !== undefined) xhr.onabort = errorCallback;
                else xhr.onreadystatechange = function() {
                    // Check readyState before timeout as it changes
                    if (xhr.readyState === 4) // Allow onerror to be called first,
                    // but that will not handle a native abort
                    // Also, save errorCallback to a variable
                    // as xhr.onerror cannot be accessed
                    window1.setTimeout(function() {
                        if (callback) errorCallback();
                    });
                };
                // Create the abort callback
                callback = callback("abort");
                try {
                    // Do send the request (this may raise an exception)
                    xhr.send(options.hasContent && options.data || null);
                } catch (e) {
                    // #14683: Only rethrow if this hasn't been notified as an error yet
                    if (callback) throw e;
                }
            },
            abort: function abort() {
                if (callback) callback();
            }
        };
    });
    // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
    jQuery.ajaxPrefilter(function(s) {
        if (s.crossDomain) s.contents.script = false;
    });
    // Install script dataType
    jQuery.ajaxSetup({
        accepts: {
            script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript"
        },
        contents: {
            script: /\b(?:java|ecma)script\b/
        },
        converters: {
            "text script": function(text) {
                jQuery.globalEval(text);
                return text;
            }
        }
    });
    // Handle cache's special case and crossDomain
    jQuery.ajaxPrefilter("script", function(s) {
        if (s.cache === undefined) s.cache = false;
        if (s.crossDomain) s.type = "GET";
    });
    // Bind script tag hack transport
    jQuery.ajaxTransport("script", function(s) {
        // This transport only deals with cross domain requests
        if (s.crossDomain) {
            var script, callback;
            return {
                send: function send(_, complete) {
                    script = jQuery("<script>").prop({
                        charset: s.scriptCharset,
                        src: s.url
                    }).on("load error", callback = function(evt) {
                        script.remove();
                        callback = null;
                        if (evt) complete(evt.type === "error" ? 404 : 200, evt.type);
                    });
                    // Use native DOM manipulation to avoid our domManip AJAX trickery
                    document.head.appendChild(script[0]);
                },
                abort: function abort() {
                    if (callback) callback();
                }
            };
        }
    });
    var oldCallbacks = [], rjsonp = /(=)\?(?=&|$)|\?\?/;
    // Default jsonp settings
    jQuery.ajaxSetup({
        jsonp: "callback",
        jsonpCallback: function jsonpCallback() {
            var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce++;
            this[callback] = true;
            return callback;
        }
    });
    // Detect, normalize options and install callbacks for jsonp requests
    jQuery.ajaxPrefilter("json jsonp", function(s, originalSettings, jqXHR) {
        var callbackName, overwritten, responseContainer, jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");
        // Handle iff the expected data type is "jsonp" or we have a parameter to set
        if (jsonProp || s.dataTypes[0] === "jsonp") {
            // Get callback name, remembering preexisting value associated with it
            callbackName = s.jsonpCallback = jQuery.isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;
            // Insert callback into url or form data
            if (jsonProp) s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
            else if (s.jsonp !== false) s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
            // Use data converter to retrieve json after script execution
            s.converters["script json"] = function() {
                if (!responseContainer) jQuery.error(callbackName + " was not called");
                return responseContainer[0];
            };
            // Force json dataType
            s.dataTypes[0] = "json";
            // Install callback
            overwritten = window1[callbackName];
            window1[callbackName] = function() {
                responseContainer = arguments;
            };
            // Clean-up function (fires after converters)
            jqXHR.always(function() {
                // If previous value didn't exist - remove it
                if (overwritten === undefined) jQuery(window1).removeProp(callbackName);
                else window1[callbackName] = overwritten;
                // Save back as free
                if (s[callbackName]) {
                    // Make sure that re-using the options doesn't screw things around
                    s.jsonpCallback = originalSettings.jsonpCallback;
                    // Save the callback name for future use
                    oldCallbacks.push(callbackName);
                }
                // Call if it was a function and we have a response
                if (responseContainer && jQuery.isFunction(overwritten)) overwritten(responseContainer[0]);
                responseContainer = overwritten = undefined;
            });
            // Delegate to script
            return "script";
        }
    });
    // Support: Safari 8 only
    // In Safari 8 documents created via document.implementation.createHTMLDocument
    // collapse sibling forms: the second one becomes a child of the first one.
    // Because of that, this security measure has to be disabled in Safari 8.
    // https://bugs.webkit.org/show_bug.cgi?id=137337
    support.createHTMLDocument = function() {
        var body = document.implementation.createHTMLDocument("").body;
        body.innerHTML = "<form></form><form></form>";
        return body.childNodes.length === 2;
    }();
    // Argument "data" should be string of html
    // context (optional): If specified, the fragment will be created in this context,
    // defaults to document
    // keepScripts (optional): If true, will include scripts passed in the html string
    jQuery.parseHTML = function(data, context, keepScripts) {
        if (typeof data !== "string") return [];
        if (typeof context === "boolean") {
            keepScripts = context;
            context = false;
        }
        var base, parsed, scripts;
        if (!context) {
            // Stop scripts or inline event handlers from being executed immediately
            // by using document.implementation
            if (support.createHTMLDocument) {
                context = document.implementation.createHTMLDocument("");
                // Set the base href for the created document
                // so any parsed elements with URLs
                // are based on the document's URL (gh-2965)
                base = context.createElement("base");
                base.href = document.location.href;
                context.head.appendChild(base);
            } else context = document;
        }
        parsed = rsingleTag.exec(data);
        scripts = !keepScripts && [];
        // Single tag
        if (parsed) return [
            context.createElement(parsed[1])
        ];
        parsed = buildFragment([
            data
        ], context, scripts);
        if (scripts && scripts.length) jQuery(scripts).remove();
        return jQuery.merge([], parsed.childNodes);
    };
    /**
 * Load a url into a page
 */ jQuery.fn.load = function(url, params, callback) {
        var selector, type, response, self = this, off = url.indexOf(" ");
        if (off > -1) {
            selector = stripAndCollapse(url.slice(off));
            url = url.slice(0, off);
        }
        // If it's a function
        if (jQuery.isFunction(params)) {
            // We assume that it's the callback
            callback = params;
            params = undefined;
        // Otherwise, build a param string
        } else if (params && typeof params === "object") type = "POST";
        // If we have elements to modify, make the request
        if (self.length > 0) jQuery.ajax({
            url: url,
            // If "type" variable is undefined, then "GET" method will be used.
            // Make value of this field explicit since
            // user can override it through ajaxSetup method
            type: type || "GET",
            dataType: "html",
            data: params
        }).done(function(responseText) {
            // Save response for use in complete callback
            response = arguments;
            self.html(selector ? // If a selector was specified, locate the right elements in a dummy div
            // Exclude scripts to avoid IE 'Permission Denied' errors
            jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) : // Otherwise use the full result
            responseText);
        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
        }).always(callback && function(jqXHR, status) {
            self.each(function() {
                callback.apply(this, response || [
                    jqXHR.responseText,
                    status,
                    jqXHR
                ]);
            });
        });
        return this;
    };
    // Attach a bunch of functions for handling common AJAX events
    jQuery.each([
        "ajaxStart",
        "ajaxStop",
        "ajaxComplete",
        "ajaxError",
        "ajaxSuccess",
        "ajaxSend"
    ], function(i, type) {
        jQuery.fn[type] = function(fn) {
            return this.on(type, fn);
        };
    });
    jQuery.expr.pseudos.animated = function(elem) {
        return jQuery.grep(jQuery.timers, function(fn) {
            return elem === fn.elem;
        }).length;
    };
    jQuery.offset = {
        setOffset: function setOffset(elem, options, i) {
            var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition, position = jQuery.css(elem, "position"), curElem = jQuery(elem), props = {};
            // Set position first, in-case top/left are set even on static elem
            if (position === "static") elem.style.position = "relative";
            curOffset = curElem.offset();
            curCSSTop = jQuery.css(elem, "top");
            curCSSLeft = jQuery.css(elem, "left");
            calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;
            // Need to be able to calculate position if either
            // top or left is auto and position is either absolute or fixed
            if (calculatePosition) {
                curPosition = curElem.position();
                curTop = curPosition.top;
                curLeft = curPosition.left;
            } else {
                curTop = parseFloat(curCSSTop) || 0;
                curLeft = parseFloat(curCSSLeft) || 0;
            }
            if (jQuery.isFunction(options)) // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
            options = options.call(elem, i, jQuery.extend({}, curOffset));
            if (options.top != null) props.top = options.top - curOffset.top + curTop;
            if (options.left != null) props.left = options.left - curOffset.left + curLeft;
            if ("using" in options) options.using.call(elem, props);
            else curElem.css(props);
        }
    };
    jQuery.fn.extend({
        offset: function offset(options) {
            // Preserve chaining for setter
            if (arguments.length) return options === undefined ? this : this.each(function(i) {
                jQuery.offset.setOffset(this, options, i);
            });
            var doc, docElem, rect, win, elem = this[0];
            if (!elem) return;
            // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
            // Support: IE <=11 only
            // Running getBoundingClientRect on a
            // disconnected node in IE throws an error
            if (!elem.getClientRects().length) return {
                top: 0,
                left: 0
            };
            rect = elem.getBoundingClientRect();
            doc = elem.ownerDocument;
            docElem = doc.documentElement;
            win = doc.defaultView;
            return {
                top: rect.top + win.pageYOffset - docElem.clientTop,
                left: rect.left + win.pageXOffset - docElem.clientLeft
            };
        },
        position: function position() {
            if (!this[0]) return;
            var offsetParent, offset, elem = this[0], parentOffset = {
                top: 0,
                left: 0
            };
            // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
            // because it is its only offset parent
            if (jQuery.css(elem, "position") === "fixed") // Assume getBoundingClientRect is there when computed position is fixed
            offset = elem.getBoundingClientRect();
            else {
                // Get *real* offsetParent
                offsetParent = this.offsetParent();
                // Get correct offsets
                offset = this.offset();
                if (!nodeName(offsetParent[0], "html")) parentOffset = offsetParent.offset();
                // Add offsetParent borders
                parentOffset = {
                    top: parentOffset.top + jQuery.css(offsetParent[0], "borderTopWidth", true),
                    left: parentOffset.left + jQuery.css(offsetParent[0], "borderLeftWidth", true)
                };
            }
            // Subtract parent offsets and element margins
            return {
                top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
                left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
            };
        },
        // This method will return documentElement in the following cases:
        // 1) For the element inside the iframe without offsetParent, this method will return
        //    documentElement of the parent window
        // 2) For the hidden or detached element
        // 3) For body or html element, i.e. in case of the html node - it will return itself
        //
        // but those exceptions were never presented as a real life use-cases
        // and might be considered as more preferable results.
        //
        // This logic, however, is not guaranteed and can change at any point in the future
        offsetParent: function offsetParent() {
            return this.map(function() {
                var offsetParent = this.offsetParent;
                while(offsetParent && jQuery.css(offsetParent, "position") === "static")offsetParent = offsetParent.offsetParent;
                return offsetParent || documentElement;
            });
        }
    });
    // Create scrollLeft and scrollTop methods
    jQuery.each({
        scrollLeft: "pageXOffset",
        scrollTop: "pageYOffset"
    }, function(method, prop) {
        var top = "pageYOffset" === prop;
        jQuery.fn[method] = function(val) {
            return access(this, function(elem, method, val) {
                // Coalesce documents and windows
                var win;
                if (jQuery.isWindow(elem)) win = elem;
                else if (elem.nodeType === 9) win = elem.defaultView;
                if (val === undefined) return win ? win[prop] : elem[method];
                if (win) win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
                else elem[method] = val;
            }, method, val, arguments.length);
        };
    });
    // Support: Safari <=7 - 9.1, Chrome <=37 - 49
    // Add the top/left cssHooks using jQuery.fn.position
    // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
    // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
    // getComputedStyle returns percent when specified for top/left/bottom/right;
    // rather than make the css module depend on the offset module, just check for it here
    jQuery.each([
        "top",
        "left"
    ], function(i, prop) {
        jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function(elem, computed) {
            if (computed) {
                computed = curCSS(elem, prop);
                // If curCSS returns percentage, fallback to offset
                return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
            }
        });
    });
    // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
    jQuery.each({
        Height: "height",
        Width: "width"
    }, function(name, type) {
        jQuery.each({
            padding: "inner" + name,
            content: type,
            "": "outer" + name
        }, function(defaultExtra, funcName) {
            // Margin is only for outerHeight, outerWidth
            jQuery.fn[funcName] = function(margin, value) {
                var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"), extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
                return access(this, function(elem, type, value) {
                    var doc;
                    if (jQuery.isWindow(elem)) // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
                    return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
                    // Get document width or height
                    if (elem.nodeType === 9) {
                        doc = elem.documentElement;
                        // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
                        // whichever is greatest
                        return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
                    }
                    return value === undefined ? // Get width or height on the element, requesting but not forcing parseFloat
                    jQuery.css(elem, type, extra) : // Set width or height on the element
                    jQuery.style(elem, type, value, extra);
                }, type, chainable ? margin : undefined, chainable);
            };
        });
    });
    jQuery.fn.extend({
        bind: function bind(types, data, fn) {
            return this.on(types, null, data, fn);
        },
        unbind: function unbind(types, fn) {
            return this.off(types, null, fn);
        },
        delegate: function delegate(selector, types, data, fn) {
            return this.on(types, selector, data, fn);
        },
        undelegate: function undelegate(selector, types, fn) {
            // ( namespace ) or ( selector, types [, fn] )
            return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
        }
    });
    jQuery.holdReady = function(hold) {
        if (hold) jQuery.readyWait++;
        else jQuery.ready(true);
    };
    jQuery.isArray = Array.isArray;
    jQuery.parseJSON = JSON.parse;
    jQuery.nodeName = nodeName;
    // Register as a named AMD module, since jQuery can be concatenated with other
    // files that may use define, but not via a proper concatenation script that
    // understands anonymous AMD modules. A named AMD is safest and most robust
    // way to register. Lowercase jquery is used because AMD module names are
    // derived from file names, and jQuery is normally delivered in a lowercase
    // file name. Do this after creating the global so that if an AMD module wants
    // to call noConflict to hide this version of jQuery, it will work.
    // Note that for maximum portability, libraries that are not jQuery should
    // declare themselves as anonymous modules, and avoid setting a global if an
    // AMD loader is present. jQuery is a special case. For more information, see
    // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon
    if (typeof define === "function" && define.amd) define("jquery", [], function() {
        return jQuery;
    });
    var // Map over jQuery in case of overwrite
    _jQuery = window1.jQuery, // Map over the $ in case of overwrite
    _$ = window1.$;
    jQuery.noConflict = function(deep) {
        if (window1.$ === jQuery) window1.$ = _$;
        if (deep && window1.jQuery === jQuery) window1.jQuery = _jQuery;
        return jQuery;
    };
    // Expose jQuery and $ identifiers, even in AMD
    // (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
    // and CommonJS for browser emulators (#13566)
    if (!noGlobal) window1.jQuery = window1.$ = jQuery;
    return jQuery;
});

});
parcelRegister("alyXF", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $7886fc1fd1492e59$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $7886fc1fd1492e59$export$5f0017c582d45a2d; });
function $7886fc1fd1492e59$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});


parcelRegister("5ihUn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3dac866b50928f7b$export$7c398597f8905a1; });
function $3dac866b50928f7b$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $3dac866b50928f7b$export$7c398597f8905a1(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $3dac866b50928f7b$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $3dac866b50928f7b$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("6agJ4", function(module, exports) {

$parcel$export(module.exports, "__generator", function () { return $47d0a6a8961a8f8d$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__values", function () { return $47d0a6a8961a8f8d$export$19a8beecd37a4c45; });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol */ 
var $alyXF = parcelRequire("alyXF");
var $47d0a6a8961a8f8d$var$extendStatics = function extendStatics1(d, b) {
    $47d0a6a8961a8f8d$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $47d0a6a8961a8f8d$var$extendStatics(d, b);
};
function $47d0a6a8961a8f8d$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $47d0a6a8961a8f8d$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $47d0a6a8961a8f8d$export$18ce0697a983be9b = function __assign1() {
    $47d0a6a8961a8f8d$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $47d0a6a8961a8f8d$export$18ce0697a983be9b.apply(this, arguments);
};
function $47d0a6a8961a8f8d$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $47d0a6a8961a8f8d$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $47d0a6a8961a8f8d$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $47d0a6a8961a8f8d$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $47d0a6a8961a8f8d$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $47d0a6a8961a8f8d$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $alyXF._)(x)) === "symbol" ? x : "".concat(x);
}
function $47d0a6a8961a8f8d$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $alyXF._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $47d0a6a8961a8f8d$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $47d0a6a8961a8f8d$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $47d0a6a8961a8f8d$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $47d0a6a8961a8f8d$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $47d0a6a8961a8f8d$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $47d0a6a8961a8f8d$export$45d3717a4c69092e(o, m, p);
}
function $47d0a6a8961a8f8d$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $47d0a6a8961a8f8d$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $47d0a6a8961a8f8d$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($47d0a6a8961a8f8d$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $47d0a6a8961a8f8d$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $47d0a6a8961a8f8d$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $47d0a6a8961a8f8d$export$10c90e4f7922046c(v) {
    return this instanceof $47d0a6a8961a8f8d$export$10c90e4f7922046c ? (this.v = v, this) : new $47d0a6a8961a8f8d$export$10c90e4f7922046c(v);
}
function $47d0a6a8961a8f8d$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $47d0a6a8961a8f8d$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $47d0a6a8961a8f8d$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $47d0a6a8961a8f8d$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $47d0a6a8961a8f8d$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $47d0a6a8961a8f8d$export$19a8beecd37a4c45 === "function" ? $47d0a6a8961a8f8d$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $47d0a6a8961a8f8d$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $47d0a6a8961a8f8d$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $47d0a6a8961a8f8d$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $47d0a6a8961a8f8d$export$45d3717a4c69092e(result, mod, k);
    }
    $47d0a6a8961a8f8d$var$__setModuleDefault(result, mod);
    return result;
}
function $47d0a6a8961a8f8d$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $47d0a6a8961a8f8d$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $47d0a6a8961a8f8d$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $47d0a6a8961a8f8d$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $47d0a6a8961a8f8d$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $47d0a6a8961a8f8d$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $47d0a6a8961a8f8d$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $47d0a6a8961a8f8d$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    function next() {
        while(env.stack.length){
            var rec = env.stack.pop();
            try {
                var result = rec.dispose && rec.dispose.call(rec.value);
                if (rec.async) return Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } catch (e) {
                fail(e);
            }
        }
        if (env.hasError) throw env.error;
    }
    return next();
}
var $47d0a6a8961a8f8d$export$2e2bcd8739ae039 = {
    __extends: $47d0a6a8961a8f8d$export$a8ba968b8961cb8a,
    __assign: $47d0a6a8961a8f8d$export$18ce0697a983be9b,
    __rest: $47d0a6a8961a8f8d$export$3c9a16f847548506,
    __decorate: $47d0a6a8961a8f8d$export$29e00dfd3077644b,
    __param: $47d0a6a8961a8f8d$export$d5ad3fd78186038f,
    __metadata: $47d0a6a8961a8f8d$export$f1db080c865becb9,
    __awaiter: $47d0a6a8961a8f8d$export$1050f835b63b671e,
    __generator: $47d0a6a8961a8f8d$export$67ebef60e6f28a6,
    __createBinding: $47d0a6a8961a8f8d$export$45d3717a4c69092e,
    __exportStar: $47d0a6a8961a8f8d$export$f33643c0debef087,
    __values: $47d0a6a8961a8f8d$export$19a8beecd37a4c45,
    __read: $47d0a6a8961a8f8d$export$8d051b38c9118094,
    __spread: $47d0a6a8961a8f8d$export$afc72e2116322959,
    __spreadArrays: $47d0a6a8961a8f8d$export$6388937ca91ccae8,
    __spreadArray: $47d0a6a8961a8f8d$export$1216008129fb82ed,
    __await: $47d0a6a8961a8f8d$export$10c90e4f7922046c,
    __asyncGenerator: $47d0a6a8961a8f8d$export$e427f37a30a4de9b,
    __asyncDelegator: $47d0a6a8961a8f8d$export$bbd80228419bb833,
    __asyncValues: $47d0a6a8961a8f8d$export$e3b29a3d6162315f,
    __makeTemplateObject: $47d0a6a8961a8f8d$export$4fb47efe1390b86f,
    __importStar: $47d0a6a8961a8f8d$export$c21735bcef00d192,
    __importDefault: $47d0a6a8961a8f8d$export$da59b14a69baef04,
    __classPrivateFieldGet: $47d0a6a8961a8f8d$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $47d0a6a8961a8f8d$export$d40a35129aaff81f,
    __classPrivateFieldIn: $47d0a6a8961a8f8d$export$81fdc39f203e4e04,
    __addDisposableResource: $47d0a6a8961a8f8d$export$88ac25d8e944e405,
    __disposeResources: $47d0a6a8961a8f8d$export$8f076105dc360e92
};

});

parcelRegister("e3o07", function(module, exports) {

$parcel$export(module.exports, "AdminApi", function () { return $5c3c9234bcb9fcaf$export$7566e081473f4297; });
$parcel$export(module.exports, "AudioProApi", function () { return $5c3c9234bcb9fcaf$export$e06b37e60b17b3cc; });
$parcel$export(module.exports, "CreateCenterApi", function () { return $5c3c9234bcb9fcaf$export$788bdde2dd25d221; });
$parcel$export(module.exports, "EditCenterApi", function () { return $5c3c9234bcb9fcaf$export$bf8ad012010c3e85; });
$parcel$export(module.exports, "EditOrlApi", function () { return $5c3c9234bcb9fcaf$export$b84fcd7034608719; });
$parcel$export(module.exports, "MyVisibilityApi", function () { return $5c3c9234bcb9fcaf$export$cc73579c789abfdb; });
$parcel$export(module.exports, "RdvApi", function () { return $5c3c9234bcb9fcaf$export$7a0a9669d5711085; });
$parcel$export(module.exports, "StatsApi", function () { return $5c3c9234bcb9fcaf$export$536cc970372a085; });
/**
 * 1001Audios
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ 
var $3V7B6 = parcelRequire("3V7B6");

var $fqAw8 = parcelRequire("fqAw8");

var $lu64P = parcelRequire("lu64P");

var $qCKPt = parcelRequire("qCKPt");

var $01ElO = parcelRequire("01ElO");

var $fEtMY = parcelRequire("fEtMY");
var $5c3c9234bcb9fcaf$var$BASE_PATH = ""; // "https://localhost".replace(/\/+$/, "");
var $5c3c9234bcb9fcaf$export$70edad7ad5bb3f5d = function BaseAPI() {
    "use strict";
    var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
    (0, $3V7B6._)(this, BaseAPI);
    this.basePath = basePath;
    this.fetch = fetch;
};
var $5c3c9234bcb9fcaf$export$8b63ead54f77e71b = {
    /**
   * @param email
   */ adminLogin: function(params, options) {
        var baseUrl = "/admin/api/admin-login";
        var urlObj = $fEtMY.parse(baseUrl, true);
        var fetchOptions = $01ElO({}, {
            method: "POST"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/json"
        };
        if (params["email"]) fetchOptions.body = JSON.stringify(params["email"] || {});
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    },
    /**
   * @param email
   */ adminLogin_1: function(params, options) {
        var baseUrl = "/admin/admin-login";
        var urlObj = $fEtMY.parse(baseUrl, true);
        var fetchOptions = $01ElO({}, {
            method: "POST"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/json"
        };
        if (params["email"]) fetchOptions.body = JSON.stringify(params["email"] || {});
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    },
    /**
   * @param id
   */ deleteNotifications: function(params, options) {
        var baseUrl = "/admin/api/delete-notification";
        var urlObj = $fEtMY.parse(baseUrl, true);
        var fetchOptions = $01ElO({}, {
            method: "POST"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/json"
        };
        if (params["id"]) fetchOptions.body = JSON.stringify(params["id"] || {});
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    },
    /**
   * @param id
   */ deleteNotifications_2: function(params, options) {
        var baseUrl = "/admin/delete-notifications";
        var urlObj = $fEtMY.parse(baseUrl, true);
        var fetchOptions = $01ElO({}, {
            method: "POST"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/json"
        };
        if (params["id"]) fetchOptions.body = JSON.stringify(params["id"] || {});
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    },
    /**
   */ getTrackedCalls: function(options) {
        var baseUrl = "/api/tracked-calls";
        var urlObj = $fEtMY.parse(baseUrl, true);
        var fetchOptions = $01ElO({}, {
            method: "GET"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    },
    /**
   * @param request
   */ updateTrackedCalls: function(params, options) {
        var baseUrl = "/api/tracked-calls";
        var urlObj = $fEtMY.parse(baseUrl, true);
        var fetchOptions = $01ElO({}, {
            method: "POST"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/json"
        };
        if (params["request"]) fetchOptions.body = JSON.stringify(params["request"] || {});
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    }
};
var $5c3c9234bcb9fcaf$export$29738f06654883e0 = {
    /**
   * @param email
   */ adminLogin: function(params, options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$8b63ead54f77e71b.adminLogin(params, options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response;
                else throw response;
            });
        };
    },
    /**
   * @param email
   */ adminLogin_1: function(params, options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$8b63ead54f77e71b.adminLogin_1(params, options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response;
                else throw response;
            });
        };
    },
    /**
   * @param id
   */ deleteNotifications: function(params, options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$8b63ead54f77e71b.deleteNotifications(params, options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response;
                else throw response;
            });
        };
    },
    /**
   * @param id
   */ deleteNotifications_2: function(params, options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$8b63ead54f77e71b.deleteNotifications_2(params, options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response;
                else throw response;
            });
        };
    },
    /**
   */ getTrackedCalls: function(options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$8b63ead54f77e71b.getTrackedCalls(options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response.json();
                else throw response;
            });
        };
    },
    /**
   * @param request
   */ updateTrackedCalls: function(params, options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$8b63ead54f77e71b.updateTrackedCalls(params, options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response;
                else throw response;
            });
        };
    }
};
var $5c3c9234bcb9fcaf$export$7566e081473f4297 = /*#__PURE__*/ function(BaseAPI) {
    "use strict";
    (0, $lu64P._)(AdminApi, BaseAPI);
    var _super = (0, $qCKPt._)(AdminApi);
    function AdminApi() {
        (0, $3V7B6._)(this, AdminApi);
        return _super.apply(this, arguments);
    }
    (0, $fqAw8._)(AdminApi, [
        {
            /**
   * @param email
   */ key: "adminLogin",
            value: function adminLogin(params, options) {
                return $5c3c9234bcb9fcaf$export$29738f06654883e0.adminLogin(params, options)(this.fetch, this.basePath);
            }
        },
        {
            /**
   * @param email
   */ key: "adminLogin_1",
            value: function adminLogin_1(params, options) {
                return $5c3c9234bcb9fcaf$export$29738f06654883e0.adminLogin_1(params, options)(this.fetch, this.basePath);
            }
        },
        {
            /**
   * @param id
   */ key: "deleteNotifications",
            value: function deleteNotifications(params, options) {
                return $5c3c9234bcb9fcaf$export$29738f06654883e0.deleteNotifications(params, options)(this.fetch, this.basePath);
            }
        },
        {
            /**
   * @param id
   */ key: "deleteNotifications_2",
            value: function deleteNotifications_2(params, options) {
                return $5c3c9234bcb9fcaf$export$29738f06654883e0.deleteNotifications_2(params, options)(this.fetch, this.basePath);
            }
        },
        {
            /**
   */ key: "getTrackedCalls",
            value: function getTrackedCalls(options) {
                return $5c3c9234bcb9fcaf$export$29738f06654883e0.getTrackedCalls(options)(this.fetch, this.basePath);
            }
        },
        {
            /**
   * @param request
   */ key: "updateTrackedCalls",
            value: function updateTrackedCalls(params, options) {
                return $5c3c9234bcb9fcaf$export$29738f06654883e0.updateTrackedCalls(params, options)(this.fetch, this.basePath);
            }
        }
    ]);
    return AdminApi;
}($5c3c9234bcb9fcaf$export$70edad7ad5bb3f5d);
var $5c3c9234bcb9fcaf$export$7b8831ddec65bd8b = function AdminApiFactory(fetch, basePath) {
    return {
        /**
     * @param email
     */ adminLogin: function(params, options) {
            return $5c3c9234bcb9fcaf$export$29738f06654883e0.adminLogin(params, options)(fetch, basePath);
        },
        /**
     * @param email
     */ adminLogin_1: function(params, options) {
            return $5c3c9234bcb9fcaf$export$29738f06654883e0.adminLogin_1(params, options)(fetch, basePath);
        },
        /**
     * @param id
     */ deleteNotifications: function(params, options) {
            return $5c3c9234bcb9fcaf$export$29738f06654883e0.deleteNotifications(params, options)(fetch, basePath);
        },
        /**
     * @param id
     */ deleteNotifications_2: function(params, options) {
            return $5c3c9234bcb9fcaf$export$29738f06654883e0.deleteNotifications_2(params, options)(fetch, basePath);
        },
        /**
     */ getTrackedCalls: function(options) {
            return $5c3c9234bcb9fcaf$export$29738f06654883e0.getTrackedCalls(options)(fetch, basePath);
        },
        /**
     * @param request
     */ updateTrackedCalls: function(params, options) {
            return $5c3c9234bcb9fcaf$export$29738f06654883e0.updateTrackedCalls(params, options)(fetch, basePath);
        }
    };
};
var $5c3c9234bcb9fcaf$export$cb2234eb3af1994e = {
    /**
   * @param audioProId
   */ getPhoneNumber: function(params, options) {
        // verify required parameter "audioProId" is set
        if (params["audioProId"] == null) throw new Error("Missing required parameter audioProId when calling getPhoneNumber");
        var baseUrl = "/api/phone-number/{audioProId}".replace("{audioProId}", "".concat(params["audioProId"]));
        var urlObj = $fEtMY.parse(baseUrl, true);
        var fetchOptions = $01ElO({}, {
            method: "POST"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    }
};
var $5c3c9234bcb9fcaf$export$cffa5ace58392df4 = {
    /**
   * @param audioProId
   */ getPhoneNumber: function(params, options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$cb2234eb3af1994e.getPhoneNumber(params, options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response.json();
                else throw response;
            });
        };
    }
};
var $5c3c9234bcb9fcaf$export$e06b37e60b17b3cc = /*#__PURE__*/ function(BaseAPI) {
    "use strict";
    (0, $lu64P._)(AudioProApi, BaseAPI);
    var _super = (0, $qCKPt._)(AudioProApi);
    function AudioProApi() {
        (0, $3V7B6._)(this, AudioProApi);
        return _super.apply(this, arguments);
    }
    (0, $fqAw8._)(AudioProApi, [
        {
            /**
   * @param audioProId
   */ key: "getPhoneNumber",
            value: function getPhoneNumber(params, options) {
                return $5c3c9234bcb9fcaf$export$cffa5ace58392df4.getPhoneNumber(params, options)(this.fetch, this.basePath);
            }
        }
    ]);
    return AudioProApi;
}($5c3c9234bcb9fcaf$export$70edad7ad5bb3f5d);
var $5c3c9234bcb9fcaf$export$e070145a1a3c2c81 = function AudioProApiFactory(fetch, basePath) {
    return {
        /**
     * @param audioProId
     */ getPhoneNumber: function(params, options) {
            return $5c3c9234bcb9fcaf$export$cffa5ace58392df4.getPhoneNumber(params, options)(fetch, basePath);
        }
    };
};
var $5c3c9234bcb9fcaf$export$33be4acb149a3dc1 = {
    /**
   * @param model
   */ acceptOwner: function(params, options) {
        var baseUrl = "/my-account/api/accept-owner";
        var urlObj = $fEtMY.parse(baseUrl, true);
        var fetchOptions = $01ElO({}, {
            method: "POST"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/json"
        };
        if (params["model"]) fetchOptions.body = JSON.stringify(params["model"] || {});
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    },
    /**
   * @param model
   */ addOwner: function(params, options) {
        var baseUrl = "/my-account/api/add-owner";
        var urlObj = $fEtMY.parse(baseUrl, true);
        var fetchOptions = $01ElO({}, {
            method: "POST"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/json"
        };
        if (params["model"]) fetchOptions.body = JSON.stringify(params["model"] || {});
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    },
    /**
   * @param audioPro
   */ createAudioPro: function(params, options) {
        var baseUrl = "/my-account/api/create-audiopro";
        var urlObj = $fEtMY.parse(baseUrl, true);
        var fetchOptions = $01ElO({}, {
            method: "POST"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/json"
        };
        if (params["audioPro"]) fetchOptions.body = JSON.stringify(params["audioPro"] || {});
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    },
    /**
   * @param model
   */ declineOwner: function(params, options) {
        var baseUrl = "/my-account/api/decline-owner";
        var urlObj = $fEtMY.parse(baseUrl, true);
        var fetchOptions = $01ElO({}, {
            method: "POST"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/json"
        };
        if (params["model"]) fetchOptions.body = JSON.stringify(params["model"] || {});
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    }
};
var $5c3c9234bcb9fcaf$export$9a86f4dd6f32960a = {
    /**
   * @param model
   */ acceptOwner: function(params, options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$33be4acb149a3dc1.acceptOwner(params, options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response;
                else throw response;
            });
        };
    },
    /**
   * @param model
   */ addOwner: function(params, options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$33be4acb149a3dc1.addOwner(params, options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response;
                else throw response;
            });
        };
    },
    /**
   * @param audioPro
   */ createAudioPro: function(params, options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$33be4acb149a3dc1.createAudioPro(params, options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response;
                else throw response;
            });
        };
    },
    /**
   * @param model
   */ declineOwner: function(params, options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$33be4acb149a3dc1.declineOwner(params, options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response;
                else throw response;
            });
        };
    }
};
var $5c3c9234bcb9fcaf$export$788bdde2dd25d221 = /*#__PURE__*/ function(BaseAPI) {
    "use strict";
    (0, $lu64P._)(CreateCenterApi, BaseAPI);
    var _super = (0, $qCKPt._)(CreateCenterApi);
    function CreateCenterApi() {
        (0, $3V7B6._)(this, CreateCenterApi);
        return _super.apply(this, arguments);
    }
    (0, $fqAw8._)(CreateCenterApi, [
        {
            /**
   * @param model
   */ key: "acceptOwner",
            value: function acceptOwner(params, options) {
                return $5c3c9234bcb9fcaf$export$9a86f4dd6f32960a.acceptOwner(params, options)(this.fetch, this.basePath);
            }
        },
        {
            /**
   * @param model
   */ key: "addOwner",
            value: function addOwner(params, options) {
                return $5c3c9234bcb9fcaf$export$9a86f4dd6f32960a.addOwner(params, options)(this.fetch, this.basePath);
            }
        },
        {
            /**
   * @param audioPro
   */ key: "createAudioPro",
            value: function createAudioPro(params, options) {
                return $5c3c9234bcb9fcaf$export$9a86f4dd6f32960a.createAudioPro(params, options)(this.fetch, this.basePath);
            }
        },
        {
            /**
   * @param model
   */ key: "declineOwner",
            value: function declineOwner(params, options) {
                return $5c3c9234bcb9fcaf$export$9a86f4dd6f32960a.declineOwner(params, options)(this.fetch, this.basePath);
            }
        }
    ]);
    return CreateCenterApi;
}($5c3c9234bcb9fcaf$export$70edad7ad5bb3f5d);
var $5c3c9234bcb9fcaf$export$59fcf77e31a79b5c = function CreateCenterApiFactory(fetch, basePath) {
    return {
        /**
     * @param model
     */ acceptOwner: function(params, options) {
            return $5c3c9234bcb9fcaf$export$9a86f4dd6f32960a.acceptOwner(params, options)(fetch, basePath);
        },
        /**
     * @param model
     */ addOwner: function(params, options) {
            return $5c3c9234bcb9fcaf$export$9a86f4dd6f32960a.addOwner(params, options)(fetch, basePath);
        },
        /**
     * @param audioPro
     */ createAudioPro: function(params, options) {
            return $5c3c9234bcb9fcaf$export$9a86f4dd6f32960a.createAudioPro(params, options)(fetch, basePath);
        },
        /**
     * @param model
     */ declineOwner: function(params, options) {
            return $5c3c9234bcb9fcaf$export$9a86f4dd6f32960a.declineOwner(params, options)(fetch, basePath);
        }
    };
};
var $5c3c9234bcb9fcaf$export$9d6051eb537e1e42 = {
    /**
   * @param audioProId
   */ copyCallCenter: function(params, options) {
        // verify required parameter "audioProId" is set
        if (params["audioProId"] == null) throw new Error("Missing required parameter audioProId when calling copyCallCenter");
        var baseUrl = "/my-account/api/copy-callcenter/{audioProId}".replace("{audioProId}", "".concat(params["audioProId"]));
        var urlObj = $fEtMY.parse(baseUrl, true);
        var fetchOptions = $01ElO({}, {
            method: "POST"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    },
    /**
   * @param audioProId
   * @param copiedFields
   */ copyFields: function(params, options) {
        // verify required parameter "audioProId" is set
        if (params["audioProId"] == null) throw new Error("Missing required parameter audioProId when calling copyFields");
        var baseUrl = "/my-account/api/copy-fields/{audioProId}".replace("{audioProId}", "".concat(params["audioProId"]));
        var urlObj = $fEtMY.parse(baseUrl, true);
        var fetchOptions = $01ElO({}, {
            method: "POST"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/json"
        };
        if (params["copiedFields"]) fetchOptions.body = JSON.stringify(params["copiedFields"] || {});
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    },
    copyNonPremiumFields: function(params, options) {
        // verify required parameter "audioProId" is set
        if (params["audioProId"] == null) throw new Error("Missing required parameter audioProId when calling copyFields");
        var baseUrl = "/my-account/api/copy-non-premium-fields/{audioProId}".replace("{audioProId}", "".concat(params["audioProId"]));
        var urlObj = $fEtMY.parse(baseUrl, true);
        var fetchOptions = $01ElO({}, {
            method: "POST"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/json"
        };
        if (params["copiedFields"]) fetchOptions.body = JSON.stringify(params["copiedFields"] || {});
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    },
    /**
   * @param audioProId
   */ copyPricing: function(params, options) {
        // verify required parameter "audioProId" is set
        if (params["audioProId"] == null) throw new Error("Missing required parameter audioProId when calling copyPricing");
        var baseUrl = "/my-account/api/copy-pricing/{audioProId}".replace("{audioProId}", "".concat(params["audioProId"]));
        var urlObj = $fEtMY.parse(baseUrl, true);
        var fetchOptions = $01ElO({}, {
            method: "POST"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    },
    /**
   * @param audioProId
   */ copyPricingDocument: function(params, options) {
        // verify required parameter "audioProId" is set
        if (params["audioProId"] == null) throw new Error("Missing required parameter audioProId when calling copyPricingDocument");
        var baseUrl = "/my-account/api/copy-pricing-document/{audioProId}".replace("{audioProId}", "".concat(params["audioProId"]));
        var urlObj = $fEtMY.parse(baseUrl, true);
        var fetchOptions = $01ElO({}, {
            method: "POST"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    },
    /**
   * @param audioPro
   */ createAudioPro: function(params, options) {
        var baseUrl = "/my-account/api/audiopro";
        var urlObj = $fEtMY.parse(baseUrl, true);
        var fetchOptions = $01ElO({}, {
            method: "POST"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/json"
        };
        if (params["audioPro"]) fetchOptions.body = JSON.stringify(params["audioPro"] || {});
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    },
    /**
   * @param audioProId
   * @param model
   */ setTextsToAllCentersOfThisAccount: function(params, options) {
        // verify required parameter "audioProId" is set
        if (params["audioProId"] == null) throw new Error("Missing required parameter audioProId when calling setTextsToAllCentersOfThisAccount");
        var baseUrl = "/my-account/api/set-texts/{audioProId}".replace("{audioProId}", "".concat(params["audioProId"]));
        var urlObj = $fEtMY.parse(baseUrl, true);
        var fetchOptions = $01ElO({}, {
            method: "POST"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/json"
        };
        if (params["model"]) fetchOptions.body = JSON.stringify(params["model"] || {});
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    },
    /**
   * @param audioPro
   */ updateAudioPro: function(params, options) {
        var baseUrl = "/my-account/api/update-audiopro";
        var urlObj = $fEtMY.parse(baseUrl, true);
        var fetchOptions = $01ElO({}, {
            method: "PUT"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/json"
        };
        if (params["audioPro"]) fetchOptions.body = JSON.stringify(params["audioPro"] || {});
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    }
};
var $5c3c9234bcb9fcaf$export$c85b79f69ca43879 = {
    /**
   * @param audioProId
   */ copyCallCenter: function(params, options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$9d6051eb537e1e42.copyCallCenter(params, options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response;
                else throw response;
            });
        };
    },
    /**
   * @param audioProId
   * @param copiedFields
   */ copyFields: function(params, options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$9d6051eb537e1e42.copyFields(params, options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response;
                else throw response;
            });
        };
    },
    copyNonPremiumFields: function(params, options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$9d6051eb537e1e42.copyNonPremiumFields(params, options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response;
                else throw response;
            });
        };
    },
    /**
   * @param audioProId
   */ copyPricing: function(params, options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$9d6051eb537e1e42.copyPricing(params, options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response;
                else throw response;
            });
        };
    },
    /**
   * @param audioProId
   */ copyPricingDocument: function(params, options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$9d6051eb537e1e42.copyPricingDocument(params, options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response;
                else throw response;
            });
        };
    },
    /**
   * @param audioPro
   */ createAudioPro: function(params, options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$9d6051eb537e1e42.createAudioPro(params, options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response;
                else throw response;
            });
        };
    },
    /**
   * @param audioProId
   * @param model
   */ setTextsToAllCentersOfThisAccount: function(params, options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$9d6051eb537e1e42.setTextsToAllCentersOfThisAccount(params, options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response;
                else throw response;
            });
        };
    },
    /**
   * @param audioPro
   */ updateAudioPro: function(params, options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$9d6051eb537e1e42.updateAudioPro(params, options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response;
                else throw response;
            });
        };
    }
};
var $5c3c9234bcb9fcaf$export$bf8ad012010c3e85 = /*#__PURE__*/ function(BaseAPI) {
    "use strict";
    (0, $lu64P._)(EditCenterApi, BaseAPI);
    var _super = (0, $qCKPt._)(EditCenterApi);
    function EditCenterApi() {
        (0, $3V7B6._)(this, EditCenterApi);
        return _super.apply(this, arguments);
    }
    (0, $fqAw8._)(EditCenterApi, [
        {
            /**
   * @param audioProId
   */ key: "copyCallCenter",
            value: function copyCallCenter(params, options) {
                return $5c3c9234bcb9fcaf$export$c85b79f69ca43879.copyCallCenter(params, options)(this.fetch, this.basePath);
            }
        },
        {
            /**
   * @param audioProId
   * @param copiedFields
   */ key: "copyFields",
            value: function copyFields(params, options) {
                return $5c3c9234bcb9fcaf$export$c85b79f69ca43879.copyFields(params, options)(this.fetch, this.basePath);
            }
        },
        {
            /** 
    /** 
     * @param audioProId 
     * @param copiedFields 
     */ key: "copyNonPremiumFields",
            value: function copyNonPremiumFields(params, options) {
                return $5c3c9234bcb9fcaf$export$c85b79f69ca43879.copyNonPremiumFields(params, options)(this.fetch, this.basePath);
            }
        },
        {
            /**
   * @param audioProId
   */ key: "copyPricing",
            value: function copyPricing(params, options) {
                return $5c3c9234bcb9fcaf$export$c85b79f69ca43879.copyPricing(params, options)(this.fetch, this.basePath);
            }
        },
        {
            /**
   * @param audioProId
   */ key: "copyPricingDocument",
            value: function copyPricingDocument(params, options) {
                return $5c3c9234bcb9fcaf$export$c85b79f69ca43879.copyPricingDocument(params, options)(this.fetch, this.basePath);
            }
        },
        {
            /**
   * @param audioPro
   */ key: "createAudioPro",
            value: function createAudioPro(params, options) {
                return $5c3c9234bcb9fcaf$export$c85b79f69ca43879.createAudioPro(params, options)(this.fetch, this.basePath);
            }
        },
        {
            /**
   * @param audioProId
   * @param model
   */ key: "setTextsToAllCentersOfThisAccount",
            value: function setTextsToAllCentersOfThisAccount(params, options) {
                return $5c3c9234bcb9fcaf$export$c85b79f69ca43879.setTextsToAllCentersOfThisAccount(params, options)(this.fetch, this.basePath);
            }
        },
        {
            /**
   * @param audioPro
   */ key: "updateAudioPro",
            value: function updateAudioPro(params, options) {
                return $5c3c9234bcb9fcaf$export$c85b79f69ca43879.updateAudioPro(params, options)(this.fetch, this.basePath);
            }
        }
    ]);
    return EditCenterApi;
}($5c3c9234bcb9fcaf$export$70edad7ad5bb3f5d);
var $5c3c9234bcb9fcaf$export$8d12e2f3d13192b1 = function EditCenterApiFactory(fetch, basePath) {
    return {
        /**
     * @param audioProId
     */ copyCallCenter: function(params, options) {
            return $5c3c9234bcb9fcaf$export$c85b79f69ca43879.copyCallCenter(params, options)(fetch, basePath);
        },
        /**
     * @param audioProId
     * @param copiedFields
     */ copyFields: function(params, options) {
            return $5c3c9234bcb9fcaf$export$c85b79f69ca43879.copyFields(params, options)(fetch, basePath);
        },
        /**
     * @param audioProId
     */ copyPricing: function(params, options) {
            return $5c3c9234bcb9fcaf$export$c85b79f69ca43879.copyPricing(params, options)(fetch, basePath);
        },
        /**
     * @param audioProId
     */ copyPricingDocument: function(params, options) {
            return $5c3c9234bcb9fcaf$export$c85b79f69ca43879.copyPricingDocument(params, options)(fetch, basePath);
        },
        /**
     * @param audioPro
     */ createAudioPro: function(params, options) {
            return $5c3c9234bcb9fcaf$export$c85b79f69ca43879.createAudioPro(params, options)(fetch, basePath);
        },
        /**
     * @param audioProId
     * @param model
     */ setTextsToAllCentersOfThisAccount: function(params, options) {
            return $5c3c9234bcb9fcaf$export$c85b79f69ca43879.setTextsToAllCentersOfThisAccount(params, options)(fetch, basePath);
        },
        /**
     * @param audioPro
     */ updateAudioPro: function(params, options) {
            return $5c3c9234bcb9fcaf$export$c85b79f69ca43879.updateAudioPro(params, options)(fetch, basePath);
        }
    };
};
var $5c3c9234bcb9fcaf$export$be06f92357ac050a = {
    /**
   * @param orl
   */ createOrl: function(params, options) {
        var baseUrl = "/my-account/api/orl";
        var urlObj = $fEtMY.parse(baseUrl, true);
        var fetchOptions = $01ElO({}, {
            method: "POST"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/json"
        };
        if (params["orl"]) fetchOptions.body = JSON.stringify(params["orl"] || {});
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    },
    /**
   * @param orl
   */ createOrlApi: function(params, options) {
        var baseUrl = "/my-account/api/create-orl";
        var urlObj = $fEtMY.parse(baseUrl, true);
        var fetchOptions = $01ElO({}, {
            method: "POST"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/json"
        };
        if (params["orl"]) fetchOptions.body = JSON.stringify(params["orl"] || {});
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    },
    /**
   * @param orl
   */ updateOrl: function(params, options) {
        var baseUrl = "/my-account/api/update-orl";
        var urlObj = $fEtMY.parse(baseUrl, true);
        var fetchOptions = $01ElO({}, {
            method: "PUT"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/json"
        };
        if (params["orl"]) fetchOptions.body = JSON.stringify(params["orl"] || {});
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    }
};
var $5c3c9234bcb9fcaf$export$10da70745007e133 = {
    /**
   * @param orl
   */ createOrl: function(params, options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$be06f92357ac050a.createOrl(params, options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response;
                else throw response;
            });
        };
    },
    /**
   * @param orl
   */ createOrlApi: function(params, options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$be06f92357ac050a.createOrlApi(params, options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response;
                else throw response;
            });
        };
    },
    /**
   * @param orl
   */ updateOrl: function(params, options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$be06f92357ac050a.updateOrl(params, options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response;
                else throw response;
            });
        };
    }
};
var $5c3c9234bcb9fcaf$export$b84fcd7034608719 = /*#__PURE__*/ function(BaseAPI) {
    "use strict";
    (0, $lu64P._)(EditOrlApi, BaseAPI);
    var _super = (0, $qCKPt._)(EditOrlApi);
    function EditOrlApi() {
        (0, $3V7B6._)(this, EditOrlApi);
        return _super.apply(this, arguments);
    }
    (0, $fqAw8._)(EditOrlApi, [
        {
            /**
   * @param orl
   */ key: "createOrl",
            value: function createOrl(params, options) {
                return $5c3c9234bcb9fcaf$export$10da70745007e133.createOrl(params, options)(this.fetch, this.basePath);
            }
        },
        {
            /**
   * @param orl
   */ key: "createOrlApi",
            value: function createOrlApi(params, options) {
                return $5c3c9234bcb9fcaf$export$10da70745007e133.createOrlApi(params, options)(this.fetch, this.basePath);
            }
        },
        {
            /**
   * @param orl
   */ key: "updateOrl",
            value: function updateOrl(params, options) {
                return $5c3c9234bcb9fcaf$export$10da70745007e133.updateOrl(params, options)(this.fetch, this.basePath);
            }
        }
    ]);
    return EditOrlApi;
}($5c3c9234bcb9fcaf$export$70edad7ad5bb3f5d);
var $5c3c9234bcb9fcaf$export$ef3d91fb0b8897a2 = function EditOrlApiFactory(fetch, basePath) {
    return {
        /**
     * @param orl
     */ createOrl: function(params, options) {
            return $5c3c9234bcb9fcaf$export$10da70745007e133.createOrl(params, options)(fetch, basePath);
        },
        /**
     * @param orl
     */ createOrlApi: function(params, options) {
            return $5c3c9234bcb9fcaf$export$10da70745007e133.createOrlApi(params, options)(fetch, basePath);
        },
        /**
     * @param orl
     */ updateOrl: function(params, options) {
            return $5c3c9234bcb9fcaf$export$10da70745007e133.updateOrl(params, options)(fetch, basePath);
        }
    };
};
var $5c3c9234bcb9fcaf$export$82c4bd214d7997aa = {
    /**
   * @param code
   * @param centerId
   */ adminDeleteOffersForCenter: function(params, options) {
        // verify required parameter "code" is set
        if (params["code"] == null) throw new Error("Missing required parameter code when calling adminDeleteOffersForCenter");
        var baseUrl = "/my-account/api/my-offer/remove";
        var urlObj = $fEtMY.parse(baseUrl, true);
        urlObj.query = $01ElO({}, urlObj.query, {
            centerId: params["centerId"],
            code: params["code"]
        }, {
            credentials: "same-origin"
        });
        var fetchOptions = $01ElO({}, {
            method: "POST"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    },
    /**
   * @param code
   * @param centerId
   */ adminDeleteVedettesForCenter: function(params, options) {
        // verify required parameter "code" is set
        if (params["code"] == null) throw new Error("Missing required parameter code when calling adminDeleteVedettesForCenter");
        var baseUrl = "/my-account/api/my-visibility/remove";
        var urlObj = $fEtMY.parse(baseUrl, true);
        urlObj.query = $01ElO({}, urlObj.query, {
            centerId: params["centerId"],
            code: params["code"]
        }, {
            credentials: "same-origin"
        });
        var fetchOptions = $01ElO({}, {
            method: "POST"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    },
    /**
   * @param model
   */ adminUpdateOffer: function(params, options) {
        var baseUrl = "/my-account/api/my-offer/update";
        var urlObj = $fEtMY.parse(baseUrl, true);
        var fetchOptions = $01ElO({}, {
            method: "POST"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/json"
        };
        if (params["model"]) fetchOptions.body = JSON.stringify(params["model"] || {});
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    },
    /**
   * @param model
   */ adminUpdateVisibility: function(params, options) {
        var baseUrl = "/my-account/api/my-visibility/update";
        var urlObj = $fEtMY.parse(baseUrl, true);
        var fetchOptions = $01ElO({}, {
            method: "POST"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/json"
        };
        if (params["model"]) fetchOptions.body = JSON.stringify(params["model"] || {});
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    },
    /**
   */ getCurrentOfferText: function(options) {
        var baseUrl = "/my-account/api/my-offer/get-current-text";
        var urlObj = $fEtMY.parse(baseUrl, true);
        var fetchOptions = $01ElO({}, {
            method: "GET"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    },
    /**
   * @param couponUrl
   */ setCurrenCoupon: function(params, options) {
        var baseUrl = "/my-account/api/my-offer/set-current-coupon";
        var urlObj = $fEtMY.parse(baseUrl, true);
        urlObj.query = $01ElO({}, urlObj.query, {
            couponUrl: params["couponUrl"]
        }, {
            credentials: "same-origin"
        });
        var fetchOptions = $01ElO({}, {
            method: "POST"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    },
    /**
   * @param hideExpiration
   * @param newText
   */ setCurrentOfferText: function(params, options) {
        // verify required parameter "hideExpiration" is set
        if (params["hideExpiration"] == null) throw new Error("Missing required parameter hideExpiration when calling setCurrentOfferText");
        var baseUrl = "/my-account/api/my-offer/set-current-text";
        var urlObj = $fEtMY.parse(baseUrl, true);
        urlObj.query = $01ElO({}, urlObj.query, {
            newText: params["newText"],
            hideExpiration: params["hideExpiration"]
        }, {
            credentials: "same-origin"
        });
        var fetchOptions = $01ElO({}, {
            method: "POST"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    }
};
var $5c3c9234bcb9fcaf$export$67599af7679cf5d = {
    /**
   * @param code
   * @param centerId
   */ adminDeleteOffersForCenter: function(params, options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$82c4bd214d7997aa.adminDeleteOffersForCenter(params, options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response;
                else throw response;
            });
        };
    },
    /**
   * @param code
   * @param centerId
   */ adminDeleteVedettesForCenter: function(params, options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$82c4bd214d7997aa.adminDeleteVedettesForCenter(params, options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response;
                else throw response;
            });
        };
    },
    /**
   * @param model
   */ adminUpdateOffer: function(params, options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$82c4bd214d7997aa.adminUpdateOffer(params, options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response;
                else throw response;
            });
        };
    },
    /**
   * @param model
   */ adminUpdateVisibility: function(params, options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$82c4bd214d7997aa.adminUpdateVisibility(params, options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response;
                else throw response;
            });
        };
    },
    /**
   */ getCurrentOfferText: function(options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$82c4bd214d7997aa.getCurrentOfferText(options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response.json();
                else throw response;
            });
        };
    },
    /**
   * @param couponUrl
   */ setCurrenCoupon: function(params, options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$82c4bd214d7997aa.setCurrenCoupon(params, options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response;
                else throw response;
            });
        };
    },
    /**
   * @param hideExpiration
   * @param newText
   */ setCurrentOfferText: function(params, options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$82c4bd214d7997aa.setCurrentOfferText(params, options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response;
                else throw response;
            });
        };
    }
};
var $5c3c9234bcb9fcaf$export$cc73579c789abfdb = /*#__PURE__*/ function(BaseAPI) {
    "use strict";
    (0, $lu64P._)(MyVisibilityApi, BaseAPI);
    var _super = (0, $qCKPt._)(MyVisibilityApi);
    function MyVisibilityApi() {
        (0, $3V7B6._)(this, MyVisibilityApi);
        return _super.apply(this, arguments);
    }
    (0, $fqAw8._)(MyVisibilityApi, [
        {
            /**
   * @param code
   * @param centerId
   */ key: "adminDeleteOffersForCenter",
            value: function adminDeleteOffersForCenter(params, options) {
                return $5c3c9234bcb9fcaf$export$67599af7679cf5d.adminDeleteOffersForCenter(params, options)(this.fetch, this.basePath);
            }
        },
        {
            /**
   * @param code
   * @param centerId
   */ key: "adminDeleteVedettesForCenter",
            value: function adminDeleteVedettesForCenter(params, options) {
                return $5c3c9234bcb9fcaf$export$67599af7679cf5d.adminDeleteVedettesForCenter(params, options)(this.fetch, this.basePath);
            }
        },
        {
            /**
   * @param model
   */ key: "adminUpdateOffer",
            value: function adminUpdateOffer(params, options) {
                return $5c3c9234bcb9fcaf$export$67599af7679cf5d.adminUpdateOffer(params, options)(this.fetch, this.basePath);
            }
        },
        {
            /**
   * @param model
   */ key: "adminUpdateVisibility",
            value: function adminUpdateVisibility(params, options) {
                return $5c3c9234bcb9fcaf$export$67599af7679cf5d.adminUpdateVisibility(params, options)(this.fetch, this.basePath);
            }
        },
        {
            /**
   */ key: "getCurrentOfferText",
            value: function getCurrentOfferText(options) {
                return $5c3c9234bcb9fcaf$export$67599af7679cf5d.getCurrentOfferText(options)(this.fetch, this.basePath);
            }
        },
        {
            /**
   * @param couponUrl
   */ key: "setCurrenCoupon",
            value: function setCurrenCoupon(params, options) {
                return $5c3c9234bcb9fcaf$export$67599af7679cf5d.setCurrenCoupon(params, options)(this.fetch, this.basePath);
            }
        },
        {
            /**
   * @param hideExpiration
   * @param newText
   */ key: "setCurrentOfferText",
            value: function setCurrentOfferText(params, options) {
                return $5c3c9234bcb9fcaf$export$67599af7679cf5d.setCurrentOfferText(params, options)(this.fetch, this.basePath);
            }
        }
    ]);
    return MyVisibilityApi;
}($5c3c9234bcb9fcaf$export$70edad7ad5bb3f5d);
var $5c3c9234bcb9fcaf$export$bfc62cd634509500 = function MyVisibilityApiFactory(fetch, basePath) {
    return {
        /**
     * @param code
     * @param centerId
     */ adminDeleteOffersForCenter: function(params, options) {
            return $5c3c9234bcb9fcaf$export$67599af7679cf5d.adminDeleteOffersForCenter(params, options)(fetch, basePath);
        },
        /**
     * @param code
     * @param centerId
     */ adminDeleteVedettesForCenter: function(params, options) {
            return $5c3c9234bcb9fcaf$export$67599af7679cf5d.adminDeleteVedettesForCenter(params, options)(fetch, basePath);
        },
        /**
     * @param model
     */ adminUpdateOffer: function(params, options) {
            return $5c3c9234bcb9fcaf$export$67599af7679cf5d.adminUpdateOffer(params, options)(fetch, basePath);
        },
        /**
     * @param model
     */ adminUpdateVisibility: function(params, options) {
            return $5c3c9234bcb9fcaf$export$67599af7679cf5d.adminUpdateVisibility(params, options)(fetch, basePath);
        },
        /**
     */ getCurrentOfferText: function(options) {
            return $5c3c9234bcb9fcaf$export$67599af7679cf5d.getCurrentOfferText(options)(fetch, basePath);
        },
        /**
     * @param couponUrl
     */ setCurrenCoupon: function(params, options) {
            return $5c3c9234bcb9fcaf$export$67599af7679cf5d.setCurrenCoupon(params, options)(fetch, basePath);
        },
        /**
     * @param hideExpiration
     * @param newText
     */ setCurrentOfferText: function(params, options) {
            return $5c3c9234bcb9fcaf$export$67599af7679cf5d.setCurrentOfferText(params, options)(fetch, basePath);
        }
    };
};
var $5c3c9234bcb9fcaf$export$1175fcd9db34dddc = {
    /**
   * @param orlId
   * @param query
   */ askForOrlRdv: function(params, options) {
        // verify required parameter "orlId" is set
        if (params["orlId"] == null) throw new Error("Missing required parameter orlId when calling askForOrlRdv");
        var baseUrl = "/api/ask-for-orl-rdv/{orlId}".replace("{orlId}", "".concat(params["orlId"]));
        var urlObj = $fEtMY.parse(baseUrl, true);
        var fetchOptions = $01ElO({}, {
            method: "POST"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/json"
        };
        if (params["query"]) fetchOptions.body = JSON.stringify(params["query"] || {});
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    },
    /**
   * @param audioProId
   * @param query
   */ askForRdv: function(params, options) {
        // verify required parameter "audioProId" is set
        if (params["audioProId"] == null) throw new Error("Missing required parameter audioProId when calling askForRdv");
        var baseUrl = "/api/ask-for-rdv/{audioProId}".replace("{audioProId}", "".concat(params["audioProId"]));
        var urlObj = $fEtMY.parse(baseUrl, true);
        var fetchOptions = $01ElO({}, {
            method: "POST"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/json"
        };
        if (params["query"]) fetchOptions.body = JSON.stringify(params["query"] || {});
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    },
    globalAskForRdv: function(params, options) {
        var baseUrl = "/api/ask-for-rdv-global";
        var urlObj = $fEtMY.parse(baseUrl, true);
        var fetchOptions = $01ElO({}, {
            method: "POST"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/json"
        };
        if (params["query"]) fetchOptions.body = JSON.stringify(params["query"] || {});
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    },
    /**
   * @param audioProId
   */ clickedOnRdvLink: function(params, options) {
        // verify required parameter "audioProId" is set
        if (params["audioProId"] == null) throw new Error("Missing required parameter audioProId when calling clickedOnRdvLink");
        var baseUrl = "/api/clicked-on-rdv-link/{audioProId}?isMobile=".concat(params.isMobile).replace("{audioProId}", "".concat(params["audioProId"]));
        var urlObj = $fEtMY.parse(baseUrl, true);
        var fetchOptions = $01ElO({}, {
            method: "POST"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    }
};
var $5c3c9234bcb9fcaf$export$c2634ee9829036da = {
    /**
   * @param orlId
   * @param query
   */ askForOrlRdv: function(params, options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$1175fcd9db34dddc.askForOrlRdv(params, options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response;
                else throw response;
            });
        };
    },
    /**
   * @param audioProId
   * @param query
   */ askForRdv: function(params, options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$1175fcd9db34dddc.askForRdv(params, options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response;
                else throw response;
            });
        };
    },
    globalAskForRdv: function(params, options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$1175fcd9db34dddc.globalAskForRdv(params, options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response;
                else throw response;
            });
        };
    },
    /**
   * @param audioProId
   */ clickedOnRdvLink: function(params, options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$1175fcd9db34dddc.clickedOnRdvLink(params, options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response;
                else throw response;
            });
        };
    }
};
var $5c3c9234bcb9fcaf$export$7a0a9669d5711085 = /*#__PURE__*/ function(BaseAPI) {
    "use strict";
    (0, $lu64P._)(RdvApi, BaseAPI);
    var _super = (0, $qCKPt._)(RdvApi);
    function RdvApi() {
        (0, $3V7B6._)(this, RdvApi);
        return _super.apply(this, arguments);
    }
    (0, $fqAw8._)(RdvApi, [
        {
            /**
   * @param orlId
   * @param query
   */ key: "askForOrlRdv",
            value: function askForOrlRdv(params, options) {
                return $5c3c9234bcb9fcaf$export$c2634ee9829036da.askForOrlRdv(params, options)(this.fetch, this.basePath);
            }
        },
        {
            /**
   * @param audioProId
   * @param query
   */ key: "askForRdv",
            value: function askForRdv(params, options) {
                return $5c3c9234bcb9fcaf$export$c2634ee9829036da.askForRdv(params, options)(this.fetch, this.basePath);
            }
        },
        {
            key: "globalAskForRdv",
            value: function globalAskForRdv(params, options) {
                return $5c3c9234bcb9fcaf$export$c2634ee9829036da.globalAskForRdv(params, options)(this.fetch, this.basePath);
            }
        },
        {
            /**
   * @param audioProId
   */ key: "clickedOnRdvLink",
            value: function clickedOnRdvLink(params, options) {
                return $5c3c9234bcb9fcaf$export$c2634ee9829036da.clickedOnRdvLink(params, options)(this.fetch, this.basePath);
            }
        }
    ]);
    return RdvApi;
}($5c3c9234bcb9fcaf$export$70edad7ad5bb3f5d);
var $5c3c9234bcb9fcaf$export$99c66f0b44464e6f = function RdvApiFactory(fetch, basePath) {
    return {
        /**
     * @param orlId
     * @param query
     */ askForOrlRdv: function(params, options) {
            return $5c3c9234bcb9fcaf$export$c2634ee9829036da.askForOrlRdv(params, options)(fetch, basePath);
        },
        /**
     * @param audioProId
     * @param query
     */ askForRdv: function(params, options) {
            return $5c3c9234bcb9fcaf$export$c2634ee9829036da.askForRdv(params, options)(fetch, basePath);
        },
        /**
     * @param audioProId
     */ clickedOnRdvLink: function(params, options) {
            return $5c3c9234bcb9fcaf$export$c2634ee9829036da.clickedOnRdvLink(params, options)(fetch, basePath);
        }
    };
};
var $5c3c9234bcb9fcaf$export$339136ec61249109 = {
    /**
   * @param query
   */ saveStat: function(params, options) {
        var baseUrl = "/api/stat";
        var urlObj = $fEtMY.parse(baseUrl, true);
        var fetchOptions = $01ElO({}, {
            method: "POST"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/json"
        };
        if (params["query"]) fetchOptions.body = JSON.stringify(params["query"] || {});
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    },
    /**
   * @param query
   */ saveStats: function(params, options) {
        var baseUrl = "/api/stats";
        var urlObj = $fEtMY.parse(baseUrl, true);
        var fetchOptions = $01ElO({}, {
            method: "POST"
        }, options, {
            credentials: "same-origin"
        });
        var contentTypeHeader = {};
        contentTypeHeader = {
            "Content-Type": "application/json"
        };
        if (params["query"]) fetchOptions.body = JSON.stringify(params["query"] || {});
        if (contentTypeHeader) fetchOptions.headers = contentTypeHeader;
        return {
            url: $fEtMY.format(urlObj),
            options: fetchOptions
        };
    }
};
var $5c3c9234bcb9fcaf$export$111f322e8858b2bb = {
    /**
   * @param query
   */ saveStat: function(params, options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$339136ec61249109.saveStat(params, options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response;
                else throw response;
            });
        };
    },
    /**
   * @param query
   */ saveStats: function(params, options) {
        var fetchArgs = $5c3c9234bcb9fcaf$export$339136ec61249109.saveStats(params, options);
        return function() {
            var fetch = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : window["fetch"], basePath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $5c3c9234bcb9fcaf$var$BASE_PATH;
            return fetch(basePath + fetchArgs.url, fetchArgs.options).then(function(response) {
                if (response.status >= 200 && response.status < 300) return response;
                else throw response;
            });
        };
    }
};
var $5c3c9234bcb9fcaf$export$536cc970372a085 = /*#__PURE__*/ function(BaseAPI) {
    "use strict";
    (0, $lu64P._)(StatsApi, BaseAPI);
    var _super = (0, $qCKPt._)(StatsApi);
    function StatsApi() {
        (0, $3V7B6._)(this, StatsApi);
        return _super.apply(this, arguments);
    }
    (0, $fqAw8._)(StatsApi, [
        {
            /**
   * @param query
   */ key: "saveStat",
            value: function saveStat(params, options) {
                return $5c3c9234bcb9fcaf$export$111f322e8858b2bb.saveStat(params, options)(this.fetch, this.basePath);
            }
        },
        {
            /**
   * @param query
   */ key: "saveStats",
            value: function saveStats(params, options) {
                return $5c3c9234bcb9fcaf$export$111f322e8858b2bb.saveStats(params, options)(this.fetch, this.basePath);
            }
        }
    ]);
    return StatsApi;
}($5c3c9234bcb9fcaf$export$70edad7ad5bb3f5d);
var $5c3c9234bcb9fcaf$export$6e609a31cb1c1a24 = function StatsApiFactory(fetch, basePath) {
    return {
        /**
     * @param query
     */ saveStat: function(params, options) {
            return $5c3c9234bcb9fcaf$export$111f322e8858b2bb.saveStat(params, options)(fetch, basePath);
        },
        /**
     * @param query
     */ saveStats: function(params, options) {
            return $5c3c9234bcb9fcaf$export$111f322e8858b2bb.saveStats(params, options)(fetch, basePath);
        }
    };
};

});
parcelRegister("3V7B6", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2dac96a9766168b6$export$2996f80ef42b8419; });
function $2dac96a9766168b6$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("fqAw8", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b3b59c4658581d92$export$d60067ff2358eee8; });
function $b3b59c4658581d92$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $b3b59c4658581d92$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $b3b59c4658581d92$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $b3b59c4658581d92$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("lu64P", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $fa411d0b483b715e$export$7e4530ad35d3bb8; });

var $cS4cf = parcelRequire("cS4cf");
function $fa411d0b483b715e$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $cS4cf._set_prototype_of)(subClass, superClass);
}

});
parcelRegister("cS4cf", function(module, exports) {

$parcel$export(module.exports, "_set_prototype_of", function () { return $95edc881cbe5efd4$export$c2c98ac76e997b63; });
function $95edc881cbe5efd4$export$c2c98ac76e997b63(o, p) {
    $95edc881cbe5efd4$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $95edc881cbe5efd4$export$c2c98ac76e997b63(o, p);
}

});


parcelRegister("qCKPt", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $05007d9f17de8cce$export$8dd05c13f5255580; });

var $bil8c = parcelRequire("bil8c");

var $8sXzW = parcelRequire("8sXzW");

var $a1BUq = parcelRequire("a1BUq");
function $05007d9f17de8cce$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $8sXzW._is_native_reflect_construct)();
    return function _createSuperInternal() {
        var Super = (0, $bil8c._get_prototype_of)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $bil8c._get_prototype_of)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $a1BUq._possible_constructor_return)(this, result);
    };
}

});
parcelRegister("bil8c", function(module, exports) {

$parcel$export(module.exports, "_get_prototype_of", function () { return $8391c45fd9a6fcf6$export$f09211a7d3c496a1; });
$parcel$export(module.exports, "_", function () { return $8391c45fd9a6fcf6$export$f09211a7d3c496a1; });
function $8391c45fd9a6fcf6$export$f09211a7d3c496a1(o) {
    $8391c45fd9a6fcf6$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $8391c45fd9a6fcf6$export$f09211a7d3c496a1(o);
}

});

parcelRegister("8sXzW", function(module, exports) {

$parcel$export(module.exports, "_is_native_reflect_construct", function () { return $629f275c60b7f975$export$685354647fba1516; });
function $629f275c60b7f975$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("a1BUq", function(module, exports) {

$parcel$export(module.exports, "_possible_constructor_return", function () { return $74c7675b05d7c4a5$export$ef97c660ca164e52; });
$parcel$export(module.exports, "_", function () { return $74c7675b05d7c4a5$export$ef97c660ca164e52; });

var $lafPd = parcelRequire("lafPd");

var $alyXF = parcelRequire("alyXF");
function $74c7675b05d7c4a5$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $alyXF._type_of)(call) === "object" || typeof call === "function")) return call;
    return (0, $lafPd._assert_this_initialized)(self);
}

});
parcelRegister("lafPd", function(module, exports) {

$parcel$export(module.exports, "_assert_this_initialized", function () { return $f686cea8cee570d6$export$f3b8ed2e4a5d10b8; });
$parcel$export(module.exports, "_", function () { return $f686cea8cee570d6$export$f3b8ed2e4a5d10b8; });
function $f686cea8cee570d6$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});



parcelRegister("01ElO", function(module, exports) {
parcelRequire("7iTzF");

module.exports = (parcelRequire("7ARVS")).Object.assign;

});
parcelRegister("7iTzF", function(module, exports) {
// 19.1.3.1 Object.assign(target, source)

var $lOz7T = parcelRequire("lOz7T");

$lOz7T($lOz7T.S + $lOz7T.F, "Object", {
    assign: (parcelRequire("gblen"))
});

});
parcelRegister("lOz7T", function(module, exports) {

var $7sHG0 = parcelRequire("7sHG0");

var $7ARVS = parcelRequire("7ARVS");

var $8XEYz = parcelRequire("8XEYz");

var $7Yp2L = parcelRequire("7Yp2L");

var $6GC96 = parcelRequire("6GC96");
var $fe1983d0a64f8744$var$PROTOTYPE = "prototype";
var $fe1983d0a64f8744$var$$export = function $export1(type, name, source) {
    var IS_FORCED = type & $fe1983d0a64f8744$var$$export.F;
    var IS_GLOBAL = type & $fe1983d0a64f8744$var$$export.G;
    var IS_STATIC = type & $fe1983d0a64f8744$var$$export.S;
    var IS_PROTO = type & $fe1983d0a64f8744$var$$export.P;
    var IS_BIND = type & $fe1983d0a64f8744$var$$export.B;
    var IS_WRAP = type & $fe1983d0a64f8744$var$$export.W;
    var exports = IS_GLOBAL ? $7ARVS : $7ARVS[name] || ($7ARVS[name] = {});
    var expProto = exports[$fe1983d0a64f8744$var$PROTOTYPE];
    var target = IS_GLOBAL ? $7sHG0 : IS_STATIC ? $7sHG0[name] : ($7sHG0[name] || {})[$fe1983d0a64f8744$var$PROTOTYPE];
    var key, own, out;
    if (IS_GLOBAL) source = name;
    for(key in source){
        // contains in native
        own = !IS_FORCED && target && target[key] !== undefined;
        if (own && $6GC96(exports, key)) continue;
        // export native or passed
        out = own ? target[key] : source[key];
        // prevent global pollution for namespaces
        exports[key] = IS_GLOBAL && typeof target[key] != "function" ? source[key] : IS_BIND && own ? $8XEYz(out, $7sHG0) : IS_WRAP && target[key] == out ? function(C) {
            var F = function F(a, b, c) {
                if (this instanceof C) {
                    switch(arguments.length){
                        case 0:
                            return new C();
                        case 1:
                            return new C(a);
                        case 2:
                            return new C(a, b);
                    }
                    return new C(a, b, c);
                }
                return C.apply(this, arguments);
            };
            F[$fe1983d0a64f8744$var$PROTOTYPE] = C[$fe1983d0a64f8744$var$PROTOTYPE];
            return F;
        // make static versions for prototype methods
        }(out) : IS_PROTO && typeof out == "function" ? $8XEYz(Function.call, out) : out;
        // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
        if (IS_PROTO) {
            (exports.virtual || (exports.virtual = {}))[key] = out;
            // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
            if (type & $fe1983d0a64f8744$var$$export.R && expProto && !expProto[key]) $7Yp2L(expProto, key, out);
        }
    }
};
// type bitmap
$fe1983d0a64f8744$var$$export.F = 1; // forced
$fe1983d0a64f8744$var$$export.G = 2; // global
$fe1983d0a64f8744$var$$export.S = 4; // static
$fe1983d0a64f8744$var$$export.P = 8; // proto
$fe1983d0a64f8744$var$$export.B = 16; // bind
$fe1983d0a64f8744$var$$export.W = 32; // wrap
$fe1983d0a64f8744$var$$export.U = 64; // safe
$fe1983d0a64f8744$var$$export.R = 128; // real proto method for `library`
module.exports = $fe1983d0a64f8744$var$$export;

});
parcelRegister("7sHG0", function(module, exports) {
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var $56ed072bdd2c6bbc$var$global = module.exports = typeof window != "undefined" && window.Math == Math ? window : typeof self != "undefined" && self.Math == Math ? self : Function("return this")();
if (typeof __g == "number") __g = $56ed072bdd2c6bbc$var$global; // eslint-disable-line no-undef

});

parcelRegister("7ARVS", function(module, exports) {
var $5875bb0e2c8136ea$var$core = module.exports = {
    version: "2.6.12"
};
if (typeof __e == "number") __e = $5875bb0e2c8136ea$var$core; // eslint-disable-line no-undef

});

parcelRegister("8XEYz", function(module, exports) {
// optional / simple context binding

var $gZMSr = parcelRequire("gZMSr");
module.exports = function(fn, that, length) {
    $gZMSr(fn);
    if (that === undefined) return fn;
    switch(length){
        case 1:
            return function(a) {
                return fn.call(that, a);
            };
        case 2:
            return function(a, b) {
                return fn.call(that, a, b);
            };
        case 3:
            return function(a, b, c) {
                return fn.call(that, a, b, c);
            };
    }
    return function() {
        return fn.apply(that, arguments);
    };
};

});
parcelRegister("gZMSr", function(module, exports) {
module.exports = function(it) {
    if (typeof it != "function") throw TypeError(it + " is not a function!");
    return it;
};

});


parcelRegister("7Yp2L", function(module, exports) {

var $49VNb = parcelRequire("49VNb");

var $k2voR = parcelRequire("k2voR");

module.exports = (parcelRequire("2C8yr")) ? function(object, key, value) {
    return $49VNb.f(object, key, $k2voR(1, value));
} : function(object, key, value) {
    object[key] = value;
    return object;
};

});
parcelRegister("49VNb", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $3074d50b25d0e957$export$2d1720544b23b823; }, function (v) { return $3074d50b25d0e957$export$2d1720544b23b823 = v; });
var $3074d50b25d0e957$export$2d1720544b23b823;

var $5Zzc4 = parcelRequire("5Zzc4");

var $2sJbA = parcelRequire("2sJbA");

var $bop5g = parcelRequire("bop5g");
var $3074d50b25d0e957$var$dP = Object.defineProperty;

$3074d50b25d0e957$export$2d1720544b23b823 = (parcelRequire("2C8yr")) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
    $5Zzc4(O);
    P = $bop5g(P, true);
    $5Zzc4(Attributes);
    if ($2sJbA) try {
        return $3074d50b25d0e957$var$dP(O, P, Attributes);
    } catch (e) {}
    if ("get" in Attributes || "set" in Attributes) throw TypeError("Accessors not supported!");
    if ("value" in Attributes) O[P] = Attributes.value;
    return O;
};

});
parcelRegister("5Zzc4", function(module, exports) {

var $ggjjz = parcelRequire("ggjjz");
module.exports = function(it) {
    if (!$ggjjz(it)) throw TypeError(it + " is not an object!");
    return it;
};

});
parcelRegister("ggjjz", function(module, exports) {
module.exports = function(it) {
    return typeof it === "object" ? it !== null : typeof it === "function";
};

});


parcelRegister("2sJbA", function(module, exports) {



module.exports = !(parcelRequire("2C8yr")) && !(parcelRequire("flgGX"))(function() {
    return Object.defineProperty((parcelRequire("dpYOM"))("div"), "a", {
        get: function get() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("2C8yr", function(module, exports) {
// Thank's IE8 for his funny defineProperty

module.exports = !(parcelRequire("flgGX"))(function() {
    return Object.defineProperty({}, "a", {
        get: function get() {
            return 7;
        }
    }).a != 7;
});

});
parcelRegister("flgGX", function(module, exports) {
module.exports = function(exec) {
    try {
        return !!exec();
    } catch (e) {
        return true;
    }
};

});


parcelRegister("dpYOM", function(module, exports) {

var $ggjjz = parcelRequire("ggjjz");

var $7sHG0 = parcelRequire("7sHG0");
var $9c4cc95d701fdc3c$require$document = $7sHG0.document;
// typeof document.createElement is 'object' in old IE
var $9c4cc95d701fdc3c$var$is = $ggjjz($9c4cc95d701fdc3c$require$document) && $ggjjz($9c4cc95d701fdc3c$require$document.createElement);
module.exports = function(it) {
    return $9c4cc95d701fdc3c$var$is ? $9c4cc95d701fdc3c$require$document.createElement(it) : {};
};

});


parcelRegister("bop5g", function(module, exports) {
// 7.1.1 ToPrimitive(input [, PreferredType])

var $ggjjz = parcelRequire("ggjjz");
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S) {
    if (!$ggjjz(it)) return it;
    var fn, val;
    if (S && typeof (fn = it.toString) == "function" && !$ggjjz(val = fn.call(it))) return val;
    if (typeof (fn = it.valueOf) == "function" && !$ggjjz(val = fn.call(it))) return val;
    if (!S && typeof (fn = it.toString) == "function" && !$ggjjz(val = fn.call(it))) return val;
    throw TypeError("Can't convert object to primitive value");
};

});


parcelRegister("k2voR", function(module, exports) {
module.exports = function(bitmap, value) {
    return {
        enumerable: !(bitmap & 1),
        configurable: !(bitmap & 2),
        writable: !(bitmap & 4),
        value: value
    };
};

});


parcelRegister("6GC96", function(module, exports) {
var $4de4414dd422bcd0$var$hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key) {
    return $4de4414dd422bcd0$var$hasOwnProperty.call(it, key);
};

});


parcelRegister("gblen", function(module, exports) {
"use strict";

var $2C8yr = parcelRequire("2C8yr");

var $fy82u = parcelRequire("fy82u");

var $ijtTP = parcelRequire("ijtTP");

var $5udEg = parcelRequire("5udEg");

var $dUsk9 = parcelRequire("dUsk9");

var $ba5es = parcelRequire("ba5es");
var $bc7e246c57785e2c$var$$assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$bc7e246c57785e2c$var$$assign || (parcelRequire("flgGX"))(function() {
    var A = {};
    var B = {};
    // eslint-disable-next-line no-undef
    var S = Symbol();
    var K = "abcdefghijklmnopqrst";
    A[S] = 7;
    K.split("").forEach(function(k) {
        B[k] = k;
    });
    return $bc7e246c57785e2c$var$$assign({}, A)[S] != 7 || Object.keys($bc7e246c57785e2c$var$$assign({}, B)).join("") != K;
}) ? function assign(target, source) {
    var T = $dUsk9(target);
    var aLen = arguments.length;
    var index = 1;
    var getSymbols = $ijtTP.f;
    var isEnum = $5udEg.f;
    while(aLen > index){
        var S = $ba5es(arguments[index++]);
        var keys = getSymbols ? $fy82u(S).concat(getSymbols(S)) : $fy82u(S);
        var length = keys.length;
        var j = 0;
        var key;
        while(length > j){
            key = keys[j++];
            if (!$2C8yr || isEnum.call(S, key)) T[key] = S[key];
        }
    }
    return T;
} : $bc7e246c57785e2c$var$$assign;

});
parcelRegister("fy82u", function(module, exports) {
// 19.1.2.14 / 15.2.3.14 Object.keys(O)

var $5gVGK = parcelRequire("5gVGK");

var $3jDfb = parcelRequire("3jDfb");
module.exports = Object.keys || function keys(O) {
    return $5gVGK(O, $3jDfb);
};

});
parcelRegister("5gVGK", function(module, exports) {

var $6GC96 = parcelRequire("6GC96");

var $ewLRA = parcelRequire("ewLRA");

var $3d6b32193cceab17$var$arrayIndexOf = (parcelRequire("hU4hM"))(false);

var $3d6b32193cceab17$var$IE_PROTO = (parcelRequire("eOGZa"))("IE_PROTO");
module.exports = function(object, names) {
    var O = $ewLRA(object);
    var i = 0;
    var result = [];
    var key;
    for(key in O)if (key != $3d6b32193cceab17$var$IE_PROTO) $6GC96(O, key) && result.push(key);
    // Don't enum bug & hidden keys
    while(names.length > i)if ($6GC96(O, key = names[i++])) ~$3d6b32193cceab17$var$arrayIndexOf(result, key) || result.push(key);
    return result;
};

});
parcelRegister("ewLRA", function(module, exports) {
// to indexed object, toObject with fallback for non-array-like ES3 strings

var $ba5es = parcelRequire("ba5es");

var $fDe66 = parcelRequire("fDe66");
module.exports = function(it) {
    return $ba5es($fDe66(it));
};

});
parcelRegister("ba5es", function(module, exports) {
// fallback for non-array-like ES3 and non-enumerable old V8 strings

var $lwo2b = parcelRequire("lwo2b");
// eslint-disable-next-line no-prototype-builtins
module.exports = Object("z").propertyIsEnumerable(0) ? Object : function(it) {
    return $lwo2b(it) == "String" ? it.split("") : Object(it);
};

});
parcelRegister("lwo2b", function(module, exports) {
var $faaf3ad831416cd0$var$toString = {}.toString;
module.exports = function(it) {
    return $faaf3ad831416cd0$var$toString.call(it).slice(8, -1);
};

});


parcelRegister("fDe66", function(module, exports) {
// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it) {
    if (it == undefined) throw TypeError("Can't call method on  " + it);
    return it;
};

});


parcelRegister("hU4hM", function(module, exports) {
// false -> Array#indexOf
// true  -> Array#includes

var $ewLRA = parcelRequire("ewLRA");

var $jryVv = parcelRequire("jryVv");

var $bOp2j = parcelRequire("bOp2j");
module.exports = function(IS_INCLUDES) {
    return function($this, el, fromIndex) {
        var O = $ewLRA($this);
        var length = $jryVv(O.length);
        var index = $bOp2j(fromIndex, length);
        var value;
        // Array#includes uses SameValueZero equality algorithm
        // eslint-disable-next-line no-self-compare
        if (IS_INCLUDES && el != el) while(length > index){
            value = O[index++];
            // eslint-disable-next-line no-self-compare
            if (value != value) return true;
        // Array#indexOf ignores holes, Array#includes - not
        }
        else for(; length > index; index++)if (IS_INCLUDES || index in O) {
            if (O[index] === el) return IS_INCLUDES || index || 0;
        }
        return !IS_INCLUDES && -1;
    };
};

});
parcelRegister("jryVv", function(module, exports) {
// 7.1.15 ToLength

var $1rRiv = parcelRequire("1rRiv");
var $e27ba19f60702793$var$min = Math.min;
module.exports = function(it) {
    return it > 0 ? $e27ba19f60702793$var$min($1rRiv(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

});
parcelRegister("1rRiv", function(module, exports) {
// 7.1.4 ToInteger
var $10e1a7d27f2298cf$var$ceil = Math.ceil;
var $10e1a7d27f2298cf$var$floor = Math.floor;
module.exports = function(it) {
    return isNaN(it = +it) ? 0 : (it > 0 ? $10e1a7d27f2298cf$var$floor : $10e1a7d27f2298cf$var$ceil)(it);
};

});


parcelRegister("bOp2j", function(module, exports) {

var $1rRiv = parcelRequire("1rRiv");
var $8997c8eb3753335b$var$max = Math.max;
var $8997c8eb3753335b$var$min = Math.min;
module.exports = function(index, length) {
    index = $1rRiv(index);
    return index < 0 ? $8997c8eb3753335b$var$max(index + length, 0) : $8997c8eb3753335b$var$min(index, length);
};

});


parcelRegister("eOGZa", function(module, exports) {

var $ac97143ebd2eed64$var$shared = (parcelRequire("GFfRi"))("keys");

var $7RbnK = parcelRequire("7RbnK");
module.exports = function(key) {
    return $ac97143ebd2eed64$var$shared[key] || ($ac97143ebd2eed64$var$shared[key] = $7RbnK(key));
};

});
parcelRegister("GFfRi", function(module, exports) {

var $7ARVS = parcelRequire("7ARVS");

var $7sHG0 = parcelRequire("7sHG0");
var $0803ecb31db857c7$var$SHARED = "__core-js_shared__";
var $0803ecb31db857c7$var$store = $7sHG0[$0803ecb31db857c7$var$SHARED] || ($7sHG0[$0803ecb31db857c7$var$SHARED] = {});

(module.exports = function(key, value) {
    return $0803ecb31db857c7$var$store[key] || ($0803ecb31db857c7$var$store[key] = value !== undefined ? value : {});
})("versions", []).push({
    version: $7ARVS.version,
    mode: (parcelRequire("AJSPP")) ? "pure" : "global",
    copyright: "\xa9 2020 Denis Pushkarev (zloirock.ru)"
});

});
parcelRegister("AJSPP", function(module, exports) {
module.exports = true;

});


parcelRegister("7RbnK", function(module, exports) {
var $5b864fd9cf804af2$var$id = 0;
var $5b864fd9cf804af2$var$px = Math.random();
module.exports = function(key) {
    return "Symbol(".concat(key === undefined ? "" : key, ")_", (++$5b864fd9cf804af2$var$id + $5b864fd9cf804af2$var$px).toString(36));
};

});



parcelRegister("3jDfb", function(module, exports) {
// IE 8- don't enum bug keys
module.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");

});


parcelRegister("ijtTP", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $d55131bec0c38095$export$2d1720544b23b823; }, function (v) { return $d55131bec0c38095$export$2d1720544b23b823 = v; });
var $d55131bec0c38095$export$2d1720544b23b823;
$d55131bec0c38095$export$2d1720544b23b823 = Object.getOwnPropertySymbols;

});

parcelRegister("5udEg", function(module, exports) {

$parcel$export(module.exports, "f", function () { return $3fea5767a822a18f$export$2d1720544b23b823; }, function (v) { return $3fea5767a822a18f$export$2d1720544b23b823 = v; });
var $3fea5767a822a18f$export$2d1720544b23b823;
$3fea5767a822a18f$export$2d1720544b23b823 = ({}).propertyIsEnumerable;

});

parcelRegister("dUsk9", function(module, exports) {
// 7.1.13 ToObject(argument)

var $fDe66 = parcelRequire("fDe66");
module.exports = function(it) {
    return Object($fDe66(it));
};

});




parcelRegister("fEtMY", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $alyXF = parcelRequire("alyXF");
"use strict";

var $keFlU = parcelRequire("keFlU");

var $1TxB6 = parcelRequire("1TxB6");
exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;
exports.Url = Url;
function Url() {
    this.protocol = null;
    this.slashes = null;
    this.auth = null;
    this.host = null;
    this.port = null;
    this.hostname = null;
    this.hash = null;
    this.search = null;
    this.query = null;
    this.pathname = null;
    this.path = null;
    this.href = null;
}
// Reference: RFC 3986, RFC 1808, RFC 2396
// define these here so at least they only have to be
// compiled once on the first module load.
var protocolPattern = /^([a-z0-9.+-]+:)/i, portPattern = /:[0-9]*$/, // Special case for a simple path URL
simplePathPattern = /^(\/\/?(?!\/)[^\?\s]*)(\?[^\s]*)?$/, // RFC 2396: characters reserved for delimiting URLs.
// We actually just auto-escape these.
delims = [
    "<",
    ">",
    '"',
    "`",
    " ",
    "\r",
    "\n",
    "	"
], // RFC 2396: characters not allowed for various reasons.
unwise = [
    "{",
    "}",
    "|",
    "\\",
    "^",
    "`"
].concat(delims), // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
autoEscape = [
    "'"
].concat(unwise), // Characters that are never ever allowed in a hostname.
// Note that any invalid chars are also handled, but these
// are the ones that are *expected* to be seen, so we fast-path
// them.
nonHostChars = [
    "%",
    "/",
    "?",
    ";",
    "#"
].concat(autoEscape), hostEndingChars = [
    "/",
    "?",
    "#"
], hostnameMaxLen = 255, hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/, hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/, // protocols that can allow "unsafe" and "unwise" chars.
unsafeProtocol = {
    "javascript": true,
    "javascript:": true
}, // protocols that never have a hostname.
hostlessProtocol = {
    "javascript": true,
    "javascript:": true
}, // protocols that always contain a // bit.
slashedProtocol = {
    "http": true,
    "https": true,
    "ftp": true,
    "gopher": true,
    "file": true,
    "http:": true,
    "https:": true,
    "ftp:": true,
    "gopher:": true,
    "file:": true
};

var $gBDBE = parcelRequire("gBDBE");
function urlParse(url, parseQueryString, slashesDenoteHost) {
    if (url && $1TxB6.isObject(url) && url instanceof Url) return url;
    var u = new Url;
    u.parse(url, parseQueryString, slashesDenoteHost);
    return u;
}
Url.prototype.parse = function(url, parseQueryString, slashesDenoteHost) {
    if (!$1TxB6.isString(url)) throw new TypeError("Parameter 'url' must be a string, not " + (typeof url === "undefined" ? "undefined" : (0, $alyXF._)(url)));
    // Copy chrome, IE, opera backslash-handling behavior.
    // Back slashes before the query string get converted to forward slashes
    // See: https://code.google.com/p/chromium/issues/detail?id=25916
    var queryIndex = url.indexOf("?"), splitter = queryIndex !== -1 && queryIndex < url.indexOf("#") ? "?" : "#", uSplit = url.split(splitter), slashRegex = /\\/g;
    uSplit[0] = uSplit[0].replace(slashRegex, "/");
    url = uSplit.join(splitter);
    var rest = url;
    // trim before proceeding.
    // This is to support parse stuff like "  http://foo.com  \n"
    rest = rest.trim();
    if (!slashesDenoteHost && url.split("#").length === 1) {
        // Try fast path regexp
        var simplePath = simplePathPattern.exec(rest);
        if (simplePath) {
            this.path = rest;
            this.href = rest;
            this.pathname = simplePath[1];
            if (simplePath[2]) {
                this.search = simplePath[2];
                if (parseQueryString) this.query = $gBDBE.parse(this.search.substr(1));
                else this.query = this.search.substr(1);
            } else if (parseQueryString) {
                this.search = "";
                this.query = {};
            }
            return this;
        }
    }
    var proto = protocolPattern.exec(rest);
    if (proto) {
        proto = proto[0];
        var lowerProto = proto.toLowerCase();
        this.protocol = lowerProto;
        rest = rest.substr(proto.length);
    }
    // figure out if it's got a host
    // user@server is *always* interpreted as a hostname, and url
    // resolution will treat //foo/bar as host=foo,path=bar because that's
    // how the browser resolves relative URLs.
    if (slashesDenoteHost || proto || rest.match(/^\/\/[^@\/]+@[^@\/]+/)) {
        var slashes = rest.substr(0, 2) === "//";
        if (slashes && !(proto && hostlessProtocol[proto])) {
            rest = rest.substr(2);
            this.slashes = true;
        }
    }
    if (!hostlessProtocol[proto] && (slashes || proto && !slashedProtocol[proto])) {
        // there's a hostname.
        // the first instance of /, ?, ;, or # ends the host.
        //
        // If there is an @ in the hostname, then non-host chars *are* allowed
        // to the left of the last @ sign, unless some host-ending character
        // comes *before* the @-sign.
        // URLs are obnoxious.
        //
        // ex:
        // http://a@b@c/ => user:a@b host:c
        // http://a@b?@c => user:a host:c path:/?@c
        // v0.12 TODO(isaacs): This is not quite how Chrome does things.
        // Review our test case against browsers more comprehensively.
        // find the first instance of any hostEndingChars
        var hostEnd = -1;
        for(var i = 0; i < hostEndingChars.length; i++){
            var hec = rest.indexOf(hostEndingChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // at this point, either we have an explicit point where the
        // auth portion cannot go past, or the last @ char is the decider.
        var auth, atSign;
        if (hostEnd === -1) // atSign can be anywhere.
        atSign = rest.lastIndexOf("@");
        else // atSign must be in auth portion.
        // http://a@b/c@d => host:b auth:a path:/c@d
        atSign = rest.lastIndexOf("@", hostEnd);
        // Now we have a portion which is definitely the auth.
        // Pull that off.
        if (atSign !== -1) {
            auth = rest.slice(0, atSign);
            rest = rest.slice(atSign + 1);
            this.auth = decodeURIComponent(auth);
        }
        // the host is the remaining to the left of the first non-host char
        hostEnd = -1;
        for(var i = 0; i < nonHostChars.length; i++){
            var hec = rest.indexOf(nonHostChars[i]);
            if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) hostEnd = hec;
        }
        // if we still have not hit it, then the entire thing is a host.
        if (hostEnd === -1) hostEnd = rest.length;
        this.host = rest.slice(0, hostEnd);
        rest = rest.slice(hostEnd);
        // pull out port.
        this.parseHost();
        // we've indicated that there is a hostname,
        // so even if it's empty, it has to be present.
        this.hostname = this.hostname || "";
        // if hostname begins with [ and ends with ]
        // assume that it's an IPv6 address.
        var ipv6Hostname = this.hostname[0] === "[" && this.hostname[this.hostname.length - 1] === "]";
        // validate a little.
        if (!ipv6Hostname) {
            var hostparts = this.hostname.split(/\./);
            for(var i = 0, l = hostparts.length; i < l; i++){
                var part = hostparts[i];
                if (!part) continue;
                if (!part.match(hostnamePartPattern)) {
                    var newpart = "";
                    for(var j = 0, k = part.length; j < k; j++)if (part.charCodeAt(j) > 127) // we replace non-ASCII char with a temporary placeholder
                    // we need this to make sure size of hostname is not
                    // broken by replacing non-ASCII by nothing
                    newpart += "x";
                    else newpart += part[j];
                    // we test again with ASCII char only
                    if (!newpart.match(hostnamePartPattern)) {
                        var validParts = hostparts.slice(0, i);
                        var notHost = hostparts.slice(i + 1);
                        var bit = part.match(hostnamePartStart);
                        if (bit) {
                            validParts.push(bit[1]);
                            notHost.unshift(bit[2]);
                        }
                        if (notHost.length) rest = "/" + notHost.join(".") + rest;
                        this.hostname = validParts.join(".");
                        break;
                    }
                }
            }
        }
        if (this.hostname.length > hostnameMaxLen) this.hostname = "";
        else // hostnames are always lower case.
        this.hostname = this.hostname.toLowerCase();
        if (!ipv6Hostname) // IDNA Support: Returns a punycoded representation of "domain".
        // It only converts parts of the domain name that
        // have non-ASCII characters, i.e. it doesn't matter if
        // you call it with a domain that already is ASCII-only.
        this.hostname = $keFlU.toASCII(this.hostname);
        var p = this.port ? ":" + this.port : "";
        var h = this.hostname || "";
        this.host = h + p;
        this.href += this.host;
        // strip [ and ] from the hostname
        // the host field still retains them, though
        if (ipv6Hostname) {
            this.hostname = this.hostname.substr(1, this.hostname.length - 2);
            if (rest[0] !== "/") rest = "/" + rest;
        }
    }
    // now rest is set to the post-host stuff.
    // chop off any delim chars.
    if (!unsafeProtocol[lowerProto]) // First, make 100% sure that any "autoEscape" chars get
    // escaped, even if encodeURIComponent doesn't think they
    // need to be.
    for(var i = 0, l = autoEscape.length; i < l; i++){
        var ae = autoEscape[i];
        if (rest.indexOf(ae) === -1) continue;
        var esc = encodeURIComponent(ae);
        if (esc === ae) esc = escape(ae);
        rest = rest.split(ae).join(esc);
    }
    // chop off from the tail first.
    var hash = rest.indexOf("#");
    if (hash !== -1) {
        // got a fragment string.
        this.hash = rest.substr(hash);
        rest = rest.slice(0, hash);
    }
    var qm = rest.indexOf("?");
    if (qm !== -1) {
        this.search = rest.substr(qm);
        this.query = rest.substr(qm + 1);
        if (parseQueryString) this.query = $gBDBE.parse(this.query);
        rest = rest.slice(0, qm);
    } else if (parseQueryString) {
        // no query string, but parseQueryString still requested
        this.search = "";
        this.query = {};
    }
    if (rest) this.pathname = rest;
    if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) this.pathname = "/";
    //to support http.request
    if (this.pathname || this.search) {
        var p = this.pathname || "";
        var s = this.search || "";
        this.path = p + s;
    }
    // finally, reconstruct the href based on what has been validated.
    this.href = this.format();
    return this;
};
// format a parsed object into a url string
function urlFormat(obj) {
    // ensure it's an object, and not a string url.
    // If it's an obj, this is a no-op.
    // this way, you can call url_format() on strings
    // to clean up potentially wonky urls.
    if ($1TxB6.isString(obj)) obj = urlParse(obj);
    if (!(obj instanceof Url)) return Url.prototype.format.call(obj);
    return obj.format();
}
Url.prototype.format = function() {
    var auth = this.auth || "";
    if (auth) {
        auth = encodeURIComponent(auth);
        auth = auth.replace(/%3A/i, ":");
        auth += "@";
    }
    var protocol = this.protocol || "", pathname = this.pathname || "", hash = this.hash || "", host = false, query = "";
    if (this.host) host = auth + this.host;
    else if (this.hostname) {
        host = auth + (this.hostname.indexOf(":") === -1 ? this.hostname : "[" + this.hostname + "]");
        if (this.port) host += ":" + this.port;
    }
    if (this.query && $1TxB6.isObject(this.query) && Object.keys(this.query).length) query = $gBDBE.stringify(this.query);
    var search = this.search || query && "?" + query || "";
    if (protocol && protocol.substr(-1) !== ":") protocol += ":";
    // only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
    // unless they had them to begin with.
    if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
        host = "//" + (host || "");
        if (pathname && pathname.charAt(0) !== "/") pathname = "/" + pathname;
    } else if (!host) host = "";
    if (hash && hash.charAt(0) !== "#") hash = "#" + hash;
    if (search && search.charAt(0) !== "?") search = "?" + search;
    pathname = pathname.replace(/[?#]/g, function(match) {
        return encodeURIComponent(match);
    });
    search = search.replace("#", "%23");
    return protocol + host + pathname + search + hash;
};
function urlResolve(source, relative) {
    return urlParse(source, false, true).resolve(relative);
}
Url.prototype.resolve = function(relative) {
    return this.resolveObject(urlParse(relative, false, true)).format();
};
function urlResolveObject(source, relative) {
    if (!source) return relative;
    return urlParse(source, false, true).resolveObject(relative);
}
Url.prototype.resolveObject = function(relative) {
    if ($1TxB6.isString(relative)) {
        var rel = new Url();
        rel.parse(relative, false, true);
        relative = rel;
    }
    var result = new Url();
    var tkeys = Object.keys(this);
    for(var tk = 0; tk < tkeys.length; tk++){
        var tkey = tkeys[tk];
        result[tkey] = this[tkey];
    }
    // hash is always overridden, no matter what.
    // even href="" will remove it.
    result.hash = relative.hash;
    // if the relative url is empty, then there's nothing left to do here.
    if (relative.href === "") {
        result.href = result.format();
        return result;
    }
    // hrefs like //foo/bar always cut to the protocol.
    if (relative.slashes && !relative.protocol) {
        // take everything except the protocol from relative
        var rkeys = Object.keys(relative);
        for(var rk = 0; rk < rkeys.length; rk++){
            var rkey = rkeys[rk];
            if (rkey !== "protocol") result[rkey] = relative[rkey];
        }
        //urlParse appends trailing / to urls like http://www.example.com
        if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) result.path = result.pathname = "/";
        result.href = result.format();
        return result;
    }
    if (relative.protocol && relative.protocol !== result.protocol) {
        // if it's a known url protocol, then changing
        // the protocol does weird things
        // first, if it's not file:, then we MUST have a host,
        // and if there was a path
        // to begin with, then we MUST have a path.
        // if it is file:, then the host is dropped,
        // because that's known to be hostless.
        // anything else is assumed to be absolute.
        if (!slashedProtocol[relative.protocol]) {
            var keys = Object.keys(relative);
            for(var v = 0; v < keys.length; v++){
                var k = keys[v];
                result[k] = relative[k];
            }
            result.href = result.format();
            return result;
        }
        result.protocol = relative.protocol;
        if (!relative.host && !hostlessProtocol[relative.protocol]) {
            var relPath = (relative.pathname || "").split("/");
            while(relPath.length && !(relative.host = relPath.shift()));
            if (!relative.host) relative.host = "";
            if (!relative.hostname) relative.hostname = "";
            if (relPath[0] !== "") relPath.unshift("");
            if (relPath.length < 2) relPath.unshift("");
            result.pathname = relPath.join("/");
        } else result.pathname = relative.pathname;
        result.search = relative.search;
        result.query = relative.query;
        result.host = relative.host || "";
        result.auth = relative.auth;
        result.hostname = relative.hostname || relative.host;
        result.port = relative.port;
        // to support http.request
        if (result.pathname || result.search) {
            var p = result.pathname || "";
            var s = result.search || "";
            result.path = p + s;
        }
        result.slashes = result.slashes || relative.slashes;
        result.href = result.format();
        return result;
    }
    var isSourceAbs = result.pathname && result.pathname.charAt(0) === "/", isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === "/", mustEndAbs = isRelAbs || isSourceAbs || result.host && relative.pathname, removeAllDots = mustEndAbs, srcPath = result.pathname && result.pathname.split("/") || [], relPath = relative.pathname && relative.pathname.split("/") || [], psychotic = result.protocol && !slashedProtocol[result.protocol];
    // if the url is a non-slashed url, then relative
    // links like ../.. should be able
    // to crawl up to the hostname, as well.  This is strange.
    // result.protocol has already been set by now.
    // Later on, put the first path part into the host field.
    if (psychotic) {
        result.hostname = "";
        result.port = null;
        if (result.host) {
            if (srcPath[0] === "") srcPath[0] = result.host;
            else srcPath.unshift(result.host);
        }
        result.host = "";
        if (relative.protocol) {
            relative.hostname = null;
            relative.port = null;
            if (relative.host) {
                if (relPath[0] === "") relPath[0] = relative.host;
                else relPath.unshift(relative.host);
            }
            relative.host = null;
        }
        mustEndAbs = mustEndAbs && (relPath[0] === "" || srcPath[0] === "");
    }
    if (isRelAbs) {
        // it's absolute.
        result.host = relative.host || relative.host === "" ? relative.host : result.host;
        result.hostname = relative.hostname || relative.hostname === "" ? relative.hostname : result.hostname;
        result.search = relative.search;
        result.query = relative.query;
        srcPath = relPath;
    // fall through to the dot-handling below.
    } else if (relPath.length) {
        // it's relative
        // throw away the existing file, and take the new path instead.
        if (!srcPath) srcPath = [];
        srcPath.pop();
        srcPath = srcPath.concat(relPath);
        result.search = relative.search;
        result.query = relative.query;
    } else if (!$1TxB6.isNullOrUndefined(relative.search)) {
        // just pull out the search.
        // like href='?foo'.
        // Put this after the other two cases because it simplifies the booleans
        if (psychotic) {
            result.hostname = result.host = srcPath.shift();
            //occationaly the auth can get stuck only in host
            //this especially happens in cases like
            //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
            var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
            if (authInHost) {
                result.auth = authInHost.shift();
                result.host = result.hostname = authInHost.shift();
            }
        }
        result.search = relative.search;
        result.query = relative.query;
        //to support http.request
        if (!$1TxB6.isNull(result.pathname) || !$1TxB6.isNull(result.search)) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
        result.href = result.format();
        return result;
    }
    if (!srcPath.length) {
        // no path at all.  easy.
        // we've already handled the other stuff above.
        result.pathname = null;
        //to support http.request
        if (result.search) result.path = "/" + result.search;
        else result.path = null;
        result.href = result.format();
        return result;
    }
    // if a url ENDs in . or .., then it must get a trailing slash.
    // however, if it ends in anything else non-slashy,
    // then it must NOT get a trailing slash.
    var last = srcPath.slice(-1)[0];
    var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === "." || last === "..") || last === "";
    // strip single dots, resolve double dots to parent dir
    // if the path tries to go above the root, `up` ends up > 0
    var up = 0;
    for(var i = srcPath.length; i >= 0; i--){
        last = srcPath[i];
        if (last === ".") srcPath.splice(i, 1);
        else if (last === "..") {
            srcPath.splice(i, 1);
            up++;
        } else if (up) {
            srcPath.splice(i, 1);
            up--;
        }
    }
    // if the path is allowed to go above the root, restore leading ..s
    if (!mustEndAbs && !removeAllDots) for(; up--; up)srcPath.unshift("..");
    if (mustEndAbs && srcPath[0] !== "" && (!srcPath[0] || srcPath[0].charAt(0) !== "/")) srcPath.unshift("");
    if (hasTrailingSlash && srcPath.join("/").substr(-1) !== "/") srcPath.push("");
    var isAbsolute = srcPath[0] === "" || srcPath[0] && srcPath[0].charAt(0) === "/";
    // put the host back
    if (psychotic) {
        result.hostname = result.host = isAbsolute ? "" : srcPath.length ? srcPath.shift() : "";
        //occationaly the auth can get stuck only in host
        //this especially happens in cases like
        //url.resolveObject('mailto:local1@domain1', 'local2@domain2')
        var authInHost = result.host && result.host.indexOf("@") > 0 ? result.host.split("@") : false;
        if (authInHost) {
            result.auth = authInHost.shift();
            result.host = result.hostname = authInHost.shift();
        }
    }
    mustEndAbs = mustEndAbs || result.host && srcPath.length;
    if (mustEndAbs && !isAbsolute) srcPath.unshift("");
    if (!srcPath.length) {
        result.pathname = null;
        result.path = null;
    } else result.pathname = srcPath.join("/");
    //to support request.http
    if (!$1TxB6.isNull(result.pathname) || !$1TxB6.isNull(result.search)) result.path = (result.pathname ? result.pathname : "") + (result.search ? result.search : "");
    result.auth = relative.auth || result.auth;
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
};
Url.prototype.parseHost = function() {
    var host = this.host;
    var port = portPattern.exec(host);
    if (port) {
        port = port[0];
        if (port !== ":") this.port = port.substr(1);
        host = host.substr(0, host.length - port.length);
    }
    if (host) this.hostname = host;
};

});
parcelRegister("keFlU", function(module, exports) {
(function(root) {
    /** Detect free variables */ var freeExports = exports && !exports.nodeType && exports;
    var freeModule = module && !module.nodeType && module;
    var freeGlobal = typeof $parcel$global == "object" && $parcel$global;
    if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal || freeGlobal.self === freeGlobal) root = freeGlobal;
    /**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */ var punycode, /** Highest positive signed 32-bit float value */ maxInt = 2147483647, /** Bootstring parameters */ base = 36, tMin = 1, tMax = 26, skew = 38, damp = 700, initialBias = 72, initialN = 128, delimiter = "-", /** Regular expressions */ regexPunycode = /^xn--/, regexNonASCII = /[^\x20-\x7E]/, regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, /** Error messages */ errors = {
        "overflow": "Overflow: input needs wider integers to process",
        "not-basic": "Illegal input >= 0x80 (not a basic code point)",
        "invalid-input": "Invalid input"
    }, /** Convenience shortcuts */ baseMinusTMin = base - tMin, floor = Math.floor, stringFromCharCode = String.fromCharCode, /** Temporary variable */ key;
    /*--------------------------------------------------------------------------*/ /**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */ function error(type) {
        throw RangeError(errors[type]);
    }
    /**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */ function map(array, fn) {
        var length = array.length;
        var result = [];
        while(length--)result[length] = fn(array[length]);
        return result;
    }
    /**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */ function mapDomain(string, fn) {
        var parts = string.split("@");
        var result = "";
        if (parts.length > 1) {
            // In email addresses, only the domain name should be punycoded. Leave
            // the local part (i.e. everything up to `@`) intact.
            result = parts[0] + "@";
            string = parts[1];
        }
        // Avoid `split(regex)` for IE8 compatibility. See #17.
        string = string.replace(regexSeparators, ".");
        var labels = string.split(".");
        var encoded = map(labels, fn).join(".");
        return result + encoded;
    }
    /**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */ function ucs2decode(string) {
        var output = [], counter = 0, length = string.length, value, extra;
        while(counter < length){
            value = string.charCodeAt(counter++);
            if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
                // high surrogate, and there is a next character
                extra = string.charCodeAt(counter++);
                if ((extra & 0xFC00) == 0xDC00) output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
                else {
                    // unmatched surrogate; only append this code unit, in case the next
                    // code unit is the high surrogate of a surrogate pair
                    output.push(value);
                    counter--;
                }
            } else output.push(value);
        }
        return output;
    }
    /**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */ function ucs2encode(array) {
        return map(array, function(value) {
            var output = "";
            if (value > 0xFFFF) {
                value -= 0x10000;
                output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
                value = 0xDC00 | value & 0x3FF;
            }
            output += stringFromCharCode(value);
            return output;
        }).join("");
    }
    /**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */ function basicToDigit(codePoint) {
        if (codePoint - 48 < 10) return codePoint - 22;
        if (codePoint - 65 < 26) return codePoint - 65;
        if (codePoint - 97 < 26) return codePoint - 97;
        return base;
    }
    /**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */ function digitToBasic(digit, flag) {
        //  0..25 map to ASCII a..z or A..Z
        // 26..35 map to ASCII 0..9
        return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
    }
    /**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * http://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */ function adapt(delta, numPoints, firstTime) {
        var k = 0;
        delta = firstTime ? floor(delta / damp) : delta >> 1;
        delta += floor(delta / numPoints);
        for(; delta > baseMinusTMin * tMax >> 1; k += base)delta = floor(delta / baseMinusTMin);
        return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
    }
    /**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */ function decode(input) {
        // Don't use UCS-2
        var output = [], inputLength = input.length, out, i = 0, n = initialN, bias = initialBias, basic, j, index, oldi, w, k, digit, t, /** Cached calculation results */ baseMinusT;
        // Handle the basic code points: let `basic` be the number of input code
        // points before the last delimiter, or `0` if there is none, then copy
        // the first basic code points to the output.
        basic = input.lastIndexOf(delimiter);
        if (basic < 0) basic = 0;
        for(j = 0; j < basic; ++j){
            // if it's not a basic code point
            if (input.charCodeAt(j) >= 0x80) error("not-basic");
            output.push(input.charCodeAt(j));
        }
        // Main decoding loop: start just after the last delimiter if any basic code
        // points were copied; start at the beginning otherwise.
        for(index = basic > 0 ? basic + 1 : 0; index < inputLength;){
            // `index` is the index of the next character to be consumed.
            // Decode a generalized variable-length integer into `delta`,
            // which gets added to `i`. The overflow checking is easier
            // if we increase `i` as we go, then subtract off its starting
            // value at the end to obtain `delta`.
            for(oldi = i, w = 1, k = base;; k += base){
                if (index >= inputLength) error("invalid-input");
                digit = basicToDigit(input.charCodeAt(index++));
                if (digit >= base || digit > floor((maxInt - i) / w)) error("overflow");
                i += digit * w;
                t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                if (digit < t) break;
                baseMinusT = base - t;
                if (w > floor(maxInt / baseMinusT)) error("overflow");
                w *= baseMinusT;
            }
            out = output.length + 1;
            bias = adapt(i - oldi, out, oldi == 0);
            // `i` was supposed to wrap around from `out` to `0`,
            // incrementing `n` each time, so we'll fix that now:
            if (floor(i / out) > maxInt - n) error("overflow");
            n += floor(i / out);
            i %= out;
            // Insert `n` at position `i` of the output
            output.splice(i++, 0, n);
        }
        return ucs2encode(output);
    }
    /**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */ function encode(input) {
        var n, delta, handledCPCount, basicLength, bias, j, m, q, k, t, currentValue, output = [], /** `inputLength` will hold the number of code points in `input`. */ inputLength, /** Cached calculation results */ handledCPCountPlusOne, baseMinusT, qMinusT;
        // Convert the input in UCS-2 to Unicode
        input = ucs2decode(input);
        // Cache the length
        inputLength = input.length;
        // Initialize the state
        n = initialN;
        delta = 0;
        bias = initialBias;
        // Handle the basic code points
        for(j = 0; j < inputLength; ++j){
            currentValue = input[j];
            if (currentValue < 0x80) output.push(stringFromCharCode(currentValue));
        }
        handledCPCount = basicLength = output.length;
        // `handledCPCount` is the number of code points that have been handled;
        // `basicLength` is the number of basic code points.
        // Finish the basic string - if it is not empty - with a delimiter
        if (basicLength) output.push(delimiter);
        // Main encoding loop:
        while(handledCPCount < inputLength){
            // All non-basic code points < n have been handled already. Find the next
            // larger one:
            for(m = maxInt, j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue >= n && currentValue < m) m = currentValue;
            }
            // Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
            // but guard against overflow
            handledCPCountPlusOne = handledCPCount + 1;
            if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) error("overflow");
            delta += (m - n) * handledCPCountPlusOne;
            n = m;
            for(j = 0; j < inputLength; ++j){
                currentValue = input[j];
                if (currentValue < n && ++delta > maxInt) error("overflow");
                if (currentValue == n) {
                    // Represent delta as a generalized variable-length integer
                    for(q = delta, k = base;; k += base){
                        t = k <= bias ? tMin : k >= bias + tMax ? tMax : k - bias;
                        if (q < t) break;
                        qMinusT = q - t;
                        baseMinusT = base - t;
                        output.push(stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0)));
                        q = floor(qMinusT / baseMinusT);
                    }
                    output.push(stringFromCharCode(digitToBasic(q, 0)));
                    bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
                    delta = 0;
                    ++handledCPCount;
                }
            }
            ++delta;
            ++n;
        }
        return output.join("");
    }
    /**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */ function toUnicode(input) {
        return mapDomain(input, function(string) {
            return regexPunycode.test(string) ? decode(string.slice(4).toLowerCase()) : string;
        });
    }
    /**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */ function toASCII(input) {
        return mapDomain(input, function(string) {
            return regexNonASCII.test(string) ? "xn--" + encode(string) : string;
        });
    }
    /*--------------------------------------------------------------------------*/ /** Define the public API */ punycode = {
        /**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */ "version": "1.3.2",
        /**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */ "ucs2": {
            "decode": ucs2decode,
            "encode": ucs2encode
        },
        "decode": decode,
        "encode": encode,
        "toASCII": toASCII,
        "toUnicode": toUnicode
    };
    /** Expose `punycode` */ // Some AMD build optimizers, like r.js, check for specific condition patterns
    // like the following:
    if (typeof define == "function" && typeof define.amd == "object" && define.amd) define("punycode", function() {
        return punycode;
    });
    else if (freeExports && freeModule) {
        if (module.exports == freeExports) freeModule.exports = punycode;
        else for(key in punycode)punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
    } else root.punycode = punycode;
})(this);

});

parcelRegister("1TxB6", function(module, exports) {
"use strict";
module.exports = {
    isString: function isString(arg) {
        return typeof arg === "string";
    },
    isObject: function isObject(arg) {
        return typeof arg === "object" && arg !== null;
    },
    isNull: function isNull(arg) {
        return arg === null;
    },
    isNullOrUndefined: function isNullOrUndefined(arg) {
        return arg == null;
    }
};

});

parcelRegister("gBDBE", function(module, exports) {

$parcel$export(module.exports, "parse", function () { return $c16ed30023428278$export$98e6a39c04603d36; }, function (v) { return $c16ed30023428278$export$98e6a39c04603d36 = v; });
$parcel$export(module.exports, "stringify", function () { return $c16ed30023428278$export$fac44ee5b035f737; }, function (v) { return $c16ed30023428278$export$fac44ee5b035f737 = v; });
var $c16ed30023428278$export$2f872c0f2117be69;
var $c16ed30023428278$export$98e6a39c04603d36;
var $c16ed30023428278$export$c564cdbbe6da493;
var $c16ed30023428278$export$fac44ee5b035f737;
"use strict";

$c16ed30023428278$export$2f872c0f2117be69 = $c16ed30023428278$export$98e6a39c04603d36 = (parcelRequire("GPZXy"));

$c16ed30023428278$export$c564cdbbe6da493 = $c16ed30023428278$export$fac44ee5b035f737 = (parcelRequire("iqMiV"));

});
parcelRegister("GPZXy", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function $080c4225b86b4eef$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || "&";
    eq = eq || "=";
    var obj = {};
    if (typeof qs !== "string" || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === "number") maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, "%20"), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = "";
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!$080c4225b86b4eef$var$hasOwnProperty(obj, k)) obj[k] = v;
        else if ($080c4225b86b4eef$var$isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};
var $080c4225b86b4eef$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === "[object Array]";
};

});

parcelRegister("iqMiV", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $alyXF = parcelRequire("alyXF");
"use strict";
var $d6b01fe9356d470f$var$stringifyPrimitive = function stringifyPrimitive(v) {
    switch(typeof v === "undefined" ? "undefined" : (0, $alyXF._)(v)){
        case "string":
            return v;
        case "boolean":
            return v ? "true" : "false";
        case "number":
            return isFinite(v) ? v : "";
        default:
            return "";
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || "&";
    eq = eq || "=";
    if (obj === null) obj = undefined;
    if (typeof obj === "object") return $d6b01fe9356d470f$var$map($d6b01fe9356d470f$var$objectKeys(obj), function(k) {
        var ks = encodeURIComponent($d6b01fe9356d470f$var$stringifyPrimitive(k)) + eq;
        if ($d6b01fe9356d470f$var$isArray(obj[k])) return $d6b01fe9356d470f$var$map(obj[k], function(v) {
            return ks + encodeURIComponent($d6b01fe9356d470f$var$stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent($d6b01fe9356d470f$var$stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return "";
    return encodeURIComponent($d6b01fe9356d470f$var$stringifyPrimitive(name)) + eq + encodeURIComponent($d6b01fe9356d470f$var$stringifyPrimitive(obj));
};
var $d6b01fe9356d470f$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === "[object Array]";
};
function $d6b01fe9356d470f$var$map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var $d6b01fe9356d470f$var$objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};

});




parcelRegister("jMKlL", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $e676742b692767e7$export$581ff339ea0ba762; });

var $8jq63 = parcelRequire("8jq63");
function $e676742b692767e7$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $8jq63._define_property)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRegister("8jq63", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $60d45751fc6a24a2$export$1e71eb4bef00f6b0; });
$parcel$export(module.exports, "_", function () { return $60d45751fc6a24a2$export$1e71eb4bef00f6b0; });
function $60d45751fc6a24a2$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRegister("5GxwX", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $423ae278f44530ff$export$4fa2f4023c9cbda5; });
function $423ae278f44530ff$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $423ae278f44530ff$export$4fa2f4023c9cbda5(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $423ae278f44530ff$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("c5bRs", function(module, exports) {
$parcel$export(module.exports, "EditCenterApi", function () { return (parcelRequire("e3o07")).EditCenterApi; });
$parcel$export(module.exports, "MyVisibilityApi", function () { return (parcelRequire("e3o07")).MyVisibilityApi; });
$parcel$export(module.exports, "StatsApi", function () { return (parcelRequire("e3o07")).StatsApi; });
// tslint:disable
/**
 * 1001Audios
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ parcelRequire("e3o07");
parcelRequire("lt811");

});
parcelRegister("lt811", function(module, exports) {
// tslint:disable
/**
 * 1001Audios
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ 
var $3V7B6 = parcelRequire("3V7B6");
var $2a8b423f9693885d$export$fa89be98fe0936f2 = function Configuration() {
    "use strict";
    var param = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    (0, $3V7B6._)(this, Configuration);
    this.apiKey = param.apiKey;
    this.username = param.username;
    this.password = param.password;
    this.accessToken = param.accessToken;
    this.basePath = param.basePath;
};

});



var $bUBkB = parcelRequire("bUBkB");
var $44ccd1d31d1dfce0$exports = {};

/*!
 * jQuery Smooth Scroll - v2.2.0 - 2017-05-05
 * https://github.com/kswedberg/jquery-smooth-scroll
 * Copyright (c) 2017 Karl Swedberg
 * Licensed MIT
 */ (function(factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "jquery"
    ], factory);
    else if (0, $44ccd1d31d1dfce0$exports) // CommonJS
    factory((parcelRequire("bUBkB")));
    else // Browser globals
    factory(jQuery);
})(function($) {
    var version = "2.2.0";
    var optionOverrides = {};
    var defaults = {
        exclude: [],
        excludeWithin: [],
        offset: 0,
        // one of 'top' or 'left'
        direction: "top",
        // if set, bind click events through delegation
        //  supported since jQuery 1.4.2
        delegateSelector: null,
        // jQuery set of elements you wish to scroll (for $.smoothScroll).
        //  if null (default), $('html, body').firstScrollable() is used.
        scrollElement: null,
        // only use if you want to override default behavior
        scrollTarget: null,
        // automatically focus the target element after scrolling to it
        autoFocus: false,
        // fn(opts) function to be called before scrolling occurs.
        // `this` is the element(s) being scrolled
        beforeScroll: function beforeScroll() {},
        // fn(opts) function to be called after scrolling occurs.
        // `this` is the triggering element
        afterScroll: function afterScroll() {},
        // easing name. jQuery comes with "swing" and "linear." For others, you'll need an easing plugin
        // from jQuery UI or elsewhere
        easing: "swing",
        // speed can be a number or 'auto'
        // if 'auto', the speed will be calculated based on the formula:
        // (current scroll position - target scroll position) / autoCoeffic
        speed: 400,
        // coefficient for "auto" speed
        autoCoefficient: 2,
        // $.fn.smoothScroll only: whether to prevent the default click action
        preventDefault: true
    };
    var getScrollable = function getScrollable(opts) {
        var scrollable = [];
        var scrolled = false;
        var dir = opts.dir && opts.dir === "left" ? "scrollLeft" : "scrollTop";
        this.each(function() {
            var el = $(this);
            if (this === document || this === window) return;
            if (document.scrollingElement && (this === document.documentElement || this === document.body)) {
                scrollable.push(document.scrollingElement);
                return false;
            }
            if (el[dir]() > 0) scrollable.push(this);
            else {
                // if scroll(Top|Left) === 0, nudge the element 1px and see if it moves
                el[dir](1);
                scrolled = el[dir]() > 0;
                if (scrolled) scrollable.push(this);
                // then put it back, of course
                el[dir](0);
            }
        });
        if (!scrollable.length) this.each(function() {
            // If no scrollable elements and <html> has scroll-behavior:smooth because
            // "When this property is specified on the root element, it applies to the viewport instead."
            // and "The scroll-behavior property of the … body element is *not* propagated to the viewport."
            // → https://drafts.csswg.org/cssom-view/#propdef-scroll-behavior
            if (this === document.documentElement && $(this).css("scrollBehavior") === "smooth") scrollable = [
                this
            ];
            // If still no scrollable elements, fall back to <body>,
            // if it's in the jQuery collection
            // (doing this because Safari sets scrollTop async,
            // so can't set it to 1 and immediately get the value.)
            if (!scrollable.length && this.nodeName === "BODY") scrollable = [
                this
            ];
        });
        // Use the first scrollable element if we're calling firstScrollable()
        if (opts.el === "first" && scrollable.length > 1) scrollable = [
            scrollable[0]
        ];
        return scrollable;
    };
    var rRelative = /^([\-\+]=)(\d+)/;
    $.fn.extend({
        scrollable: function scrollable(dir) {
            var scrl = getScrollable.call(this, {
                dir: dir
            });
            return this.pushStack(scrl);
        },
        firstScrollable: function firstScrollable(dir) {
            var scrl = getScrollable.call(this, {
                el: "first",
                dir: dir
            });
            return this.pushStack(scrl);
        },
        smoothScroll: function smoothScroll(options, extra) {
            options = options || {};
            if (options === "options") {
                if (!extra) return this.first().data("ssOpts");
                return this.each(function() {
                    var $this = $(this);
                    var opts = $.extend($this.data("ssOpts") || {}, extra);
                    $(this).data("ssOpts", opts);
                });
            }
            var opts = $.extend({}, $.fn.smoothScroll.defaults, options);
            var clickHandler = function clickHandler(event) {
                var escapeSelector = function escapeSelector(str) {
                    return str.replace(/(:|\.|\/)/g, "\\$1");
                };
                var link = this;
                var $link = $(this);
                var thisOpts = $.extend({}, opts, $link.data("ssOpts") || {});
                var exclude = opts.exclude;
                var excludeWithin = thisOpts.excludeWithin;
                var elCounter = 0;
                var ewlCounter = 0;
                var include = true;
                var clickOpts = {};
                var locationPath = $.smoothScroll.filterPath(location.pathname);
                var linkPath = $.smoothScroll.filterPath(link.pathname);
                var hostMatch = location.hostname === link.hostname || !link.hostname;
                var pathMatch = thisOpts.scrollTarget || linkPath === locationPath;
                var thisHash = escapeSelector(link.hash);
                if (thisHash && !$(thisHash).length) include = false;
                if (!thisOpts.scrollTarget && (!hostMatch || !pathMatch || !thisHash)) include = false;
                else {
                    while(include && elCounter < exclude.length)if ($link.is(escapeSelector(exclude[elCounter++]))) include = false;
                    while(include && ewlCounter < excludeWithin.length)if ($link.closest(excludeWithin[ewlCounter++]).length) include = false;
                }
                if (include) {
                    if (thisOpts.preventDefault) event.preventDefault();
                    $.extend(clickOpts, thisOpts, {
                        scrollTarget: thisOpts.scrollTarget || thisHash,
                        link: link
                    });
                    $.smoothScroll(clickOpts);
                }
            };
            if (options.delegateSelector !== null) this.off("click.smoothscroll", options.delegateSelector).on("click.smoothscroll", options.delegateSelector, clickHandler);
            else this.off("click.smoothscroll").on("click.smoothscroll", clickHandler);
            return this;
        }
    });
    var getExplicitOffset = function getExplicitOffset(val) {
        var explicit = {
            relative: ""
        };
        var parts = typeof val === "string" && rRelative.exec(val);
        if (typeof val === "number") explicit.px = val;
        else if (parts) {
            explicit.relative = parts[1];
            explicit.px = parseFloat(parts[2]) || 0;
        }
        return explicit;
    };
    var onAfterScroll = function onAfterScroll(opts) {
        var $tgt = $(opts.scrollTarget);
        if (opts.autoFocus && $tgt.length) {
            $tgt[0].focus();
            if (!$tgt.is(document.activeElement)) {
                $tgt.prop({
                    tabIndex: -1
                });
                $tgt[0].focus();
            }
        }
        opts.afterScroll.call(opts.link, opts);
    };
    $.smoothScroll = function(options, px) {
        if (options === "options" && typeof px === "object") return $.extend(optionOverrides, px);
        var opts, $scroller, speed, delta;
        var explicitOffset = getExplicitOffset(options);
        var scrollTargetOffset = {};
        var scrollerOffset = 0;
        var offPos = "offset";
        var scrollDir = "scrollTop";
        var aniProps = {};
        var aniOpts = {};
        if (explicitOffset.px) opts = $.extend({
            link: null
        }, $.fn.smoothScroll.defaults, optionOverrides);
        else {
            opts = $.extend({
                link: null
            }, $.fn.smoothScroll.defaults, options || {}, optionOverrides);
            if (opts.scrollElement) {
                offPos = "position";
                if (opts.scrollElement.css("position") === "static") opts.scrollElement.css("position", "relative");
            }
            if (px) explicitOffset = getExplicitOffset(px);
        }
        scrollDir = opts.direction === "left" ? "scrollLeft" : scrollDir;
        if (opts.scrollElement) {
            $scroller = opts.scrollElement;
            if (!explicitOffset.px && !/^(?:HTML|BODY)$/.test($scroller[0].nodeName)) scrollerOffset = $scroller[scrollDir]();
        } else $scroller = $("html, body").firstScrollable(opts.direction);
        // beforeScroll callback function must fire before calculating offset
        opts.beforeScroll.call($scroller, opts);
        scrollTargetOffset = explicitOffset.px ? explicitOffset : {
            relative: "",
            px: $(opts.scrollTarget)[offPos]() && $(opts.scrollTarget)[offPos]()[opts.direction] || 0
        };
        aniProps[scrollDir] = scrollTargetOffset.relative + (scrollTargetOffset.px + scrollerOffset + opts.offset);
        speed = opts.speed;
        // automatically calculate the speed of the scroll based on distance / coefficient
        if (speed === "auto") {
            // $scroller[scrollDir]() is position before scroll, aniProps[scrollDir] is position after
            // When delta is greater, speed will be greater.
            delta = Math.abs(aniProps[scrollDir] - $scroller[scrollDir]());
            // Divide the delta by the coefficient
            speed = delta / opts.autoCoefficient;
        }
        aniOpts = {
            duration: speed,
            easing: opts.easing,
            complete: function complete() {
                onAfterScroll(opts);
            }
        };
        if (opts.step) aniOpts.step = opts.step;
        if ($scroller.length) $scroller.stop().animate(aniProps, aniOpts);
        else onAfterScroll(opts);
    };
    $.smoothScroll.version = version;
    $.smoothScroll.filterPath = function(string) {
        string = string || "";
        return string.replace(/^\//, "").replace(/(?:index|default).[a-zA-Z]{3,4}$/, "").replace(/\/$/, "");
    };
    // default options
    $.fn.smoothScroll.defaults = defaults;
});



var $bUBkB = parcelRequire("bUBkB");
if ($bUBkB(document.body).hasClass("blog-list")) setTimeout(function() {
    var elementBottom = $bUBkB(".inner")[0].getBoundingClientRect().bottom + window.scrollY;
    var docHeight = $bUBkB(document).height();
    console.log("height:", docHeight);
    console.log("bottom:", elementBottom);
    var spacing = docHeight - elementBottom;
    console.log("diff:", spacing);
    $bUBkB(".sidebar").sticky({
        topSpacing: 20,
        bottomSpacing: spacing + 50
    });
    $bUBkB(".sidebar").sticky("update");
    $bUBkB(".sidebar").on("sticky-bottom-reached", function() {
        console.log("Bottom reached");
    });
    $bUBkB(".sidebar").on("sticky-bottom-unreached", function() {
        console.log("Bottom unreached");
    });
}, 1000);



var $5ihUn = parcelRequire("5ihUn");

var $6agJ4 = parcelRequire("6agJ4");

var $bUBkB = parcelRequire("bUBkB");

var $e3o07 = parcelRequire("e3o07");
function $97d6ffd33a62cf3b$export$8995636b7242f090(arr) {
    var i = 0, len = arr.length, pair, obj = {};
    while(i < len){
        pair = arr[i];
        obj[pair[0]] = pair[1];
        i += 1;
    }
    return obj;
}


var $46d1fcc02aa0a939$export$d0a8044dce8ff2fc = function() {
    try {
        return window.matchMedia("only screen and (max-width: 480px)").matches;
    } catch (e) {
        return undefined;
    }
};


function $e95a0614adfba180$export$842dcfa371c6bb83(phone) {
    if (window["countryCode"] === "CH") {
        if (phone.trim().substring(0, 1) !== "0") phone = "0" + phone;
        return phone.trim().replace(/ /g, "").replace(/(\d{3})(\d{3})(\d{2})(\d{2})/, "$1 $2 $3 $4").trim();
    } else {
        if (phone.replace(/ /g, "").substring(0, 2) === "08") return phone.trim().replace(/ /g, "").replace(/0(\d{3})(\d{3})(\d{3})/, "0 $1 $2 $3").trim();
        else return phone.trim().replace(/ /g, "").replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, "$1 $2 $3 $4 $5").trim();
    }
}


var $e51894327719f7f1$var$wnd = window;
function $e51894327719f7f1$export$91354855d0da8111() {
    if ($e51894327719f7f1$var$wnd.page === "audiopro-detail" || $e51894327719f7f1$var$wnd.page === "search-results") {
        $(".js-rdv-url-link").on("click", function(event) {
            var form = $(this).parents("form");
            form.find("button[type=submit]").click();
            if (!form[0].checkValidity()) event.preventDefault();
        });
        $(".ask-for-rdv").on("click", function() {
            window["ga"]("send", {
                hitType: "event",
                eventCategory: "Fiche Centre",
                eventAction: "click",
                eventLabel: "Demande de RDV"
            });
            new (0, $e3o07.StatsApi)().saveStat({
                query: {
                    centerId: $(this).data("audioproid"),
                    location: "detail",
                    type: $(this).data("stat-type") || "click-rdv"
                }
            });
        });
        $(".rdv-link").on("click", function() {
            window["ga"]("send", {
                hitType: "event",
                eventCategory: "Fiche Centre",
                eventAction: "click",
                eventLabel: "Demande de RDV"
            });
            var audioProId = $(this).data("audioproid") || $e51894327719f7f1$var$wnd.audiopro._id;
            new (0, $e3o07.RdvApi)().clickedOnRdvLink({
                audioProId: audioProId,
                isMobile: (0, $46d1fcc02aa0a939$export$d0a8044dce8ff2fc)()
            });
        });
        $(".rdv-link-callcenter").on("click", function(event) {
            event.preventDefault();
            var id = $(this).data("audioproid");
            $("#rdvLinkModal-" + id).modal({
                backdrop: true
            });
            if (window.page === "search-results") $("[name=isSearch]").val("true");
        });
        $bUBkB(".rdvform").on("submit", function(event) {
            var audioProId = $(this).data("audioproid");
            event.preventDefault();
            event.stopPropagation();
            var $this = $(this);
            var formValues = (0, $97d6ffd33a62cf3b$export$8995636b7242f090)($this.serializeArray().map(function(i) {
                return [
                    i.name,
                    i.value
                ];
            }));
            console.log(formValues);
            formValues.isMobile = (0, $46d1fcc02aa0a939$export$d0a8044dce8ff2fc)();
            $this.find(".ask-for-rdv-loader").show();
            $this.find(".ask-for-rdv").hide();
            new (0, $e3o07.RdvApi)().askForRdv({
                audioProId: audioProId,
                query: formValues
            }).then(function() {
                console.log("OK!");
            });
            $this.find(".rdv-success").show();
            $this.find(".ask-for-rdv-loader").hide();
            $this.find("#close").show();
            $this.find(".rdv-inputs").hide();
            return false;
        });
    }
}
function $e51894327719f7f1$export$af12e467c1278c18() {
    if ($e51894327719f7f1$var$wnd.page === "audiopro-detail" && $bUBkB(".rdv-block").length > 0) {
        $e51894327719f7f1$var$initializeReviewsCarousel();
        $("#go-to-rdv-form").on("click", function(event) {
            event.preventDefault();
            $(".rdv-block").click();
            $.smoothScroll({
                speed: 400,
                scrollTarget: ".rdv-block",
                offset: -50
            });
        });
        new (0, $e3o07.StatsApi)().saveStat({
            query: {
                centerId: window["audiopro"]._id,
                location: "detail",
                type: "view-detail"
            }
        });
    }
    if ($e51894327719f7f1$var$wnd.page === "audiopro-detail") {
        if (window["audiopro"].popupFreeTestEnabled && window["audiopro"].popupFreeTestDelay > 0) setTimeout(function() {
            var isModalAlreadyOpen = document.querySelector(".modal.show");
            if (isModalAlreadyOpen) {
                console.log("Modal already open, exiting.");
                return;
            }
            var identifier = "#automaticFreeTestPopup-" + window["audiopro"]._id;
            console.log("Identifier", identifier);
            $(identifier).modal({
                backdrop: true
            });
        }, 1000 * window["audiopro"].popupFreeTestDelay);
        $bUBkB(".phone-button,.callback-button").on("click", function() {
            var _ref = (0, $5ihUn._)(function(event) {
                var id, phoneNumberResponse, phoneNumber, enseigne, city, postalcode, address, isCallback, modalId, $el;
                return (0, $6agJ4.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            id = $(this).data("audioproid");
                            return [
                                4,
                                new (0, $e3o07.AudioProApi)().getPhoneNumber({
                                    audioProId: id
                                })
                            ];
                        case 1:
                            phoneNumberResponse = _state.sent();
                            phoneNumber = (0, $e95a0614adfba180$export$842dcfa371c6bb83)(phoneNumberResponse.phoneNumber);
                            enseigne = $(this).data("enseigne");
                            city = $(this).data("city");
                            postalcode = $(this).data("postalcode");
                            address = $(this).data("address");
                            isCallback = $(this).is(".callback-button");
                            console.log("isCallback", isCallback);
                            modalId = $(this).data("type") === "orl" ? "#orlPhoneNumberModal" : isCallback ? "#callback-" + id : "#phoneNumberModal-" + id;
                            console.log("modalId", modalId);
                            $bUBkB(modalId + " .modal-phone-number").text(phoneNumber);
                            if (phoneNumber.substring(0, 3) === "0 8") $bUBkB(modalId + " .modal-free-call").text("(Appel Gratuit)");
                            else if (enseigne !== "Audition Sant\xe9") $bUBkB(modalId + " .modal-free-call").text("(Appel non surtax\xe9)");
                            $bUBkB(modalId + " .modal-enseigne").text(enseigne);
                            $bUBkB(modalId + " .modal-city").text(city);
                            $bUBkB(modalId + " .modal-postalcode").text(postalcode);
                            $bUBkB(modalId + " .modal-address").text(address);
                            if ($(this).attr("href") === "#") {
                                event.preventDefault();
                                // Only on non mobiles devices
                                if ($(document).width() > 576 || isCallback) $(modalId).modal({
                                    backdrop: true
                                });
                                else {
                                    $el = $(this).children(".telephone");
                                    if ($el.length) {
                                        if ($el.data("type") === "block") $(this).replaceWith($el.show().css("display", "block"));
                                        else $(this).replaceWith($el.show().css("display", "inline-block"));
                                    }
                                }
                            }
                            window["ga"]("send", {
                                hitType: "event",
                                eventCategory: "Fiche Centre",
                                eventAction: "click",
                                eventLabel: "Telephone"
                            });
                            new (0, $e3o07.StatsApi)().saveStat({
                                query: {
                                    centerId: window["audiopro"]._id,
                                    location: "detail",
                                    type: "click-phone-number"
                                }
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function(event) {
                return _ref.apply(this, arguments);
            };
        }());
        if (document.getElementById("map")) {
            var myLatLng = {
                lat: $e51894327719f7f1$var$wnd.audiopro.location.coordinates[1],
                lng: $e51894327719f7f1$var$wnd.audiopro.location.coordinates[0]
            };
            var map = new google.maps.Map(document.getElementById("map"), {
                zoom: 17,
                center: myLatLng
            });
            var marker = new google.maps.Marker({
                position: myLatLng,
                map: map,
                title: $e51894327719f7f1$var$wnd.audiopro.enseigne
            });
            marker.setIcon({
                url: "/assets/images/pin-blue.png"
            });
        }
    }
    var scrollDiv = document.createElement("div");
    scrollDiv.className = "modal-scrollbar-measure";
    document.body.appendChild(scrollDiv);
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    // Topbar is disabled for now
    /* 
  // Compensate the navbar
  $(".phoneNumberModal").on("show.bs.modal", function (e) {
    $(".center-topbar").css("padding-right", scrollbarWidth);
  });

  $(".phoneNumberModal").on("hidden.bs.modal", function (e) {
    $(".center-topbar").css("padding-right", 0);
  });
  // Compensate the navbar
  $("#orlPhoneNumberModal").on("show.bs.modal", function (e) {
    $(".center-topbar").css("padding-right", scrollbarWidth);
  });

  $("#orlPhoneNumberModal").on("hidden.bs.modal", function (e) {
    $(".center-topbar").css("padding-right", 0);
  });

  function showHideTopBar() {
    const pos = $(document).scrollTop();
    $(".center-topbar").toggleClass("visible", pos > 350);
  }

  // Only on non mobiles devices
  if ($(document).width() > 576) {
    $(window).scroll(showHideTopBar);
    showHideTopBar();
  } */ if ($("#collapsed-content")[0]) {
        var contentHeight = $("#collapsed-content")[0].scrollHeight;
        if (contentHeight >= 40) {
            $("#see-more").show();
            $("#see-more").on("click", function(event) {
                event.preventDefault();
                $("#collapsed-content").css("max-height", "inherit");
                $("#collapsed-content").css("overflow", "visible");
                $("#see-more").hide();
            });
        }
    }
}
function $e51894327719f7f1$var$initializeReviewsCarousel() {
    return $e51894327719f7f1$var$_initializeReviewsCarousel.apply(this, arguments);
}
function $e51894327719f7f1$var$_initializeReviewsCarousel() {
    $e51894327719f7f1$var$_initializeReviewsCarousel = (0, $5ihUn._)(function() {
        return (0, $6agJ4.__generator)(this, function(_state) {
            $(".carousel").carousel({
                interval: false
            });
            $(".js-expand-review").on("click", function() {
                $(this).parent(".review-content").hide().siblings(".review-content-full").show();
            });
            return [
                2
            ];
        });
    });
    return $e51894327719f7f1$var$_initializeReviewsCarousel.apply(this, arguments);
}


var $62f26d8281bc5c23$exports = {};

var $alyXF = parcelRequire("alyXF");
var $62f26d8281bc5c23$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $62f26d8281bc5c23$var$_typeof = typeof Symbol === "function" && (0, $alyXF._)(Symbol.iterator) === "symbol" ? function _typeof(obj) {
    return typeof obj === "undefined" ? "undefined" : (0, $alyXF._)(obj);
} : function(obj) {
    return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $alyXF._)(obj);
};
(function(global, factory) {
    $62f26d8281bc5c23$var$_typeof($62f26d8281bc5c23$exports) === "object" && true ? $62f26d8281bc5c23$exports = factory() : typeof define === "function" && define.amd ? define(factory) : global.LazyLoad = factory();
})(undefined, function() {
    "use strict";
    var defaultSettings = {
        elements_selector: "img",
        container: window,
        threshold: 300,
        throttle: 150,
        data_src: "src",
        data_srcset: "srcset",
        class_loading: "loading",
        class_loaded: "loaded",
        class_error: "error",
        class_initial: "initial",
        skip_invisible: true,
        callback_load: null,
        callback_error: null,
        callback_set: null,
        callback_processed: null,
        callback_enter: null
    };
    var isBot = !("onscroll" in window) || /glebot/.test(navigator.userAgent);
    var callCallback = function callCallback(callback, argument) {
        if (callback) callback(argument);
    };
    var getTopOffset = function getTopOffset(element) {
        return element.getBoundingClientRect().top + window.pageYOffset - element.ownerDocument.documentElement.clientTop;
    };
    var isBelowViewport = function isBelowViewport(element, container, threshold) {
        var fold = container === window ? window.innerHeight + window.pageYOffset : getTopOffset(container) + container.offsetHeight;
        return fold <= getTopOffset(element) - threshold;
    };
    var getLeftOffset = function getLeftOffset(element) {
        return element.getBoundingClientRect().left + window.pageXOffset - element.ownerDocument.documentElement.clientLeft;
    };
    var isAtRightOfViewport = function isAtRightOfViewport(element, container, threshold) {
        var documentWidth = window.innerWidth;
        var fold = container === window ? documentWidth + window.pageXOffset : getLeftOffset(container) + documentWidth;
        return fold <= getLeftOffset(element) - threshold;
    };
    var isAboveViewport = function isAboveViewport(element, container, threshold) {
        var fold = container === window ? window.pageYOffset : getTopOffset(container);
        return fold >= getTopOffset(element) + threshold + element.offsetHeight;
    };
    var isAtLeftOfViewport = function isAtLeftOfViewport(element, container, threshold) {
        var fold = container === window ? window.pageXOffset : getLeftOffset(container);
        return fold >= getLeftOffset(element) + threshold + element.offsetWidth;
    };
    var isInsideViewport = function isInsideViewport(element, container, threshold) {
        return !isBelowViewport(element, container, threshold) && !isAboveViewport(element, container, threshold) && !isAtRightOfViewport(element, container, threshold) && !isAtLeftOfViewport(element, container, threshold);
    };
    /* Creates instance and notifies it through the window element */ var createInstance = function createInstance(classObj, options) {
        var event;
        var eventString = "LazyLoad::Initialized";
        var instance = new classObj(options);
        try {
            // Works in modern browsers
            event = new CustomEvent(eventString, {
                detail: {
                    instance: instance
                }
            });
        } catch (err) {
            // Works in Internet Explorer (all versions)
            event = document.createEvent("CustomEvent");
            event.initCustomEvent(eventString, false, false, {
                instance: instance
            });
        }
        window.dispatchEvent(event);
    };
    /* Auto initialization of one or more instances of lazyload, depending on the 
        options passed in (plain object or an array) */ var autoInitialize = function autoInitialize(classObj, options) {
        var optsLength = options.length;
        if (!optsLength) // Plain object
        createInstance(classObj, options);
        else // Array of objects
        for(var i = 0; i < optsLength; i++)createInstance(classObj, options[i]);
    };
    var dataPrefix = "data-";
    var getData = function getData(element, attribute) {
        return element.getAttribute(dataPrefix + attribute);
    };
    var setData = function setData(element, attribute, value) {
        return element.setAttribute(dataPrefix + attribute, value);
    };
    var setSourcesForPicture = function setSourcesForPicture(element, srcsetDataAttribute) {
        var parent = element.parentNode;
        if (parent.tagName !== "PICTURE") return;
        for(var i = 0; i < parent.children.length; i++){
            var pictureChild = parent.children[i];
            if (pictureChild.tagName === "SOURCE") {
                var sourceSrcset = getData(pictureChild, srcsetDataAttribute);
                if (sourceSrcset) pictureChild.setAttribute("srcset", sourceSrcset);
            }
        }
    };
    var setSources = function setSources(element, srcsetDataAttribute, srcDataAttribute) {
        var tagName = element.tagName;
        var elementSrc = getData(element, srcDataAttribute);
        if (tagName === "IMG") {
            setSourcesForPicture(element, srcsetDataAttribute);
            var imgSrcset = getData(element, srcsetDataAttribute);
            if (imgSrcset) element.setAttribute("srcset", imgSrcset);
            if (elementSrc) element.setAttribute("src", elementSrc);
            return;
        }
        if (tagName === "IFRAME") {
            if (elementSrc) element.setAttribute("src", elementSrc);
            return;
        }
        if (elementSrc) element.style.backgroundImage = 'url("' + elementSrc + '")';
    };
    var supportsClassList = "classList" in document.createElement("p");
    var addClass = function addClass(element, className) {
        if (supportsClassList) {
            element.classList.add(className);
            return;
        }
        element.className += (element.className ? " " : "") + className;
    };
    var removeClass = function removeClass(element, className) {
        if (supportsClassList) {
            element.classList.remove(className);
            return;
        }
        element.className = element.className.replace(new RegExp("(^|\\s+)" + className + "(\\s+|$)"), " ").replace(/^\s+/, "").replace(/\s+$/, "");
    };
    /*
     * Constructor
     */ var LazyLoad = function LazyLoad(instanceSettings) {
        this._settings = $62f26d8281bc5c23$var$_extends({}, defaultSettings, instanceSettings);
        this._queryOriginNode = this._settings.container === window ? document : this._settings.container;
        this._previousLoopTime = 0;
        this._loopTimeout = null;
        this._boundHandleScroll = this.handleScroll.bind(this);
        this._isFirstLoop = true;
        window.addEventListener("resize", this._boundHandleScroll);
        this.update();
    };
    LazyLoad.prototype = {
        /*
         * Private methods
         */ _reveal: function _reveal(element) {
            var settings = this._settings;
            var errorCallback = function errorCallback() {
                /* As this method is asynchronous, it must be protected against external destroy() calls */ if (!settings) return;
                element.removeEventListener("load", loadCallback);
                element.removeEventListener("error", errorCallback);
                removeClass(element, settings.class_loading);
                addClass(element, settings.class_error);
                callCallback(settings.callback_error, element);
            };
            var loadCallback = function loadCallback() {
                /* As this method is asynchronous, it must be protected against external destroy() calls */ if (!settings) return;
                removeClass(element, settings.class_loading);
                addClass(element, settings.class_loaded);
                element.removeEventListener("load", loadCallback);
                element.removeEventListener("error", errorCallback);
                callCallback(settings.callback_load, element);
            };
            callCallback(settings.callback_enter, element);
            if (element.tagName === "IMG" || element.tagName === "IFRAME") {
                element.addEventListener("load", loadCallback);
                element.addEventListener("error", errorCallback);
                addClass(element, settings.class_loading);
            }
            setSources(element, settings.data_srcset, settings.data_src);
            callCallback(settings.callback_set, element);
        },
        _loopThroughElements: function _loopThroughElements() {
            var settings = this._settings, elements = this._elements, elementsLength = !elements ? 0 : elements.length;
            var i = void 0, processedIndexes = [], firstLoop = this._isFirstLoop;
            for(i = 0; i < elementsLength; i++){
                var element = elements[i];
                /* If must skip_invisible and element is invisible, skip it */ if (settings.skip_invisible && element.offsetParent === null) continue;
                if (isBot || isInsideViewport(element, settings.container, settings.threshold)) {
                    if (firstLoop) addClass(element, settings.class_initial);
                    /* Start loading the image */ this._reveal(element);
                    /* Marking the element as processed. */ processedIndexes.push(i);
                    setData(element, "was-processed", true);
                }
            }
            /* Removing processed elements from this._elements. */ while(processedIndexes.length){
                elements.splice(processedIndexes.pop(), 1);
                callCallback(settings.callback_processed, elements.length);
            }
            /* Stop listening to scroll event when 0 elements remains */ if (elementsLength === 0) this._stopScrollHandler();
            /* Sets isFirstLoop to false */ if (firstLoop) this._isFirstLoop = false;
        },
        _purgeElements: function _purgeElements() {
            var elements = this._elements, elementsLength = elements.length;
            var i = void 0, elementsToPurge = [];
            for(i = 0; i < elementsLength; i++){
                var element = elements[i];
                /* If the element has already been processed, skip it */ if (getData(element, "was-processed")) elementsToPurge.push(i);
            }
            /* Removing elements to purge from this._elements. */ while(elementsToPurge.length > 0)elements.splice(elementsToPurge.pop(), 1);
        },
        _startScrollHandler: function _startScrollHandler() {
            if (!this._isHandlingScroll) {
                this._isHandlingScroll = true;
                this._settings.container.addEventListener("scroll", this._boundHandleScroll);
            }
        },
        _stopScrollHandler: function _stopScrollHandler() {
            if (this._isHandlingScroll) {
                this._isHandlingScroll = false;
                this._settings.container.removeEventListener("scroll", this._boundHandleScroll);
            }
        },
        /* 
         * Public methods
         */ handleScroll: function handleScroll() {
            var throttle = this._settings.throttle;
            if (throttle !== 0) {
                var now = Date.now();
                var remainingTime = throttle - (now - this._previousLoopTime);
                if (remainingTime <= 0 || remainingTime > throttle) {
                    if (this._loopTimeout) {
                        clearTimeout(this._loopTimeout);
                        this._loopTimeout = null;
                    }
                    this._previousLoopTime = now;
                    this._loopThroughElements();
                } else if (!this._loopTimeout) this._loopTimeout = setTimeout((function() {
                    this._previousLoopTime = Date.now();
                    this._loopTimeout = null;
                    this._loopThroughElements();
                }).bind(this), remainingTime);
            } else this._loopThroughElements();
        },
        update: function update() {
            // Converts to array the nodeset obtained querying the DOM from _queryOriginNode with elements_selector
            this._elements = Array.prototype.slice.call(this._queryOriginNode.querySelectorAll(this._settings.elements_selector));
            this._purgeElements();
            this._loopThroughElements();
            this._startScrollHandler();
        },
        destroy: function destroy() {
            window.removeEventListener("resize", this._boundHandleScroll);
            if (this._loopTimeout) {
                clearTimeout(this._loopTimeout);
                this._loopTimeout = null;
            }
            this._stopScrollHandler();
            this._elements = null;
            this._queryOriginNode = null;
            this._settings = null;
        }
    };
    /* Automatic instances creation if required (useful for async script loading!) */ var autoInitOptions = window.lazyLoadOptions;
    if (autoInitOptions) autoInitialize(LazyLoad, autoInitOptions);
    return LazyLoad;
});


var $86b63a2fc4796b80$var$myLazyLoad = new $62f26d8281bc5c23$exports({
    threshold: 600
});
var $86b63a2fc4796b80$var$myLazyLoadDiv = new $62f26d8281bc5c23$exports({
    elements_selector: ".lazy",
    threshold: 600
});


function $65c41bce49c9f364$export$79145f2fbddd9106() {
    if (document.getElementById("map-for-autocomplete")) //We need a hidden map on the homepage to have the autocomplete work
    var map = new google.maps.Map(document.getElementById("map-for-autocomplete"), {
        zoom: 12,
        scrollwheel: false
    });
}
function $65c41bce49c9f364$export$21ef4c26e665e784() {
    window["$"] = $;
    window["jQuery"] = $;
}



var $bUBkB = parcelRequire("bUBkB");
if (document.getElementById("test-auditif-content")) {
    var $94de3cf94b6a62cb$var$questions = [
        "Avez-vous l\u2019impression de faire r\xe9p\xe9ter votre entourage\xa0?",
        "Percevez-vous des probl\xe8mes d\u2019articulation chez vos interlocuteurs (par exemple avec vos enfants ou petits enfants)\xa0?",
        "Est-ce que parfois vous vous dites\xa0: \xab\xa0J\u2019entends mais je ne comprends pas\xa0\xbb ?",
        "Avez-vous tendance \xe0 monter le son de la t\xe9l\xe9vision\xa0?",
        "Maintenir une conversation dans un milieu bruyant (restaurant, r\xe9union..) est difficile pour vous\xa0?",
        "Avez-vous du mal \xe0 localiser certains sons\xa0?",
        "Est-ce que certain sons ou certaines situations (klaxonnes, travaux, cin\xe9ma) vous sont d\xe9rangeants\xa0?",
        "Avez-vous souvent des acouph\xe8nes (sifflement ou bourdonnement) ?",
        "Avez-vous \xe9t\xe9 expos\xe9(e) aux bruits lors de votre activit\xe9 professionnelle\xa0?"
    ];
    var $94de3cf94b6a62cb$var$currentQuestion = 0;
    var $94de3cf94b6a62cb$var$yeses = 0;
    var $94de3cf94b6a62cb$var$noses = 0;
    function nextQuestion() {
        $94de3cf94b6a62cb$var$currentQuestion++;
        $bUBkB(".js-question").each(function(index, elem) {
            $bUBkB(elem).toggleClass("current", index === $94de3cf94b6a62cb$var$currentQuestion);
        });
        if ($94de3cf94b6a62cb$var$currentQuestion >= $94de3cf94b6a62cb$var$questions.length) finalize();
        else $bUBkB(".question-text").text($94de3cf94b6a62cb$var$questions[$94de3cf94b6a62cb$var$currentQuestion]);
    }
    function finalize() {
        $bUBkB(".test-current").hide();
        $bUBkB(".resultat").addClass("fini");
        if ($94de3cf94b6a62cb$var$yeses >= 3) $bUBkB(".test-failed").show();
        else $bUBkB(".test-success").show();
        $bUBkB(".find-center").smoothScroll();
    }
    $bUBkB(".js-reponse-oui").on("click", function() {
        $94de3cf94b6a62cb$var$yeses++;
        nextQuestion();
    });
    $bUBkB(".js-reponse-non").on("click", function() {
        $94de3cf94b6a62cb$var$noses++;
        nextQuestion();
    });
}



var $5ihUn = parcelRequire("5ihUn");

var $jMKlL = parcelRequire("jMKlL");

var $5GxwX = parcelRequire("5GxwX");

var $6agJ4 = parcelRequire("6agJ4");

var $bUBkB = parcelRequire("bUBkB");

var $e3o07 = parcelRequire("e3o07");


var $20baf3c310b4da18$var$wnd = window;
function $20baf3c310b4da18$export$6794e2eac1c24bce() {
    if ($20baf3c310b4da18$var$wnd.page === "orl-detail") {
        $(".js-rdv-url-link").on("click", function(event) {
            var form = $(this).parents("form");
            form.find("button[type=submit]").click();
            if (!form[0].checkValidity()) event.preventDefault();
        });
        if (document.getElementById("map")) {
            var myLatLng = {
                lat: $20baf3c310b4da18$var$wnd.audiopro.location.coordinates[1],
                lng: $20baf3c310b4da18$var$wnd.audiopro.location.coordinates[0]
            };
            var map = new google.maps.Map(document.getElementById("map"), {
                zoom: 17,
                center: myLatLng
            });
            var marker = new google.maps.Marker({
                position: myLatLng,
                map: map,
                title: $20baf3c310b4da18$var$wnd.audiopro.enseigne
            });
            marker.setIcon({
                url: "/assets/images/pin-blue.png"
            });
        }
        $(".rdv-button").on("click", function() {
            window["ga"]("send", {
                hitType: "event",
                eventCategory: "Fiche Centre",
                eventAction: "click",
                eventLabel: "Demande de RDV"
            });
            new (0, $e3o07.StatsApi)().saveStat({
                query: {
                    centerId: window["audiopro"]._id,
                    location: "detail",
                    type: "click-rdv"
                }
            });
        });
        $bUBkB(".rdvform").on("submit", function(event) {
            var orlid = $(this).data("orlid");
            var mode = $(this).data("mode");
            event.preventDefault();
            event.stopPropagation();
            var $this = $(this);
            var formValues = (0, $97d6ffd33a62cf3b$export$8995636b7242f090)($this.serializeArray().map(function(i) {
                return [
                    i.name,
                    i.value
                ];
            }));
            console.log(formValues);
            formValues = (0, $5GxwX._)((0, $jMKlL._)({}, formValues), {
                mode: mode
            });
            $this.find(".ask-for-rdv-loader").show();
            $this.find(".ask-for-rdv").hide();
            new (0, $e3o07.RdvApi)().askForOrlRdv({
                orlId: orlid,
                query: formValues
            }).then(function() {});
            console.log("OK!");
            $this.find(".rdv-success").show();
            $this.find(".ask-for-rdv-loader").hide();
            $this.find("#close").show();
            $this.find(".rdv-inputs").hide();
            return false;
        });
        $(".rdv-link-callcenter").on("click", function(event) {
            event.preventDefault();
            var id = $(this).data("audioproid");
            $("#rdvLinkModal-" + id).modal({
                backdrop: true
            });
            if (window.page === "search-results") $("[name=isSearch]").val("true");
        });
        $bUBkB(".phone-button").on("click", function() {
            var _ref = (0, $5ihUn._)(function(event) {
                var phoneNumber, enseigne, city, postalcode, address, modalId, id, phoneNumberResponse, $el;
                return (0, $6agJ4.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            phoneNumber = $(this).data("phonenumber");
                            enseigne = $(this).data("enseigne");
                            city = $(this).data("city");
                            postalcode = $(this).data("postalcode");
                            address = $(this).data("address");
                            modalId = $(this).data("type") === "orl" ? "#orlPhoneNumberModal" : "#phoneNumberModal-" + $(this).data("audioproid");
                            if (!($(this).data("type") === "audiopro")) return [
                                3,
                                2
                            ];
                            id = $(this).data("audioproid");
                            return [
                                4,
                                new (0, $e3o07.AudioProApi)().getPhoneNumber({
                                    audioProId: id
                                })
                            ];
                        case 1:
                            phoneNumberResponse = _state.sent();
                            phoneNumber = (0, $e95a0614adfba180$export$842dcfa371c6bb83)(phoneNumberResponse.phoneNumber);
                            _state.label = 2;
                        case 2:
                            $bUBkB(modalId + " .modal-phone-number").text(phoneNumber);
                            $bUBkB(modalId + " .modal-free-call").text(phoneNumber.substring(0, 3) === "0 8" ? "(Appel Gratuit)" : "(Appel non surtax\xe9)");
                            $bUBkB(modalId + " .modal-enseigne").text(enseigne);
                            $bUBkB(modalId + " .modal-city").text(city);
                            $bUBkB(modalId + " .modal-postalcode").text(postalcode);
                            $bUBkB(modalId + " .modal-address").text(address);
                            if ($(this).attr("href") === "#") {
                                event.preventDefault();
                                // Only on non mobiles devices
                                if ($(document).width() > 576) $(modalId).modal({
                                    backdrop: true
                                });
                                else {
                                    $el = $(this).children(".telephone");
                                    if ($el.length) {
                                        if ($el.data("type") === "block") $(this).replaceWith($el.show().css("display", "block"));
                                        else $(this).replaceWith($el.show().css("display", "inline-block"));
                                    }
                                }
                            }
                            window["ga"]("send", {
                                hitType: "event",
                                eventCategory: "ORL",
                                eventAction: "click",
                                eventLabel: "Telephone"
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function(event) {
                return _ref.apply(this, arguments);
            };
        }());
        $bUBkB("#orlRdvform").on("submit", function(event) {
            event.preventDefault();
            event.stopPropagation();
            var formValues = (0, $97d6ffd33a62cf3b$export$8995636b7242f090)($bUBkB("#orlRdvform").serializeArray().map(function(i) {
                return [
                    i.name,
                    i.value
                ];
            }));
            $bUBkB("#loader").show();
            $bUBkB("#ask-for-rdv").hide();
            new (0, $e3o07.RdvApi)().askForOrlRdv({
                orlId: $20baf3c310b4da18$var$wnd.audiopro._id,
                query: formValues
            }).then(function() {
                console.log("OK!");
                $bUBkB("#rdv-success").show();
                $bUBkB("#loader").hide();
                $bUBkB("#close").show();
                $bUBkB("#rdv-inputs").hide();
            });
            return false;
        });
    }
    var scrollDiv = document.createElement("div");
    scrollDiv.className = "modal-scrollbar-measure";
    document.body.appendChild(scrollDiv);
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    // Compensate the navbar
    $("#phoneNumberModal").on("show.bs.modal", function(e) {
        $(".center-topbar").css("padding-right", scrollbarWidth);
    });
    $("#phoneNumberModal").on("hidden.bs.modal", function(e) {
        $(".center-topbar").css("padding-right", 0);
    });
    // Compensate the navbar
    $("#orlPhoneNumberModal").on("show.bs.modal", function(e) {
        $(".center-topbar").css("padding-right", scrollbarWidth);
    });
    $("#orlPhoneNumberModal").on("hidden.bs.modal", function(e) {
        $(".center-topbar").css("padding-right", 0);
    });
}



var $5ihUn = parcelRequire("5ihUn");

var $6agJ4 = parcelRequire("6agJ4");

var $bUBkB = parcelRequire("bUBkB");

var $e3o07 = parcelRequire("e3o07");

var $c1dc61a9dfd51abd$var$wnd = window;
function $c1dc61a9dfd51abd$export$5e21beef2e326574() {
    if ($c1dc61a9dfd51abd$var$wnd.page === "chu-detail") {
        $(".js-rdv-url-link").on("click", function(event) {
            var form = $(this).parents("form");
            form.find("button[type=submit]").click();
            if (!form[0].checkValidity()) event.preventDefault();
        });
        if (document.getElementById("map")) {
            var myLatLng = {
                lat: $c1dc61a9dfd51abd$var$wnd.chu.location.coordinates[1],
                lng: $c1dc61a9dfd51abd$var$wnd.chu.location.coordinates[0]
            };
            var map = new google.maps.Map(document.getElementById("map"), {
                zoom: 17,
                center: myLatLng
            });
            var marker = new google.maps.Marker({
                position: myLatLng,
                map: map,
                title: $c1dc61a9dfd51abd$var$wnd.chu.enseigne
            });
            marker.setIcon({
                url: "/assets/images/pin-blue.png"
            });
        }
        $(".rdv-button").on("click", function() {
            window["ga"]("send", {
                hitType: "event",
                eventCategory: "Fiche Centre",
                eventAction: "click",
                eventLabel: "Demande de RDV"
            });
            new (0, $e3o07.StatsApi)().saveStat({
                query: {
                    centerId: window["chu"]._id,
                    location: "detail",
                    type: "click-rdv"
                }
            });
        });
        $bUBkB(".phone-button").on("click", function() {
            var _ref = (0, $5ihUn._)(function(event) {
                var phoneNumber, enseigne, city, postalcode, address, modalId, id, phoneNumberResponse, $el;
                return (0, $6agJ4.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            console.log("clicked");
                            phoneNumber = $(this).data("phonenumber");
                            enseigne = $(this).data("enseigne");
                            city = $(this).data("city");
                            postalcode = $(this).data("postalcode");
                            address = $(this).data("address");
                            modalId = $(this).data("type") === "chu" ? "#chuPhoneNumberModal" : "#phoneNumberModal-" + $(this).data("audioproid");
                            if (!($(this).data("type") === "audiopro")) return [
                                3,
                                2
                            ];
                            id = $(this).data("audioproid");
                            return [
                                4,
                                new (0, $e3o07.AudioProApi)().getPhoneNumber({
                                    audioProId: id
                                })
                            ];
                        case 1:
                            phoneNumberResponse = _state.sent();
                            phoneNumber = (0, $e95a0614adfba180$export$842dcfa371c6bb83)(phoneNumberResponse.phoneNumber);
                            _state.label = 2;
                        case 2:
                            $bUBkB(modalId + " .modal-phone-number").text(phoneNumber);
                            $bUBkB(modalId + " .modal-free-call").text(phoneNumber.substring(0, 3) === "0 8" ? "(Appel Gratuit)" : "(Appel non surtax\xe9)");
                            $bUBkB(modalId + " .modal-enseigne").text(enseigne);
                            $bUBkB(modalId + " .modal-city").text(city);
                            $bUBkB(modalId + " .modal-postalcode").text(postalcode);
                            $bUBkB(modalId + " .modal-address").text(address);
                            if ($(this).attr("href") === "#") {
                                event.preventDefault();
                                // Only on non mobiles devices
                                if ($(document).width() > 576) $(modalId).modal({
                                    backdrop: true
                                });
                                else {
                                    $el = $(this).children(".telephone");
                                    if ($el.length) {
                                        if ($el.data("type") === "block") $(this).replaceWith($el.show().css("display", "block"));
                                        else $(this).replaceWith($el.show().css("display", "inline-block"));
                                    }
                                }
                            }
                            window["ga"]("send", {
                                hitType: "event",
                                eventCategory: "CHU",
                                eventAction: "click",
                                eventLabel: "Telephone"
                            });
                            return [
                                2
                            ];
                    }
                });
            });
            return function(event) {
                return _ref.apply(this, arguments);
            };
        }());
    }
    var scrollDiv = document.createElement("div");
    scrollDiv.className = "modal-scrollbar-measure";
    document.body.appendChild(scrollDiv);
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    // Compensate the navbar
    $("#phoneNumberModal").on("show.bs.modal", function(e) {
        $(".center-topbar").css("padding-right", scrollbarWidth);
    });
    $("#phoneNumberModal").on("hidden.bs.modal", function(e) {
        $(".center-topbar").css("padding-right", 0);
    });
    // Compensate the navbar
    $("#chuPhoneNumberModal").on("show.bs.modal", function(e) {
        $(".center-topbar").css("padding-right", scrollbarWidth);
    });
    $("#chuPhoneNumberModal").on("hidden.bs.modal", function(e) {
        $(".center-topbar").css("padding-right", 0);
    });
}



var $bUBkB = parcelRequire("bUBkB");

var $e3o07 = parcelRequire("e3o07");

var $3507bbeeb1d2b16e$var$wnd = window;
if ($3507bbeeb1d2b16e$var$wnd.page === "rdv-page") $bUBkB(".rdvform").on("submit", function(event) {
    debugger;
    event.preventDefault();
    event.stopPropagation();
    var $this = $(this);
    var formValues = (0, $97d6ffd33a62cf3b$export$8995636b7242f090)($this.serializeArray().map(function(i) {
        return [
            i.name,
            i.value
        ];
    }));
    console.log(formValues);
    $this.find(".ask-for-rdv-loader").show();
    $this.find(".ask-for-rdv").hide();
    new (0, $e3o07.RdvApi)().globalAskForRdv({
        query: formValues
    }).then(function() {
        console.log("OK!");
    });
    $(".rdv-success").show();
    $(".ask-for-rdv-loader").hide();
    $(".rdvform").hide();
    return false;
});



var $bUBkB = parcelRequire("bUBkB");
var $c70c8f04c51e342a$var$loadingPlacePromise = null;
var $c70c8f04c51e342a$var$placeLoaded = $bUBkB("input[name=autofilled]").val() === "true";
function $c70c8f04c51e342a$export$3a2c34b81dbf4e57() {
    var domElem = document.getElementById("address-input");
    if (!domElem) return;
    function pacSelectFirst(input) {
        // store the original event binding function
        var _addEventListener = input.addEventListener ? input.addEventListener : input.attachEvent;
        function addEventListenerWrapper(type, listener) {
            // Simulate a 'down arrow' keypress on hitting 'return' when no pac suggestion is selected,
            // and then trigger the original listener.
            if (type === "keydown") {
                var orig_listener = listener;
                listener = function listener(event) {
                    var suggestion_selected = $bUBkB(".pac-item-selected").length > 0;
                    if (event.which === 13 && !suggestion_selected) {
                        var simulated_downarrow = $bUBkB.Event("keydown", {
                            keyCode: 40,
                            which: 40
                        });
                        orig_listener.apply(input, [
                            simulated_downarrow
                        ]);
                    }
                    orig_listener.apply(input, [
                        event
                    ]);
                };
            }
            if (type === "blur") {
                var orig_listener = listener;
                listener = function listener(event) {
                    var suggestion_selected = $bUBkB(".pac-item-selected").length > 0;
                    if (!suggestion_selected) {
                        var firstResult = $bUBkB(".pac-container .pac-item:first .pac-item-query").text();
                        // if the results are not loaded yet:
                        firstResult = firstResult || $bUBkB(input).val();
                        $bUBkB(input).val(firstResult);
                        $c70c8f04c51e342a$var$loadingPlacePromise = fillPlaceDataFromName(firstResult);
                        $c70c8f04c51e342a$var$loadingPlacePromise.then(function() {
                            $c70c8f04c51e342a$var$loadingPlacePromise = null;
                        }).catch(function(err) {
                            console.log(err);
                            $c70c8f04c51e342a$var$loadingPlacePromise = null;
                        });
                    }
                    orig_listener.apply(input, [
                        event
                    ]);
                };
            }
            _addEventListener.apply(input, [
                type,
                listener
            ]);
        }
        input.addEventListener = addEventListenerWrapper;
        input.attachEvent = addEventListenerWrapper;
    }
    pacSelectFirst(domElem);
    function fillPlaceDataFromName(name) {
        return new Promise(function(resolve, reject) {
            var autocompleteService = new google.maps.places.AutocompleteService();
            autocompleteService.getPlacePredictions({
                input: name,
                offset: name.length,
                componentRestrictions: {
                    country: window.countryCode
                }
            }, function(list, status) {
                if (list == null || list.length == 0) reject();
                else {
                    var placeService = new google.maps.places.PlacesService(document.getElementById("map-for-autocomplete"));
                    placeService.getDetails(list[0], function(result, status) {
                        if (status !== google.maps.places.PlacesServiceStatus.OK) {
                            console.error(status);
                            reject();
                            return;
                        }
                        $c70c8f04c51e342a$var$fillAutocompleteData(result, true);
                        resolve(null);
                    });
                }
            });
        });
    }
    $bUBkB("#search-button").on("click", function(event) {
        if ($c70c8f04c51e342a$var$loadingPlacePromise) {
            $c70c8f04c51e342a$var$loadingPlacePromise.then(function() {
                $bUBkB("#search-button").click();
            });
            event.preventDefault();
        } else if (!$c70c8f04c51e342a$var$placeLoaded) // $('#address-input').css('border', '1px solid #e35454');
        event.preventDefault();
    });
    function startGeolocation() {
        $bUBkB(".fa-location-arrow").removeClass("fa-exclamation").addClass("fa-spin").parent().addClass("disabled").attr("disabled", "disabled");
    }
    function stopGeolocation() {
        $bUBkB(".fa-location-arrow").removeClass("fa-spin").removeClass("fa-location-arrow").addClass("fa-exclamation-triangle");
    }
    $bUBkB("#locate-me-button").on("click", function() {
        startGeolocation();
        if (navigator.geolocation) navigator.geolocation.getCurrentPosition(function(position) {
            var pos = {
                lat: position.coords.latitude,
                lng: position.coords.longitude
            };
            var geocoder = new google.maps.Geocoder();
            geocoder.geocode({
                location: pos
            }, function(results, status) {
                if (status.toString() === "OK") {
                    if (results[0]) {
                        $bUBkB("#address-input").val(results[0].formatted_address);
                        $c70c8f04c51e342a$var$fillAutocompleteData(results[0]);
                    } else {
                        console.log("No results found");
                        stopGeolocation();
                    }
                } else {
                    console.log("Geocoder failed due to: " + status);
                    stopGeolocation();
                }
            });
        }, function(err) {
            console.log(err);
            stopGeolocation();
        });
        else // Browser doesn't support Geolocation
        stopGeolocation();
    });
    // $('.audiopro-type-selector').on('change', event=>{
    //   var newValue = $(event.target).val();
    //   if(newValue === 'audiopro'){
    //     $('form.search').attr('action','/city/search');
    //   }else if(newValue === 'orl'){
    //     $('form.search').attr('action','/orl-oto-rhino-laryngologie/city/search');
    //   }
    // });
    $bUBkB("#address-input").on("keypress", function(event) {});
    var autocomplete = new google.maps.places.Autocomplete(domElem, {
        types: [
            "geocode"
        ],
        componentRestrictions: {
            country: window.countryCode
        }
    });
    var placeSelected = false;
    // When the user selects an address from the dropdown, populate the address
    // fields in the form.
    google.maps.event.addDomListener(domElem, "keydown", function(e) {
        if (e.keyCode === 13 && !placeSelected) e.preventDefault();
    });
    autocomplete.addListener("place_changed", function() {
        placeSelected = true;
        var gPlace = autocomplete.getPlace();
        if (gPlace) {
            $c70c8f04c51e342a$var$fillAutocompleteData(gPlace);
            return;
        } else return;
    });
}
function $c70c8f04c51e342a$var$fillAutocompleteData(gPlace) {
    var doNotSubmit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var EARTH_RADIUS = 6371;
    var n, radius;
    if (gPlace.geometry) {
        var form = $bUBkB("#search-button").parents("form");
        if (gPlace.geometry.viewport) {
            $bUBkB(".auto-filled").remove();
            var center = gPlace.geometry.viewport.getCenter();
            var northEast = gPlace.geometry.viewport.getNorthEast();
            var latCenter = center.lat() / 57.2958;
            var lngCenter = center.lng() / 57.2958;
            var latNorthEast = northEast.lat() / 57.2958;
            var lngNorthEast = northEast.lng() / 57.2958;
            radius = EARTH_RADIUS * Math.acos(Math.sin(latCenter) * Math.sin(latNorthEast) + Math.cos(latCenter) * Math.cos(latNorthEast) * Math.cos(lngNorthEast - lngCenter));
            form.append($bUBkB('<input type="hidden" data-address-component="1" />').val(radius).attr("name", "radius"));
        }
        $c70c8f04c51e342a$var$placeLoaded = true;
        form.find("input[name=place_id]").val(gPlace.place_id);
        form.find("input[name=geometry]").val(JSON.stringify(gPlace.geometry));
        form.find("input[name=latitude]").val(gPlace.geometry.location.lat());
        form.find("input[name=longitude]").val(gPlace.geometry.location.lng());
        form.find("input[data-address-component]").remove();
        for(var p = gPlace.address_components, m = 0; m < p.length; m += 1){
            var h = p[m];
            n = h.types[0];
            var f = "country" === n ? h.short_name : h.long_name;
            form.append($bUBkB('<input type="hidden" data-address-component="1" />').val(f).attr("name", n));
        }
        form.append($bUBkB('<input type="hidden" data-address-component="1" />').val(gPlace.name || gPlace.formatted_address).attr("name", "name"));
        form.append($bUBkB('<input type="hidden" data-address-component="1" />').val(gPlace.types[0]).attr("name", "type"));
        form.append($bUBkB('<input type="hidden" data-address-component="1" />').val(gPlace.types).attr("name", "types"));
        form.append($bUBkB('<input type="hidden" data-address-component="1" />').val(radius).attr("name", "radius"));
        if (!doNotSubmit) form.submit();
    }
}



var $5ihUn = parcelRequire("5ihUn");

var $6agJ4 = parcelRequire("6agJ4");

var $bUBkB = parcelRequire("bUBkB");

var $e3o07 = parcelRequire("e3o07");
var $456d77bc1665cb4c$exports = {};
// Sticky Plugin v1.0.4 for jQuery
// =============
// Author: Anthony Garand
// Improvements by German M. Bravo (Kronuz) and Ruud Kamphuis (ruudk)
// Improvements by Leonardo C. Daronco (daronco)
// Created: 02/14/2011
// Date: 07/20/2015
// Website: http://stickyjs.com/
// Description: Makes an element on the page stick on the screen as you scroll
//              It will only set the 'top' and 'position' of your element, you
//              might need to adjust the width in some cases.

var $bUBkB = parcelRequire("bUBkB");

(function(factory) {
    if (typeof define === "function" && define.amd) // AMD. Register as an anonymous module.
    define([
        "jquery"
    ], factory);
    else if (0, $456d77bc1665cb4c$exports) // Node/CommonJS
    $456d77bc1665cb4c$exports = factory((parcelRequire("bUBkB")));
    else // Browser globals
    factory($bUBkB);
})(function($) {
    var slice = Array.prototype.slice; // save ref to original slice()
    var splice = Array.prototype.splice; // save ref to original slice()
    var defaults = {
        topSpacing: 0,
        bottomSpacing: 0,
        className: "is-sticky",
        wrapperClassName: "sticky-wrapper",
        center: false,
        getWidthFrom: "",
        widthFromWrapper: true,
        responsiveWidth: false,
        zIndex: "auto"
    }, $window = $(window), $document = $(document), sticked = [], windowHeight = $window.height(), scroller = function scroller() {
        var scrollTop = $window.scrollTop(), documentHeight = $document.height(), dwh = documentHeight - windowHeight, extra = scrollTop > dwh ? dwh - scrollTop : 0;
        for(var i = 0, l = sticked.length; i < l; i++){
            var s = sticked[i], elementTop = s.stickyWrapper.offset().top, etse = elementTop - s.topSpacing - extra;
            //update height in case of dynamic content
            s.stickyWrapper.css("height", s.stickyElement.outerHeight());
            if (scrollTop <= etse) {
                if (s.currentTop !== null) {
                    s.stickyElement.css({
                        width: "",
                        position: "",
                        top: "",
                        "z-index": ""
                    });
                    s.stickyElement.parent().removeClass(s.className);
                    s.stickyElement.trigger("sticky-end", [
                        s
                    ]);
                    s.currentTop = null;
                }
            } else {
                var newTop = documentHeight - s.stickyElement.outerHeight() - s.topSpacing - s.bottomSpacing - scrollTop - extra;
                if (newTop < 0) newTop = newTop + s.topSpacing;
                else newTop = s.topSpacing;
                if (s.currentTop !== newTop) {
                    var newWidth;
                    if (s.getWidthFrom) newWidth = $(s.getWidthFrom).width() || null;
                    else if (s.widthFromWrapper) newWidth = s.stickyWrapper.width();
                    if (newWidth == null) newWidth = s.stickyElement.width();
                    s.stickyElement.css("width", newWidth).css("position", "fixed").css("top", newTop).css("z-index", s.zIndex);
                    s.stickyElement.parent().addClass(s.className);
                    if (s.currentTop === null) s.stickyElement.trigger("sticky-start", [
                        s
                    ]);
                    else // sticky is started but it have to be repositioned
                    s.stickyElement.trigger("sticky-update", [
                        s
                    ]);
                    if (s.currentTop === s.topSpacing && s.currentTop > newTop || s.currentTop === null && newTop < s.topSpacing) // just reached bottom || just started to stick but bottom is already reached
                    s.stickyElement.trigger("sticky-bottom-reached", [
                        s
                    ]);
                    else if (s.currentTop !== null && newTop === s.topSpacing && s.currentTop < newTop) // sticky is started && sticked at topSpacing && overflowing from top just finished
                    s.stickyElement.trigger("sticky-bottom-unreached", [
                        s
                    ]);
                    s.currentTop = newTop;
                }
                // Check if sticky has reached end of container and stop sticking
                var stickyWrapperContainer = s.stickyWrapper.parent();
                var unstick = s.stickyElement.offset().top + s.stickyElement.outerHeight() >= stickyWrapperContainer.offset().top + stickyWrapperContainer.outerHeight() && s.stickyElement.offset().top <= s.topSpacing;
                if (unstick) s.stickyElement.css("position", "absolute").css("top", "").css("bottom", 0).css("z-index", "");
                else s.stickyElement.css("position", "fixed").css("top", newTop).css("bottom", "").css("z-index", s.zIndex);
            }
        }
    }, resizer = function resizer() {
        windowHeight = $window.height();
        for(var i = 0, l = sticked.length; i < l; i++){
            var s = sticked[i];
            var newWidth = null;
            if (s.getWidthFrom) {
                if (s.responsiveWidth) newWidth = $(s.getWidthFrom).width();
            } else if (s.widthFromWrapper) newWidth = s.stickyWrapper.width();
            if (newWidth != null) s.stickyElement.css("width", newWidth);
        }
    }, methods = {
        init: function init(options) {
            var o = $.extend({}, defaults, options);
            return this.each(function() {
                var stickyElement = $(this);
                var stickyId = stickyElement.attr("id");
                var wrapperId = stickyId ? stickyId + "-" + defaults.wrapperClassName : defaults.wrapperClassName;
                var wrapper = $("<div></div>").attr("id", wrapperId).addClass(o.wrapperClassName);
                stickyElement.wrapAll(function() {
                    if ($(this).parent("#" + wrapperId).length == 0) return wrapper;
                });
                var stickyWrapper = stickyElement.parent();
                if (o.center) stickyWrapper.css({
                    width: stickyElement.outerWidth(),
                    marginLeft: "auto",
                    marginRight: "auto"
                });
                if (stickyElement.css("float") === "right") stickyElement.css({
                    float: "none"
                }).parent().css({
                    float: "right"
                });
                o.stickyElement = stickyElement;
                o.stickyWrapper = stickyWrapper;
                o.currentTop = null;
                sticked.push(o);
                methods.setWrapperHeight(this);
                methods.setupChangeListeners(this);
            });
        },
        setWrapperHeight: function setWrapperHeight(stickyElement) {
            var element = $(stickyElement);
            var stickyWrapper = element.parent();
            if (stickyWrapper) stickyWrapper.css("height", element.outerHeight());
        },
        setupChangeListeners: function setupChangeListeners(stickyElement) {
            if (window.MutationObserver) {
                var mutationObserver = new window.MutationObserver(function(mutations) {
                    if (mutations[0].addedNodes.length || mutations[0].removedNodes.length) methods.setWrapperHeight(stickyElement);
                });
                mutationObserver.observe(stickyElement, {
                    subtree: true,
                    childList: true
                });
            } else {
                stickyElement.addEventListener("DOMNodeInserted", function() {
                    methods.setWrapperHeight(stickyElement);
                }, false);
                stickyElement.addEventListener("DOMNodeRemoved", function() {
                    methods.setWrapperHeight(stickyElement);
                }, false);
            }
        },
        update: scroller,
        unstick: function unstick(options) {
            return this.each(function() {
                var that = this;
                var unstickyElement = $(that);
                var removeIdx = -1;
                var i = sticked.length;
                while(i-- > 0)if (sticked[i].stickyElement.get(0) === that) {
                    splice.call(sticked, i, 1);
                    removeIdx = i;
                }
                if (removeIdx !== -1) {
                    unstickyElement.unwrap();
                    unstickyElement.css({
                        width: "",
                        position: "",
                        top: "",
                        float: "",
                        "z-index": ""
                    });
                }
            });
        }
    };
    // should be more efficient than using $window.scroll(scroller) and $window.resize(resizer):
    if (window.addEventListener) {
        window.addEventListener("scroll", scroller, false);
        window.addEventListener("resize", resizer, false);
    } else if (window.attachEvent) {
        window.attachEvent("onscroll", scroller);
        window.attachEvent("onresize", resizer);
    }
    $.fn.sticky = function(method) {
        if (methods[method]) return methods[method].apply(this, slice.call(arguments, 1));
        else if (typeof method === "object" || !method) return methods.init.apply(this, arguments);
        else $.error("Method " + method + " does not exist on jQuery.sticky");
    };
    $.fn.unstick = function(method) {
        if (methods[method]) return methods[method].apply(this, slice.call(arguments, 1));
        else if (typeof method === "object" || !method) return methods.unstick.apply(this, arguments);
        else $.error("Method " + method + " does not exist on jQuery.sticky");
    };
    $(function() {
        setTimeout(scroller, 0);
    });
});



if (window["page"] === "search-results") {
    $bUBkB(".js-single-search-result").on("mousedown", function(event) {
        var target = $bUBkB(this).data("target");
        var isButtonClick = $bUBkB(event.target).is("a") || $bUBkB(event.target).hasClass("btn") || $bUBkB(event.target).parent().hasClass("btn");
        if (isButtonClick) return;
        if (event.which === 1) document.location.href = target;
        else if (event.which === 2) // middle click opens in a new tab
        window.open(target, "_blank");
    });
    $bUBkB("#audika-ad-link").on("click", function(event) {
        new (0, $e3o07.StatsApi)().saveStat({
            query: {
                centerId: "audika",
                type: "ad-click",
                location: "search-results"
            }
        });
    });
    new (0, $e3o07.StatsApi)().saveStats({
        query: {
            requests: window["centers"].map(function(center) {
                return {
                    centerId: center._id,
                    location: "search",
                    type: "view-search"
                };
            })
        }
    });
    $bUBkB(".js-phone").click(function() {
        var _ref = (0, $5ihUn._)(function(event) {
            var id, phoneNumberResponse, phoneNumber, enseigne, city, address, postalCode, $el, centerId;
            return (0, $6agJ4.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        id = $bUBkB(this).data("audioproid");
                        return [
                            4,
                            new (0, $e3o07.AudioProApi)().getPhoneNumber({
                                audioProId: id
                            })
                        ];
                    case 1:
                        phoneNumberResponse = _state.sent();
                        phoneNumber = (0, $e95a0614adfba180$export$842dcfa371c6bb83)(phoneNumberResponse.phoneNumber);
                        enseigne = $bUBkB(this).data("enseigne");
                        city = $bUBkB(this).data("city");
                        address = $bUBkB(this).data("address");
                        postalCode = $bUBkB(this).data("postalcode");
                        $bUBkB("#phoneNumberModal-" + id + " .modal-phone-number").text(phoneNumber);
                        $bUBkB("#phoneNumberModal-" + id + " .modal-free-call").text(phoneNumber.substring(0, 3) === "0 8" ? "(Appel Gratuit)" : "(Appel non surtax\xe9)");
                        $bUBkB("#phoneNumberModal-" + id + " .modal-enseigne").text(enseigne);
                        $bUBkB("#phoneNumberModal-" + id + " .modal-postalcode").text(postalCode);
                        $bUBkB("#phoneNumberModal-" + id + " .modal-city").text(city);
                        $bUBkB("#phoneNumberModal-" + id + " .modal-address").text(address);
                        // Only on non mobiles devices
                        if ($bUBkB(document).width() > 576) $bUBkB("#phoneNumberModal-" + id).modal({
                            backdrop: true
                        });
                        else {
                            $el = $bUBkB(this).children(".telephone");
                            if ($el.data("type") === "block") $bUBkB(this).replaceWith($el.show().css("display", "block"));
                            else $bUBkB(this).replaceWith($el.show().css("display", "inline-block"));
                        }
                        window["ga"]("send", {
                            hitType: "event",
                            eventCategory: "Encart Centre",
                            eventAction: "click",
                            eventLabel: "Telephone"
                        });
                        centerId = $bUBkB(this).data("centerid");
                        new (0, $e3o07.StatsApi)().saveStat({
                            query: {
                                centerId: centerId,
                                location: "search",
                                type: "click-phone-number"
                            }
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }());
    $bUBkB(".detail-button").on("click", function(event) {
        window["ga"]("send", {
            hitType: "event",
            eventCategory: "Encart Centre",
            eventAction: "click",
            eventLabel: "Voir fiche"
        });
    });
}
var $04df4a0c76238a5a$var$activePins = [];
function $04df4a0c76238a5a$var$setPinActive(marker) {
    $04df4a0c76238a5a$var$disableAllPins();
    $04df4a0c76238a5a$var$activePins.push(marker);
    marker.setIcon({
        url: "/assets/images/pin-blue.png"
    });
}
function $04df4a0c76238a5a$var$setPinInactive(marker) {
    $04df4a0c76238a5a$var$activePins = $04df4a0c76238a5a$var$activePins.filter(function(i) {
        return i != marker;
    });
    marker.setIcon({
        url: "/assets/images/pin-yellow.png"
    });
}
function $04df4a0c76238a5a$var$disableAllPins() {
    $04df4a0c76238a5a$var$activePins.forEach($04df4a0c76238a5a$var$setPinInactive);
}
var $04df4a0c76238a5a$var$activeCenters = [];
function $04df4a0c76238a5a$var$setCenterActive(id) {
    $04df4a0c76238a5a$var$disableAllCenters();
    $04df4a0c76238a5a$var$activeCenters.push(id);
    $bUBkB("#audio-" + id).addClass("active");
}
function $04df4a0c76238a5a$var$setCenterInactive(id) {
    $04df4a0c76238a5a$var$activeCenters = $04df4a0c76238a5a$var$activeCenters.filter(function(i) {
        return i != id;
    });
    $bUBkB("#audio-" + id).removeClass("active");
}
function $04df4a0c76238a5a$var$disableAllCenters() {
    $04df4a0c76238a5a$var$activeCenters.forEach($04df4a0c76238a5a$var$setCenterInactive);
}
var $04df4a0c76238a5a$var$wnd = window;
var $04df4a0c76238a5a$export$d41d6118675e9b78 = function() {
    if (google && google.maps) {
        var reBounds = new google.maps.LatLngBounds();
        $bUBkB.each($04df4a0c76238a5a$var$wnd.centers, function(index, center) {
            reBounds.extend(new google.maps.LatLng(center.location.coordinates[1], center.location.coordinates[0]));
        });
        var map = new google.maps.Map(document.getElementById("map"), {
            zoom: 12,
            scrollwheel: false,
            center: reBounds.getCenter()
        });
        map.fitBounds(reBounds);
        /*     new google.maps.Marker({
      icon: "/assets/images/home_marker.png",
      position: new google.maps.LatLng(wnd.centerLat, wnd.centerLng),
      map: map,
      title: wnd.search,
    }); */ $bUBkB.each($04df4a0c76238a5a$var$wnd.centers, function(index, center) {
            var marker = new google.maps.Marker({
                position: new google.maps.LatLng(center.location.coordinates[1], center.location.coordinates[0]),
                map: map,
                title: center.enseigne,
                icon: "/assets/images/pin-yellow.png"
            });
            marker.addListener("click", function() {
                console.log("Pin clicked", center);
                $04df4a0c76238a5a$var$setPinActive(marker);
                $04df4a0c76238a5a$var$setCenterActive(center._id);
                var offset = $bUBkB("#audio-" + center._id).offset();
                $bUBkB("html, body").animate({
                    scrollTop: offset.top - 10
                }, 500);
            });
            $bUBkB("#audio-" + center._id).on("mouseenter", function() {
                $04df4a0c76238a5a$var$disableAllCenters();
                $04df4a0c76238a5a$var$setPinActive(marker);
            });
            $bUBkB("#audio-" + center._id).on("mouseleave", function() {
                return $04df4a0c76238a5a$var$setPinInactive(marker);
            });
        });
        $bUBkB(window).on("load", function() {
            var elementBottom = $bUBkB(".search--result")[0].getBoundingClientRect().bottom + window.scrollY;
            var docHeight = $bUBkB(document).height();
            console.log("height:", docHeight);
            console.log("bottom:", elementBottom);
            var spacing = docHeight - elementBottom;
            console.log("diff:", spacing);
            $bUBkB("#map-container").sticky({
                topSpacing: 0,
                bottomSpacing: spacing
            });
            $bUBkB("#map-container").sticky("update");
        });
    }
};



var $bUBkB = parcelRequire("bUBkB");
parcelRequire("c5bRs");
var $e3o07 = parcelRequire("e3o07");
$bUBkB(".js-save-redirection-stat").on("click", function() {
    var $el = $bUBkB(this);
    var centerId = $el.data("centerid");
    new (0, $e3o07.StatsApi)().saveStat({
        query: {
            centerId: centerId,
            location: document.location.href,
            type: "redirect"
        }
    });
});


window["jQuery"] = $bUBkB;
window["$"] = $bUBkB;

var $3V7B6 = parcelRequire("3V7B6");

var $fqAw8 = parcelRequire("fqAw8");
/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): util.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ var $c737ba01c092e0c8$var$Util = function($) {
    /**
   * ------------------------------------------------------------------------
   * Private TransitionEnd Helpers
   * ------------------------------------------------------------------------
   */ var transition = false;
    var MAX_UID = 1000000;
    var TransitionEndEvent = {
        WebkitTransition: "webkitTransitionEnd",
        MozTransition: "transitionend",
        OTransition: "oTransitionEnd otransitionend",
        transition: "transitionend"
    };
    // shoutout AngusCroll (https://goo.gl/pxwQGp)
    function toType(obj) {
        return ({}).toString.call(obj).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
    }
    function isElement(obj) {
        return (obj[0] || obj).nodeType;
    }
    function getSpecialTransitionEndEvent() {
        return {
            bindType: transition.end,
            delegateType: transition.end,
            handle: function(event) {
                if ($(event.target).is(this)) return event.handleObj.handler.apply(this, arguments) // eslint-disable-line prefer-rest-params
                ;
                return undefined;
            }
        };
    }
    function transitionEndTest() {
        if (window.QUnit) return false;
        var el = document.createElement("bootstrap");
        for(var name in TransitionEndEvent){
            if (el.style[name] !== undefined) return {
                end: TransitionEndEvent[name]
            };
        }
        return false;
    }
    function transitionEndEmulator(duration) {
        var _this = this;
        var called = false;
        $(this).one(Util.TRANSITION_END, function() {
            called = true;
        });
        setTimeout(function() {
            if (!called) Util.triggerTransitionEnd(_this);
        }, duration);
        return this;
    }
    function setTransitionEndSupport() {
        transition = transitionEndTest();
        $.fn.emulateTransitionEnd = transitionEndEmulator;
        if (Util.supportsTransitionEnd()) $.event.special[Util.TRANSITION_END] = getSpecialTransitionEndEvent();
    }
    /**
   * --------------------------------------------------------------------------
   * Public Util Api
   * --------------------------------------------------------------------------
   */ var Util = {
        TRANSITION_END: "bsTransitionEnd",
        getUID: function(prefix) {
            do // eslint-disable-next-line no-bitwise
            prefix += ~~(Math.random() * MAX_UID // "~~" acts like a faster Math.floor() here
            );
            while (document.getElementById(prefix));
            return prefix;
        },
        getSelectorFromElement: function(element) {
            var selector = element.getAttribute("data-target");
            if (!selector) {
                selector = element.getAttribute("href") || "";
                selector = /^#[a-z]/i.test(selector) ? selector : null;
            }
            return selector;
        },
        reflow: function(element) {
            return element.offsetHeight;
        },
        triggerTransitionEnd: function(element) {
            $(element).trigger(transition.end);
        },
        supportsTransitionEnd: function() {
            return Boolean(transition);
        },
        typeCheckConfig: function(componentName, config, configTypes) {
            for(var property in configTypes)if (configTypes.hasOwnProperty(property)) {
                var expectedTypes = configTypes[property];
                var value = config[property];
                var valueType = value && isElement(value) ? "element" : toType(value);
                if (!new RegExp(expectedTypes).test(valueType)) throw new Error("".concat(componentName.toUpperCase(), ": ") + 'Option "'.concat(property, '" provided type "').concat(valueType, '" ') + 'but expected type "'.concat(expectedTypes, '".'));
            }
        }
    };
    setTransitionEndSupport();
    return Util;
}(jQuery);
var $c737ba01c092e0c8$export$2e2bcd8739ae039 = $c737ba01c092e0c8$var$Util;


/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): collapse.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ var $0c5ec71b22441381$var$Collapse = function($) {
    /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var NAME = "collapse";
    var VERSION = "4.0.0-alpha.6";
    var DATA_KEY = "bs.collapse";
    var EVENT_KEY = ".".concat(DATA_KEY);
    var DATA_API_KEY = ".data-api";
    var JQUERY_NO_CONFLICT = $.fn[NAME];
    var TRANSITION_DURATION = 600;
    var Default = {
        toggle: true,
        parent: ""
    };
    var DefaultType = {
        toggle: "boolean",
        parent: "string"
    };
    var Event = {
        SHOW: "show".concat(EVENT_KEY),
        SHOWN: "shown".concat(EVENT_KEY),
        HIDE: "hide".concat(EVENT_KEY),
        HIDDEN: "hidden".concat(EVENT_KEY),
        CLICK_DATA_API: "click".concat(EVENT_KEY).concat(DATA_API_KEY)
    };
    var ClassName = {
        SHOW: "show",
        COLLAPSE: "collapse",
        COLLAPSING: "collapsing",
        COLLAPSED: "collapsed"
    };
    var Dimension = {
        WIDTH: "width",
        HEIGHT: "height"
    };
    var Selector = {
        ACTIVES: ".card > .show, .card > .collapsing",
        DATA_TOGGLE: '[data-toggle="collapse"]'
    };
    /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ var Collapse = /*#__PURE__*/ function() {
        "use strict";
        function Collapse(element, config) {
            (0, $3V7B6._)(this, Collapse);
            this._isTransitioning = false;
            this._element = element;
            this._config = this._getConfig(config);
            this._triggerArray = $.makeArray($('[data-toggle="collapse"][href="#'.concat(element.id, '"],') + '[data-toggle="collapse"][data-target="#'.concat(element.id, '"]')));
            this._parent = this._config.parent ? this._getParent() : null;
            if (!this._config.parent) this._addAriaAndCollapsedClass(this._element, this._triggerArray);
            if (this._config.toggle) this.toggle();
        }
        (0, $fqAw8._)(Collapse, [
            {
                // public
                key: "toggle",
                value: function toggle() {
                    if ($(this._element).hasClass(ClassName.SHOW)) this.hide();
                    else this.show();
                }
            },
            {
                key: "show",
                value: function show() {
                    var _this = this;
                    if (this._isTransitioning) throw new Error("Collapse is transitioning");
                    if ($(this._element).hasClass(ClassName.SHOW)) return;
                    var actives;
                    var activesData;
                    if (this._parent) {
                        actives = $.makeArray($(this._parent).find(Selector.ACTIVES));
                        if (!actives.length) actives = null;
                    }
                    if (actives) {
                        activesData = $(actives).data(DATA_KEY);
                        if (activesData && activesData._isTransitioning) return;
                    }
                    var startEvent = $.Event(Event.SHOW);
                    $(this._element).trigger(startEvent);
                    if (startEvent.isDefaultPrevented()) return;
                    if (actives) {
                        Collapse._jQueryInterface.call($(actives), "hide");
                        if (!activesData) $(actives).data(DATA_KEY, null);
                    }
                    var dimension = this._getDimension();
                    $(this._element).removeClass(ClassName.COLLAPSE).addClass(ClassName.COLLAPSING);
                    this._element.style[dimension] = 0;
                    this._element.setAttribute("aria-expanded", true);
                    if (this._triggerArray.length) $(this._triggerArray).removeClass(ClassName.COLLAPSED).attr("aria-expanded", true);
                    this.setTransitioning(true);
                    var complete = function() {
                        $(_this._element).removeClass(ClassName.COLLAPSING).addClass(ClassName.COLLAPSE).addClass(ClassName.SHOW);
                        _this._element.style[dimension] = "";
                        _this.setTransitioning(false);
                        $(_this._element).trigger(Event.SHOWN);
                    };
                    if (!(0, $c737ba01c092e0c8$export$2e2bcd8739ae039).supportsTransitionEnd()) {
                        complete();
                        return;
                    }
                    var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
                    var scrollSize = "scroll".concat(capitalizedDimension);
                    $(this._element).one((0, $c737ba01c092e0c8$export$2e2bcd8739ae039).TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);
                    this._element.style[dimension] = "".concat(this._element[scrollSize], "px");
                }
            },
            {
                key: "hide",
                value: function hide() {
                    var _this = this;
                    if (this._isTransitioning) throw new Error("Collapse is transitioning");
                    if (!$(this._element).hasClass(ClassName.SHOW)) return;
                    var startEvent = $.Event(Event.HIDE);
                    $(this._element).trigger(startEvent);
                    if (startEvent.isDefaultPrevented()) return;
                    var dimension = this._getDimension();
                    var offsetDimension = dimension === Dimension.WIDTH ? "offsetWidth" : "offsetHeight";
                    this._element.style[dimension] = "".concat(this._element[offsetDimension], "px");
                    (0, $c737ba01c092e0c8$export$2e2bcd8739ae039).reflow(this._element);
                    $(this._element).addClass(ClassName.COLLAPSING).removeClass(ClassName.COLLAPSE).removeClass(ClassName.SHOW);
                    this._element.setAttribute("aria-expanded", false);
                    if (this._triggerArray.length) $(this._triggerArray).addClass(ClassName.COLLAPSED).attr("aria-expanded", false);
                    this.setTransitioning(true);
                    var complete = function() {
                        _this.setTransitioning(false);
                        $(_this._element).removeClass(ClassName.COLLAPSING).addClass(ClassName.COLLAPSE).trigger(Event.HIDDEN);
                    };
                    this._element.style[dimension] = "";
                    if (!(0, $c737ba01c092e0c8$export$2e2bcd8739ae039).supportsTransitionEnd()) {
                        complete();
                        return;
                    }
                    $(this._element).one((0, $c737ba01c092e0c8$export$2e2bcd8739ae039).TRANSITION_END, complete).emulateTransitionEnd(TRANSITION_DURATION);
                }
            },
            {
                key: "setTransitioning",
                value: function setTransitioning(isTransitioning) {
                    this._isTransitioning = isTransitioning;
                }
            },
            {
                key: "dispose",
                value: function dispose() {
                    $.removeData(this._element, DATA_KEY);
                    this._config = null;
                    this._parent = null;
                    this._element = null;
                    this._triggerArray = null;
                    this._isTransitioning = null;
                }
            },
            {
                // private
                key: "_getConfig",
                value: function _getConfig(config) {
                    config = $.extend({}, Default, config);
                    config.toggle = Boolean(config.toggle) // coerce string values
                    ;
                    (0, $c737ba01c092e0c8$export$2e2bcd8739ae039).typeCheckConfig(NAME, config, DefaultType);
                    return config;
                }
            },
            {
                key: "_getDimension",
                value: function _getDimension() {
                    var hasWidth = $(this._element).hasClass(Dimension.WIDTH);
                    return hasWidth ? Dimension.WIDTH : Dimension.HEIGHT;
                }
            },
            {
                key: "_getParent",
                value: function _getParent() {
                    var _this = this;
                    var parent = $(this._config.parent)[0];
                    var selector = '[data-toggle="collapse"][data-parent="'.concat(this._config.parent, '"]');
                    $(parent).find(selector).each(function(i, element) {
                        _this._addAriaAndCollapsedClass(Collapse._getTargetFromElement(element), [
                            element
                        ]);
                    });
                    return parent;
                }
            },
            {
                key: "_addAriaAndCollapsedClass",
                value: function _addAriaAndCollapsedClass(element, triggerArray) {
                    if (element) {
                        var isOpen = $(element).hasClass(ClassName.SHOW);
                        element.setAttribute("aria-expanded", isOpen);
                        if (triggerArray.length) $(triggerArray).toggleClass(ClassName.COLLAPSED, !isOpen).attr("aria-expanded", isOpen);
                    }
                }
            }
        ], [
            {
                key: "VERSION",
                get: // getters
                function get() {
                    return VERSION;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default;
                }
            },
            {
                key: "_getTargetFromElement",
                value: // static
                function _getTargetFromElement(element) {
                    var selector = (0, $c737ba01c092e0c8$export$2e2bcd8739ae039).getSelectorFromElement(element);
                    return selector ? $(selector)[0] : null;
                }
            },
            {
                key: "_jQueryInterface",
                value: function _jQueryInterface(config) {
                    return this.each(function() {
                        var $this = $(this);
                        var data = $this.data(DATA_KEY);
                        var _config = $.extend({}, Default, $this.data(), typeof config === "object" && config);
                        if (!data && _config.toggle && /show|hide/.test(config)) _config.toggle = false;
                        if (!data) {
                            data = new Collapse(this, _config);
                            $this.data(DATA_KEY, data);
                        }
                        if (typeof config === "string") {
                            if (data[config] === undefined) throw new Error('No method named "'.concat(config, '"'));
                            data[config]();
                        }
                    });
                }
            }
        ]);
        return Collapse;
    }();
    /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */ $(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function(event) {
        event.preventDefault();
        var target = Collapse._getTargetFromElement(this);
        var data = $(target).data(DATA_KEY);
        var config = data ? "toggle" : $(this).data();
        Collapse._jQueryInterface.call($(target), config);
    });
    /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */ $.fn[NAME] = Collapse._jQueryInterface;
    $.fn[NAME].Constructor = Collapse;
    $.fn[NAME].noConflict = function() {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return Collapse._jQueryInterface;
    };
    return Collapse;
}(jQuery);
var $0c5ec71b22441381$export$2e2bcd8739ae039 = $0c5ec71b22441381$var$Collapse;



var $3V7B6 = parcelRequire("3V7B6");

var $fqAw8 = parcelRequire("fqAw8");

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): dropdown.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ var $c6eea131f434e039$var$Dropdown = function($) {
    /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var NAME = "dropdown";
    var VERSION = "4.0.0-alpha.6";
    var DATA_KEY = "bs.dropdown";
    var EVENT_KEY = ".".concat(DATA_KEY);
    var DATA_API_KEY = ".data-api";
    var JQUERY_NO_CONFLICT = $.fn[NAME];
    var ESCAPE_KEYCODE = 27 // KeyboardEvent.which value for Escape (Esc) key
    ;
    var ARROW_UP_KEYCODE = 38 // KeyboardEvent.which value for up arrow key
    ;
    var ARROW_DOWN_KEYCODE = 40 // KeyboardEvent.which value for down arrow key
    ;
    var RIGHT_MOUSE_BUTTON_WHICH = 3 // MouseEvent.which value for the right button (assuming a right-handed mouse)
    ;
    var Event = {
        HIDE: "hide".concat(EVENT_KEY),
        HIDDEN: "hidden".concat(EVENT_KEY),
        SHOW: "show".concat(EVENT_KEY),
        SHOWN: "shown".concat(EVENT_KEY),
        CLICK: "click".concat(EVENT_KEY),
        CLICK_DATA_API: "click".concat(EVENT_KEY).concat(DATA_API_KEY),
        FOCUSIN_DATA_API: "focusin".concat(EVENT_KEY).concat(DATA_API_KEY),
        KEYDOWN_DATA_API: "keydown".concat(EVENT_KEY).concat(DATA_API_KEY)
    };
    var ClassName = {
        BACKDROP: "dropdown-backdrop",
        DISABLED: "disabled",
        SHOW: "show"
    };
    var Selector = {
        BACKDROP: ".dropdown-backdrop",
        DATA_TOGGLE: '[data-toggle="dropdown"]',
        FORM_CHILD: ".dropdown form",
        ROLE_MENU: '[role="menu"]',
        ROLE_LISTBOX: '[role="listbox"]',
        NAVBAR_NAV: ".navbar-nav",
        VISIBLE_ITEMS: '[role="menu"] li:not(.disabled) a, [role="listbox"] li:not(.disabled) a'
    };
    /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ var Dropdown = /*#__PURE__*/ function() {
        "use strict";
        function Dropdown(element) {
            (0, $3V7B6._)(this, Dropdown);
            this._element = element;
            this._addEventListeners();
        }
        (0, $fqAw8._)(Dropdown, [
            {
                // public
                key: "toggle",
                value: function toggle() {
                    if (this.disabled || $(this).hasClass(ClassName.DISABLED)) return false;
                    var parent = Dropdown._getParentFromElement(this);
                    var isActive = $(parent).hasClass(ClassName.SHOW);
                    Dropdown._clearMenus();
                    if (isActive) return false;
                    if ("ontouchstart" in document.documentElement && !$(parent).closest(Selector.NAVBAR_NAV).length) {
                        // if mobile we use a backdrop because click events don't delegate
                        var dropdown = document.createElement("div");
                        dropdown.className = ClassName.BACKDROP;
                        $(dropdown).insertBefore(this);
                        $(dropdown).on("click", Dropdown._clearMenus);
                    }
                    var relatedTarget = {
                        relatedTarget: this
                    };
                    var showEvent = $.Event(Event.SHOW, relatedTarget);
                    $(parent).trigger(showEvent);
                    if (showEvent.isDefaultPrevented()) return false;
                    this.focus();
                    this.setAttribute("aria-expanded", true);
                    $(parent).toggleClass(ClassName.SHOW);
                    $(parent).trigger($.Event(Event.SHOWN, relatedTarget));
                    return false;
                }
            },
            {
                key: "dispose",
                value: function dispose() {
                    $.removeData(this._element, DATA_KEY);
                    $(this._element).off(EVENT_KEY);
                    this._element = null;
                }
            },
            {
                // private
                key: "_addEventListeners",
                value: function _addEventListeners() {
                    $(this._element).on(Event.CLICK, this.toggle);
                }
            }
        ], [
            {
                key: "VERSION",
                get: // getters
                function get() {
                    return VERSION;
                }
            },
            {
                key: "_jQueryInterface",
                value: // static
                function _jQueryInterface(config) {
                    return this.each(function() {
                        var data = $(this).data(DATA_KEY);
                        if (!data) {
                            data = new Dropdown(this);
                            $(this).data(DATA_KEY, data);
                        }
                        if (typeof config === "string") {
                            if (data[config] === undefined) throw new Error('No method named "'.concat(config, '"'));
                            data[config].call(this);
                        }
                    });
                }
            },
            {
                key: "_clearMenus",
                value: function _clearMenus(event) {
                    if (event && event.which === RIGHT_MOUSE_BUTTON_WHICH) return;
                    var backdrop = $(Selector.BACKDROP)[0];
                    if (backdrop) backdrop.parentNode.removeChild(backdrop);
                    var toggles = $.makeArray($(Selector.DATA_TOGGLE));
                    for(var i = 0; i < toggles.length; i++){
                        var parent = Dropdown._getParentFromElement(toggles[i]);
                        var relatedTarget = {
                            relatedTarget: toggles[i]
                        };
                        if (!$(parent).hasClass(ClassName.SHOW)) continue;
                        if (event && (event.type === "click" && /input|textarea/i.test(event.target.tagName) || event.type === "focusin") && $.contains(parent, event.target)) continue;
                        var hideEvent = $.Event(Event.HIDE, relatedTarget);
                        $(parent).trigger(hideEvent);
                        if (hideEvent.isDefaultPrevented()) continue;
                        toggles[i].setAttribute("aria-expanded", "false");
                        $(parent).removeClass(ClassName.SHOW).trigger($.Event(Event.HIDDEN, relatedTarget));
                    }
                }
            },
            {
                key: "_getParentFromElement",
                value: function _getParentFromElement(element) {
                    var parent;
                    var selector = (0, $c737ba01c092e0c8$export$2e2bcd8739ae039).getSelectorFromElement(element);
                    if (selector) parent = $(selector)[0];
                    return parent || element.parentNode;
                }
            },
            {
                key: "_dataApiKeydownHandler",
                value: function _dataApiKeydownHandler(event) {
                    if (!/(38|40|27|32)/.test(event.which) || /input|textarea/i.test(event.target.tagName)) return;
                    event.preventDefault();
                    event.stopPropagation();
                    if (this.disabled || $(this).hasClass(ClassName.DISABLED)) return;
                    var parent = Dropdown._getParentFromElement(this);
                    var isActive = $(parent).hasClass(ClassName.SHOW);
                    if (!isActive && event.which !== ESCAPE_KEYCODE || isActive && event.which === ESCAPE_KEYCODE) {
                        if (event.which === ESCAPE_KEYCODE) {
                            var toggle = $(parent).find(Selector.DATA_TOGGLE)[0];
                            $(toggle).trigger("focus");
                        }
                        $(this).trigger("click");
                        return;
                    }
                    var items = $(parent).find(Selector.VISIBLE_ITEMS).get();
                    if (!items.length) return;
                    var index = items.indexOf(event.target);
                    if (event.which === ARROW_UP_KEYCODE && index > 0) index--;
                    if (event.which === ARROW_DOWN_KEYCODE && index < items.length - 1) index++;
                    if (index < 0) index = 0;
                    items[index].focus();
                }
            }
        ]);
        return Dropdown;
    }();
    /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */ $(document).on(Event.KEYDOWN_DATA_API, Selector.DATA_TOGGLE, Dropdown._dataApiKeydownHandler).on(Event.KEYDOWN_DATA_API, Selector.ROLE_MENU, Dropdown._dataApiKeydownHandler).on(Event.KEYDOWN_DATA_API, Selector.ROLE_LISTBOX, Dropdown._dataApiKeydownHandler).on("".concat(Event.CLICK_DATA_API, " ").concat(Event.FOCUSIN_DATA_API), Dropdown._clearMenus).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, Dropdown.prototype.toggle).on(Event.CLICK_DATA_API, Selector.FORM_CHILD, function(e) {
        e.stopPropagation();
    });
    /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */ $.fn[NAME] = Dropdown._jQueryInterface;
    $.fn[NAME].Constructor = Dropdown;
    $.fn[NAME].noConflict = function() {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return Dropdown._jQueryInterface;
    };
    return Dropdown;
}(jQuery);
var $c6eea131f434e039$export$2e2bcd8739ae039 = $c6eea131f434e039$var$Dropdown;



var $3V7B6 = parcelRequire("3V7B6");

var $fqAw8 = parcelRequire("fqAw8");

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): carousel.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ var $a18ee444970a0769$var$Carousel = function($) {
    /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var NAME = "carousel";
    var VERSION = "4.0.0-alpha.6";
    var DATA_KEY = "bs.carousel";
    var EVENT_KEY = ".".concat(DATA_KEY);
    var DATA_API_KEY = ".data-api";
    var JQUERY_NO_CONFLICT = $.fn[NAME];
    var TRANSITION_DURATION = 600;
    var ARROW_LEFT_KEYCODE = 37 // KeyboardEvent.which value for left arrow key
    ;
    var ARROW_RIGHT_KEYCODE = 39 // KeyboardEvent.which value for right arrow key
    ;
    var Default = {
        interval: 5000,
        keyboard: true,
        slide: false,
        pause: "hover",
        wrap: true
    };
    var DefaultType = {
        interval: "(number|boolean)",
        keyboard: "boolean",
        slide: "(boolean|string)",
        pause: "(string|boolean)",
        wrap: "boolean"
    };
    var Direction = {
        NEXT: "next",
        PREV: "prev",
        LEFT: "left",
        RIGHT: "right"
    };
    var Event = {
        SLIDE: "slide".concat(EVENT_KEY),
        SLID: "slid".concat(EVENT_KEY),
        KEYDOWN: "keydown".concat(EVENT_KEY),
        MOUSEENTER: "mouseenter".concat(EVENT_KEY),
        MOUSELEAVE: "mouseleave".concat(EVENT_KEY),
        LOAD_DATA_API: "load".concat(EVENT_KEY).concat(DATA_API_KEY),
        CLICK_DATA_API: "click".concat(EVENT_KEY).concat(DATA_API_KEY)
    };
    var ClassName = {
        CAROUSEL: "carousel",
        ACTIVE: "active",
        SLIDE: "slide",
        RIGHT: "carousel-item-right",
        LEFT: "carousel-item-left",
        NEXT: "carousel-item-next",
        PREV: "carousel-item-prev",
        ITEM: "carousel-item"
    };
    var Selector = {
        ACTIVE: ".active",
        ACTIVE_ITEM: ".active.carousel-item",
        ITEM: ".carousel-item",
        NEXT_PREV: ".carousel-item-next, .carousel-item-prev",
        INDICATORS: ".carousel-indicators",
        DATA_SLIDE: "[data-slide], [data-slide-to]",
        DATA_RIDE: '[data-ride="carousel"]'
    };
    /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ var Carousel = /*#__PURE__*/ function() {
        "use strict";
        function Carousel(element, config) {
            (0, $3V7B6._)(this, Carousel);
            this._items = null;
            this._interval = null;
            this._activeElement = null;
            this._isPaused = false;
            this._isSliding = false;
            this._config = this._getConfig(config);
            this._element = $(element)[0];
            this._indicatorsElement = $(this._element).find(Selector.INDICATORS)[0];
            this._addEventListeners();
        }
        (0, $fqAw8._)(Carousel, [
            {
                // public
                key: "next",
                value: function next() {
                    if (this._isSliding) throw new Error("Carousel is sliding");
                    this._slide(Direction.NEXT);
                }
            },
            {
                key: "nextWhenVisible",
                value: function nextWhenVisible() {
                    // Don't call next when the page isn't visible
                    if (!document.hidden) this.next();
                }
            },
            {
                key: "prev",
                value: function prev() {
                    if (this._isSliding) throw new Error("Carousel is sliding");
                    this._slide(Direction.PREVIOUS);
                }
            },
            {
                key: "pause",
                value: function pause(event) {
                    if (!event) this._isPaused = true;
                    if ($(this._element).find(Selector.NEXT_PREV)[0] && (0, $c737ba01c092e0c8$export$2e2bcd8739ae039).supportsTransitionEnd()) {
                        (0, $c737ba01c092e0c8$export$2e2bcd8739ae039).triggerTransitionEnd(this._element);
                        this.cycle(true);
                    }
                    clearInterval(this._interval);
                    this._interval = null;
                }
            },
            {
                key: "cycle",
                value: function cycle(event) {
                    if (!event) this._isPaused = false;
                    if (this._interval) {
                        clearInterval(this._interval);
                        this._interval = null;
                    }
                    if (this._config.interval && !this._isPaused) this._interval = setInterval((document.visibilityState ? this.nextWhenVisible : this.next).bind(this), this._config.interval);
                }
            },
            {
                key: "to",
                value: function to(index) {
                    var _this = this;
                    this._activeElement = $(this._element).find(Selector.ACTIVE_ITEM)[0];
                    var activeIndex = this._getItemIndex(this._activeElement);
                    if (index > this._items.length - 1 || index < 0) return;
                    if (this._isSliding) {
                        $(this._element).one(Event.SLID, function() {
                            return _this.to(index);
                        });
                        return;
                    }
                    if (activeIndex === index) {
                        this.pause();
                        this.cycle();
                        return;
                    }
                    var direction = index > activeIndex ? Direction.NEXT : Direction.PREVIOUS;
                    this._slide(direction, this._items[index]);
                }
            },
            {
                key: "dispose",
                value: function dispose() {
                    $(this._element).off(EVENT_KEY);
                    $.removeData(this._element, DATA_KEY);
                    this._items = null;
                    this._config = null;
                    this._element = null;
                    this._interval = null;
                    this._isPaused = null;
                    this._isSliding = null;
                    this._activeElement = null;
                    this._indicatorsElement = null;
                }
            },
            {
                // private
                key: "_getConfig",
                value: function _getConfig(config) {
                    config = $.extend({}, Default, config);
                    (0, $c737ba01c092e0c8$export$2e2bcd8739ae039).typeCheckConfig(NAME, config, DefaultType);
                    return config;
                }
            },
            {
                key: "_addEventListeners",
                value: function _addEventListeners() {
                    var _this = this;
                    if (this._config.keyboard) $(this._element).on(Event.KEYDOWN, function(event) {
                        return _this._keydown(event);
                    });
                    if (this._config.pause === "hover" && !("ontouchstart" in document.documentElement)) $(this._element).on(Event.MOUSEENTER, function(event) {
                        return _this.pause(event);
                    }).on(Event.MOUSELEAVE, function(event) {
                        return _this.cycle(event);
                    });
                }
            },
            {
                key: "_keydown",
                value: function _keydown(event) {
                    if (/input|textarea/i.test(event.target.tagName)) return;
                    switch(event.which){
                        case ARROW_LEFT_KEYCODE:
                            event.preventDefault();
                            this.prev();
                            break;
                        case ARROW_RIGHT_KEYCODE:
                            event.preventDefault();
                            this.next();
                            break;
                        default:
                            return;
                    }
                }
            },
            {
                key: "_getItemIndex",
                value: function _getItemIndex(element) {
                    this._items = $.makeArray($(element).parent().find(Selector.ITEM));
                    return this._items.indexOf(element);
                }
            },
            {
                key: "_getItemByDirection",
                value: function _getItemByDirection(direction, activeElement) {
                    var isNextDirection = direction === Direction.NEXT;
                    var isPrevDirection = direction === Direction.PREVIOUS;
                    var activeIndex = this._getItemIndex(activeElement);
                    var lastItemIndex = this._items.length - 1;
                    var isGoingToWrap = isPrevDirection && activeIndex === 0 || isNextDirection && activeIndex === lastItemIndex;
                    if (isGoingToWrap && !this._config.wrap) return activeElement;
                    var delta = direction === Direction.PREVIOUS ? -1 : 1;
                    var itemIndex = (activeIndex + delta) % this._items.length;
                    return itemIndex === -1 ? this._items[this._items.length - 1] : this._items[itemIndex];
                }
            },
            {
                key: "_triggerSlideEvent",
                value: function _triggerSlideEvent(relatedTarget, eventDirectionName) {
                    var slideEvent = $.Event(Event.SLIDE, {
                        relatedTarget: relatedTarget,
                        direction: eventDirectionName
                    });
                    $(this._element).trigger(slideEvent);
                    return slideEvent;
                }
            },
            {
                key: "_setActiveIndicatorElement",
                value: function _setActiveIndicatorElement(element) {
                    if (this._indicatorsElement) {
                        $(this._indicatorsElement).find(Selector.ACTIVE).removeClass(ClassName.ACTIVE);
                        var nextIndicator = this._indicatorsElement.children[this._getItemIndex(element)];
                        if (nextIndicator) $(nextIndicator).addClass(ClassName.ACTIVE);
                    }
                }
            },
            {
                key: "_slide",
                value: function _slide(direction, element) {
                    var _this = this;
                    var activeElement = $(this._element).find(Selector.ACTIVE_ITEM)[0];
                    var nextElement = element || activeElement && this._getItemByDirection(direction, activeElement);
                    var isCycling = Boolean(this._interval);
                    var directionalClassName;
                    var orderClassName;
                    var eventDirectionName;
                    if (direction === Direction.NEXT) {
                        directionalClassName = ClassName.LEFT;
                        orderClassName = ClassName.NEXT;
                        eventDirectionName = Direction.LEFT;
                    } else {
                        directionalClassName = ClassName.RIGHT;
                        orderClassName = ClassName.PREV;
                        eventDirectionName = Direction.RIGHT;
                    }
                    if (nextElement && $(nextElement).hasClass(ClassName.ACTIVE)) {
                        this._isSliding = false;
                        return;
                    }
                    var slideEvent = this._triggerSlideEvent(nextElement, eventDirectionName);
                    if (slideEvent.isDefaultPrevented()) return;
                    if (!activeElement || !nextElement) // some weirdness is happening, so we bail
                    return;
                    this._isSliding = true;
                    if (isCycling) this.pause();
                    this._setActiveIndicatorElement(nextElement);
                    var slidEvent = $.Event(Event.SLID, {
                        relatedTarget: nextElement,
                        direction: eventDirectionName
                    });
                    if ((0, $c737ba01c092e0c8$export$2e2bcd8739ae039).supportsTransitionEnd() && $(this._element).hasClass(ClassName.SLIDE)) {
                        $(nextElement).addClass(orderClassName);
                        (0, $c737ba01c092e0c8$export$2e2bcd8739ae039).reflow(nextElement);
                        $(activeElement).addClass(directionalClassName);
                        $(nextElement).addClass(directionalClassName);
                        $(activeElement).one((0, $c737ba01c092e0c8$export$2e2bcd8739ae039).TRANSITION_END, function() {
                            $(nextElement).removeClass("".concat(directionalClassName, " ").concat(orderClassName)).addClass(ClassName.ACTIVE);
                            $(activeElement).removeClass("".concat(ClassName.ACTIVE, " ").concat(orderClassName, " ").concat(directionalClassName));
                            _this._isSliding = false;
                            setTimeout(function() {
                                return $(_this._element).trigger(slidEvent);
                            }, 0);
                        }).emulateTransitionEnd(TRANSITION_DURATION);
                    } else {
                        $(activeElement).removeClass(ClassName.ACTIVE);
                        $(nextElement).addClass(ClassName.ACTIVE);
                        this._isSliding = false;
                        $(this._element).trigger(slidEvent);
                    }
                    if (isCycling) this.cycle();
                }
            }
        ], [
            {
                key: "VERSION",
                get: // getters
                function get() {
                    return VERSION;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default;
                }
            },
            {
                key: "_jQueryInterface",
                value: // static
                function _jQueryInterface(config) {
                    return this.each(function() {
                        var data = $(this).data(DATA_KEY);
                        var _config = $.extend({}, Default, $(this).data());
                        if (typeof config === "object") $.extend(_config, config);
                        var action = typeof config === "string" ? config : _config.slide;
                        if (!data) {
                            data = new Carousel(this, _config);
                            $(this).data(DATA_KEY, data);
                        }
                        if (typeof config === "number") data.to(config);
                        else if (typeof action === "string") {
                            if (data[action] === undefined) throw new Error('No method named "'.concat(action, '"'));
                            data[action]();
                        } else if (_config.interval) {
                            data.pause();
                            data.cycle();
                        }
                    });
                }
            },
            {
                key: "_dataApiClickHandler",
                value: function _dataApiClickHandler(event) {
                    var selector = (0, $c737ba01c092e0c8$export$2e2bcd8739ae039).getSelectorFromElement(this);
                    if (!selector) return;
                    var target = $(selector)[0];
                    if (!target || !$(target).hasClass(ClassName.CAROUSEL)) return;
                    var config = $.extend({}, $(target).data(), $(this).data());
                    var slideIndex = this.getAttribute("data-slide-to");
                    if (slideIndex) config.interval = false;
                    Carousel._jQueryInterface.call($(target), config);
                    if (slideIndex) $(target).data(DATA_KEY).to(slideIndex);
                    event.preventDefault();
                }
            }
        ]);
        return Carousel;
    }();
    /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */ $(document).on(Event.CLICK_DATA_API, Selector.DATA_SLIDE, Carousel._dataApiClickHandler);
    $(window).on(Event.LOAD_DATA_API, function() {
        $(Selector.DATA_RIDE).each(function() {
            var $carousel = $(this);
            Carousel._jQueryInterface.call($carousel, $carousel.data());
        });
    });
    /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */ $.fn[NAME] = Carousel._jQueryInterface;
    $.fn[NAME].Constructor = Carousel;
    $.fn[NAME].noConflict = function() {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return Carousel._jQueryInterface;
    };
    return Carousel;
}(jQuery);
var $a18ee444970a0769$export$2e2bcd8739ae039 = $a18ee444970a0769$var$Carousel;



var $3V7B6 = parcelRequire("3V7B6");

var $fqAw8 = parcelRequire("fqAw8");

/**
 * --------------------------------------------------------------------------
 * Bootstrap (v4.0.0-alpha.6): modal.js
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * --------------------------------------------------------------------------
 */ var $65218dc38db9bcee$var$Modal = function($) {
    /**
   * ------------------------------------------------------------------------
   * Constants
   * ------------------------------------------------------------------------
   */ var NAME = "modal";
    var VERSION = "4.0.0-alpha.6";
    var DATA_KEY = "bs.modal";
    var EVENT_KEY = ".".concat(DATA_KEY);
    var DATA_API_KEY = ".data-api";
    var JQUERY_NO_CONFLICT = $.fn[NAME];
    var TRANSITION_DURATION = 300;
    var BACKDROP_TRANSITION_DURATION = 150;
    var ESCAPE_KEYCODE = 27 // KeyboardEvent.which value for Escape (Esc) key
    ;
    var Default = {
        backdrop: true,
        keyboard: true,
        focus: true,
        show: true
    };
    var DefaultType = {
        backdrop: "(boolean|string)",
        keyboard: "boolean",
        focus: "boolean",
        show: "boolean"
    };
    var Event = {
        HIDE: "hide".concat(EVENT_KEY),
        HIDDEN: "hidden".concat(EVENT_KEY),
        SHOW: "show".concat(EVENT_KEY),
        SHOWN: "shown".concat(EVENT_KEY),
        FOCUSIN: "focusin".concat(EVENT_KEY),
        RESIZE: "resize".concat(EVENT_KEY),
        CLICK_DISMISS: "click.dismiss".concat(EVENT_KEY),
        KEYDOWN_DISMISS: "keydown.dismiss".concat(EVENT_KEY),
        MOUSEUP_DISMISS: "mouseup.dismiss".concat(EVENT_KEY),
        MOUSEDOWN_DISMISS: "mousedown.dismiss".concat(EVENT_KEY),
        CLICK_DATA_API: "click".concat(EVENT_KEY).concat(DATA_API_KEY)
    };
    var ClassName = {
        SCROLLBAR_MEASURER: "modal-scrollbar-measure",
        BACKDROP: "modal-backdrop",
        OPEN: "modal-open",
        FADE: "fade",
        SHOW: "show"
    };
    var Selector = {
        DIALOG: ".modal-dialog",
        DATA_TOGGLE: '[data-toggle="modal"]',
        DATA_DISMISS: '[data-dismiss="modal"]',
        FIXED_CONTENT: ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top"
    };
    /**
   * ------------------------------------------------------------------------
   * Class Definition
   * ------------------------------------------------------------------------
   */ var Modal = /*#__PURE__*/ function() {
        "use strict";
        function Modal(element, config) {
            (0, $3V7B6._)(this, Modal);
            this._config = this._getConfig(config);
            this._element = element;
            this._dialog = $(element).find(Selector.DIALOG)[0];
            this._backdrop = null;
            this._isShown = false;
            this._isBodyOverflowing = false;
            this._ignoreBackdropClick = false;
            this._isTransitioning = false;
            this._originalBodyPadding = 0;
            this._scrollbarWidth = 0;
        }
        (0, $fqAw8._)(Modal, [
            {
                // public
                key: "toggle",
                value: function toggle(relatedTarget) {
                    return this._isShown ? this.hide() : this.show(relatedTarget);
                }
            },
            {
                key: "show",
                value: function show(relatedTarget) {
                    var _this = this;
                    if (this._isTransitioning) throw new Error("Modal is transitioning");
                    if ((0, $c737ba01c092e0c8$export$2e2bcd8739ae039).supportsTransitionEnd() && $(this._element).hasClass(ClassName.FADE)) this._isTransitioning = true;
                    var showEvent = $.Event(Event.SHOW, {
                        relatedTarget: relatedTarget
                    });
                    $(this._element).trigger(showEvent);
                    if (this._isShown || showEvent.isDefaultPrevented()) return;
                    this._isShown = true;
                    this._checkScrollbar();
                    this._setScrollbar();
                    $(document.body).addClass(ClassName.OPEN);
                    this._setEscapeEvent();
                    this._setResizeEvent();
                    $(this._element).on(Event.CLICK_DISMISS, Selector.DATA_DISMISS, function(event) {
                        return _this.hide(event);
                    });
                    $(this._dialog).on(Event.MOUSEDOWN_DISMISS, function() {
                        $(_this._element).one(Event.MOUSEUP_DISMISS, function(event) {
                            if ($(event.target).is(_this._element)) _this._ignoreBackdropClick = true;
                        });
                    });
                    this._showBackdrop(function() {
                        return _this._showElement(relatedTarget);
                    });
                }
            },
            {
                key: "hide",
                value: function hide(event) {
                    var _this = this;
                    if (event) event.preventDefault();
                    if (this._isTransitioning) throw new Error("Modal is transitioning");
                    var transition = (0, $c737ba01c092e0c8$export$2e2bcd8739ae039).supportsTransitionEnd() && $(this._element).hasClass(ClassName.FADE);
                    if (transition) this._isTransitioning = true;
                    var hideEvent = $.Event(Event.HIDE);
                    $(this._element).trigger(hideEvent);
                    if (!this._isShown || hideEvent.isDefaultPrevented()) return;
                    this._isShown = false;
                    this._setEscapeEvent();
                    this._setResizeEvent();
                    $(document).off(Event.FOCUSIN);
                    $(this._element).removeClass(ClassName.SHOW);
                    $(this._element).off(Event.CLICK_DISMISS);
                    $(this._dialog).off(Event.MOUSEDOWN_DISMISS);
                    if (transition) $(this._element).one((0, $c737ba01c092e0c8$export$2e2bcd8739ae039).TRANSITION_END, function(event) {
                        return _this._hideModal(event);
                    }).emulateTransitionEnd(TRANSITION_DURATION);
                    else this._hideModal();
                }
            },
            {
                key: "dispose",
                value: function dispose() {
                    $.removeData(this._element, DATA_KEY);
                    $(window, document, this._element, this._backdrop).off(EVENT_KEY);
                    this._config = null;
                    this._element = null;
                    this._dialog = null;
                    this._backdrop = null;
                    this._isShown = null;
                    this._isBodyOverflowing = null;
                    this._ignoreBackdropClick = null;
                    this._originalBodyPadding = null;
                    this._scrollbarWidth = null;
                }
            },
            {
                // private
                key: "_getConfig",
                value: function _getConfig(config) {
                    config = $.extend({}, Default, config);
                    (0, $c737ba01c092e0c8$export$2e2bcd8739ae039).typeCheckConfig(NAME, config, DefaultType);
                    return config;
                }
            },
            {
                key: "_showElement",
                value: function _showElement(relatedTarget) {
                    var _this = this;
                    var transition = (0, $c737ba01c092e0c8$export$2e2bcd8739ae039).supportsTransitionEnd() && $(this._element).hasClass(ClassName.FADE);
                    if (!this._element.parentNode || this._element.parentNode.nodeType !== Node.ELEMENT_NODE) // don't move modals dom position
                    document.body.appendChild(this._element);
                    this._element.style.display = "block";
                    this._element.removeAttribute("aria-hidden");
                    this._element.scrollTop = 0;
                    if (transition) (0, $c737ba01c092e0c8$export$2e2bcd8739ae039).reflow(this._element);
                    $(this._element).addClass(ClassName.SHOW);
                    if (this._config.focus) this._enforceFocus();
                    var shownEvent = $.Event(Event.SHOWN, {
                        relatedTarget: relatedTarget
                    });
                    var transitionComplete = function() {
                        if (_this._config.focus) _this._element.focus();
                        _this._isTransitioning = false;
                        $(_this._element).trigger(shownEvent);
                    };
                    if (transition) $(this._dialog).one((0, $c737ba01c092e0c8$export$2e2bcd8739ae039).TRANSITION_END, transitionComplete).emulateTransitionEnd(TRANSITION_DURATION);
                    else transitionComplete();
                }
            },
            {
                key: "_enforceFocus",
                value: function _enforceFocus() {
                    var _this = this;
                    $(document).off(Event.FOCUSIN) // guard against infinite focus loop
                    .on(Event.FOCUSIN, function(event) {
                        if (document !== event.target && _this._element !== event.target && !$(_this._element).has(event.target).length) _this._element.focus();
                    });
                }
            },
            {
                key: "_setEscapeEvent",
                value: function _setEscapeEvent() {
                    var _this = this;
                    if (this._isShown && this._config.keyboard) $(this._element).on(Event.KEYDOWN_DISMISS, function(event) {
                        if (event.which === ESCAPE_KEYCODE) _this.hide();
                    });
                    else if (!this._isShown) $(this._element).off(Event.KEYDOWN_DISMISS);
                }
            },
            {
                key: "_setResizeEvent",
                value: function _setResizeEvent() {
                    var _this = this;
                    if (this._isShown) $(window).on(Event.RESIZE, function(event) {
                        return _this._handleUpdate(event);
                    });
                    else $(window).off(Event.RESIZE);
                }
            },
            {
                key: "_hideModal",
                value: function _hideModal() {
                    var _this = this;
                    this._element.style.display = "none";
                    this._element.setAttribute("aria-hidden", "true");
                    this._isTransitioning = false;
                    this._showBackdrop(function() {
                        $(document.body).removeClass(ClassName.OPEN);
                        _this._resetAdjustments();
                        _this._resetScrollbar();
                        $(_this._element).trigger(Event.HIDDEN);
                    });
                }
            },
            {
                key: "_removeBackdrop",
                value: function _removeBackdrop() {
                    if (this._backdrop) {
                        $(this._backdrop).remove();
                        this._backdrop = null;
                    }
                }
            },
            {
                key: "_showBackdrop",
                value: function _showBackdrop(callback) {
                    var _this = this;
                    var animate = $(this._element).hasClass(ClassName.FADE) ? ClassName.FADE : "";
                    if (this._isShown && this._config.backdrop) {
                        var doAnimate = (0, $c737ba01c092e0c8$export$2e2bcd8739ae039).supportsTransitionEnd() && animate;
                        this._backdrop = document.createElement("div");
                        this._backdrop.className = ClassName.BACKDROP;
                        if (animate) $(this._backdrop).addClass(animate);
                        $(this._backdrop).appendTo(document.body);
                        $(this._element).on(Event.CLICK_DISMISS, function(event) {
                            if (_this._ignoreBackdropClick) {
                                _this._ignoreBackdropClick = false;
                                return;
                            }
                            if (event.target !== event.currentTarget) return;
                            if (_this._config.backdrop === "static") _this._element.focus();
                            else _this.hide();
                        });
                        if (doAnimate) (0, $c737ba01c092e0c8$export$2e2bcd8739ae039).reflow(this._backdrop);
                        $(this._backdrop).addClass(ClassName.SHOW);
                        if (!callback) return;
                        if (!doAnimate) {
                            callback();
                            return;
                        }
                        $(this._backdrop).one((0, $c737ba01c092e0c8$export$2e2bcd8739ae039).TRANSITION_END, callback).emulateTransitionEnd(BACKDROP_TRANSITION_DURATION);
                    } else if (!this._isShown && this._backdrop) {
                        $(this._backdrop).removeClass(ClassName.SHOW);
                        var callbackRemove = function() {
                            _this._removeBackdrop();
                            if (callback) callback();
                        };
                        if ((0, $c737ba01c092e0c8$export$2e2bcd8739ae039).supportsTransitionEnd() && $(this._element).hasClass(ClassName.FADE)) $(this._backdrop).one((0, $c737ba01c092e0c8$export$2e2bcd8739ae039).TRANSITION_END, callbackRemove).emulateTransitionEnd(BACKDROP_TRANSITION_DURATION);
                        else callbackRemove();
                    } else if (callback) callback();
                }
            },
            {
                // ----------------------------------------------------------------------
                // the following methods are used to handle overflowing modals
                // todo (fat): these should probably be refactored out of modal.js
                // ----------------------------------------------------------------------
                key: "_handleUpdate",
                value: function _handleUpdate() {
                    this._adjustDialog();
                }
            },
            {
                key: "_adjustDialog",
                value: function _adjustDialog() {
                    var isModalOverflowing = this._element.scrollHeight > document.documentElement.clientHeight;
                    if (!this._isBodyOverflowing && isModalOverflowing) this._element.style.paddingLeft = "".concat(this._scrollbarWidth, "px");
                    if (this._isBodyOverflowing && !isModalOverflowing) this._element.style.paddingRight = "".concat(this._scrollbarWidth, "px");
                }
            },
            {
                key: "_resetAdjustments",
                value: function _resetAdjustments() {
                    this._element.style.paddingLeft = "";
                    this._element.style.paddingRight = "";
                }
            },
            {
                key: "_checkScrollbar",
                value: function _checkScrollbar() {
                    this._isBodyOverflowing = document.body.clientWidth < window.innerWidth;
                    this._scrollbarWidth = this._getScrollbarWidth();
                }
            },
            {
                key: "_setScrollbar",
                value: function _setScrollbar() {
                    var bodyPadding = parseInt($(Selector.FIXED_CONTENT).css("padding-right") || 0, 10);
                    this._originalBodyPadding = document.body.style.paddingRight || "";
                    if (this._isBodyOverflowing) document.body.style.paddingRight = "".concat(bodyPadding + this._scrollbarWidth, "px");
                }
            },
            {
                key: "_resetScrollbar",
                value: function _resetScrollbar() {
                    document.body.style.paddingRight = this._originalBodyPadding;
                }
            },
            {
                key: "_getScrollbarWidth",
                value: function _getScrollbarWidth() {
                    var scrollDiv = document.createElement("div");
                    scrollDiv.className = ClassName.SCROLLBAR_MEASURER;
                    document.body.appendChild(scrollDiv);
                    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
                    document.body.removeChild(scrollDiv);
                    return scrollbarWidth;
                }
            }
        ], [
            {
                key: "VERSION",
                get: // getters
                function get() {
                    return VERSION;
                }
            },
            {
                key: "Default",
                get: function get() {
                    return Default;
                }
            },
            {
                key: "_jQueryInterface",
                value: // static
                function _jQueryInterface(config, relatedTarget) {
                    return this.each(function() {
                        var data = $(this).data(DATA_KEY);
                        var _config = $.extend({}, Modal.Default, $(this).data(), typeof config === "object" && config);
                        if (!data) {
                            data = new Modal(this, _config);
                            $(this).data(DATA_KEY, data);
                        }
                        if (typeof config === "string") {
                            if (data[config] === undefined) throw new Error('No method named "'.concat(config, '"'));
                            data[config](relatedTarget);
                        } else if (_config.show) data.show(relatedTarget);
                    });
                }
            }
        ]);
        return Modal;
    }();
    /**
   * ------------------------------------------------------------------------
   * Data Api implementation
   * ------------------------------------------------------------------------
   */ $(document).on(Event.CLICK_DATA_API, Selector.DATA_TOGGLE, function(event) {
        var _this = this;
        var target;
        var selector = (0, $c737ba01c092e0c8$export$2e2bcd8739ae039).getSelectorFromElement(this);
        if (selector) target = $(selector)[0];
        var config = $(target).data(DATA_KEY) ? "toggle" : $.extend({}, $(target).data(), $(this).data());
        if (this.tagName === "A" || this.tagName === "AREA") event.preventDefault();
        var $target = $(target).one(Event.SHOW, function(showEvent) {
            if (showEvent.isDefaultPrevented()) // only register focus restorer if modal will actually get shown
            return;
            $target.one(Event.HIDDEN, function() {
                if ($(_this).is(":visible")) _this.focus();
            });
        });
        Modal._jQueryInterface.call($(target), config, this);
    });
    /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */ $.fn[NAME] = Modal._jQueryInterface;
    $.fn[NAME].Constructor = Modal;
    $.fn[NAME].noConflict = function() {
        $.fn[NAME] = JQUERY_NO_CONFLICT;
        return Modal._jQueryInterface;
    };
    return Modal;
}(jQuery);
var $65218dc38db9bcee$export$2e2bcd8739ae039 = $65218dc38db9bcee$var$Modal;


/**
 * Material-scrollTop
 *
 * Author: Bartholomej
 * Website: https://github.com/bartholomej/material-scrollTop
 * Docs: https://github.com/bartholomej/material-scrollTop
 * Repo: https://github.com/bartholomej/material-scrollTop
 * Issues: https://github.com/bartholomej/material-scrollTop/issues
 */ (function($) {
    function mScrollTop(element, settings) {
        var _ = this, breakpoint;
        var scrollTo = 0;
        _.btnClass = ".material-scrolltop";
        _.revealClass = "reveal";
        _.btnElement = $(_.btnClass);
        _.initial = {
            revealElement: "body",
            revealPosition: "top",
            padding: 0,
            duration: 600,
            easing: "swing",
            onScrollEnd: false
        };
        _.options = $.extend({}, _.initial, settings);
        _.revealElement = $(_.options.revealElement);
        breakpoint = _.options.revealPosition !== "bottom" ? _.revealElement.offset().top : _.revealElement.offset().top + _.revealElement.height();
        scrollTo = element.offsetTop + _.options.padding;
        $(document).scroll(function() {
            if (breakpoint < $(document).scrollTop()) _.btnElement.addClass(_.revealClass);
            else _.btnElement.removeClass(_.revealClass);
        });
        _.btnElement.click(function() {
            var trigger = true;
            $("html, body").animate({
                scrollTop: scrollTo
            }, _.options.duration, _.options.easing, function() {
                if (trigger) {
                    trigger = false;
                    var callback = _.options.onScrollEnd;
                    if (typeof callback === "function") callback();
                }
            });
            return false;
        });
    }
    $.fn.materialScrollTop = function() {
        var _ = this, opt = arguments[0], l = _.length, i = 0;
        if (typeof opt == "object" || typeof opt == "undefined") _[i].materialScrollTop = new mScrollTop(_[i], opt);
        return _;
    };
})(jQuery);


$bUBkB('[data-spy="afaaafix"]').on("affixed.bs.affix", function() {
    $bUBkB(".affix").css("width", Number($bUBkB(".affix").parent().css("width").replace("px", "")) - 30);
});
function $408e1f7c776d60df$var$onScroll() {
    var scroll = $bUBkB(window).scrollTop();
    if (scroll >= 14) $bUBkB(".header").addClass("scrolled");
    else $bUBkB(".header").removeClass("scrolled");
}
$408e1f7c776d60df$var$onScroll();
$bUBkB(window).scroll($408e1f7c776d60df$var$onScroll);
jQuery("body").materialScrollTop();
$bUBkB("a.menulink").smoothScroll();
$bUBkB("a.menulink").on("click", function() {
    $bUBkB("#navbarNav").collapse("hide");
});
$bUBkB("a.find-center").smoothScroll();
window["googleMapsLoaded"] = function() {
    if (window["page"] === "search-results") (0, $04df4a0c76238a5a$export$d41d6118675e9b78)();
    if (window["page"] === "home" || window["page"] === "search-results" || window["page"] === "my-account-search" || window["page"] === "audiopro-detail" || window["page"] === "orl-detail") {
        (0, $c70c8f04c51e342a$export$3a2c34b81dbf4e57)();
        (0, $65c41bce49c9f364$export$79145f2fbddd9106)();
    }
    (0, $e51894327719f7f1$export$af12e467c1278c18)();
    (0, $20baf3c310b4da18$export$6794e2eac1c24bce)();
    (0, $c1dc61a9dfd51abd$export$5e21beef2e326574)();
};
(0, $e51894327719f7f1$export$91354855d0da8111)();
if (window["page"] === "home") (0, $65c41bce49c9f364$export$21ef4c26e665e784)();
setTimeout(function() {
    function loadGoogleApis() {
        var windowWidth = window.screen.width < window.outerWidth ? window.screen.width : window.outerWidth;
        var mobile = windowWidth < 500;
        if (mobile) $("<script/>").attr({
            src: "https://maps.googleapis.com/maps/api/js?key=" + window.mapsApiKey + "&libraries=places&language=fr&callback=googleMapsLoaded"
        }).appendTo("body");
        else $("<script/>").attr({
            src: "https://maps.googleapis.com/maps/api/js?key=" + window.mapsApiKey + "&libraries=geometry,places&language=fr&callback=googleMapsLoaded"
        }).appendTo("body");
        $("<script/>").attr({
            src: "https://www.google.com/jsapi"
        }).appendTo("body");
    }
    loadGoogleApis();
}, 1);


$bUBkB(".dropdown-toggle").dropdown();

})();
//# sourceMappingURL=front.js.map
